<template>
    <div class="container-fluid" id="dvcrud">
		<detalhespedido v-bind:idpedido="vidpedidodet" v-bind:rotinacorte="crotinacortes"></detalhespedido>
		<visualizadorestoque :idproduto="idprodutoestoque" :descricao="descproestoque"></visualizadorestoque>
		<informacoescliente v-bind:id="idclienteinf" 
			v-bind:nomecliente="nomeclienteinf"
			v-bind:vlcredito="vlcreditoinf"
			v-bind:imagemcliente="imagemclienteinf">
		</informacoescliente>
		<alertacliente v-bind:idcliente="vidclientealerta"></alertacliente>		
        <div id="dvimagens" class="row" style="display: none;">
            <div class="col-md-12">
                <viewer :images="images" rebuild class="viewer">
                    <img v-for="src in images" :key="src" :src="src">
                </viewer>                            
            </div>
        </div>        		
        <div class="row">
			<consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa" v-bind:incmassa="true" v-bind:idestoque="videstoqueedicao"></consultaprodutos>
			<detalhesprodutos v-bind:idproduto="vidprodutos"></detalhesprodutos>
			<consultaclientes></consultaclientes>
			<etiquesvolumespedido v-bind:pedido="pedidomenu"></etiquesvolumespedido>
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: block;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>						
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>							
                        </router-link>
						<button v-if="!pmaisfiltros" type="button" class="close" title="Mais filtros" style="margin-right: 15px;" @click.prevent="mtdopmaisfiltros()"><i class="fa fa-angle-double-down"></i></button>
						<button v-else type="button" class="close" title="Menos filtros" style="margin-right: 15px;" @click.prevent="mtdopmaisfiltros()"><i class="fa fa-angle-double-up"></i></button>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edidpedidopesq">Nr. Pedido:</label>
                                <input id="edidpedidopesq" type="text" v-mask="'########'" class="form-control form-control-sm" v-model="pidpedido" @keyup="mtdlimpar_listagem()">
                            </div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-3">
								<span class="lblselect2">Cliente:</span>
								<select id="cbclientepesq" data-placeholder="Selecione um cliente" v-model="pidcliente" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<span class="lblselect2">Vendedor:</span>
								<select id="cbvendedorpesq" data-placeholder="Selecione um vendedor" v-model="pidvendedor" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<span class="lblselect2">Rota:</span>
								<select id="cbrotapesq" data-placeholder="Selecione uma rota" v-model="pidrota" data-allow-clear="true" style="width:100%;">
								</select>
							</div>							
							<div class="col-sm-12 col-md-2 col-lg-2">
								<span class="lblselect2">Plano de pgto:</span>
								<select id="cbplanopesq" data-placeholder="Selecione um plano" v-model="pidplano" data-allow-clear="true" style="width:100%;">
								</select>
							</div>														
                            <div class="col-12 col-sm-12 col-md-1 col-lg-1">
                                <label for="cbtipopesq">Tipo:</label>
                                <select name="cbtipopesq" class="form-control form-control-sm" id="cbtipopesq" v-model="ptipo" @change="mtdlimpar_listagem()">
                                    <option value="0">Pedidos</option>
                                    <option value="1">Orçamentos</option>
                                    <option value="2">Ordens de serviço</option>
									<option value="3">Cashback</option>
                                    <option value="4">Todos</option>
									<option value="5">Exceto cashback</option>
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="edidentificadorospesq">Identificador:</label>
								<input type="text" class="form-control form-control-sm" id="edidentificadorospesq" 
								style="text-transform: uppercase;"
								v-model="pidentificador" data-bv-group=".group" maxlength="20">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edresponsavelpesq">Responsável:</label>
								<input type="text" class="form-control form-control-sm" id="edresponsavelpesq" v-model="presponsavel" data-bv-group=".group" maxlength="20">
							</div>														
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="cbfiltropor">Por:</label>
								<select class="form-control form-control-sm" id="cbfiltropor" v-model="pfiltropor" v-bind:disabled="hab_desab_periodo">
									<option value="0">Emissão</option>
									<option value="1">Fatura</option>
									<option value="2">Retorno</option>
								</select>
							</div>							
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div v-show="pmaisfiltros" class="col-sm-12 col-md-2 col-lg-2">
								<label for="edhrini">Hr. inicial:</label>
								<input type="text" v-model="phrini" 
									class="form-control form-control-sm" id="edhrini" 
									v-mask="'##:##'">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>	
							<div v-show="pmaisfiltros" class="col-sm-12 col-md-2 col-lg-2">
								<label for="edhrfim">Hr. final:</label>
								<input type="text" v-model="phrfim" 
									class="form-control form-control-sm" id="edhrfim" 
									v-mask="'##:##'">
							</div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-1">
                                <label for="cbsituacaopesq">Situação:</label>
                                <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="psituacao" @change="mtdlimpar_listagem()">
                                    <option value="0">Abertos</option>
                                    <option value="1">Faturados</option>
                                    <option value="2">Cancelados</option>
                                    <option value="3">Todos</option>
                                </select>
                            </div>							
                            <div class="col-6 col-sm-6 col-md-2 col-lg-1">
                                <label for="cbentregaexternapesq">Entrega:</label>
                                <select name="cbentregaexternapesq" class="form-control form-control-sm" id="cbentregaexternapesq" v-model="pentregaexterna" @change="mtdlimpar_listagem()">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>
                            <div v-if="parseInt(pentregaexterna) === 1" class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacaoentrega">Finalizada:</label>
                                <select name="cbsituacaoentrega" class="form-control form-control-sm" id="cbsituacaoentrega" v-model="psituacaoentrega" @change="mtdlimpar_listagem()">
                                    <option value="0">Não</option>
                                    <option value="1">Sim</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div>
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="edidpedidooffpesq">Id. off:</label>
								<input type="text" class="form-control form-control-sm" id="edidpedidooffpesq" v-model="pidpedidooff" data-bv-group=".group" maxlength="20" title="Número da venda feita no PDV off line">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="edidlancamentopdvoffpesq">Id. pdv off:</label>
								<input type="text" class="form-control form-control-sm" id="edidlancamentopdvoffpesq" v-model="pidlancamentopdvoff" data-bv-group=".group" maxlength="20" title="Número do lançamento do PDV off line">
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<span class="lblselect2">Forma de pgto:</span>
								<select id="cbformapesq" data-placeholder="Selecione uma forma" v-model="pidforma" data-allow-clear="true" style="width:100%;">
								</select>
							</div>							
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbcredito">Pedidos c/ crédito:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbcredito" v-model="pcredito" @change="mtdlimpar_listagem()">
                                    <option value="0">Não filtrar</option>
                                    <option value="2">Em Aberto</option>
                                    <option value="3">Liquidados</option>
                                    <option value="4">Todos</option>
                               </select>
                            </div>		
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <label for="cborigem">Origem:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cborigem" v-model="porigem" @change="mtdlimpar_listagem()">
                                    <option value="0">Web</option>
                                    <option value="5">App</option>
									<option value="6">E-commerce</option>
                                    <option value="10">Todos</option>
                                </select>
                            </div>																																	
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
							<div v-show="pmaisfiltros" class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Marca:</span>
                                <select id="cbmarcapesq" v-model="pidmarca"
                                        data-placeholder="Selecione uma marca"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div v-show="pmaisfiltros" class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">Grupo:</span>
                                <select id="cbgrupopesq" v-model="pidgrupo"
                                        data-placeholder="Selecione um grupo"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>
                            <div v-show="pmaisfiltros" class="col-sm-12 col-md-2 col-lg-2">
                                <span class="lblselect2">St. Operacional:</span>
                                <select id="cbstospesq" v-model="pidstos"
                                        data-placeholder="Selecione um situação"
                                        data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>							
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Listar</button>
                            </div>
                            <div id="dvlistagempedidos" class="col-md-12" style="margin-top: 10px;">
								
							
								
								<ul v-show="exibicaocard && lstpedidos.length > 0" class="list-group" style="margin-bottom: 10px;">
									
									<li class="list-group-item list-group-item-action" style="background-color: #1e2b37; padding-top: 5px; padding-bottom: 0px; border-radius: 13px 13px 0px 0px;">
										<div class="row d-none d-md-flex">
											<div class="col-md-1" style="padding-left: 0px;">
												<i style="font-size: 23px; padding: 2px; width: 30px; margin-right: 6px; color: #cccccc"  @click.prevent="marcadesmarcatodos()"  
												:class="todosmarcados ? 'fa fa-check-square-o' : 'fa fa-square-o'"></i>
											</div>
											<div class="col-md-2">
												<i @click.prevent="mtdsortlista('id')" style="color: #cccccc; font-size: 12px; font-weight: bolder;" 
													:class="mtdverificaordematual('id') === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'">
												</i>
											</div>
											<div class="col-md-3">
												<i @click.prevent="mtdsortlista('nomecliente')" style="color: #cccccc; font-size: 12px; font-weight: bolder;" 
													:class="mtdverificaordematual('nomecliente') === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'">
												</i>
											</div>
											<div class="col-md-2">
												<i @click.prevent="mtdsortlista('fantasia')" style="color: #cccccc; font-size: 12px; font-weight: bolder;" 
													:class="mtdverificaordematual('fantasia') === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'">
												</i>
											</div>
											<div class="col-md-2">
												<i @click.prevent="mtdsortlista('identificador')" style="color: #cccccc; font-size: 12px; font-weight: bolder;"  
												:class="mtdverificaordematual('identificador') === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
											</div>
											<div class="col-md-2">
												<i @click.prevent="mtdsortlista('totalgeral')" style="color: #cccccc; font-size: 12px; font-weight: bolder;" 
													:class="mtdverificaordematual('totalgeral') === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'">
												</i>
											</div>
										</div>
										<!-- Mobile header: show as a horizontal scrollable row with icons and tooltips -->
										<div class="d-flex d-md-none flex-nowrap overflow-auto" style="gap: 10px; padding-bottom: 5px;">
											<div>
												<i style="font-size: 20px; color: #cccccc" @click.prevent="marcadesmarcatodos()" 
													:class="todosmarcados ? 'fa fa-check-square-o' : 'fa fa-square-o'" title="Selecionar todos"></i>
											</div>
											<div>
												<i @click.prevent="mtdsortlista('id')" style="color: #cccccc; font-size: 14px;" 
													:class="mtdverificaordematual('id') === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" title="Ordenar por Pedido"></i>
											</div>
											<div>
												<i @click.prevent="mtdsortlista('nomecliente')" style="color: #cccccc; font-size: 14px;" 
													:class="mtdverificaordematual('nomecliente') === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" title="Ordenar por Cliente"></i>
											</div>
											<div>
												<i @click.prevent="mtdsortlista('fantasia')" style="color: #cccccc; font-size: 14px;" 
													:class="mtdverificaordematual('fantasia') === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" title="Ordenar por Filial"></i>
											</div>
											<div>
												<i @click.prevent="mtdsortlista('identificador')" style="color: #cccccc; font-size: 14px;"  
													:class="mtdverificaordematual('identificador') === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" title="Ordenar por Identificador"></i>
											</div>
											<div>
												<i @click.prevent="mtdsortlista('totalgeral')" style="color: #cccccc; font-size: 14px;" 
													:class="mtdverificaordematual('totalgeral') === 'asc' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" title="Ordenar por Valor"></i>
											</div>
										</div>

									</li>
									
									<li class="list-group-item list-group-item-action" v-for="(pedido, index) in lstpedidos" v-bind:key="index" style="padding: 5px;">
										<div class="row">
											<div class="col-md-1" style="padding-top: 5px; padding-right: 2px;">
												<div class="row">
													<div class="col-md-12">
														<div style="width: 100%; display: flex; justify-content: center;">

											
															<i v-show="parseInt(pedido.marcado) === 0" style="font-size: 23px; padding: 2px; width: 30px; margin-right: 6px;" @click.prevent="marcadesmarcaitem(pedido, index)" class="fa fa-square-o"></i>

															<i v-show="parseInt(pedido.marcado) === 1" style="font-size: 23px; padding: 2px; width: 30px; margin-right: 6px;"  @click.prevent="marcadesmarcaitem(pedido, index)"  class="fa fa-check-square-o"></i>
																
                                             																															
														<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(pedido)" style="font-size: 10px; padding: 2px; width: 30px;">
															<i class="fa fa-navicon"></i>
														</button>
														<button type="button" class="btn btn-info btn-sm" @click.prevent="mtddetalhespedido(pedido.id)" style="font-size: 10px; padding: 2px; width: 30px; margin-left: 6px;" title="Detalhes do pedido">
															<i  class="fa fa-info-circle"></i>
														</button>																		
														</div>												
													</div>
													<div class="col-md-12">
														<span v-if="parseInt(pedido.tipo) === 0" class="badge badge-primary badge-pill" style="background-color: #6BA2D0; width: 100%;">PEDIDO</span>
														<span v-else-if="parseInt(pedido.tipo) === 1" class="badge badge-primary badge-pill" style="background-color: #EEA435; width: 100%;">ORÇAMENTO</span>
														<span v-else-if="parseInt(pedido.tipo) === 2" class="badge badge-primary badge-pill" style="background-color: #A42F11; width: 100%;">O. S.</span>
														<span v-else class="badge badge-primary badge-pill" style="background-color: #74A82A; width: 100%;">CASHBACK</span>													
													</div>													
													<div class="col-md-12 text-center">
														<i v-if="parseInt(pedido.liberarpdv) === 1" @dblclick="mtdrotinapdv(pedido.id)" class="fa fa-unlock icone-libera-pdv" style="color: #5A956A;" title="Liberado para o PDV (clique duas vezes para bloquear)"></i>
														<i v-else class="fa fa-lock icone-libera-pdv" style="color: #EEA435;" @dblclick="mtdrotinapdv(pedido.id)" title="Bloqueado para o PDV (clique duas vezes para desbloquear)"></i>
														<i v-if="parseInt(pedido.origem) === 5" class="fa fa-tablet icone-origem" title="Pedido realizado pelo app" style="font-size: 18px; margin-left: 5px;;"></i>										
														<i v-if="parseInt(pedido.entregaexterna) === 1" class="fa fa-truck" title="Entrega externa" style="font-size: 18px; color: #0acf97; margin-left: 5px; transform: scale(-1, 1);"></i>
														

														<span v-if="parseFloat(pedido.vlcredito) === 0 && parseFloat(pedido.vlcreditoutilizado) === 0"></span>
														<span v-else-if="parseFloat(pedido.vlcredito) > 0 && parseFloat(pedido.vlcreditoutilizado) === 0" class="bdg-credito bdg-credito-disponivel badge badge-pill badge-success" title="Crédito diponível" @click.prevent="mtdmostradetcred(pedido)"><i class="fa fa-dollar"></i></span>
														<span v-else-if="parseFloat(pedido.vlcreditoutilizado) >= parseFloat(pedido.vlcredito)" class="bdg-credito bdg-credito-utilizado badge badge-pill badge-secondary" title="Crédito já utilizado" @click.prevent="mtdmostradetcred(pedido)"><i class="fa fa-dollar"></i></span>										
														<span v-else-if="parseFloat(pedido.vlcredito) > 0 && parseFloat(pedido.vlcreditoutilizado) > 0" class="bdg-credito bdg-credito-saldo badge badge-pill badge-info"  title="Saldo de crédito à utilizar" @click.prevent="mtdmostradetcred(pedido)"><i class="fa fa-dollar"></i></span>

														<span v-if="parseInt(pedido.conferido) === 1" title="Conferência finalizada"><i class="fa fa-check-square-o" style="top: 0px; color: #5a956a; font-weight: 600; font-size: 18px; margin-left: 5px;"></i></span>
														<span v-else-if="parseInt(pedido.confiniciada) === 1" title="Conferência iniciada"><i class="fa fa-list-ol" style="color: #EEA435; font-size: 18px;  margin-left: 5px;"></i></span>
														
														<span v-if="(parseFloat(pedido.vlcreditodisponivel) < parseFloat(pedido.totalgeral) && parseInt(pedido.tipoplano) === 1) || (parseInt(pedido.atraso) - parseInt(pedido.qtddiasbloqvenda) > 0)" 
															title="Possíveis pendências: - Cliente com limite de crédito insuficiente; - Débitos em atraso.">
															<i class="fa fa-exclamation-circle icone-pendencias">
																<i v-if="parseInt(pedido.liberarfat) === 1" class="fa fa-check" style="position: relative; color: #0acf97; font-size: 16px; top: -4px; left: -12px;" title="Liberado para faturamento"></i>											
															</i>													
														</span>	
														<i v-if="parseInt(pedido.imppadrao) > 0"  
															@click.prevent="parseInt(pedido.imppadrao) === 1 ? mtdimprimirpedido(pedido.id, 1) : (parseInt(pedido.imppadrao) === 3 ? mtdimprimirpedido(pedido.id, 2) : mtdimprimirpedido(pedido.id, 0))"
															class="fa fa-print icone-imprimir-pedido" title="Imprimir pedido">
														</i>
													</div>
												</div>																								
											</div>
											<div class="col-md-2">
												<div class="row">
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">NR. PEDIDO:</span>
														<span style="color: #6c757d; font-size: 12px; font-weight: bold; float: left; margin-left: 3px;">{{ mtdformatarzeros(pedido.id, 8) }}</span>

														<span v-if="parseInt(pedido.stpedido) === 0" class="badge badge-primary badge-pill" style="float: right;">ABERTO</span>
														<span v-else-if="parseInt(pedido.stpedido) === 1" class="badge badge-secondary badge-pill" style="background-color: #5A956A; float: right;">FATURADO</span>
														<span v-else class="badge badge-danger badge-pill" style="float: right;">CANCELADO</span>														
													</div>
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">EMISSÃO:</span>
														<span style="color: #6c757d; font-size: 12px; float: right;">{{ pedido.dtregistro }}</span>
													</div>
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">DT. FATURA:</span>
														<span style="color: #6c757d; font-size: 12px; float: right;">{{ pedido.dtfatura }}</span>
													</div>		
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">INF. OFF: </span>
														<span style="color: #6c757d; font-size: 12px; float: right;" v-if="parseInt(pedido.idpedidooff) > 0" title="Número da venda no PDV offline / Número da abertura do PDV offline">{{ mtdformatarzeros(pedido.idpedidooff, 8)}}/{{ pedido.idlancamentopdvoff }}</span>
													</div>																																					
												</div>
											</div>
											<div class="col-md-3">
												<div class="row">
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">CLIENTE:</span>
														<span style="color: #6c757d; font-size: 12px; float: left; margin-left: 2px;"> {{ mtdformatarzeros(pedido.idcliente, 5) }}</span>
														<i @click.prevent="mtdinformacoescliente(pedido.idcliente, pedido.nomecliente, pedido.vlcreditoclli, pathimgview+pedido.imagemcliente)" class="fa fa-info-circle icon-detalhes" title="Detalhes do cliente" style="color: #4250f2; font-size: 15px; float: left; margin-top: 1px; margin-left: 2px;"></i>
													</div>					
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">NOME:</span>
														<span style="color: #6c757d; font-size: 12px; float: left; margin-left: 2px;"> {{ pedido.nomecliente }}</span>
													</div>
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">ROTA:</span>
														<span style="color: #6c757d; font-size: 12px; float: left; margin-left: 2px;"> {{ pedido.descrota }}</span>
													</div>																																										
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">RESPONSÁVEL:</span>
														<span style="color: #6c757d; font-size: 12px; float: left; margin-left: 2px;"> {{ pedido.responsavel }}</span>
													</div>													
												</div>
											</div>																						
											<div class="col-md-2">
												<div class="row">
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">FILIAL:</span>
														<span style="color: #6c757d; font-size: 12px; float: left; margin-left: 2px;"> {{ pedido.fantasia }}</span>
													</div>					
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">VENDEDOR:</span>
														<span style="color: #6c757d; font-size: 12px; float: left; margin-left: 2px;"> {{ pedido.nomevendedor }}</span>
													</div>
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">PLANO:</span>
														<span style="color: #6c757d; font-size: 12px; float: left; margin-left: 2px;"> {{ pedido.descplano }}</span>
													</div>																																										
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">ST. OPERAC.:</span>
														<!-- <span v-show="parseInt(pedido.idstos) >  0" class="badge  badge-pill" v-bind:style="pedido.corstos !== '' ? 'background-color: '+pedido.corstos+' !important' : ''" style="color: white; font-size: 9px; float: left; margin-left: 2px; margin-top: 4px;"> {{ pedido.descstos }}</span> -->
												        <span v-show="parseInt(pedido.idstos) >  0" class="badge  badge-pill"   v-bind:style="'background-color: '+pedido.corstos+' !important; color: white; font-size: 9px; float: left; margin-left: 2px; margin-top: 4px; float: right;'" > {{ pedido.descstos }}</span>
														
													</div>													
												</div>
											</div>	
											<div class="col-md-2">
												<div class="row">
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">IDENTIFICADOR:</span>
														<span style="color: #6c757d; font-size: 12px; float: left; margin-left: 2px;"> {{ pedido.identificador }}</span>
													</div>					
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">NR. SÉRIE:</span>
														<span style="color: #6c757d; font-size: 12px; float: left; margin-left: 2px;"> {{ pedido.serie }}</span>
													</div>
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">DT. RETORNO:</span>
														<span style="color: #6c757d; font-size: 12px; float: left; margin-left: 2px;"> {{ pedido.dtretorno }}</span>
													</div>	
													<div class="col-md-12">
														<span style="font-size: 12px; font-weight: bold; float: left;">FONE:</span>
														<span style="color: #6c757d; font-size: 12px; float: left; margin-left: 2px;"> {{ mtdformatafone(pedido.fone) }}</span>
													</div>																																																						
												</div>
											</div>																									
											<div class="col-md-2">
												<div class="row">
													<div class="col-md-12">
														<span style="font-size: 14px; font-weight: bold; float: left;">VALOR:</span>
														<span v-if="parseInt(pedido.tipo) !== 3" style="font-size: 14px; color: #6c757d; font-weight: bold; float: right;">{{ mtdformatavalordecimal(parseFloat(pedido.totalgeral), 2) }}</span>
														<span v-else style="color: #74A82A; font-size: 12px; font-weight: bold; float: right;">{{ mtdformatavalordecimal(parseFloat(pedido.vlcredito) - parseFloat(pedido.vlcreditoutilizado), 2) }}</span>
													</div>
													<div class="col-md-12">
														<span v-if="parseFloat(pedido.totaldesconto) > 0" style="font-size: 10px; font-weight: bold; float: left;">DESCONTOS:</span>
														<span v-if="parseFloat(pedido.totaldesconto) > 0" style="color: #5c8f94; font-weight: bold; font-size: 10px; float: right;">({{ pedido.percdesconto }}%) {{ mtdformatavalordecimal(parseFloat(pedido.totaldesconto), 2) }}</span>														
													</div>
													<div v-show="pvisualizarcustos" class="col-md-12">
														<span style="font-size: 10px; font-weight: bold; float: left;">TOT. CUSTO:</span>
														<span style="font-size: 10px;color: #f82b54; font-weight: bold; float: right;">{{ mtdformatavalordecimal(parseFloat(pedido.totalcusto), 2) }}</span>														
													</div>
													<div class="col-md-12">
														<ul class="list-group">
															<li v-for="(forma, indexf) in pedido.formas" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
																<span v-if="parseInt(forma.qtdparcelascartao) > 0" class="lbldescformapedido">{{forma.descricao}}({{forma.qtdparcelascartao}})</span>
																<span v-else class="lbldescformapedido">{{forma.descricao}}</span>
																<span class="lbldescformapedido">{{mtdformatavalordecimal(parseFloat(forma.vlforma) - parseFloat(forma.vltroco), 2)}}</span>
															</li>
														</ul>
													</div>																																																							
												</div>
											</div>											
										</div>
									</li>
								</ul>	
								
								
                                <vue-bootstrap4-table v-show="!exibicaocard" ref="reflstpedidos"				
										@on-select-row="mtdprocessaselecionados()"
                                        @on-unselect-row="mtdprocessaselecionados()"
                                        @on-all-select-rows="mtdprocessaselecionados()"
                                        @on-all-unselect-rows="mtdprocessaselecionados()"
                                       
                                        :rows="lstpedidos"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    									
                                    <template slot="opcoes" slot-scope="item">
										<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>
                                    </template>
                                    <template slot="slot_detalhes" slot-scope="item">
                                        <i @click.prevent="mtddetalhespedido(item.row.id)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido"></i>
                                    </template>																		
                                    <template slot="id_f" slot-scope="item">
										<div class="row">
											<div class="col-md-12 text-center">
												<span style="color: #6c757d; font-size: 12px; font-weight: bold;">{{ mtdformatarzeros(item.row.id, 8) }} </span>
											</div>
											<div class="col-md-12 text-center">
												<i v-if="parseInt(item.row.liberarpdv) === 1" @dblclick="mtdrotinapdv(item.row.id)" class="fa fa-unlock icone-libera-pdv" style="color: #5A956A;" title="Liberado para o PDV (clique duas vezes para bloquear)"></i>
												<i v-else class="fa fa-lock icone-libera-pdv" style="color: #EEA435;" @dblclick="mtdrotinapdv(item.row.id)" title="Bloqueado para o PDV (clique duas vezes para desbloquear)"></i>
												<i v-if="parseInt(item.row.origem) === 5" class="fa fa-tablet icone-origem" title="Pedido realizado pelo app" style="font-size: 18px; margin-left: 5px;;"></i>										
												<i v-if="parseInt(item.row.entregaexterna) === 1" class="fa fa-truck" title="Entrega externa" style="font-size: 18px; color: #0acf97; margin-left: 5px; transform: scale(-1, 1);"></i>
												

												<span v-if="parseFloat(item.row.vlcredito) === 0 && parseFloat(item.row.vlcreditoutilizado) === 0"></span>
												<span v-else-if="parseFloat(item.row.vlcredito) > 0 && parseFloat(item.row.vlcreditoutilizado) === 0" class="bdg-credito bdg-credito-disponivel badge badge-pill badge-success" title="Crédito diponível" @click.prevent="mtdmostradetcred(item.row)"><i class="fa fa-dollar"></i></span>
												<span v-else-if="parseFloat(item.row.vlcreditoutilizado) >= parseFloat(item.row.vlcredito)" class="bdg-credito bdg-credito-utilizado badge badge-pill badge-secondary" title="Crédito já utilizado" @click.prevent="mtdmostradetcred(item.row)"><i class="fa fa-dollar"></i></span>										
												<span v-else-if="parseFloat(item.row.vlcredito) > 0 && parseFloat(item.row.vlcreditoutilizado) > 0" class="bdg-credito bdg-credito-saldo badge badge-pill badge-info"  title="Saldo de crédito à utilizar" @click.prevent="mtdmostradetcred(item.row)"><i class="fa fa-dollar"></i></span>

												<span v-if="parseInt(item.row.conferido) === 1" title="Conferência finalizada"><i class="fa fa-check-square-o" style="top: 0px; color: #5a956a; font-weight: 600; font-size: 18px; margin-left: 5px;"></i></span>
												<span v-else-if="parseInt(item.row.confiniciada) === 1" title="Conferência iniciada"><i class="fa fa-list-ol" style="color: #EEA435; font-size: 18px;  margin-left: 5px;"></i></span>
												
												<span v-if="(parseFloat(item.row.vlcreditodisponivel) < parseFloat(item.row.totalgeral) && parseInt(item.row.tipoplano) === 1) || (parseInt(item.row.atraso) - parseInt(item.row.qtddiasbloqvenda) > 0)" 
													title="Possíveis pendências: - Cliente com limite de crédito insuficiente; - Débitos em atraso.">
													<i class="fa fa-exclamation-circle icone-pendencias">
														<i v-if="parseInt(item.row.liberarfat) === 1" class="fa fa-check" style="position: relative; color: #0acf97; font-size: 16px; top: -4px; left: -12px;" title="Liberado para faturamento"></i>											
													</i>													
												</span>	
												<i v-if="parseInt(item.row.imppadrao) > 0"  
													@click.prevent="parseInt(item.row.imppadrao) === 1 ? mtdimprimirpedido(item.row.id, 1) : (parseInt(item.row.imppadrao) === 3 ? mtdimprimirpedido(item.row.id, 2) : mtdimprimirpedido(item.row.id, 0))"
													class="fa fa-print icone-imprimir-pedido" title="Imprimir pedido">
												</i>						

											</div>
										</div>										
                                    </template>

                                    <template slot="slot_tipo" slot-scope="item">										
                                        <template v-if="parseInt(item.row.tipo) === 0">
											<span class="badge badge-primary badge-pill" style="background-color: #6BA2D0;">PEDIDO</span>
                                        </template>
                                        <template v-else-if="parseInt(item.row.tipo) === 1">
											<span class="badge badge-primary badge-pill" style="background-color: #EEA435;">ORÇAMENTO</span>
                                        </template>
                                        <template v-else-if="parseInt(item.row.tipo) === 2">
											<span class="badge badge-primary badge-pill" style="background-color: #A42F11;">O. S.</span>
                                        </template>										
                                        <template v-else>
											<span class="badge badge-primary badge-pill" style="background-color: #74A82A;">CASHBACK</span>
                                        </template>										
                                    </template>

                                    <template slot="slot_stpedido" slot-scope="item">
                                        <template v-if="parseInt(item.row.stpedido) === 0">
											<span class="badge badge-primary badge-pill">ABERTO</span>
                                        </template>
                                        <template v-else-if="parseInt(item.row.stpedido) === 1">
											<span class="badge badge-secondary badge-pill" style="background-color: #5A956A;">FATURADO</span>
                                        </template>
                                        <template v-else>
											<span class="badge badge-danger badge-pill">CANCELADO</span>
                                        </template>										
                                    </template>
                                    <template slot="slot_dtemissao" slot-scope="item">                                        
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.dtregistro }}</span>
                                    </template>	
                                    <template slot="slot_dtfatura" slot-scope="item">
                                        <span style="color: #6c757d; font-size: 12px;">{{ item.row.dtfatura }}</span>
                                    </template>									
									<template slot="slot_cliente" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px; font-weight: 600;"><i @click.prevent="mtdinformacoescliente(item.row.idcliente, item.row.nomecliente, item.row.vlcreditoclli, pathimgview+item.row.imagemcliente)" class="fa fa-info-circle icon-detalhes" title="Detalhes do cliente" style="color: #4250f2; font-size: 18px; position: relative; top: 2px; margin-right: 3px;"></i> {{ item.row.idcliente }} - {{ item.row.nomecliente }}</span>
									</template>											
									<template slot="slot_filial" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.fantasia }}</span>
									</template>															
									<template slot="slot_vendedor" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.nomevendedor }}</span>
									</template>
									<template slot="slot_plano" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.descplano }}</span>
									</template>
									<template slot="slot_identificador" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.identificador }}</span>
									</template>																		
									<template slot="slot_serie" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.serie }}</span>
									</template>									
									<template slot="slot_retorno" slot-scope="item">
										<span style="color: #6c757d; font-size: 12px;">{{ item.row.dtretorno }}</span>
									</template>									
									<template slot="slot_totalgeral" slot-scope="item">										
										<span v-if="parseInt(item.row.tipo) !== 3" style="color: #6c757d; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(item.row.totalgeral), 2) }}</span>
										<span v-else style="color: #74A82A; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(item.row.vlcredito) - parseFloat(item.row.vlcreditoutilizado), 2) }}</span>
									</template>																						
									<template slot="slot_totalcusto" slot-scope="item">
										<span style="color: #f82b54; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(item.row.totalcusto), 2) }}</span>
									</template>
									<template slot="slot_formaspedido" slot-scope="item">
										<ul class="list-group">
											<li v-for="(forma, indexf) in item.row.formas" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" style="padding: 2px;">
												<span v-if="parseInt(forma.qtdparcelascartao) > 0" class="lbldescformapedido">{{forma.descricao}}({{forma.qtdparcelascartao}})</span>
												<span v-else class="lbldescformapedido">{{forma.descricao}}</span>
												<span class="lbldescformapedido">{{mtdformatavalordecimal(parseFloat(forma.vlforma) - parseFloat(forma.vltroco), 2)}}</span>
											</li>
										</ul>										
									</template> 
                                    <template slot="slot_desconto" slot-scope="item">
                                        <span v-if="parseFloat(item.row.totaldesconto) > 0" style="color: #5c8f94; font-weight: bold; font-size: 10px;">({{ item.row.percdesconto }}%) {{ mtdformatavalordecimal(parseFloat(item.row.totaldesconto), 2) }}</span>
										<span v-else></span>
                                    </template>																																						
                                    <template slot="slot_dadosoff" slot-scope="item">
                                        <span style="color: #6c757d; font-size: 12px;" v-if="parseInt(item.row.idpedidooff) > 0" title="Número da venda no PDV offline / Número da abertura do PDV offline">{{ mtdformatarzeros(item.row.idpedidooff, 8)}}/{{ item.row.idlancamentopdvoff }}</span>
										<span v-else></span>
                                    </template>									
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12" style="margin-bottom: 10px;">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstpedidos.length}}</span>
                                    </li>
                                </ul>
                            </div>	
							<div class="col-md-12">
								<div class="row" v-show="pvisualizartotalizadores && lstpedidos.length > 0">
									<div class="col-sm-12 col-md-4 col-lg-4">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total aberto <span class="badge badge-info" style="font-size: 12px;">{{ pqa }}</span>
												<span class="badge badge-primary bdg-totais">{{ mtdformatavalordecimal(ptotalaberto, 2) }}</span></a>
										</ul>
									</div>
									<div class="col-sm-12 col-md-4 col-lg-4'">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total faturado <span class="badge badge-info" style="font-size: 12px;">{{ pqf }}</span>
												<span class="badge badge-primary bdg-totais" style="background-color: #5a956a;">{{ mtdformatavalordecimal(ptotalfaturado, 2) }}</span></a>
										</ul>
									</div>
									<div class="col-sm-12 col-md-4 col-lg-4">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total cancelado <span class="badge badge-info" style="font-size: 12px;">{{ pqc }}</span>
												<span class="badge badge-danger bdg-totais">{{ mtdformatavalordecimal(ptotalcancelado, 2) }}</span></a>
										</ul>
									</div>
									<div class="col-sm-12 col-md-4 col-lg-4" style="margin-top: 5px;">
										<ul class="list-group">
											<a class="list-group-item lstdettot">
												<div class="row" >
													<div class="col-4" >
														<p style="margin: 0;">Total desc/acresc</p>
													</div>

													<div class="col-8" >
														<div style="display: flex; justify-content: end" >
															<span class="badge badge-info bdg-totais" style="width: 110px!important;">({{mtdformatavalordecimal(ptotaldescontoperc, 2)}}%) {{ mtdformatavalordecimal(ptotaldesconto, 2) }}</span>
															<span class="badge badge-primary bdg-totais" style="width: 110px!important; margin-left: 10px; background-color: #007bff">({{mtdformatavalordecimal(ptotalacrescperc, 2)}}%) {{ mtdformatavalordecimal(ptotalacrescimo, 2) }}</span>
														</div>
                                                    </div>
												</div>
											</a>
										</ul>
									</div>
									<div class="col-sm-12 col-md-4 col-lg-4" style="margin-top: 5px;">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total cashback <span class="badge badge-info" style="font-size: 12px;">{{ pqca }}</span>
												<span class="badge badge-info bdg-totais" style="background-color: #74A82A;">{{ mtdformatavalordecimal(ptotalcreditos, 2) }}</span></a>
										</ul>
									</div>
									<div v-if="pvisualizarcustos" class="col-sm-12 col-md-4 col-lg-4" style="margin-top: 5px;">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total custo
												<span class="badge badge-primary bdg-totais" style="background-color: #f82b54;">{{ mtdformatavalordecimal(ptotalcusto, 2) }}</span></a>
										</ul>
									</div>
									
									<!--Luiz Trindade - Margem de lucro geral-->
									<div v-if="pvisualizarcustos" class="col-sm-12 col-md-12 col-lg-6" style="margin-top: 5px;">
										<ul class="list-group">
											<a class="list-group-item lstdettot">Total margem lucro
												<span class="badge badge-info text-right badge-primary bdg-totais" >{{ mtdformatavalordecimal(pmargemlucrogeral, 2) }}%</span></a>
										</ul>
									</div>

									<div v-if="pvisualizarcustos" class="col-sm-12 col-md-12 col-lg-6" style="margin-top: 5px;">
										<ul class="list-group">
											<a class="list-group-item lstdettot">MKP
												<span class="badge badge-info text-right badge-primary bdg-totais" >{{ mtdformatavalordecimal(ptotalmkp, 2) }}%</span></a>
										</ul>
									</div>
							</div>
							</div>														
                        </div>												
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
							<div class="col-12 col-sm-4 col-md-8 col-lg-8" id="dvpaginacao">
							<v-pagination
									v-model="pagina_atual"
									:page-count="pqtd_paginas"
									:classes="bootstrapPaginationClasses">
							</v-pagination>
							</div>
							<div class="col-12 col-sm-4 col-md-2 col-lg-2">
								<div class="dropdown">
									<button type="button" class="btn btn-secondary btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
										<i class="fa fa-navicon"></i> Outras
									</button>
									<div class="dropdown-menu">
										<a class="dropdown-item" href="#" @click.stop @click.prevent="alternadetalheimpressao"><i class="fa fa-print"></i> Imprimir</a>
										<div v-if="mostrarDetalheImpressao" class="dropdown-item" @click.stop>
											<label for="cbdetalhadaitem" class="mb-0">Detalhar impressão:</label>
											<select name="cbdetalhadaitem" class="form-control form-control-sm" id="cbdetalhadaitem" v-model="detalheitem">
												<option value="0">Não</option>
												<option value="1">Sim</option>
											</select>
											<div class="mt-2">
												<button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="confirmarImpressao(detalheitem)"><i class="fa fa-print"></i> Confirmar</button>
											</div>
										</div>
										<a class="dropdown-item" href="#" @click.prevent="mtdimpressao(1)"><i class="fa fa-file-excel-o"></i> Exportar excel</a>
										<a v-if="crotinacortes" class="dropdown-item" href="#" @click.prevent="mtdanalisecortes()"><i class="fa fa-leanpub"></i> Rotina de cortes</a>
										<a v-if="crotinacortes" class="dropdown-item" href="#" @click.prevent="mtditenscortados()"><i class="fa fa-scissors"></i> Gerenciar itens cortados</a>
										<a class="dropdown-item" href="#" @click.prevent="mtdcreditoavulso()"><i class="fa fa-dollar"></i> Crédito avulso</a>        
										<a v-if="vqtdpedidosselecionados > 0" class="dropdown-item" href="#" @click.prevent="mtddimprimeguia()"><i class="fa fa-clone"></i> Imprimir guias de separação</a>                                                                    
										<a v-if="vqtdpedidosselecionados > 1" class="dropdown-item" href="#" @click.prevent="mtdagruparpedidos()"><i class="fa fa-object-group"></i> Agrupar pedidos</a>                                                                    
										<a v-if="vqtdpedidosselecionados > 0" class="dropdown-item" href="#" @click.prevent="mtddimpressaosint()"><i class="fa fa-clone"></i> Impressão sintetizada</a>                                                                    
										<div v-if="mostrarDetalheImpressao" class="dropdown-divider"></div>
									</div>
								</div>                                
							</div>
							<div class="col-12 col-sm-4 col-md-2 col-lg-2">
								<button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
							</div>
                        </div>
                    </div>					
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-3 col-lg-2">
                                <label for="edid">Nr. Pedido:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
							<div class="col-sm-12 col-md-9 col-lg-3">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilial" data-placeholder="Selecione uma filial" v-model="vidfilial" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="cbtipo">Tipo:</label>
								<select class="form-control form-control-sm" id="cbtipo" v-model="vtipo"  v-bind:disabled="ativadesativa || mtdverificaperfilalt()">
									<option value="0">Pedido</option>
									<option value="1">Orçamento</option>
									<option value="2">Ordem de serviço</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-2">
								<label for="eddtemissao">*Dt. Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissao" v-model="vdtemissao" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
							<div class="col-sm-12 col-md-6 col-lg-3">
								<span class="lblselect2">*Vendedor:</span>
								<select id="cbvendedor" data-placeholder="Selecione um vendedor" v-model="vidvendedor" v-bind:disabled="ativadesativavendedor" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edcliente">*Cliente:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="edcliente" v-model="vidcliente" v-bind:disabled="ativadesativa" maxlength="11" v-on:blur="mtdlocalizarcliente(vidcliente)">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarcliente()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-md-5 col-lg-5 col-xl-5">
								<label for="ednomecliente">Nome do cliente:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="ednomecliente" v-model="vnomecliente"
										data-bv-group=".group" maxlength="50" disabled style="font-weight: bold;"/>
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdinformacoescliente(vidcliente, vnomecliente, vvlcreditoclidet)" title="Detalhes do cliente"><i class="fa fa-info-circle" style="padding-top: 3px;"></i></a>
									</div>
									<i v-if="valertarcliente" class="fa fa-exclamation-triangle icone-alerta-cliente" 
										@click.prevent="mtdvisualizaralerta()" title="Clique para visualizar conteúdo do alerta do cliente."></i>										
								</div>	
							</div>							
                            <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">                            
                                <div class="custom-control custom-switch border rounded" style="margin-top: 20px;padding: 5px;">
                                    <input type="checkbox" class="custom-control-input" id="cbentregaexterna" v-model="ventregaexterna" v-bind:disabled="ativadesativa">
                                    <label class="custom-control-label" for="cbentregaexterna" id="lblentregar" style="margin-left: 40px;">Entregar<i class="fa fa-truck" id="icone-entregar"></i></label>
                                </div>
                            </div> 														
							<div class="col-sm-12 col-md-3 col-lg-3 col-xl-3" id="dvplano">
								<button v-if="vidplano === null" type="button" class="btn btn-success btn-block btn-sm btn_selecionar_plano" v-bind:disabled="ativadesativa" @click.prevent="mtdselecionarplano()"><i class="fa fa-pencil-square-o"></i> Selecione o plano</button>
								<button v-else type="button" class="btn btn-success btn-block btn-sm btn_selecionar_plano" v-bind:disabled="ativadesativa" @click.prevent="mtdselecionarplano()"><i class="fa fa-pencil-square-o"></i> {{ mtdformatarzeros(vidplano, 2) }} - {{ vdescplano }}</button>
							</div>
                        </div>
						<div class="row" id="dvnav-tabs" style="margin-top: 15px;">
							<div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link nav-link-ped active" data-toggle="tab" href="#dvprodutos">Produtos</a>
                                    </li>
                                    <li v-show="parseInt(vtipo) > 0" class="nav-item">
                                        <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvservicos">Serviços</a>
                                    </li>									
                                    <li v-show="parseInt(vtipo) === 2 && !mtdverificatiposis(5)" class="nav-item">
                                        <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvinformacoesos">Informações da O.S</a>
                                    </li>
									<li class="nav-item">
                                        <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvobservacoes">Observações</a>
                                    </li>									
								    <li class="nav-item">
                                        <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvimagensped">Imagens</a>
                                    </li>
									<!-- <li v-show="parseInt(vtipo) === 2 && mtdverificatiposis(6)" class="nav-item"> -->
									<li v-show="parseInt(vtipo) === 2 && mtdverificatiposis(5)" class="nav-item"> 
                                        <a class="nav-link nav-link-ped" data-toggle="tab" href="#dvexameotica">Exame ocular</a>
                                    </li>																											
                                </ul>								
								<div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
									<div id="dvprodutos" class="container-fluid tab-pane active">
										<div class="row">
											<div class="col-sm-12 col-md-2 col-lg-2 col-xl-4">
											</div>				
											<div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-4 col-lg-3 col-xl-2" style="margin-bottom: 10px;">
												<button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdadcionaritem()"><i class="fa fa-plus"></i> Adicionar ítem</button>
											</div>											
											<div v-if="parseInt(opcrud) < 3" class="col-sm-12 col-md-4 col-lg-3 col-xl-2" style="margin-bottom: 10px;">
												<button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdaplicardesconto()"><i class="fa fa-percent"></i> Aplicar Desconto <i class="fa fa-dollar"></i></button>
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2" style="padding-bottom: 10px;">                            
												<!-- <div class="custom-control custom-switch border rounded" style="margin-top: -2px;padding: 5px;">
													<input type="checkbox" class="custom-control-input" id="cbmostraestoque" v-model="vmostraestoque" v-bind:disabled="ativadesativa">
													<label class="custom-control-label" for="cbmostraestoque" id="lblmostraestoque" style="margin-left: 40px;">Mostrar estoques</label>
												</div> -->


												<button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdmudamostraestoque()" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-cubes"></i></button>
												Atz/mostrar estoques

												
											</div>
											<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2" style="padding-bottom: 10px;">                            
												<div class="custom-control custom-switch border rounded" style="margin-top: -2px;padding: 5px;">
													<input type="checkbox" class="custom-control-input" id="cbreservar" v-model="vreservar" v-bind:disabled="ativadesativa">
													<label class="custom-control-label" for="cbreservar" id="lblreservar" style="margin-left: 40px;">Reservar itens</label>
												</div>
											</div> 																																								
											<div  class="col-md-12">
												<vue-bootstrap4-table
														:rows="lstitens"
														:columns="columnsi"
														:config="config"
														:classes="classes">														
													<template slot="empty-results">
														<div class="col-md-12 text-center">Sem itens no pedido</div>
													</template>
													<!-- ícones de ordenação da table -->
													<template slot="sort-asc-icon">
														<i class="fa-icones-ordenacao fa fa-sort-asc"></i>
													</template>
													<template slot="sort-desc-icon">
														<i class="fa-icones-ordenacao fa fa-sort-desc"></i>
													</template>
													<template slot="no-sort-icon">
														<i class="fa-icones-ordenacao fa fa-unsorted"></i>
													</template>                                    
													<!--  -->													
													<template slot="opcoesi" slot-scope="item">
														<div style= "display: flex; justify-content: center;" >
															<button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn"   @click.prevent="mtdalteraritem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-edit"></i></button>
															<button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritem(item.row.item)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
															<button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn"   @click.prevent="mtdvisualizarestoque(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-cubes"></i></button>
														</div>
													</template>		
													<template slot="slot_detalhesprodutos" slot-scope="item">
														<i @click.prevent="mtddetalhesprodutos(item.row.idproduto)" class="fa fa-info-circle icon-detalhes" title="Detalhes do produto"></i>
													</template>												
													<template slot="slot_item" slot-scope="item">
														{{ mtdformatarzeros(item.row.item, 3) }}
													</template>													
													<template slot="id_fi" slot-scope="item">
														{{ item.row.coddig }}
													</template>
													<template slot="slot_qtditem" slot-scope="item">
														{{ mtdformatavalordecimal(parseFloat(item.row.qtditem), 4) }}
													</template>
													<template slot="slot_qtdlevar" slot-scope="item">
														<span>{{ mtdformatavalordecimal(parseFloat(item.row.qtditem) - parseFloat(item.row.qtdentregar), 4) }}</span>
														<i v-if="parseFloat(item.row.qtdentregar) !== parseFloat(item.row.qtditem)" @click.prevent="mtdalterarqtdlevar(item.row)" class="fa fa-shopping-basket" style="color: #0acf97; margin-left: 5px; cursor: pointer;" title="Quantidade que o cliente vai levar. Clique para alterar!"></i>
														<i v-else @click.prevent="mtdalterarqtdlevar(item.row)" class="fa fa-shopping-basket text-black-50" style="margin-left: 5px; cursor: pointer;" title="Quantidade que o cliente vai levar. Clique para alterar!"></i>
													</template>													
													<template slot="slot_unditem" slot-scope="item">
														{{ item.row.unditem }}
													</template>
													<template slot="slot_vlunitarioitem" slot-scope="item">
														{{ mtdformatavalordecimal(parseFloat(item.row.vlunitario), 2) }}
													</template>
													<template slot="slot_valordescacres" slot-scope="item">
														<template v-if="parseFloat(item.row.valordescacres) > 0">
															<template v-if="parseInt(item.row.descacres) === 0">
																<template v-if="parseInt(item.row.tipodescacres) === 0">
																	- {{ mtdformatavalordecimal(parseFloat(item.row.valordescacres), 2) }} (%)
																</template>
																<template v-else>
																	- {{ mtdformatavalordecimal(parseFloat(item.row.valordescacres), 2) }} ($)
																</template>	
															</template>														
															<template v-else>
																<template v-if="parseInt(item.row.tipodescacres) === 0">
																	+ {{ mtdformatavalordecimal(parseFloat(item.row.valordescacres), 2) }} (%)
																</template>
																<template v-else>
																	+ {{ mtdformatavalordecimal(parseFloat(item.row.valordescacres), 2) }} ($)
																</template>															
															</template>
														</template>
													</template>
													<template slot="slot_vltotalitem" slot-scope="item">
														<i v-show="parseFloat(item.row.vltotalimposto) > 0" class="fa fa-info-circle text-black-50" v-bind:title="'Imposto do item: R$ '+ mtdformatavalordecimal(parseFloat(item.row.vltotalimposto), 2)" style="font-size: 18px; float: left;"></i>
														<strong style="color: #6c757d;">
															{{ mtdformatavalordecimal(parseFloat(item.row.vltotal), 2) }}
														</strong>
													</template>
													<template slot="estoqueslst" slot-scope="item">
														<div class="dv-lst-precos-produto">
															<ul class="list-group">
																<li v-for="(estoque, indexf) in item.row.estoques" v-bind:key="indexf" class="list-group-item d-flex justify-content-between align-items-center" v-bind:class="indexf%2 == 0 ? 'bkg-smoke' : ''" style="padding: 2px;">
																	<span class="lbltabelalstpro">{{estoque.descricao}}</span>
																	<span class="lbltabelalstpro font-weight-bolder">{{  estoque.qtddisponivel  }}</span>
																</li>
															</ul>                              
														</div> 
													</template>													
												</vue-bootstrap4-table>
											</div>	
																				
											<div v-show="parseInt(vtipo) > 0" class="col-md-12">
												<ul class="list-group">
													<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
														<span style="color: #666666; font-weight: bold;">Itens: <span style="font-weight: normal;">{{mtdformatarzeros(lstitens.length, 3)}}</span></span>
														<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 150px;">{{mtdformatavalordecimal(parseFloat(vtotalprodutos), 2)}}</span>
													</li>
												</ul>
											</div>											
										</div>
									</div>
									<div id="dvservicos" class="container-fluid tab-pane">
										<div v-show="parseInt(opcrud) < 3" class="row">
											<div  class="col-sm-12 col-md-7 col-lg-7">
												<span class="lblselect2">Serviço:</span>
												<select id="cbservico" data-placeholder="Selecione um serviço" v-model="vidservicoedicao" data-allow-clear="true" style="width:100%;">
												</select>
											</div>
											<div class="col-sm-12 col-md-5 col-lg-5">
												<span class="lblselect2">Técnico:</span>
												<select id="cbtecnico" data-placeholder="Selecione um técnico" v-model="vidtecnicoedicao" data-allow-clear="true" style="width:100%;">
												</select>
											</div>
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="edqtdservedicao">Qtd:</label>
												<input type="number" class="form-control form-control-sm" id="edqtdservedicao" v-model="vqtdservicoedicao" v-bind="calculatotalserv" v-bind:disabled="ativadesativa" min="1" maxlength="11"/>
											</div>											
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="cbtipodescontoservicoedicao">Tp. Descto.:</label>
												<select class="form-control form-control-sm" id="cbtipodescontoservicoedicao" v-model="vtipodescontoservicoedicao" v-bind:disabled="ativadesativa" v-bind="calculatotalserv">
													<option value="0">Percentual</option>
													<option value="1" >Valor</option>
												</select>
											</div>											
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="edvalordescontoservicoedicao">{{ vtitdescserv }}</label>
												<money type="text" class="form-control form-control-sm" id="edvalordescontoservicoedicao" v-model="vvalordescontoservicoedicao" v-bind="[calculatotalserv, money]" style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-3 col-lg-2">
												<label for="edvlservicoedicao">Valor Unitário:</label>
												<money type="text" class="form-control form-control-sm" id="edvlservicoedicao" v-model="vvlservicoedicao" v-bind="money" style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-6 col-lg-2">
												<label for="edvltotalservicoedicao">Total:</label>
												<money type="text" class="form-control form-control-sm" id="edvltotalservicoedicao" v-model="vvltotalservicoedicao" v-bind="[calculatotalserv, money]" readonly style="text-align:right;"></money>
											</div>
											<div class="col-sm-12 col-md-6 col-lg-2" style="padding-top: 22px;">
												<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdadicionarservico()" style="width: 100%;"><i class="fa fa-plus"></i> Adicionar</button>
											</div>
										</div>
										<div class="row">
											<div class="col-md-12" style="margin-top: 10px;">
												<vue-bootstrap4-table
														:rows="lstservicos"
														:columns="columnss"
														:config="config"
														:classes="classes">
													<template slot="empty-results">
														<div class="col-md-12 text-center">Sem dados para visualização</div>
													</template>
													<template slot="id_f" slot-scope="item">
														{{ item.row.idservico }}
													</template>
													<template slot="slot_vlunitarioservico" slot-scope="item">
														{{ mtdformatavalordecimal(parseFloat(item.row.vlservico), 2) }}
													</template>
													<template slot="slot_valordescacres" slot-scope="item">
														<template v-if="parseFloat(item.row.valordesconto) > 0">
															<template v-if="parseInt(item.row.tipodesconto) === 0">
																{{ mtdformatavalordecimal(parseFloat(item.row.valordesconto), 2) }} (%)
															</template>
															<template v-else>
																{{ mtdformatavalordecimal(parseFloat(item.row.valordesconto), 2) }} ($)
															</template>																												
														</template>
													</template>
													<template slot="slot_qtditemserv" slot-scope="item">
														{{ item.row.qtdservico }}
													</template>
													<template slot="slot_vltotalservico" slot-scope="item">
														<strong style="color: #6c757d;">{{ mtdformatavalordecimal(parseFloat(item.row.vltotal), 2) }}</strong>
													</template>																																					
													<template slot="opcoes" slot-scope="item">
														<button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluirservico(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
													</template>
												</vue-bootstrap4-table>
											</div>
											<div class="col-md-12">
												<ul class="list-group">
													<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
														<span style="color: #666666; font-weight: bold;">Serviços: <span style="font-weight: normal;">{{mtdformatarzeros(lstservicos.length, 3)}}</span></span>
														<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 150px;">{{mtdformatavalordecimal(parseFloat(vtotalservicos), 2)}}</span>
													</li>
												</ul>
											</div>											
										</div>
									</div>
									<div id="dvinformacoesos" class="container-fluid tab-pane">
										<div class="row">
											<div class="col-12 col-sm-12 col-md-12 col-lg-9">
												<div class="row">
													<!-- <div class="col-sm-12 col-md-3 col-lg-3">
														<label for="edresponsavelos">Responsável:</label>
														<input type="text" class="form-control form-control-sm" id="edresponsavelos" v-model="vresponsavel" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>
													<div class="col-sm-12 col-md-2 col-lg-2">
														<label for="edfone">Fone:</label>
														<input type="text" v-model="vfone" v-bind:disabled="ativadesativa"
															class="form-control form-control-sm" id="edfone" 
															v-mask="['(##) ####-####', '(##) #####-####']">
													</div>											 -->
													<div class="col-sm-12 col-md-5 col-lg-5">
														<label for="edobjetoos">Objeto:</label>
														<input type="text" class="form-control form-control-sm" id="edobjetoos" v-model="vobjeto" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>																						
													<div class="col-sm-12 col-md-3 col-lg-3">
														<label for="edidentificadoros">*Identificador/placa:</label>
														<div class="input-group" style="z-index: 1;">
															<input type="text" class="form-control form-control-sm" id="edidentificadoros" v-model="videntificador" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
															<div class="input-group-append" @click.prevent="contultaplaca()" title="Consultar placa" style="cursor: pointer">
																<span class="input-group-text"><i class="fa fa-gavel"></i></span>
															</div>
														</div>
													</div>											
													<div class="col-sm-12 col-md-3 col-lg-3">
														<label for="edmarcacaoos">*Marcação:</label>
														<input type="text" class="form-control form-control-sm" id="edmarcacaoos" v-model="vmarcacao" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>
													<div class="col-sm-12 col-md-3 col-lg-3">
														<label for="ednrserieos">Número de série:</label>
														<input type="text" class="form-control form-control-sm" id="ednrserieos" v-model="vnrserie" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>
													<div class="col-sm-12 col-md-4 col-lg-4">
														<label for="edmarcaos">*Marca:</label>
														<input type="text" class="form-control form-control-sm" id="edmarcaos" v-model="vmarca" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>
													<div class="col-sm-12 col-md-5 col-lg-5">
														<label for="edmodeloos">*Modelo:</label>
														<input type="text" class="form-control form-control-sm" id="edmodeloos" v-model="vmodelo" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
													</div>
													<div class="col-sm-12 col-md-12 col-lg-12">
														<label for="eddefeitoapresentadoos">Defeito apresentado:</label>
														<input type="text" class="form-control form-control-sm" id="eddefeitoapresentadoos" v-model="vdefeitoapresentado" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="100">
													</div>
													<div class="col-sm-12 col-md-12 col-lg-12">
														<label for="edacessoriosos">Acessórios:</label>
														<input type="text" class="form-control form-control-sm" id="edacessoriosos" v-model="vacessorios" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="100">
													</div>
													<div class="col-sm-12 col-md-8 col-lg-8">
														<label for="edoutrasinformacoesos">Outras informações:</label>
														<input type="text" class="form-control form-control-sm" id="edoutrasinformacoesos" v-model="voutrasinformacoes" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="100">
													</div>				
												</div>
											</div>
											<div class="col-12 col-sm-12 col-md-12 col-lg-3">
												<div class="row">
													<div class="col-md-12" style="margin-top: 15px;">
														<ul class="list-group">
															<li class="list-group-item text-center text-black-50" style="padding: 5px;">
																<span style="font-size: 16px; font-weight: 600;">CHECKLIST</span>
																<i v-show="opcrud < 3" class="fa fa-th-list" id="btmarcartodaschecklist" @click.prevent="mtdmarcartodaschecklist()" data-toggle="tooltip" title="Marcar/Desmarcar todas"></i>
															</li>
															<div style="height: 228px; overflow-y: auto;">
																<li v-for="(checkitem, index) in lstchecklist" @click.prevent="mtdhabilitachecklist(index)" v-bind:key="index" class="list-group-item d-flex justify-content-between align-items-center item-op-usuario" style="padding: 10px 15px 10px 15px;">
																	<span class="menuprincipal">{{ checkitem.descricao }}</span>
																	<span v-if="parseInt(checkitem.habilita) === 0"><i class="fa fa-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
																	<span v-else><i class="fa fa-check-square-o" style="font-size:18px; color: rgba(0,0,0,.65); font-weight: bold; cursor: pointer;"></i></span>
																</li>
															</div>
														</ul>
													</div>
												</div>
											</div>
										</div>
									</div>								
									<div id="dvobservacoes" class="container-fluid tab-pane">
										<div class="row">
											<div v-show="parseInt(opcrud) < 3" class="col-sm-12 col-md-8 col-lg-10">
												<span class="lblselect2">Informação complementar:</span>
												<select id="cbinfcpl" data-placeholder="Selecione uma opção" v-model="vidinfcpl"
														v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
												</select>
											</div>
											<div v-show="parseInt(opcrud) < 3" class="col-md-2">
												<button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdadicionarinfcpl()" style="margin-top: 22px;"><i class="fa fa-plus"></i> Adicionar</button>
											</div>
											<div class="col-sm-12" style="margin-top: 15px;">
												<textarea class="form-control center" rows="5" id="tcfwef" v-model="vobservacoes" v-bind:disabled="ativadesativa" maxlength="5000"></textarea>
											</div>			
										</div>
									</div>
									<div id="dvimagensped" class="container-fluid tab-pane">
										<div class="row" style="padding-left: 15px; padding-right: 15px;">
                                            <div class="col-md-12 border rounded" style="padding-top: 15px;">
                                                <div v-if="lstImagens.length > 0" class="row">
													<div v-for="(imagem, index) in lstImagens" v-bind:key="index" class="col-md-2 text-center" style="margin-bottom: 15px;">                                            
														<button v-if="parseInt(opcrud) < 3" type="button" class="btn btn-danger btn-sm btn-del-imgproduto" @click.prevent="mtdexcluirimgpedido(imagem.patharquivo)"><i class="fa fa-trash"></i></button>
														<img class="img-thumbnail img-produto" v-bind:src="pathimgview+imagem.patharquivo">                                                  
													</div>
                                                </div>
                                                <div v-else class="row">
                                                    <div class="col-md-12 text-center">
                                                        <h6 style="font-size: 12px; padding-bottom: 5px;">Sem imagens para visualização</h6>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="parseInt(opcrud) < 3" class="col-md-12 text-center" style="margin-top: 15px;">
                                                <input
                                                    type="file" 
                                                    id="ipselecionarimg"
                                                    accept="image/png, image/jpeg" 
                                                    @change="mtdselecionarimagem" 
                                                    style="display: none;"
                                                    ref="if_imgpedido">
                                                <button type="button" @click="$refs.if_imgpedido.click()" class="btn btn-primary btn-sm"><i class="fa fa-picture-o"></i> Adicionar imagem</button>
                                            </div>																	
										</div>
									</div>
									<div id="dvexameotica" class="container-fluid tab-pane">

										<div class="row" style="padding-left: 15px; padding-right: 15px;">
											<div class="custom-control custom-switch border rounded" style="margin-top: 20px;padding: 5px;">
												<input type="checkbox" class="custom-control-input" id="cbativainfooculos" v-model="vativainfooculos">
												<label class="custom-control-label" for="cbativainfooculos" id="lbativainfooculos" style="margin-left: 40px;">Informar receita <i class="fa fa-object-group"></i></label>
											</div>	
										</div>

										<div v-show="vativainfooculos" class="row" style="padding-left: 15px; padding-right: 15px; padding-top: 20px;">	
											<div class="container-fluid">
												<ul class="nav nav-tabs" role="tablist">
													<li class="nav-item">
														<a class="nav-link nav-link-ped active" data-toggle="tab" href="#dvperto">Perto</a>
													</li>
													<li v-show="parseInt(vtipo) > 0" class="nav-item">
														<a class="nav-link nav-link-ped" data-toggle="tab" href="#dvlonge">Longe</a>
													</li>															
												</ul>								
												<div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
													<div id="dvperto" class="container-fluid tab-pane active">
														<div class="row">
															<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
																<div class="card border-primary">
																	<div class="card-header card-white">
																		Olho esquerdo
																	</div>
																	<div class="card-body">
																		<div class="container">
																			<div class="row">
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Esférico(esquerdo):</label>
																					<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vesfericoesquerdoperto" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																				</div>
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Cilíndrico(esquerdo):</label>
																					<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vcilindricoesquerdoperto" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																				</div>
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Eixo(esquerdo):</label>
																					<input type="number" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="veixoesquerdoperto" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></input>
																				</div>
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Adição(esquerdo):</label>
																					<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vadicaoesquerdoperto" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
															<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
																<div class="card border-primary">
																	<div class="card-header card-white">
																		Olho direito
																	</div>
																	<div class="card-body">
																		<div class="container">
																			<div class="row">
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Esférico(direito):</label>
																					<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vesfericodireitoperto" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																				</div>
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Cilíndrico(direito):</label>
																					<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vcilindricodireitoperto" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																				</div>
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Eixo(direito):</label>
																					<input type="number" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="veixodireitoperto" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></input>
																				</div>
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Adição(direito):</label>
																					<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vadicaodireitoperto" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
													<div id="dvlonge" class="container-fluid tab-pane">
														<div class="row">
															<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
																<div class="card border-primary">
																	<div class="card-header card-white">
																		Olho esquerdo
																	</div>
																	<div class="card-body ">
																		<div class="container">
																			<div class="row">
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Esférico(esquerdo):</label>
																					<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vesfericoesquerdolonge" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																				</div>
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Cilíndrico(esquerdo):</label>
																					<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vcilindricoesquerdolonge" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																				</div>
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Eixo(esquerdo):</label>
																					<input type="number" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="veixoesquerdolonge" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></input>
																				</div>
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Adição(esquerdo):</label>
																					<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vadicaoesquerdolonge" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
															<div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
																<div class="card border-primary">
																	<div class="card-header card-white">
																		Olho direito
																	</div>
																	<div class="card-body">
																		<div class="container">
																			<div class="row">
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Esférico(direito):</label>
																					<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vesfericodireitolonge" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																				</div>
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Cilíndrico(direito):</label>
																					<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vcilindricodireitolonge" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																				</div>
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Eixo(direito):</label>
																					<input type="number" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="veixodireitolonge" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></input>
																				</div>
																				<div class="col-sm-6" >
																					<label for="edvlunitarioedicao">Adição(direito):</label>
																					<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vadicaodireitolonge" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
																				</div>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="row">
													<div class="col-sm-6" >
														<label for="edvlunitarioedicao">DP total:</label>
														<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vdptotal" v-bind:disabled="ativadesativa" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
													</div>
												</div>
											</div>			
										</div>
									</div>																		
								</div>									
							</div>
							<div class="col-sm-12 col-md-12 col-lg-12 col-xl-12" id="dvmais" style="margin-top: 5px;">
								<div class="row">
									<div class="col-md-3" v-bind:class="lstpedidosexcluiragrupar.length === 0 ? 'col-lg-3 col-xl-3' : 'col-lg-3 col-xl-3'">
										<label for="edresponsavelos">Responsável:</label>
										<input type="text" class="form-control form-control-sm" id="edresponsavelos" v-model="vresponsavel" v-bind:disabled="ativadesativa" data-bv-group=".group" maxlength="20">
									</div>
									<div class="col-md-3" v-bind:class="lstpedidosexcluiragrupar.length === 0 ? 'col-lg-3 col-xl-3' : 'col-lg-2 col-xl-2'">
										<label for="edfone">Fone:</label>
										<input type="text" v-model="vfone" v-bind:disabled="ativadesativa"
											class="form-control form-control-sm" id="edfone" 
											v-mask="['(##) ####-####', '(##) #####-####']">
									</div>
									<div class="col-md-3" v-bind:class="lstpedidosexcluiragrupar.length === 0 ? 'col-lg-3 col-xl-3' : 'col-lg-2 col-xl-2'">
										<label for="eddtretorno">Dt. Retorno:</label>
										<div class="input-group">
											<date-picker id="eddtretorno" v-model="vdtretorno" :config="options"
												class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
											<div class="input-group-append">
												<span class="input-group-text"><i class="fa fa-calendar"></i></span>
											</div>										
										</div>
									</div>
									<div class="col-md-3">
										<span class="lblselect2">St. Operacional:</span>
										<select id="cbstos" data-placeholder="Selecione uma situação" v-model="vidstos" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
										</select>
									</div>																																									
									<div v-if="lstpedidosexcluiragrupar.length > 0" class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2">
										<div class="custom-control custom-switch border rounded" style="margin-top: 20px;padding: 5px;">
											<input type="checkbox" class="custom-control-input" id="cbexcluiragrupados" v-model="vexcluiragrupados">
											<label class="custom-control-label" for="cbexcluiragrupados" id="lblexcluiragrupados" style="margin-left: 40px;">Excluir agrupados <i class="fa fa-object-group"></i></label>
										</div>										
									</div>
								</div>									
							</div>
							<div :class="!mtdverificatiposis(2) ? 'col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3' : 'col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2'" style="margin-top: 15px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Itens</span>
										<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 100px; background-color: #4250f2;">{{ vqtditens }}</span>
									</li>
								</ul>
							</div>
							<div :class="!mtdverificatiposis(2) ? 'col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3' : 'col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2'" style="margin-top: 15px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Quantitativo</span>
										<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 100px; background-color: #4250f2;">{{ vquantitativo }}</span>
									</li>
								</ul>
							</div>
							<div class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2" style="margin-top: 15px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<label v-show="ativaedicaofrete" for="totalfrete">Frete:</label>
										<!-- <span v-show="ativaedicaofrete" class="badge badge-primary badge-pill text-right bdg-qtd-reg-info" style="width: 100px; font-size: 18px"><money type="text" class="form-control form-control-sm" @blur.native="mtdativafrete()" id="totalfrete" v-model="vtotfrete" v-bind="money" data-bv-group=".group" style="text-align: right; background-color: transparent; border: transparent; color: white;"></money></span> -->
										<money v-show="ativaedicaofrete" type="text" class="form-control form-control-sm" @blur.native="mtdativafrete()" id="totalfrete" v-model="vtotfrete" v-bind="money" data-bv-group=".group" style="text-align: right;  "></money>
										<span v-show="!ativaedicaofrete" style="color: #666666; font-weight: bold;">Frete</span>
										<span v-show="!ativaedicaofrete" class="badge badge-primary badge-pill text-right bdg-qtd-reg-info" @click.prevent="mtdativafocusfrete()" style="width: 100px; font-size: 18px">{{mtdformatavalordecimal(parseFloat(vtotfrete), 2)}}</span>
									</li>
								</ul>
							</div>	
							<div v-show="mtdverificatiposis(2)" class="col-12 col-sm-12 col-md-12 col-lg-2 col-xl-2" style="margin-top: 15px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<label v-show="ativaedicaotxservico" for="totaltaxaservico">Tx serviço:</label>
										<!-- <span v-show="ativaedicaofrete" class="badge badge-primary badge-pill text-right bdg-qtd-reg-info" style="width: 100px; font-size: 18px"><money type="text" class="form-control form-control-sm" @blur.native="mtdativafrete()" id="totalfrete" v-model="vtotfrete" v-bind="money" data-bv-group=".group" style="text-align: right; background-color: transparent; border: transparent; color: white;"></money></span> -->
										<money v-show="ativaedicaotxservico" type="text" class="form-control form-control-sm" @blur.native="mtdativatxservico()" id="totaltaxaservico" v-model="vtottaxaservico" v-bind="money" data-bv-group=".group" style="text-align: right;  "></money>
										<span v-show="!ativaedicaotxservico" style="color: #666666; font-weight: bold;">Tx serviço</span>
										<span v-show="!ativaedicaotxservico" class="badge badge-primary badge-pill text-right bdg-qtd-reg-info" @click.prevent="mtdativafocustxservico()" style="width: 100px; font-size: 18px">{{mtdformatavalordecimal(parseFloat(vtottaxaservico), 2)}}</span>
									</li>
								</ul>
							</div>																						
							<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4" style="margin-top: 15px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Total Geral</span>
										<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #5A956A;">{{mtdformatavalordecimal(parseFloat(vtotalgeral), 2)}}</span>
									</li>
								</ul>
							</div>
						</div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-6 col-md-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-3 col-md-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-3 col-md-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
				<div id="pnentregaexterna" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">{{ itensbc.item2.titulo }}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
							<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
								<label for="ednrpedidoentrega">Nr. Pedido:</label>
								<input type="text" class="form-control form-control-sm font-weight-bold" id="ednrpedidoentrega" v-bind:value="pedidoentrega.id"
									data-bv-group=".group" maxlength="50" disabled/>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
								<label for="edfilialentrega">Filial:</label>
								<input type="text" class="form-control form-control-sm" id="edfilialentrega" v-bind:value="pedidoentrega.idfilial + ' - ' + pedidoentrega.fantasia"
									data-bv-group=".group" disabled/>
							</div>							
							<div class="col-sm-12 col-md-4 col-lg-4 col-xl-4">
								<label for="edclienteentrega">Cliente:</label>
								<input type="text" class="form-control form-control-sm" id="edclienteentrega" v-bind:value="pedidoentrega.idcliente + ' - ' + pedidoentrega.nomecliente"
									data-bv-group=".group" disabled/>
							</div>											
							<div class="col-sm-12 col-md-2 col-lg-2 col-xl-2">
								<label for="eddtemissaoentrega">Dt. Emissão:</label>
								<input type="text" class="form-control form-control-sm text-right font-weight-bold" id="eddtemissaoentrega" v-bind:value="pedidoentrega.dtemissao"
									data-bv-group=".group" disabled/>
							</div>
							<div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
								<label for="edvendedorentrega">Vendedor:</label>
								<input type="text" class="form-control form-control-sm" id="edvendedorentrega" v-bind:value="pedidoentrega.idvendedor + ' - ' + pedidoentrega.nomevendedor"
									data-bv-group=".group" disabled/>
							</div>																	
							<div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
								<label for="edplanoentrega">Plano:</label>
								<input type="text" class="form-control form-control-sm" id="edplanoentrega" v-bind:value="pedidoentrega.idplano + ' - ' + pedidoentrega.descplano"
									data-bv-group=".group" disabled/>
							</div>
                            <!-- <div class="col-sm-2 col-md-2">
                            </div> -->
                            <div v-if="lstInfosPPL.idprepostagem" class="col-sm-2 col-md-2">
								<button id="btentregartodos"
										type="button"
										@click.prevent="mtdInfosPrePostagem()"
										class="btn btn-primary btn-sm"
										style="width:100%; margin-top:20px;">
									<i class="fa fa-envelope" aria-hidden="true"></i> Gerar Etiqueta
								</button>
							</div>

							<div v-else class="col-sm-2 col-md-2">
								<button id="btentregartodos"
										type="button"
										@click.prevent="mtdInfosPrePostagem()"
										class="btn btn-primary btn-sm"
										style="width:100%; margin-top:20px;">
									<i class="fa fa-truck" aria-hidden="true"></i> Gerar Pré-Postagem
								</button>
							</div>

							
                            <div class="col-sm-2 col-md-2">
                                <button id="btentregartodos" type="button" @click.prevent="mtdpreparaalterarstatusentrega()"
                                        class="btn btn-primary btn-sm" style="width:100%; margin-top:20px;">
										<i class="fa fa-motorcycle" aria-hidden="true"></i> Status da Entrega
                                </button>
                            </div>							
                            <div class="col-sm-2 col-md-2">
                                <button id="btentregartodos" type="button" @click.prevent="mtdentregartodositens()"
                                        class="btn btn-primary btn-green btn-sm" style="width:100%; margin-top:20px;">
										<i class="fa fa-refresh"></i> Entregar todos
                                </button>
                            </div>							
							<div class="col-md-12" style="margin-top: 15px;">
								<vue-bootstrap4-table
										:rows="pedidoentrega.itens"
										:columns="columnsientrega"
										:config="config"
										:classes="classes">														
									<template slot="empty-results">
										<div class="col-md-12 text-center">Sem itens para visualização</div>
									</template>			
									<template slot="slot_item" slot-scope="item">
										{{ mtdformatarzeros(item.row.item, 3) }}
									</template>													
									<template slot="id_fi" slot-scope="item">
										{{ item.row.coddig }}
									</template>
									<template slot="slot_qtditem" slot-scope="item">
										<span class="font-weight-bold text-black-50">{{ mtdformatavalordecimal(parseFloat(item.row.qtditem), 4) }}</span>
									</template>
									<template slot="slot_qtdlevou" slot-scope="item">
										<span class="font-weight-bold text-black-50">{{ mtdformatavalordecimal(parseFloat(item.row.qtditem) - parseFloat(item.row.qtdentregar), 4) }}</span>
									</template>									
									<template slot="slot_qtdlevar" slot-scope="item">
										<span class="font-weight-bold" style="color: #4250f2;">{{ mtdformatavalordecimal(parseFloat(item.row.qtdentregar), 4) }}</span>
									</template>	
									<template slot="slot_qtdentregue" slot-scope="item">										
										<span class="font-weight-bold" style="color: #0acf97; padding-right: 5px;">{{ mtdformatavalordecimal(parseFloat(item.row.qtdentregue), 4) }}</span>
										<button type="button" class="btn btn-info btn-sm btn-editaitementrega ajt-btn" @click.prevent="mtddefinirqtdentregue(item.row)"><i class="fa fa-edit"></i></button>
									</template>																						
									<template slot="slot_unditem" slot-scope="item">
										{{ item.row.unditem }}
									</template>	
								</vue-bootstrap4-table>
							</div>
							<div class="col-sm-12">
								<label for="txtobservacoesentrega">Observações</label>
								<textarea class="form-control center" rows="3" id="txtobservacoesentrega" v-bind:value="pedidoentrega.observacoes" disabled></textarea>
							</div>																																						
						</div>
					</div>					
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-6 col-md-6">
                            </div>
                            <div class="col-sm-2 col-md-2">
                                <button id="btgravar" type="button" @click.prevent="mtdfinalizarentregaexterna()"
                                        class="btn btn-primary btn-green btn-sm" style="width:100%; margin-bottom:10px;">
										<i class="fa fa-check"></i> Finalizar entrega
                                </button>
                            </div>
                            <div class="col-sm-2 col-md-2">
                                <button type="button" @click.prevent="mtdsalvarentrega()" class="btn btn-info btn-sm" style="width:100%">
                                    <i class="fa fa-edit"></i> Gravar
                                </button>
                            </div>							
                            <div class="col-sm-2 col-md-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>										
				</div>
				<div id="pnconferencia" class="card" style="display: none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelarconf()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <span v-if="!vachouPro" class="badge badge-info badge-pill text-center bdg-alerta" style="width: 100% !important;">{{vmsgPro}}</span>
                        <span v-else class="badge badge-info badge-pill text-center bdg-success" style="width: 100% !important;">{{vmsgPro}}</span>
                        <span v-if="vfinalizado" class="badge badge-info badge-pill text-center bdg-finalizado" style="width: 100% !important;">CONFERÊNCIA FINALIZADA</span>

                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
								<label for="edvicodpro">Produto:</label>
								<div class="input-group mb-3">
									<input type="text" class="form-control form-control-sm" id="edvicodpro" title="F2 pesquisar produto" v-on:keyup.13="submitProd()"
										v-model="vicodpro" placeholder="Pesquisar..." v-bind:disabled="ativadesativacod" autocomplete="off">
								</div>
                            </div>
							<div v-show="mtdinformafator()" class="col-sm-12 col-md-1 col-lg-1">
                                <label for="edqtdfalta">Fat. Qtd.:</label>
                                <input type="number" v-model="vfatorconf" class="form-control form-control-sm" id="edqtdfalta" 
                                       style="text-transform: uppercase; font-weight: bold; text-align: center;">
                            </div>	
                            <div :class="!mtdinformafator() ? 'col-sm-12 col-md-8 col-lg-8' : 'col-sm-12 col-md-7 col-lg-7'">
                                <label for="eddescpro">Descrição do produto:</label>
                                <input type="text" v-model="videscpro" class="form-control form-control-sm" id="eddescpro" disabled
                                    style="text-transform: uppercase; font-weight: bold;">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdfalta">Qtd. Falta:</label>
                                <input type="text" v-model="vqtdfalta" class="form-control form-control-sm" id="edqtdfalta" disabled
                                    style="text-transform: uppercase; font-weight: bold; text-align: center;">
                            </div>							                               
                        </div>
                    </div>

                    <div class="col-md-12" style="margin-top: 10px;">
                        <vue-bootstrap4-table
                            :rows="lstitensconf"
                            :columns="columnsconf"
                            :config="config"
                            :classes="classes">

                            <template slot="empty-results">
                                <div class="col-md-12 text-center">Sem dados para visualização</div>
                            </template>
                            <template slot="status_s" slot-scope="item">
                                <span v-if="item.row.situacao === 1" title="Status"><i class="fa fa-check-square-o" style="color: rgb(90, 149, 106); font-weight: 600; font-size: 18px;"></i></span>
                                <span v-else title="Status" style="color: rgb(248, 43, 84); font-weight: 600; font-size: 18px;"><i class="fa fa-check-circle-o"></i></span>
                            </template>
							<template slot="qtd_c" slot-scope="item">
								
								<span  >{{item.row.qtdconf}}</span>
                                <span style="padding-left: 10px !important;" v-if="mtdisalowedqtdconf()" title="Editar quantidade"><i  @click.prevent="mtdsetarqtditemconf(item.row)" class="fa fa-hand-pointer-o" style="color: rgb(90, 149, 106); font-weight: 600; font-size: 18px; cursor: pointer"></i></span>
            
                            </template>
                        </vue-bootstrap4-table>
                    </div>

                    <div class="col-md-12" style="margin-bottom: 15px;">
                        <ul class="list-group">
                        <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                            Total de itens                            
                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 182px !important;">{{lstitensconf.length}}</span>
                        </li>
                        </ul>
                    </div>

					<div class="card-footer" style="padding: 10px;">
						<div class="row">
							<div class="col-4 col-sm-4 col-md-2 col-lg-2">
								<button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelarconf()"><i class="fa fa-close"></i> Cancelar</button>
							</div>               
							<div class="col-4 col-sm-4 col-md-2 col-lg-2">
								<button type="button" id="btngravar" class="btn btn-success btn-sm btn-block" v-bind:disabled="temItens" @click.prevent="mtdgravarconf()"><i class="fa fa-file"></i> Gravar</button>
							</div>
						</div>
					</div>
				</div>
            </div>
        </div>
		<div class="modal fade" id="mdmenupedido">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(pedidomenu.id, 8) }}</li>
								<!-- <li v-if="$store.state.usuario.id == 1" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdaddformapagto(pedidomenu)"><i class="fa fa-id-card-o" aria-hidden="true"></i> ADD FORMA PAGTO</li> -->
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(pedidomenu)"><i class="fa fa-edit"></i> ALTERAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(pedidomenu)"><i class="fa fa-trash"></i> EXCLUIR</li>
								<li v-if="parseInt(pedidomenu.conferido) === 0" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdconferencia(pedidomenu)" data-dismiss="modal"><i class="fa fa-list-ol"></i> CONFERÊNCIA</li>
								<li v-if="parseInt(pedidomenu.liberarpdv) === 0" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdrotinapdv(pedidomenu.id)"><i class="fa fa-unlock"></i> LIBERAR PDV</li>
								<li v-else class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdrotinapdv(pedidomenu.id)"><i class="fa fa-lock"></i> BLOQUEAR PDV</li>

								<li v-if="(parseInt(pedidomenu.liberarfat) === 0) && (parseFloat(pedidomenu.vlcreditodisponivel) < parseFloat(pedidomenu.totalgeral) && parseInt(pedidomenu.tipoplano) === 1) || (parseInt(pedidomenu.atraso) - parseInt(pedidomenu.qtddiasbloqvenda) > 0)" class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdliberarpedido(pedidomenu.id)"><i class="fa fa-check"></i> LIBERAR FATURAMENTO</li>

								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdfaturarpedido(pedidomenu.id)"><i class="fa fa-money"></i> FATURAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdetiquetasvolumes()" data-dismiss="modal"><i class="fa fa-tags"></i> ETIQUETAS DE VOLUMES</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdcancelarpedido(pedidomenu.id)"><i class="fa fa-close"></i> CANCELAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdclonar(pedidomenu)"><i class="fa fa-clone"></i> CLONAR</li>
								<li v-show="parseInt(pedidomenu.stpedido) === 1" class="list-group-item list-group-item-action font-weight-bold" data-toggle="collapse" data-target="#dvdefnf" style="color: #6c757d;">
									<div class="row">
										<div class="col-md-12">
											<i class="fa fa-qrcode"></i> NOTA FISCAL
										</div>
										<div id="dvdefnf" class="col-md-12 collapse" style="margin-top: 15px;">
											<div class="card" style="margin-left: -15px; margin-right: -15px;">
												<div class="card-body" style="padding: 15px;">
													<div class="row">
														<div v-if="parseInt(pedidomenu.idnotafiscal) === 0" class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-primary btn-block" @click.prevent="mtddefinirfilialemissaonf(pedidomenu, 55)">NF-e</button>
														</div>
														<div v-if="parseInt(pedidomenu.idnotafiscal) === 0" class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-secondary btn-block" @click.prevent="mtddefinirfilialemissaonf(pedidomenu, 65)">NFC-e</button>
														</div>
														<div v-if="parseInt(pedidomenu.idnotafiscal) > 0" class="col-md-12">
															<button type="button" class="btn btn-info btn-block" @click.prevent="mtdimprimirdanfe(pedidomenu)"><i class="fa fa-print"></i> Imprimir DANFE</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</li>							
								<li class="list-group-item list-group-item-action font-weight-bold" data-toggle="collapse" data-target="#dvdefimpressao" style="color: #6c757d;">
									<div class="row">
										<div class="col-md-12">									
											<i class="fa fa-print"></i> IMPRIMIR
										</div>
										<div id="dvdefimpressao" class="col-md-12 collapse" style="margin-top: 15px;">
											<div class="card" style="margin-left: -15px; margin-right: -15px;">
												<div class="card-body" style="padding: 15px;">
													<div class="row">
														<div class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-primary btn-block" @click.prevent="mtdimprimirpedido(pedidomenu.id, 0)"><i class="fa fa-file-text-o"></i> Padrão</button>
														</div>
														<div class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-secondary btn-block" @click.prevent="mtdimprimirpedido(pedidomenu.id, 1)"><i class="fa fa-wpforms"></i> Cupom</button>
														</div>
														<div v-show="parseInt(pedidomenu.stpedido) === 1" class="col-6 col-sm-6 col-md-12" style="margin-top: 10px;">
															<button type="button" class="btn btn-primary btn-block" data-dismiss="modal" @click.prevent="mtdrotinarecibopedido(pedidomenu)"><i class="fa fa-sticky-note-o"></i> Recibo</button>
														</div>	
														<div v-show="parseInt(pedidomenu.stpedido) === 0" class="col-6 col-sm-6 col-md-12" style="margin-top: 10px;">
															<button type="button" class="btn btn-secondary btn-block" @click.prevent="mtdimprimirpedido(pedidomenu.id, 2)"><i class="fa fa-wpforms"></i> Guia de balcão</button>
														</div>													
													</div>
												</div>
											</div>
										</div>
									</div>										
								</li>
								<li class="list-group-item list-group-item-action font-weight-bold" data-toggle="collapse" data-target="#dvdefguiaseparacao" style="color: #6c757d;">
									<div class="row">
										<div class="col-md-12">
											<i class="fa fa-print"></i> GUIA SEPARAÇÃO
										</div>
										<div id="dvdefguiaseparacao" class="col-md-12 collapse" style="margin-top: 15px;">
											<div class="card" style="margin-left: -15px; margin-right: -15px;">
												<div class="card-body" style="padding: 15px;">
													<div class="row">
														<div class="col-6 col-sm-6 col-md-12 mb-3">
															<label for="cbordemitens">Ordem itens:</label>
															<select class="form-control form-control-sm" id="cbordemitens" v-model="vordemitens"
																	title="Ordem dos itens na impressão do pedido"
																	@click.stop>
																<option value="0">Item</option>
																<option value="1">Código</option>
																<option value="2">Descrição</option>
																<option value="3">Localização</option>
																<option value="4">Referência</option>
																<option value="5">Estoque</option>
															</select>
														</div>
														<div class="col-6 col-sm-6 col-md-12 mb-3">
															<label for="cbdestacacupom">Destacar itens (cupom):</label>
															<select class="form-control form-control-sm" id="cbdestacacupom" v-model="vdestacacupom"
																	title="Destacar os itens"
																	@click.stop>
																<option value="0">Não</option>
																<option value="1">Sim</option>
															</select>
														</div>
														<div class="col-6 col-sm-6 col-md-12 mb-3">
															<label for="cbocaoitemguia">Itens:</label>
															<select class="form-control form-control-sm" id="cbocaoitemguia" v-model="vocaoitemguia"
																	title="Destacar os itens"
																	@click.stop>
																<option value="0">Não conferidos</option>
																<option value="1">Conferidos</option>
																<option value="2">Todos</option>
															</select>
														</div>
													</div>
													<div class="row">
														<div class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-primary btn-block" @click.prevent="mtdimprimirguiaseparacao(pedidomenu.id, 0)">
																<i class="fa fa-file-text-o"></i> Padrão
															</button>
														</div>
														<div class="col-6 col-sm-6 col-md-6">
															<button type="button" class="btn btn-secondary btn-block" @click.prevent="mtdimprimirguiaseparacao(pedidomenu.id, 1)">
																<i class="fa fa-wpforms"></i> Cupom
															</button>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdvisualizarimagens(pedidomenu)" data-dismiss="modal"><i class="fa fa-picture-o"></i> IMAGENS</li>								
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtddevolucao(pedidomenu)" data-dismiss="modal"><i class="fa fa-undo"></i> DEVOLUÇÃO</li>																
								<div id="dventregaexternamenu">
									<li v-show="parseInt(pedidomenu.stpedido) === 1 && parseInt(pedidomenu.entregaexterna) === 1" class="list-group-item list-group-item-action font-weight-bold" data-toggle="collapse" data-target="#dvdefentrega" style="color: #6c757d;">
										<div class="row">
											<div class="col-md-12">									
												<i class="fa fa-truck"></i> ENTREGA EXTERNA
											</div>
										</div>																																		
									</li>
									<div id="dvdefentrega" class="col-md-12 collapse" style="margin-top: 15px;">
										<div class="card" style="margin-left: -15px; margin-right: -15px;">
											<div class="card-body" style="padding: 15px;">
												<div class="row">
													<div class="col-12 col-sm-12 col-md-12">
														<button type="button" class="btn btn-primary btm-sm btn-block" @click.prevent="mtdentregaexterna(pedidomenu)" data-dismiss="modal"><i class="fa fa-edit"></i> Gerenciar</button>
													</div>
													<div class="col-12 col-sm-12 col-md-12" style="margin-top: 15px;">
														<div class="row">
															<div class="card" style="margin-left: 15px; margin-right: 15px;">
																<div class="card-header text-center font-weight-bold" style="padding: 5px;">IMPRESSÃO</div>
																<div class="card-body" style="padding: 15px;">
																	<div class="row">
																		<div class="col-md-12">
																			<input type="radio" id="one" value="0" v-model="eopimpentrega">
																			<label for="one" style="margin-left: 5px;">Itens pendentes</label>																	
																		</div>
																		<div class="col-md-12" style="margin-top: 15px; margin-bottom: 15px;">
																			<input type="radio" id="two" value="1" v-model="eopimpentrega">
																			<label for="two" style="margin-left: 5px;">Todos os itens</label>																	
																		</div>
																		<div class="col-6 col-sm-6 col-md-6">
																			<button type="button" class="btn btn-primary btn-block" @click.prevent="mtdimprimirentrega(pedidomenu.id, 0, eopimpentrega)" data-dismiss="modal"><i class="fa fa-file-text-o"></i> Padrão</button>
																		</div>
																		<div class="col-6 col-sm-6 col-md-6">
																			<button type="button" class="btn btn-secondary btn-block" @click.prevent="mtdimprimirentrega(pedidomenu.id, 1, eopimpentrega)" data-dismiss="modal"><i class="fa fa-wpforms"></i> Cupom</button>
																		</div>																																					
																	</div>
																</div>
															</div>		
														</div>															
													</div>
												</div>
											</div>
										</div>
									</div>								
								</div>
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>		
		<!-- Modal de edição do ítem do pedido -->
		<div class="modal fade" id="mdedicaoitem" tabindex="-1">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">     
					<div class="modal-header">
						<h4 v-if="parseInt(vopitem) === 1" class="modal-title"><i class="fa fa-edit"></i> Edição do ítem(Inclusão)</h4>
						<h4 v-else class="modal-title"><i class="fa fa-edit"></i> Edição do ítem(Alteração) - {{ mtdformatarzeros(vitemalteracao, 3) }}</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">
							<!-- CP PRODUTO EDIÇÃO -->
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edidprodutoedicao">*Produto:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="edidprodutoedicao" v-bind:disabled="parseInt(vopitem) === 2" v-model="vcoddigedicao" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddigedicao)" v-on:keyup.13="mtdlocalizarproduto(vcoddigedicao)" style="text-transform: uppercase;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
									</div>
								</div>
							</div>
							<div class="col-sm-12 col-md-8 col-lg-7">
								<label for="eddescricaoprodutoedicao">Descrição do produto:</label>
								<div class="input-group" style="z-index: 1;">
									<input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="vdescricaoprodutoedicao" maxlength="100" style="font-weight: bold;" v-bind:disabled="vedicaodescpro" v-on:blur="mtddesabilitaedicaodescpro()">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdhabilitaedicaodescpro()" title="Alterar descrição"><i class="fa fa-edit" style="padding-top: 3px;"></i></a>
									</div>
								</div>									
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="edundprodutoedicao">Und:</label>
								<input type="text" class="form-control form-control-sm" id="edundprodutoedicao" v-model="vundprodutoedicao" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="edqtditemedicao">*Quantidade:</label>
								<div class="input-group" style="z-index: 1;">
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdquantidade(2)"><i class="fa fa-minus"></i></a>
									</div>									
									<money type="text" class="form-control form-control-sm" id="edqtditemedicao" v-on:blur="mtdverificadescontoquantidade()" v-on:input="mtdverificadescontoquantidade()" v-model="vqtditemedicao" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
									<div class="input-group-append">
										<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdquantidade(1)"><i class="fa fa-plus"></i></a>
									</div>									
								</div>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-3">
								<label for="cbmanipulavaledicao">Manipular valor:</label>
								<select class="form-control form-control-sm" id="cbmanipulavaledicao" v-model="vmanipulavaledicao" v-bind:disabled="pmanipularvaloritem">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>							
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="cbdescacresedicao">Atribuir:</label>
								<select class="form-control form-control-sm" id="cbdescacresedicao" v-model="vdescacresedicao" v-bind="calculatotalitem" v-bind:disabled="manipulaval ? false : true">
									<option value="0">Desconto</option>
									<option value="1">Acréscimo</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">
								<label for="cbtipodescacresedicao">Tipo:</label>
								<select class="form-control form-control-sm" id="cbtipodescacresedicao" v-model="vtipodescacresedicao" v-bind="calculatotalitem" v-bind:disabled="manipulaval ? false : true">
									<option value="0">Percentual</option>
									<option value="1">Valor</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-2">								
								<label for="edvaldescacresedicao">{{ vtitdesc }}</label>
								<div class="input-group" style="z-index: 1;">
									<money type="text" class="form-control form-control-sm" id="edvaldescacresedicao" v-model="vvalordescacresedicao" v-bind="[calculatotalitem, money]" v-bind:disabled="manipulaval ? false : true" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
									<div class="input-group-append" style="height: 31px;">
										<span v-if="parseInt(vtipodescacresedicao) === 0" class="input-group-text font-weight-bold">%</span>	
										<span v-else class="input-group-text font-weight-bold">$</span>	
									</div>									
								</div>
							</div>
							<div class="col-sm-12" v-bind:class="parseFloat(vvltotalimpostoitemedicao) <= 0 ? 'col-md-4 col-lg-3' : 'col-md-3 col-lg-2'">
								<label for="edvlunitarioedicao">*Valor Unitário:</label>
								<money type="text" class="form-control form-control-sm" id="edvlunitarioedicao" v-model="vvlunitarioedicao" v-bind:disabled="manipulaval" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>
							<div v-show="parseFloat(vvltotalimpostoitemedicao) > 0" class="col-sm-12 col-md-3 col-lg-2">
								<label for="edimpostoitemedicao">Imposto(R$):</label>
								<input type="text" class="form-control form-control-sm text-right text-warning" id="edimpostoitemedicao" v-bind:value="mtdformatavalordecimal(parseFloat(vvltotalimpostoitemedicao), 2)" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>								
							</div>							
							<div class="col-sm-12" v-bind:class="parseFloat(vvltotalimpostoitemedicao) <= 0 ? 'col-md-4 col-lg-3' : 'col-md-3 col-lg-2'">
								<label for="edvltotaledicao">Total:</label>
								<money type="text" class="form-control form-control-sm" id="edvltotaledicao" v-model="vvltotaledicao" v-bind="[calculatotalitem, money]" readonly style="font-weight: bold; text-align:right;"></money>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-3">
								<span class="lblselect2">*Estoque:</span>
								<select id="cbestoqueedicao" data-placeholder="Selecione um estoque" v-model="videstoqueedicao" v-bind:disabled="pdefinirestoque" data-allow-clear="true" style="width:100%;">
								</select>
							</div>																																																		
							<div class="col-sm-12 col-md-2 col-lg-3">
								<span class="lblselect2">Solicitante:</span>
								<select id="cbtecnicosolicitaedicao" data-placeholder="Selecione o técnico/solicitante" v-model="vidtecnicosolicitaedicao" v-bind:disabled="pdefinirestoque" data-allow-clear="true" style="width:100%;">
								</select>
							</div>																
						</div>
						<div class="row">
							<div class="col-sm-12">
								<label for="txtinfadprod">Informações adicionais do item:</label>
								<textarea class="form-control center" rows="3" id="txtinfadprod" v-model="vinfadprod" maxlength="500"></textarea>
							</div>
							<div class="col-md-12 text-right">
								<span class="text-black-50" style="font-size: 12px; font-weight: 600;">{{ vinfadprod.length }} caracteres de 500</span>
							</div>						
						</div>
					</div>        
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdgravaritem()" id="btnsalvaritem"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
		<!-- Modal para faturamento do pedido -->
		<div class="modal fade" id="mdfaturarpedido">
			<div class="modal-dialog modal-lg modal-dialog-centered">
			<div class="modal-content">      
				<div class="modal-header">
					<h4 class="modal-title"><i class="fa fa-money"></i> Faturar pedido</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12 col-md-4 col-lg-2">
							<label>Nr. Pedido:</label>
							<input type="text" class="form-control form-control-sm" v-bind:value="mtdformatarzeros(pedidofaturar.id, 8)" disabled style="font-weight: bold; text-align: center;">
						</div>						
						<div class="col-sm-12 col-md-8 col-lg-4">
							<label>Cliente:</label>
							<input type="text" class="form-control form-control-sm" v-model="pedidofaturar.nomecliente" disabled style="font-weight: bold;">
						</div>
						<div class="col-sm-12 col-md-6 col-lg-3">
							<label for="edvlfaturar">Valor à faturar:</label>
							<money type="text" class="form-control form-control-sm" id="edvlfaturar" v-model="pedidofaturar.totalgeral" disabled v-bind="money" data-bv-group=".group" style="color: #5A956A; font-weight: bold; text-align:right;"></money>
						</div>						
						<div class="col-sm-12 col-md-6 col-lg-3">
							<label for="edvlcreditodisponivelcli">Créd. Disponível:</label>
							<money type="text" class="form-control form-control-sm" id="edvlcreditodisponivelcli" v-model="pedidofaturar.vlcreditodisponivel" disabled v-bind="money" data-bv-group=".group" style="color: #727cf5; font-weight: bold; text-align:right;"></money>
						</div>						
						<div class="col-sm-12 col-md-6 col-lg-3">
							<label for="eddtemissao">Dt. Fatura:</label>
							<div class="input-group">
								<date-picker id="eddtfatura" v-model="vdtfatura" :config="options" class="form-control form-control-sm" v-bind:disabled="palterardatafatura"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>										
							</div>
						</div>												
						<div  class="col-sm-12 col-md-4 col-lg-3">
							<span class="lblselect2">Forma de pagamento:</span>
							<select id="cbformapagamento" data-placeholder="Selecione uma forma" v-model="vidformapagamento" data-allow-clear="true" style="width:100%;">
							</select>
						</div>
						<div class="col-sm-12 col-md-4 col-lg-3">
							<label for="edvlforma">Valor:</label>
							<money type="text" class="form-control form-control-sm" id="edvlforma" v-model="vvlforma" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
						</div>
						<div class="col-sm-12 col-md-2 col-lg-2">
							<label for="ednrvendaforma">Nr. Venda:</label>
							<input type="text" class="form-control form-control-sm" id="ednrvendaforma" v-model="vnrvendaforma" maxlength="11" style="font-weight: bold;" v-mask="'###########'" v-bind:disabled="parseInt(vabatecredito) === 0">									
						</div>
						<div class="col-sm-12 col-md-12 col-lg-1">
							<button type="button" class="btn btn-primary btn-sm btn-block" style="margin-top: 20px;" @click.prevent="mtdincluirforma()"><i class="fa fa-plus"></i></button>
						</div>																														
					</div>
					<div class="row">
						<div class="col-lg-12">
							<div class="table-responsive">
								<table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
									<thead class="thead-light">
									<tr>
										<th width="35px" style="text-align: center;"></th>
										<th width="300">Forma de pagamento:</th>
										<th width="100">Valor:</th>										
										<th width="100">Perfil fluxo:</th>
									</tr>
									</thead>
									<tbody>
										<tr v-for="(forma, index) in lstformasfaturar" v-bind:key="index">
											<td width="35px" class="center" style="text-align: center;">
												<a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
												v-bind:disabled="ativadesativa"
												@click.prevent="mtddeletarforma(index)"><i class="fa fa-trash"></i></a>
											</td>												
											<td width="300px">{{ forma.descforma }}</td>
											<td width="100px" style="text-align: right;">
												<strong>{{ mtdformatavalordecimal(forma.vlforma, 2) }}</strong>
											</td>
											<td><i class="fa fa-edit icon-editar-perfil" title="Alterar perfil do fluxo" @click.prevent="mtdalterarperfilfluxo(forma, index)"></i>{{ forma.descperfilfluxo }}</td>                                                       
										</tr>
									</tbody>
								</table>
							</div>
							<div class="col-md-12" style="padding-left: 0px; padding-right: 0px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Soma das formas</span>
										<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #0acf97;">{{mtdformatavalordecimal(parseFloat(vtotalformas), 2)}}</span>
									</li>
								</ul>
							</div>							
							<div v-show="vdiferenca > 0" class="col-md-12" style="padding-left: 0px; padding-right: 0px;margin-top: 10px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Diferença</span>
										<span class="badge badge-danger badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #f82b54;">{{mtdformatavalordecimal(parseFloat(vdiferenca), 2)}}</span>
									</li>
								</ul>
							</div>														
						</div>

						<div v-show="lsttitulosfaturar.length > 0" class="col-lg-12">
							<div class="table-responsive">
								<table class="table table-bordered table-sm table-hover" style="margin-top: 10px">
									<thead class="thead-light">
									<tr>
										<th width="35px" style="text-align: center;"></th>
										<th width="80">Nr. título:</th>
										<th width="80">Vencimento:</th>
										<th width="100">Tipo de cobrança:</th>
										<th width="80">Valor:</th>															
									</tr>
									</thead>
									<tbody>
										<tr v-for="(titulo, index) in lsttitulosfaturar" v-bind:key="index">
											<td width="35px" class="center" style="text-align: center;">
												<a class="btn btn-primary btn-sm btn-opcrud ajt-btn" href="#"
												v-bind:disabled="ativadesativa"
												@click.prevent="mtdalterartitulo(titulo, index)"><i class="fa fa-edit"></i></a>
											</td>												
											<td width="80px">{{ titulo.codtit }}</td>
											<td width="80px">{{ titulo.dtventit }}</td>
											<td width="100px">{{ titulo.descricaocob }}</td>
											<td width="80px" style="text-align: right;">
												<strong>{{ mtdformatavalordecimal(titulo.vltit, 2) }}</strong>
											</td>                                                       												
										</tr>
									</tbody>
								</table>
							</div>
							<div class="col-md-12" style="padding-left: 0px; padding-right: 0px;">
								<ul class="list-group">
									<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
										<span style="color: #666666; font-weight: bold;">Soma do títulos</span>
										<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 165px; background-color: #727cf5;">{{mtdformatavalordecimal(parseFloat(vtotaltitulos), 2)}}</span>
									</li>
								</ul>
							</div>							
						</div>						                                   
					</div>						
				</div>       
				<div class="modal-footer">
					<div class="container-fluid" style="padding: 0px;">
						<div class="row">
							<div class="col-md-8 text-center">
								<div class="alert alert-success alerta-cashback" v-show="parseFloat(vltotalcashback) > 0">
									<strong>CASHBACK R$ {{ mtdformatavalordecimal(vltotalcashback, 2) }}!</strong> Disponível {{ pedidofaturar.fatorcreditoutilizar }}% p/ esta venda: R$ {{  mtdformatavalordecimal(vlcashbackdisponivelvenda, 2)  }}.
								</div>
							</div>
							<div class="col-md-2">
								<button type="button" style="margin-top: 10px;" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdconfirmarfatura()"><i class="fa fa-check"></i> Confirmar</button>
							</div>
							<div class="col-md-2">
								<button type="button" style="margin-top: 10px;" class="btn btn-secondary btn-sm btn-block" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>
					</div>	
				</div>        
			</div>
			</div>
		</div>
		<!-- Modal para seleção do plano de pagamento -->
		<div class="modal fade" id="mdselecionarplano">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="list-group">								
								<a v-for="(plano, index) in lstplanos" href="#" v-bind:class="parseInt(plano.id) === parseInt(vidplano) ? 'active': ''" v-bind:key="index" class="list-group-item list-group-item-action font-weight-bold" @click.prevent="mtddefineplano(plano)">{{ mtdformatarzeros(plano.id, 2) }} - {{ plano.descricao }}</a>
							</div>							
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>
		<!-- Modal para alteração da parcela -->
		<div class="modal fade" id="mdalterartitulo">
			<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title"><i class="fa fa-edit"></i> Alteração do título</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				 
				<div class="modal-body">
					<div class="row">
						<div class="col-md-4">
							<label>Nr. título:</label>
							<input type="text" class="form-control form-control-sm" v-model="tacodtit" disabled style="font-weight: bold;">
						</div>
						<div class="col-sm-12 col-md-4 col-lg-4">
							<label for="eddtventit">Dt. Vencimento:</label>
							<div class="input-group">
								<date-picker id="eddtventit" v-model="tadtventit" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>										
							</div>
						</div>
						<div class="col-sm-12 col-md-4 col-lg-4">
							<label for="edvltit">Valor:</label>
							<money type="text" class="form-control form-control-sm" id="edvltit" v-model="tavltit" v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
						</div>
						<div  class="col-sm-12 col-md-12 col-lg-12">
							<span class="lblselect2">Tipo de cobrança:</span>
							<select id="cbtipocobranca" data-placeholder="Selecione um tipo de cobrança" v-model="taidtipocobranca" data-allow-clear="true" style="width:100%;">
							</select>
						</div>
						<div v-show="parseInt(tatipocobranca) === 1" class="col-sm-12 col-md-12 col-lg-12" style="padding-top: 15px;">
							<div class="card">
								<div class="card-header card-in text-center" style="padding: 5px;">DADOS DO CHEQUE</div>
								<div class="card-body" style="padding: 10px;">
									<div class="row">
										<div class="col-md-4">
											<label>Nr. Cheque:</label>
											<input type="text" id="ednumerocheque" class="form-control form-control-sm" v-model="tanumerocheque">
										</div>
										<div  class="col-sm-12 col-md-8 col-lg-8">
											<span class="lblselect2">Banco:</span>
											<select id="cbbanco" data-placeholder="Selecione um banco" v-model="taidbanco" data-allow-clear="true" style="width:100%;">
											</select>
										</div>
										<div class="col-md-4">
											<label>Agência:</label>
											<input type="text" id="edagencia" class="form-control form-control-sm" v-model="taagencia">
										</div>
										<div class="col-md-4">
											<label>Conta:</label>
											<input type="text" id="edconta" class="form-control form-control-sm" v-model="taconta">
										</div>
										<div class="col-md-4">
											<label>Praça:</label>
											<input type="text" id="edpraca" class="form-control form-control-sm" v-model="tapraca">
										</div>
										<div class="col-md-12">
											<label>Emitente:</label>
											<input type="text" id="edemitente" class="form-control form-control-sm" v-model="taemitente">
										</div>
										<div class="col-md-5">
											<label for="edfone1">CNPJ/CPF:</label>
											<input type="text" v-model="tacnpjcpf"
												class="form-control form-control-sm" id="edcnpjcpf" 
												v-mask="['###.###.###-##', '##.###.###/####-##']">
										</div>
										<div  class="col-md-7">
											<span class="lblselect2">Situação do cheque:</span>
											<select id="cbsituacaocheque" data-placeholder="Selecione uma situação" v-model="taidsituacaocheque" data-allow-clear="true" style="width:100%;">
											</select>
										</div>																																																	
									</div>
								</div>
							</div>
						</div>																														
					</div>
					<div class="row" v-show="parseInt(tindiceparcela) === 0">
						<div class="col-sm-12 col-md-12 col-lg-12">
							<div class="custom-control custom-switch" style="margin-top: 10px;">
								<input type="checkbox" class="custom-control-input" id="cbajustardias" v-model="tajustardatas">
								<label class="custom-control-label" for="cbajustardias" id="lblajustardias" title="Ajusta o mesmo dia as demais datas">Ajustar mesmo dia nas demais parcelas</label>
							</div>
						</div>					
						<div class="col-sm-12 col-md-12 col-lg-12">
							<div class="custom-control custom-switch" style="margin-top: 10px;">
								<input type="checkbox" class="custom-control-input" id="cbajustarparcelas" v-model="tajustarparcelas">
								<label class="custom-control-label" for="cbajustarparcelas" id="lblajustarparcelas" title="Ajusta o valor das demais parcelas">Ajustar valor das demais parcelas</label>
							</div>
						</div>				
						<div class="col-sm-12 col-md-12 col-lg-12">
							<div class="custom-control custom-switch" style="margin-top: 10px;">
								<input type="checkbox" class="custom-control-input" id="cbajustarcentavos" v-model="tajustarcentavos">
								<label class="custom-control-label" for="cbajustarcentavos" id="lblajustarcentavos" title="Lança os centavos para a última parcela">Centavos na última parcela</label>
							</div>
						</div>
					</div>					
				</div>        
				<div class="modal-footer" style="padding: 5px;">
					<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtconfirmaralteracaotitulo()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
				</div>        
			</div>
			</div>
		</div>
		<!-- Modal para cancelamento do pedido -->
		<div class="modal fade" id="mdcancelarpedido">
			<div class="modal-dialog modal-lg modal-dialog-centered">
			<div class="modal-content">      
				<div class="modal-header">
					<h4 class="modal-title"><i class="fa fa-close"></i> Cancelamento</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-12 col-sm-12 col-md-4 col-lg-2 col-xl-2">
							<label>Nr. Docto.:</label>
							<input type="text" class="form-control form-control-sm" v-bind:value="mtdformatarzeros(pedidocancelar.id, 8)" disabled style="font-weight: bold; text-align: center;">
						</div>						
						<div class="col-12 col-sm-12 col-md-8 col-lg-4 col-xl-4">
							<label>Cliente:</label>
							<input type="text" class="form-control form-control-sm" v-model="pedidocancelar.nomecliente" disabled style="font-weight: bold;">
						</div>
						<div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
							<label for="edvlcancelar">Valor:</label>
							<money v-if="parseInt(pedidocancelar.tipo) !== 3" type="text" class="form-control form-control-sm" id="edvlcancelar" v-model="pedidocancelar.totalgeral" disabled v-bind="money" data-bv-group=".group" style="color: #5A956A; font-weight: bold; text-align:right;"></money>
							<money v-else type="text" class="form-control form-control-sm" id="edvlcancelar" v-bind:value="parseFloat(pedidocancelar.vlcredito) - parseFloat(pedidocancelar.vlcreditoutilizado)" disabled v-bind="money" data-bv-group=".group" style="color: #5A956A; font-weight: bold; text-align:right;"></money>
						</div>						
						<div class="col-sm-12 col-md-6 col-lg-3 col-xl-3">
							<label for="eddtcancelamento">Dt. Cancelamento:</label>
							<div class="input-group">
								<date-picker id="eddtcancelamento" v-model="cdtcancelamento" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>										
							</div>
						</div>
						<div class="col-sm-12">
							<label for="txtmotivocancelamento">Motivo do cancelamento:</label>
							<textarea class="form-control center" rows="3" id="txtmotivocancelamento" v-model="cmotivocancelamento"></textarea>
						</div>
					</div>						
				</div>       
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmarcancelamento()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
				</div>        
			</div>
			</div>
		</div>
		<!-- Modal para aplicação do desconto nos itens -->
		<div class="modal fade" id="mdaplicardesconto">
			<div class="modal-dialog modal-sm modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Aplicar desconto</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>
					<div class="modal-body">
						<div class="row">							
							<div class="col-md-12">
								<label for="edtotalitenssemdesconto">Total dos itens SEM desconto:</label>
								<money type="text" class="form-control form-control-sm" id="edtotalitenssemdesconto" v-model="vtotalsemdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 20px;" disabled></money>
							</div>							
							<div class="col-md-12">
								<label for="cbtipodesctotal">Tipo:</label>
								<select class="form-control form-control-sm" id="cbtipodesctotal" v-model="vtipodesctotal" style="font-size: 18px; font-weight: bold;">
									<option value="0">Percentual</option>
									<option value="1">Valor</option>
								</select>
							</div>
							<div class="col-md-12">
								<label v-if="parseInt(vtipodesctotal) === 0" for="edfatordescontototal">Percentual do desconto</label>
								<label v-else for="edfatordescontototal">Valor do desconto</label>
								<money type="text" class="form-control form-control-sm" id="edfatordescontototal" v-model="vfatordescontototal" v-bind="[calculadescontototalitens, money]" data-bv-group=".group" maxlength="20" style="text-align:right; font-size: 18px; font-weight: bold;"></money>
							</div>
							<div class="col-md-12">
								<label v-if="parseInt(vtipodesctotal) === 0" for="edfatordescontototal">Desconto(R$)</label>
								<label v-else for="edfatordescontototal">Desconto(%)</label>
								<money type="text" class="form-control form-control-sm" id="edfatordescontototal" v-model="vresdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-size: 18px; font-weight: bold;" disabled></money>
							</div>														
							<div class="col-md-12">
								<label for="edtotalitenscomdesconto">Total dos itens COM desconto:</label>
								<money type="text" class="form-control form-control-sm" id="edtotalitenscomdesconto" v-model="vtotalcomdesconto" v-bind="money" data-bv-group=".group" maxlength="20" style="font-weight: bold; text-align: right; font-size: 20px;" disabled></money>
							</div>							
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" id="btnconfirmadesconto" @click.prevent="mtdconfirmaaplicacaodesconto()"><i class="fa fa-check"></i> Aplicar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
					</div>        
				</div>
			</div>
		</div>
        <!-- Modal para alteração da quantidade que o cliente vai levar -->
        <div class="modal fade" id="mdalteracaoqtdlevar">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h4 class="modal-title"><i class="fa fa-shopping-basket"></i> Definir à levar - {{mtdformatarzeros(litemlevar.item, 3)}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <div class="alert alert-primary" role="alert">
                                    <span style="color: #666666; font-weight: 600;">{{litemlevar.idproduto}} - {{litemlevar.descproduto}}</span>
                                </div>                                                                
                            </div>                            
                            <div class="col-md-12">
								<label for="edqtdlevar">Levar:</label>
								<money type="text" class="form-control form-control-sm" id="edqtdlevar" v-model="lqtdlevar" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmaraltercaoqtdlevar()"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-sign-out"></i> Cancelar</button>
                    </div>                    
                </div>
            </div>
        </div>
        <!-- Modal para definição da quantidade entregue -->
        <div class="modal fade" id="mddefinirqtdentregue">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h6 class="modal-title" style="font-size: 18px;"><i class="fa fa-truck"></i> Quantidade entregue - {{mtdformatarzeros(eitementregar.item, 3)}}</h6>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 text-center">
                                <div class="alert alert-primary" role="alert">
                                    <span style="color: #666666; font-weight: 600;">{{eitementregar.idproduto}} - {{eitementregar.descproduto}}</span>
                                </div>                                                                
                            </div>                            
                            <div class="col-md-12">
								<label for="edqtdlevarentrega">Entregue:</label>
								<money type="text" class="form-control form-control-sm" id="edqtdlevarentrega" v-model="eqtdentregue" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmaraltercaoqtdentregue()"><i class="fa fa-check"></i> Confirmar</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-sign-out"></i> Cancelar</button>
                    </div>                    
                </div>
            </div>
        </div>
        <!-- Modal para visualização do credito da venda -->
        <div class="modal fade" id="mddetalhescredito" tabindex="-1">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">                
                    <div class="modal-header">
                        <h6 class="modal-title" style="font-size: 14px;"><i class="fa fa-dollar"></i> Crédito/Cashback: {{mtdformatarzeros(detcredito.idpedido, 8)}}</h6>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body" style="padding-bottom: 0px;">
                        <div class="row">
							<div class="col-md-12">
								<ul class="list-group" style="padding-bottom: 10px;">
									<li class="list-group-item d-flex justify-content-between align-items-center item-lst-cred">
										<span style="font-weight: 500;" class="font-weight-bold">Valor do crédito</span>
										<span class="badge badge-primary badge-pill">{{ mtdformatavalordecimal(detcredito.vlcredito, 2) }}</span>
									</li>
									<li class="list-group-item d-flex justify-content-between align-items-center item-lst-cred">
										<span style="font-weight: 500;" class="font-weight-bold">Valor utilizado</span>
										<span class="badge badge-primary badge-pill">{{ mtdformatavalordecimal(detcredito.vlcreditoutilizado, 2) }}</span>
									</li>
									<li class="list-group-item d-flex justify-content-between align-items-center item-lst-cred">
										<span style="font-weight: 500;" class="font-weight-bold">Valor disponível</span>
										<span class="badge badge-primary badge-pill">{{ mtdformatavalordecimal(detcredito.vlcreditodisponivel, 2) }}</span>
									</li>
								</ul>								
							</div>
							<div v-show="detcredito.lsthistorico.length > 0 || detcredito.lsthistoricoreccredito.length > 0" class="col-md-12">
								<ul class="list-group" style="padding-bottom: 10px;">
									<li class="list-group-item text-center" style="padding: 2px; background: #e9ecef;">
										<span style="font-weight: bold;">UTILIZAÇÕES</span>
									</li>
								</ul>								
							</div>							
							<div v-show="detcredito.lsthistorico.length > 0 || detcredito.lsthistoricoreccredito.length > 0" class="col-md-12">
								<div class="table-responsive" style="font-size: 12px;">
									<table class="table table-bordered table-sm table-hover">
										<thead class="thead-light">
										<tr>
											<th>Forma de pagamento:</th>
											<th>Valor:</th>
											<th>Dt. Utilização:</th>
											<th>Nr. Venda:</th>
											<th>Cliente:</th>
											<th style="text-align: center;">Origem:</th>
										</tr>
										</thead>
										<tbody>
											<tr v-for="(credito, index) in detcredito.lsthistorico" v-bind:key="index">
												<td>{{ credito.descricao }}</td>
												<td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(credito.vlforma), 2) }}
												</td>
												<td style="text-align: right;">{{ credito.dtfatura }}
												</td>
												<td>{{ mtdformatarzeros(credito.idpedido, 8) }}
												</td>
												<td>{{ credito.nome }}</td>
												<td style="text-align: center; font-weight: bold; cursor: pointer;" title="Venda">VND</td>
											</tr>
											<tr v-for="(credito, index) in detcredito.lsthistoricoreccredito" v-bind:key="index">
												<td>{{ credito.descforma }}</td>
												<td style="text-align: right; font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(credito.valor), 2) }}
												</td>
												<td style="text-align: right;">{{ credito.dthrecebimento }}
												</td>
												<td></td>
												<td>{{ credito.nomecliente }}</td>
												<td style="text-align: center; font-weight: bold; cursor: pointer;" title="Recebimento de título(s)">REC</td>
											</tr>																						
										</tbody>
									</table>
								</div>								
							</div>
							<div v-show="detcredito.detalhecashback.lista.length > 0" class="col-md-12">
								<ul class="list-group" style="padding-bottom: 10px;">
									<li class="list-group-item text-center" style="padding: 2px; background: #e9ecef;">
										<span style="font-weight: bold;">CASHBACK</span>
									</li>
								</ul>								
							</div>							
							<div v-show="detcredito.detalhecashback.lista.length > 0" class="col-md-12">
								<div class="table-responsive" style="font-size: 12px;">
									<table class="table table-bordered table-sm table-hover">
										<thead class="thead-light">
										<tr>
											<th>Nr. venda:</th>
											<th>Valor:</th>
											<th>Data:</th>
											<th>Validade:</th>
											<th>St:</th>
										</tr>
										</thead>
										<tbody>
											<tr v-for="(cashback, index) in detcredito.detalhecashback.lista" v-bind:key="index">
												<td>{{ cashback.idpedido }}</td>
												<td style="text-align: right;  font-weight: bold;">{{ mtdformatavalordecimal(parseFloat(cashback.cashbackacumulado), 2) }}</td>
												<td style="text-align: right;">{{ cashback.dtfatura }}</td>
												<td style="text-align: right;  font-weight: bold; cursor: pointer;" v-bind:class="cashback.stcashback === 'V' ? 'texto-perigo' : 'texto-sucesso'" v-bind:title="cashback.stcashback === 'V' ? 'Vencido' : 'Disponível'">{{ cashback.dtvalidadecashback }}</td>
												<td style="text-align: center; font-weight: bold; cursor: pointer;" v-bind:class="cashback.stcashback === 'V' ? 'texto-perigo' : 'texto-sucesso'" v-bind:title="cashback.stcashback === 'V' ? 'Vencido' : 'Disponível'">{{ cashback.stcashback }}</td>													
											</tr>
										</tbody>
									</table>
								</div>								
							</div>
							<!-- <div v-show="detcredito.detalhecashback.lista.length > 0" class="col-md-12">
								<ul class="list-group" style="padding-bottom: 10px;">
									<li class="list-group-item d-flex justify-content-between align-items-center item-lst-cred">
										<span style="font-weight: 500;" class="font-weight-bold">Disponível</span>
										<span class="badge badge-primary badge-pill">{{ mtdformatavalordecimal(detcredito.detalhecashback.disponiveis, 2) }}</span>
									</li>
									<li class="list-group-item d-flex justify-content-between align-items-center item-lst-cred">
										<span style="font-weight: 500;" class="font-weight-bold">Vencido</span>
										<span class="badge badge-primary badge-pill">{{ mtdformatavalordecimal(detcredito.detalhecashback.vencidos, 2) }}</span>
									</li>
								</ul>								
							</div>														 -->
                        </div>
                    </div>
                    <div class="modal-footer" style="padding: 5px 10px 5px 10px;">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-sign-out"></i> Sair</button>
                    </div>                    
                </div>
            </div>
        </div>
		<!-- Modal para edição do perfil do fluxo -->
        <div class="modal fade" id="mdlalterarperfilfluxofinal">
            <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title" style="font-size: 14px;">Alteração de perfil do fluxo...</h6>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <span class="lblselect2">Perfil do fluxo:</span>
                            <select id="cbperfilfluxofinal" v-model="aidperfilfluxo" data-placeholder="Selecione um perfil" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary"   data-dismiss="modal" @click.prevent="mtdconfirmarperfilfluxo()"><i class="fa fa-check"></i> Confirmar</button>
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                </div>                
            </div>
            </div>
        </div>	
		<!-- Modal pra edicao do recibo do pedido -->
		<div class="modal fade" id="mdrecibopedido">
			<div class="modal-dialog modal-lg modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-sticky-note-o"></i> Emissão de recibo do pedido</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-2">
							<label for="edpridpedido">Nr. Pedido:</label>
							<input type="text" class="form-control form-control-sm" id="edpridpedido" v-model="pedidorecibo.id" disabled/>
						</div>
						<div class="col-6">
							<label for="edprcliente">Cliente:</label>
							<input type="text" class="form-control form-control-sm" id="edprcliente" v-model="pedidorecibo.nomecliente" disabled/>
						</div>						
						<div class="col-2">
							<label for="edprvendedor">Vendedor:</label>
							<input type="text" class="form-control form-control-sm" id="edprvendedor" v-model="pedidorecibo.nomevendedor" disabled/>
						</div>						
						<div class="col-2">
							<label for="edprdtemissao">Emissão:</label>
							<input type="text" class="form-control form-control-sm" id="edprdtemissao" v-model="pedidorecibo.dtemissao" disabled/>
						</div>						
					</div>
					<div class="row">
						<div class="col-lg-12">
							<div class="table-responsive">
								<table id="tblistaitensrecibopedido" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
									<thead class="thead-dark">
									<tr>
										<th width="30">Item:</th>
										<th width="100">Codigo:</th>
										<th width="300">Descrição:</th>
										<th width="100">Vl. Unitário:</th>
										<th width="50">Qtd:</th>   
										<th width="30">Und:</th>                                         
										<th width="100">Vl. Descto:</th>
										<th width="100">Vl. Total:</th>										
									</tr>
									</thead>
									<tbody>
										<tr v-for="(item, index) in pedidorecibo.itens" v-bind:key="index" style="font-size: 12px;">
											<td class="text-center">{{item.item}}</td>
											<td>{{item.coddig}}</td>
											<td>{{item.descproduto}}</td>
											<td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario), 2)}}</td>
											<td style="text-align: right;">{{item.qtditem}}</td>
											<td class="text-center">{{item.unditem}}</td>											
											<td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.valordescacres), 2)}}</td>
											<td style="text-align: right; font-weight: 600;">{{mtdformatavalordecimal(parseFloat(item.vltotal), 2)}}</td> 
										</tr>
									</tbody>                                        
								</table>
							</div>
						</div>
						<div class="col-12" style="margin-bottom: 5px;">
							<ul class="list-group">
								<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
									<span style="color: #666666; font-weight: bold;">Total do pedido:</span>
									<span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 150px;">{{mtdformatavalordecimal(parseFloat(pedidorecibo.totalgeral), 2)}}</span>
								</li>
							</ul>							
						</div>						
					</div>
					<div class="row">
						<div class="col-12">
							<label for="edprformapagamento">Forma de pagamento:</label>
							<!-- <input type="text" class="form-control form-control-sm" id="edprformapagamento" v-model="prformapagamento"/> -->
							<textarea class="form-control center" rows="3" id="edprformapagamento" v-model="prformapagamento"></textarea>
						</div>
						<div class="col-10">
							<label for="edprtransportadora">Transportadora:</label>
							<input type="text" class="form-control form-control-sm" id="edprtransportadora" v-model="prtrasportadora"/>
						</div>						
						<div class="col-2">
							<label for="edprnnf">Nr. NF:</label>
							<input type="text" class="form-control form-control-sm" id="edprformapagamento" v-model="prnnf"/>
						</div>
						<div class="col-8">
							<label for="edprindicacao">Indicação:</label>
							<input type="text" class="form-control form-control-sm" id="edprindicacao" v-model="prindicacao"/>
						</div>												
						<div class="col-4">
							<label for="edpratividade">Atividade:</label>
							<input type="text" class="form-control form-control-sm" id="edpratividade" v-model="pratividade"/>
						</div>						
						<div class="col-12">
							<label for="txtprobservacoes">Observações:</label>
							<textarea class="form-control center" rows="3" id="txtprobservacoes" v-model="probservacoes"></textarea>
						</div>						
					</div>
				</div>
				<div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary"   data-dismiss="modal" @click.prevent="mtdconfirmarecibopedido()"><i class="fa fa-check"></i> Confirmar</button>
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
				</div>				
			</div>
			</div>
		</div>
		<!-- Modal para analise de cortes -->
		<div class="modal fade" id="mdanalisecortes">
			<div class="modal-dialog modal-xl modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-scissors"></i> Análise de cortes</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-sm-12 col-md-3 col-lg-3">
							<label for="edcdtini">De:</label>
							<div class="input-group">
								<date-picker id="edcdtini" v-model="cdtini" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>								
							</div>
						</div>
						<div class="col-sm-12 col-md-3 col-lg-3">
							<label for="edcdtfim">até:</label>
							<div class="input-group">
								<date-picker id="edcdtfim" v-model="cdtfim" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>																			
							</div>
						</div>
						<div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="cbctipo">Tipo:</label>
                                <select name="cbctipo" class="form-control form-control-sm" id="cbctipo" v-model="ctipo" >
                                    <option value="0">Pedidos</option>
                                    <option value="1">Orçamentos</option>
                                    <option value="2">Ordens de serviço</option>
                                    <option value="3">Todos</option>
                                </select>
                        </div>
						<div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="cbcdiferenca">Diferença:</label>
                                <select name="cbcdiferenca" class="form-control form-control-sm" id="cbcdiferenca" v-model="cdiferenca">
                                    <option value="0">Negativa</option>
                                    <option value="1">Positiva</option>
                                    <option value="2">Todas</option>
                                </select>
                        </div>												
						<div class="col-12 col-sm-12 col-md-2 col-lg-2">
							<button type="button" style="margin-top: 20px;" id="btclistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdlistarcortes(0)"><i class="fa fa-search"></i> Listar cortes</button>
						</div>						
					</div>
					<div class="row">
						<div class="col-lg-12">
							<div class="table-responsive">
								<table id="tbclista" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
									<thead class="thead-dark">
									<tr>
										<th width="30"></th>
										<th width="100">Código:</th>
										<th width="300">Descrição:</th>
										<th width="100">Referência:</th>
										<th width="40">Und:</th>
										<th width="100">Marca:</th>
										<th width="100">Estoque:</th>
										<th width="50">Venda:</th>                                            
										<th width="50">Estoque:</th>
										<th width="50">Corte:</th>
										<th width="50">Pedidos:</th>										
									</tr>
									</thead>
									<tbody>
										<template v-for="(item, index) in lstitenscorte">
											<tr style="font-size: 12px;" :key="index">
												<td class="text-center">
													<span v-if="parseFloat(item.expandir) === 0" style="font-size: 20px; cursor: pointer;" @click.prevent="mtdexpandirpedidos(index)"><i class="fa fa-chevron-circle-down text-primary"></i></span>
													<span v-else style="font-size: 20px; cursor: pointer;"><i class="fa fa-chevron-circle-up text-primary" @click.prevent="mtdexpandirpedidos(index)"></i></span>													
												</td>
												<td>{{item.idproduto}}</td>
												<td>{{item.descricao}}</td>
												<td>{{item.referencia}}</td>
												<td>{{item.und}}</td>
												<td>{{item.descmarca}}</td>
												<td>{{item.descestoque}}</td>
												<td style="text-align: right;">{{item.qtditem}}</td>
												<td style="text-align: right;">{{item.qtdestoque}}</td>
												<td style="text-align: right;">
													<span v-if="parseFloat(item.diferenca) >= 0" class="font-weight-bolder" style="color: #0acf97; font-size: 14px; cursor: pointer;">{{item.diferenca}}</span>
													<span v-else class="font-weight-bolder" style="color: #f82b54; font-size: 14px; cursor: pointer;">{{item.diferenca * (-1)}}</span>
												</td>
												<td style="text-align: right;">{{item.qtdpedidos}}</td>																						
											</tr>
											<tr v-bind:key="index">
												<td colspan="11" v-show="parseInt(item.expandir) === 1">
													<table id="tbclista" class="table table-bordered table-sm table-hover" style="margin-top: 2px; margin-bottom: 2px;">
														<thead class="thead-light">
															<tr>
																<th width="60">Nr. Pedido</th>
																<th width="20"></th>
																<th width="250">Cliente:</th>
																<th width="100">Vendedor:</th>
																<th width="100" >Município:</th>
																<th width="100">Rota:</th>
																<th width="100">Plano pgto.:</th>
																<th width="50" >Venda:</th>
																<th width="20"></th>                                            
																<th width="50">Total:</th>										
															</tr>																								
														</thead>
														<tbody>
															<tr v-for="(pedido, indexp) in item.pedidos" style="font-size: 12px;" :key="indexp">
																<td>{{mtdformatarzeros(pedido.idpedido, 8)}}</td>
																<td class="text-center"><i @click.prevent="mtddetalhespedido(pedido.idpedido)" class="fa fa-info-circle icon-detalhes" title="Detalhes do pedido"></i></td>
																<td>{{pedido.idcliente}} - {{pedido.nomecliente}}</td>
																<td>{{pedido.nomevendedor}}</td>
																<td>{{pedido.descmunicipiocli}}</td>
																<td>{{pedido.descrotacli}}</td>
																<td>{{pedido.descplano}}</td>
																<td style="text-align: right;">{{pedido.qtditem}}</td>
																<td class="text-center">
																	<button type="button" class="btn btn-danger btn-sm btncortaritem" @click.prevent="mtdrotinacorteitem(index, indexp)" title="Cortar item"><i class="fa fa-scissors"></i></button>
																</td>																
																<td style="text-align: right; font-weight: bold;">{{mtdformatavalordecimal(pedido.vltotal, 2)}}</td>
															</tr>	
														</tbody>
													</table>													
												</td>
											</tr>
										</template>
									</tbody>                                        
								</table>
							</div>
						</div>
						<div class="col-md-12">
							<ul class="list-group">
								<li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
									<span class="text-primary"><strong>Total à cortar ({{cqtditenscorte}})</strong></span>									
									<span class="badge badge-danger badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(parseFloat(ctotalcortes), 2)}}</span>
								</li>
							</ul>
                        </div>													
					</div>						
				</div>
				<div class="modal-footer">
					<button type="button" style='width: 150px;' class="btn btn-sm btn-primary" @click.prevent="mtdimprimirlistagemcortes()"><i class="fa fa-print"></i> Imprimir</button>
                    <button type="button" style='width: 150px;' class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Sair</button>
				</div>				
			</div>
			</div>
		</div>
		<!-- Modal para corte do item -->
		<div class="modal fade" id="mdcorteitem">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-scissors"></i> Corte do item</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<label for="editemcorte">Item:</label>
							<input type="text" style="font-size: 10px; font-weight: bold;" class="form-control form-control-sm" id="editemcorte" :value="itemcortar.idproduto +' - '+itemcortar.descricao" data-bv-group=".group" disabled>
						</div>	
						<div class="col-12">
							<label for="edpedidocorte">Pedido:</label>
							<input type="text" class="form-control form-control-sm" id="edpedidocorte" :value="mtdformatarzeros(pedidocortar.idpedido, 8)" data-bv-group=".group" style="text-align:center; font-weight: bold;" disabled>
						</div>																	
						<div class="col-12">
							<label for="edqtditemcortar">*Qtd. corte:</label>
							<money type="text" class="form-control form-control-sm" id="edqtditemcortar" v-model="qtditemcortar" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
						</div>						
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmarcorteitem()"><i class="fa fa-check"></i> Confirmar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>				        
			</div>
			</div>
		</div>				
		<!-- Modal para impressão dos itens cortados
		<div class="modal fade" id="mditenscortados">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-print"></i> Itens cortados</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<label for="edlcdtini">De:</label>
							<div class="input-group">
								<date-picker id="edlcdtini" v-model="lcdtini" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>								
							</div>
						</div>
						<div class="col-12">
							<label for="edlcdtfim">até:</label>
							<div class="input-group">
								<date-picker id="edlcdtfim" v-model="lcdtfim" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>																			
							</div>
						</div>
						<div class="col-12">
							<span class="lblselect2">Cliente:</span>
							<select id="cblccliente" data-placeholder="Selecione um cliente" v-model="lcidcliente" data-allow-clear="true" style="width:100%;">
							</select>
						</div>																			
						<div class="col-12">
							<span class="lblselect2">Vendedor:</span>
							<select id="cblcvendedor" data-placeholder="Selecione um vendedor" v-model="lcidvendedor" data-allow-clear="true" style="width:100%;">
							</select>
						</div>																	
						<div class="col-12">
							<span class="lblselect2">Produto:</span>
							<select id="cblcproduto" data-placeholder="Selecione um produto" v-model="lcidproduto" data-allow-clear="true" style="width:100%;">
							</select>
						</div>																	
						<div class="col-12">
							<span class="lblselect2">Marca:</span>
							<select id="cblcmarca" data-placeholder="Selecione uma marca" v-model="lcidmarca" data-allow-clear="true" style="width:100%;">
							</select>
						</div>																			
						<div class="col-12">
							<span class="lblselect2">Grupo:</span>
							<select id="cblcgrupo" data-placeholder="Selecione um grupo" v-model="lcidgrupo" data-allow-clear="true" style="width:100%;">
							</select>
						</div>																			
						<div class="col-12">
							<span class="lblselect2">Subgrupo:</span>
							<select id="cblcsubgrupo" data-placeholder="Selecione um subgrupo" v-model="lcidsubgrupo" data-allow-clear="true" style="width:100%;">
							</select>
						</div>																			
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdimprimiritenscortados()"><i class="fa fa-print"></i> Imprimir</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>				        
			</div>
			</div>
		</div> -->
		<!-- Modal para gerenciar/recuperar cortes -->
		<div class="modal fade" id="mdgerenciarecuperacorte">
			<div class="modal-dialog modal-xl modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-scissors"></i> Análise de cortes</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-4">
							<span class="lblselect2">Cliente:</span>
							<select id="cblccliente" data-placeholder="Selecione um cliente" v-model="lcidcliente" data-allow-clear="true" style="width:100%;">
							</select>
						</div>																			
						<div class="col-4">
							<span class="lblselect2">Rota:</span>
							<select id="cblcrota" data-placeholder="Selecione uma rota" v-model="lcidrota" data-allow-clear="true" style="width:100%;">
							</select>
						</div>				
						<div class="col-4">
							<span class="lblselect2">Produto:</span>
							<select id="cblcproduto" data-placeholder="Selecione um produto" v-model="lcidproduto" data-allow-clear="true" style="width:100%;">
							</select>
						</div>																	
						<div class="col-2">
							<span class="lblselect2">Marca:</span>
							<select id="cblcmarca" data-placeholder="Selecione uma marca" v-model="lcidmarca" data-allow-clear="true" style="width:100%;">
							</select>
						</div>																			
						<div class="col-2">
							<span class="lblselect2">Grupo:</span>
							<select id="cblcgrupo" data-placeholder="Selecione um grupo" v-model="lcidgrupo" data-allow-clear="true" style="width:100%;">
							</select>
						</div>																			
						<div class="col-2">
							<span class="lblselect2">Subgrupo:</span>
							<select id="cblcsubgrupo" data-placeholder="Selecione um subgrupo" v-model="lcidsubgrupo" data-allow-clear="true" style="width:100%;">
							</select>
						</div>	
						<div class="col-2">
							<span class="lblselect2">Vendedor:</span>
							<select id="cblcvendedor" data-placeholder="Selecione um vendedor" v-model="lcidvendedor" data-allow-clear="true" style="width:100%;">
							</select>
						</div>	
						<div class="col-2">
							<span class="lblselect2">Município:</span>
							<select id="cblidcidade" data-placeholder="Selecione uma cidade" v-model="lcidcidade" data-allow-clear="true" style="width:100%;">
							</select>
						</div>			
						<div class="col-2">
							<label for="edlcdtini">De:</label>
							<div class="input-group">
								<date-picker id="edlcdtini" v-model="lcdtini" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>								
							</div>
						</div>
						<div class="col-2">
							<label for="edlcdtfim">até:</label>
							<div class="input-group">
								<date-picker id="edlcdtfim" v-model="lcdtfim" :config="options" class="form-control form-control-sm"></date-picker>
								<div class="input-group-append">
									<span class="input-group-text"><i class="fa fa-calendar"></i></span>
								</div>																			
							</div>
						</div>
						<div class="col-2" style="padding-top: 20px" >
							<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdlistaritenscortes()"><i class="fa fa-search"></i> Listar</button>
						</div>
																							
					</div>
					<div class="row">
						<div class="col-lg-12">
							<div class="table-responsive">
								<table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
									<thead class="thead-dark">
									<tr>
										<th>Cliente:</th>
										<th>Idpedido:</th>
										<th>Produto:</th>
										<th>Und:</th>
										<th>Referência:</th>
										<th>Dt. hr. corte:</th>
										<th>Qtd. corte:</th>
										<th>Qtd. Recupera:</th>
										<th></th>
									</tr>
									</thead>
									<tbody>
										<tr v-for="(item, index) in lstrecuperacortes" v-bind:key="index" style="font-size: 12px;">
											<td>{{ item.idcliente }} - {{item.nomecliente}}</td>
											<td>{{item.idpedido}}</td>
											<td>{{item.idproduto}} - {{item.descproduto}}</td>
											<td>{{item.und}}</td>
											<td>{{item.referencia}}</td>
											<td>{{item.dthrcorte}}</td>
											<td>{{item.qtdcorte}}</td>
											 <td>
												<span @click.prevent="mtdalterarqtd(item, false, 1)"><i  class="op-qtd op-qtd-ret fa fa-minus-circle"></i></span>
												<span @dblclick="mtdinserirqtd(item)" style="font-weight: 600; cursor: pointer;" title="Dê dois cliques para alterar a quantidade">{{ mtdformatavalordecimal(item.qtdrecupera , 3)}}</span>
												<span @click.prevent="mtdalterarqtd(item, true, 1)"><i  class="op-qtd op-qtd-acres fa fa-plus-circle"></i></span>   
											 </td>
											 <td tolltip="Histórico"  @click.prevent="mtdbuscahistorico(item)" ><i  style="cursor: pointer; color: rgb(255, 128, 0)"class="fa fa-info-circle" aria-hidden="true"></i></td>
										</tr>
									</tbody>                                        
								</table>
							</div>
						</div>											
					</div>						
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdrecuperaitenscortados()"><i class="fa fa-refresh"></i> Recuperar</button>
					<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdimprimiritenscortados()"><i class="fa fa-print"></i> Imprimir</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>			
			</div>
			</div>
		</div>
		<!-- Modal para crédito avulso -->
		<div class="modal fade" id="mdcreditoavulso">
			<div class="modal-dialog modal-md modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-dollar"></i> Crédito avulso</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>				
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-12 col-lg-12">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilialca" data-placeholder="Selecione uma filial" v-model="vidfilialca" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-12">
								<span class="lblselect2">*Cliente:</span>
								<select id="cbclienteca" data-placeholder="Selecione um cliente" v-model="vidclienteca" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
							<div class="col-sm-12">
								<label for="txtobservacoesva">Observações:</label>
								<textarea class="form-control center" rows="3" id="txtobservacoesva" v-model="vobservacoesca" maxlength="500"></textarea>
							</div>						
							<div class="col-sm-12 col-md-8 col-lg-8">
							</div>						
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edvlcreditoavulso">*Valor do crédito:</label>
								<money type="text" class="form-control form-control-sm" id="edvlcreditoavulso" v-model="vvalorcreditoavulso" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
							</div>																		
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmarcreditoavulso()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
					</div>				        
				</div>
			</div>
		</div>	
		<!-- Modal para devolução -->
		<div class="modal fade" id="mddevolucao">
			<div class="modal-dialog modal-xl modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-undo"></i> Devolução</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>				
					<div class="modal-body">
						<div class="row">
							<div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label for="edclientepeddev">Cliente:</label>
								<input type="text" class="form-control form-control-sm text-uppercase" id="edclientepeddev" v-bind:value="pedidodevolucao.idcliente+' - '+pedidodevolucao.nomecliente"
									data-bv-group=".group" disabled/>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label for="edfilialdev">Filial:</label>
								<input type="text" class="form-control form-control-sm" id="edfilialdev" v-bind:value="pedidodevolucao.idfilial+' - '+pedidodevolucao.fantasia"
									data-bv-group=".group" disabled/>
							</div>							
							<div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
								<label for="ednrpeddev">Nr. Pedido:</label>
								<input type="text" class="form-control form-control-sm text-right font-weight-bold text-secondary" id="ednrpeddev" v-bind:value="mtdformatarzeros(pedidodevolucao.id, 8)"
									data-bv-group=".group" disabled/>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
								<label for="eddtfaturadev">Dt. Fatura:</label>
								<input type="text" class="form-control form-control-sm text-right" id="eddtfaturadev" v-model="pedidodevolucao.dtfatura"
									data-bv-group=".group" disabled/>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
								<label for="edplanodev">Plano de pagamento:</label>
								<input type="text" class="form-control form-control-sm text-uppercase" id="edplanodev" v-model="pedidodevolucao.descplano"
									data-bv-group=".group" disabled/>
							</div>
							<div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
								<label for="edtotalpedidodev">Total pedido:</label>
								<money type="text" class="form-control form-control-sm input-money" id="edtotalpedidodev" 
									v-model="pedidodevolucao.totalgeral" v-bind="money"
									data-bv-group=".group" style="text-align:right;" disabled>
								</money>                                
							</div>
							<div class="col-sm-12 col-md-12 col-lg-2">
								<label for="eddtdevolucao">*Dt. devolução:</label>
								<div class="input-group">
									<date-picker id="eddtdevolucao" v-model="dtemissaodevolucao" :config="options"
										class="form-control form-control-sm"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div> 
							</div>							
						</div>
						<div class="row">
							<div class="col-lg-12">
								<div class="table-responsive">
									<table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
										<thead class="thead-dark">
										<tr>
											<th width="30">Item:</th>
											<th width="100">Codigo:</th>
											<th width="300">Descrição:</th>
											<th width="100">Referência:</th>
											<th width="40">Und:</th>
											<th width="40">Marca:</th>
											<th width="100">Vl. Unitário:</th>
											<th width="50">Qtd:</th>     
											<th width="50">Qtd. Devolução:</th>
											<th width="100">Vl. Descto:</th>
											<th width="100">Vl. Total:</th>
											<th width="100">Local.:</th>
											<th width="100">Estoque:</th>                                                
										</tr>
										</thead>
										<tbody>
											<tr v-for="(item, index) in pedidodevolucao.itens" v-bind:key="index" style="font-size: 12px;">
												<td class="text-center">{{item.item}}</td>
												<td>{{item.coddig}}</td>
												<td>{{item.descproduto}}</td>
												<td>{{item.referencia}}</td>
												<td>{{item.unditem}}</td>
												<td>{{item.descmarca}}</td>
												<td style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario), 2)}}</td>
												<td style="text-align: right;">{{item.qtditem}}</td>
												<td style="text-align: right;">
													<money type="text" class="form-control form-control-sm" v-model="item.qtddevolucao" 
														@blur.native="mtdcalculatotaldevolucao()" data-bv-group=".group" maxlength="20" 														
														style="text-align:right; font-weight: bold;">
													</money>														
												</td>
												<template v-if="parseInt(item.descacres) === 0">
													<td v-if="parseInt(item.tipodescacres) === 0" style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.vlunitario) * parseFloat(item.qtditem) * parseFloat(item.valordescacres) / 100 , 2)}}</td>                                                
													<td v-else style="text-align: right;">{{mtdformatavalordecimal(parseFloat(item.valordescacres), 2)}}</td>                                                
												</template>
												<template v-else>
													<td></td>
												</template>
												<td style="text-align: right; font-weight: 500;">
													<i v-show="parseFloat(item.vltotalimposto) > 0" class="fa fa-info-circle text-black-50" v-bind:title="'Imposto do item: R$ '+ mtdformatavalordecimal(parseFloat(item.vltotalimposto), 2)" style="font-size: 18px; float: left;"></i>
													{{mtdformatavalordecimal(parseFloat(item.vltotal), 2)}}
												</td>
												<td>{{item.localizacao}}</td>
												<td style="cursor: pointer;" @click.prevent="mtdalterarestoquedevolucao(index)" >{{item.descestoque}} <i class="fa fa-edit" ></i></td>
											</tr>
										</tbody>                                        
									</table>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-12">
								<label for="txtobservacoesdevolucao">Observações:</label>
								<textarea class="form-control center" rows="3" id="txtobservacoesdevolucao" v-model="observacoesdevolucao"></textarea>
							</div>											
						</div>						
						<div class="row">
							<div class="col-sm-12 col-md-12 col-lg-10 col-xl-10 text-right">								
								<button type="button" class="btn btn-info btn-sm" style="margin-top: 20px; width: 150px;" @click.prevent="mtddevolvertodos()"><i class="fa fa-list-ul"></i> Devolver todos</button>								
							</div>
							<div class="col-sm-12 col-md-12 col-lg-2 col-xl-2">
								<label for="edtotaldevolucao">Total devolução:</label>
								<money type="text" class="form-control form-control-sm input-money" id="edtotaldevolucao" 
									v-model="totaldevolucao" v-bind="money"									
									data-bv-group=".group" style="text-align:right;" disabled>
								</money>                                
							</div>			
						</div>									
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmardevolucao()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
					</div>				        
				</div>
			</div>
		</div>				
		<!-- Modal para para definição da filial da emissão da NF -->
		<div class="modal fade" id="mddefinefilialnf">
			<div class="modal-dialog modal-md modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-qrcode"></i> Geração de NF - Modelo {{ vmodelonf }}</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>				
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<span class="lblselect2">*Filial:</span>
							<select id="cbfilialnf" data-placeholder="Selecione uma filial" v-model="vidfilialnf" data-allow-clear="true" style="width:100%;" v-bind:disabled="!alterafilialnf">
							</select>
						</div>		
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-primary btn-sm" style="width: 150px;" @click.prevent="mtdgerarenviarnf(true)" v-bind:disabled="habbtnf"><i class="fa fa-check"></i> Apenas gerar</button>
					<button type="button" class="btn btn-success btn-sm" style="width: 150px;" @click.prevent="mtdgerarenviarnf(false)" v-bind:disabled="habbtnf"><i class="fa fa-check"></i> Gerar e enviar</button>
					<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
				</div>				        
			</div>
			</div>
		</div>				
		<!-- Modal para edição do crédito avulso -->
		<div class="modal fade" id="mdedicaocreditoavulso">
			<div class="modal-dialog modal-md modal-dialog-centered">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title" style="font-size: 16px;"><i class="fa fa-dollar"></i>Alteração de crédito</h4>
						<button type="button" class="close" data-dismiss="modal">&times;</button>
					</div>				
					<div class="modal-body">
						<div class="row">
							<div class="col-md-12">
								<h6 style="color: rgb(255, 128, 0)">Importante: essa operação irá abater apenas o crédito cedido!</h6>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edtotadd">Adquirido:</label>
								<money type="text" class="form-control form-control-sm" id="edtotadd"  v-model="vvlcredadquirido" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-weight: bold; background: honeydew; color: green;" disabled></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edtotavulso">Cedido:</label>
								<money type="text" class="form-control form-control-sm" id="edtotavulso"  v-model="vlegcredavulso" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-weight: bold; background: honeydew; color: green;" disabled></money>
							</div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<label for="edtotatual">Valor atual:</label>
								<money type="text" class="form-control form-control-sm" id="edtotatual"  v-model="vlcreditotot" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-weight: bold; background: honeydew; color: green;" disabled></money>
							</div>	
							<div class="col-md-12">
								<label for="edfilialedicaocreditoavulso">Filial:</label>
								<input type="text" class="form-control form-control-sm" id="edfilialedicaocreditoavulso" v-bind:value="ecreditoavulso.idfilial+' - '+ecreditoavulso.fantasia" data-bv-group=".group" disabled>
							</div>
							<div class="col-md-12">
								<label for="edclienteedicaocreditoavulso">Cliente:</label>
								<input type="text" class="form-control form-control-sm" id="edclienteedicaocreditoavulso" v-bind:value="ecreditoavulso.idcliente+' - '+ecreditoavulso.nomecliente" data-bv-group=".group" disabled>
							</div>
							<div class="col-12">
								<label for="txteobsalteracaocredito">Motivo da alteração:</label>
								<textarea class="form-control center" rows="3" id="txteobsalteracaocredito" v-model="eobsalteracaocredito"></textarea>
							</div>																		
							<div class="col-sm-12 col-md-7 col-lg-7">
								<label for="cbdefsubs">Definir:</label>
								<select class="form-control form-control-sm" id="cbdefsubs" v-model="defsubs" >
									<option value="0">Subtrair</option>
									<option value="1">Somar</option>
								</select>
							</div>		
							<div class="col-sm-12 col-md-5 col-lg-5">
								<label for="ededicaovlcreditoavulso">*Valor do crédito:</label>
								<money type="text" class="form-control form-control-sm" id="ededicaovlcreditoavulso"  v-model="evledicaocreditoavulso" v-bind="money" data-bv-group=".group" maxlength="20" :style="vstyle"></money>
							</div>														
						</div>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-primary btn-sm" style="width: 100px;" @click.prevent="mtdconfirmaredicaocreditoavulso()"><i class="fa fa-check"></i> Confirmar</button>
						<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
					</div>				        
				</div>
			</div>
		</div>
		<div class="modal fade" id="mdalteraestoquedevolucao">
            <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h6 class="modal-title" style="font-size: 14px;">Alteração de estoque para devolução...</h6>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <span class="lblselect2">Estoque:</span>
                            <select id="cbestoquedevolucao" v-model="aestoquedevolucao" data-placeholder="Selecione um estoque" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-sm btn-primary"   data-dismiss="modal" @click.prevent="mtdconfirmaestoquedevolucao()"><i class="fa fa-check"></i> Confirmar</button>
                    <button type="button" class="btn btn-sm btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                </div>                
            </div>
            </div>
        </div>	
		<div class="modal fade" id="mdqtditem">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                                          
                    
                    <div class="modal-body">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="edqtditemproditem">Quantidade:</label>
                                    <money type="text" class="form-control form-control-sm" id="edqtditemproditem" v-model="vqtdalteritem" data-bv-group=".group" maxlength="20" style="text-align:right;" ></money>
                                </div>
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdpreparaqtd()" style="width: 100px;"><i class="fa fa-check"></i> Ok</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div> 
		<div class="modal fade" id="mdhistoricocorte">
            <div class="modal-dialog modal-md modal-dialog-centered">
                <div class="modal-content">   
					<div class = "modal-header">
						PRODUTO : {{ vleghistorico.idproduto }} - {{ vleghistorico.descproduto }} </br>
						CLIENTE : {{ vleghistorico.idcliente }} - {{ vleghistorico.nomecliente }} 
					</div>                                       
                    <div class="modal-body">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
									<table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
										<thead class="thead-dark">
										<tr>
											 <th>Data e hora</th>   
											 <th>Qtd corte</th>  
											 <th>Qtd rec</th>                                          
										</tr>
										</thead>
										<tbody>
											<tr v-for="(historico, index) in vleghistorico.historico" v-bind:key="index" style="font-size: 12px;">
												<td>{{historico.dthrrecuperacao}}</td>
												<td>{{historico.qtdcorte}}</td>
												<td>{{historico.qtdrecuperacao}}</td>
											</tr>
										</tbody>                                        
									</table>
                                </div>
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>  
		<modal name="mdl-info-pedido-ecommerce" height="auto" width="1200" @opened="carregaInfosEcommerce()">
            <div class="modal-header">
				<h6 v-if="!lstInfosPPL.idprepostagem" class="modal-title" style="font-size: 14px;"><i class="fa fa-truck" aria-hidden="true"></i> Pré-Postagem</h6>
				<h6 v-else class="modal-title" style="font-size: 14px;"><i class="fa fa-receipt" aria-hidden="true"></i> Emissão do Rótulo</h6>
				<button type="button" class="close" @click.prevente="$modal.hide('mdl-info-pedido-ecommerce')">&times;</button>
			</div>
			<div v-if="!lstInfosPPL.idprepostagem" class="modal-body">
				<div class="container">
					<div class="row">
						<!-- Coluna da Pré-Postagem -->
						<div class="col-md-6">
							<hr>
							<h6><i class="fa fa-info-circle"></i> Dados da Pré-Postagem</h6>
							<ul class="list-group list-group-sm">
								<li class="list-group-item"><strong>ID Pedido:</strong> {{ lstInfosPPL.idpedido }}</li>
								<li class="list-group-item"><strong>Serviço:</strong> {{ lstInfosPPL.descricaocodigoservico }}</li>
								<li class="list-group-item"><strong>Nome Destinatário:</strong> {{ lstInfosPPL.frete_nomedestinatario }}</li>
								<li class="list-group-item"><strong>CEP Destinatário:</strong> {{ lstInfosPPL.frete_cepdestinatario }}</li>
								<li class="list-group-item"><strong>Endereço:</strong> {{ lstInfosPPL.frete_logradourodestinario }}, {{ lstInfosPPL.frete_numerodestinatario }}</li>
								<li class="list-group-item"><strong>Bairro:</strong> {{ lstInfosPPL.bairrodestinatario }}</li>
								<li class="list-group-item"><strong>Município/UF:</strong> {{ lstInfosPPL.municipiodestinatario }} / {{ lstInfosPPL.frete_idufdestinatario }}</li>
								<li class="list-group-item"><strong>Número da nota fiscal:</strong> {{ lstInfosPPL.nrnotafiscal }}</li>
								<li class="list-group-item"><strong>Chave da NFE:</strong> {{ lstInfosPPL.chavenfe}}</li>
							</ul>
						</div>

						<!-- Coluna da Embalagem -->
						<div class="col-md-6">
							<hr>
							<h6><i class="fa fa-info-circle"></i> Dados da Embalagem escolhida</h6>
							<ul class="list-group list-group-sm">
								<li class="list-group-item"><strong>ID Embalagem:</strong> {{ embalagemEscolhida.id }}</li>
								<li class="list-group-item"><strong>Descrição:</strong> {{ embalagemEscolhida.descricao }}</li>
								<li class="list-group-item"><strong>Peso:</strong> {{ embalagemEscolhida.pesoembalagem }} g</li>
								<li class="list-group-item">
									<strong>Dimensões (C x L x A):</strong>
									{{ embalagemEscolhida.comprimentoembalagem }} x
									{{ embalagemEscolhida.larguraembalagem }} x
									{{ embalagemEscolhida.alturaembalagem }} cm
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>

			<div v-else class="modal-body">
				<div class="container">
					<div class="row">
						<div class="col-sm-12 col-md-2 col-lg-12">
							<div class="row">
								<!-- <div class="col-sm-12 col-md-2 col-lg-2">
									<label for="edid">Qtd impressões:</label>
									<input type="number" class="form-control form-control-sm" id="cbqtdimpressao" v-model="vqtdimpressãorotulo"/>
								</div> -->
								<div class="col-sm-12 col-md-6 col-lg-4">
									<label for="edid">Tp rótulo:</label>
									<select class="form-control form-control-sm" id="cbtprotulo" v-model="vtprotulo">
										<option value="P">Padrão</option>
										<option value="R">Reduzido</option>
									</select>
								</div>
								<!-- <div class="col-sm-12 col-md-6 col-lg-3">
									<label for="edid">Formato rótulo:</label>
									<select class="form-control form-control-sm" id="cbformatorotulo" v-model="vformatorotulo">
										<option value="ET">Etiqueta</option>
										<option value="EV">Envelope</option>
									</select>
								</div> -->
								<div class="col-sm-12 col-md-6 col-lg-4">
									<label for="edid">Imprime rementente:</label>
									<select class="form-control form-control-sm" id="cbimprimeremetente" v-model="vimprimeremetente">
										<option value="S">Sim</option>
										<!-- <option value="N">Não</option> no momento só remetente sim -->
									</select>
								</div>
								<div class="col-sm-12 col-md-6 col-lg-4">
									<label for="edid">Layout impressão:</label>
									<select class="form-control form-control-sm" id="cblayoutimp" v-model="vlayoutimp">
										<option value="PADRAO">PADRAO</option>
										<!-- <option value="LINEAR_100_150">LINEAR_100_150</option>
										<option value="LINEAR_100_150">LINEAR_100_80</option> -->
										<option value="LINEAR_A4">LINEAR_A4</option>
										<!-- <option value="LINEAR_A">LINEAR_A</option> -->
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="modal-footer">
				<button v-if="lstInfosPPL.idprepostagem" type="button" class="btn btn-primary btn-sm mr-auto" style="width: 300px;" @click.prevent="mtdGerarRotuloImpresso()"><i class="fa fa-receipt" aria-hidden="true"></i> Gerar Rótulo</button>
				<button v-else type="button" class="btn btn-primary btn-sm mr-auto" style="width: 300px;" @click.prevent="mtdGerarPrePostagem()"><i class="fa fa-truck" aria-hidden="true"></i> Gerar Pré-Postagem</button>
				<!-- <button type="button" class="btn btn-primary btn-sm" @click.prevent="$modal.show('mdl-info-embalagem-ecommerce')"><i class="fa fa-box" aria-hidden="true"></i> Informações embalagem</button> -->
				<!-- <button type="button" class="btn btn-secondary btn-sm" @click.prevent="$modal.hide('mdl-info-pedido-ecommerce')" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button> -->
			</div>
        </modal>
		<!-- <modal name="mdl-info-embalagem-ecommerce" height="auto" width="500" @opened="mtdInfosEmbalagem()">
			<div class="modal-header">
				<h6 class="modal-title" style="font-size: 14px;"><i class="fa fa-box" aria-hidden="true"></i> Embalagem</h6>
				<button type="button" class="close" @click.prevente="$modal.hide('mdl-info-embalagem-ecommerce')">&times;</button>
			</div>
			<div class="modal-body">
				<div class="container">
					<div class="row">
						<div class="col-sm-12 col-md-2 col-lg-12">
							<div class="row">
								<div class="col-sm-12 col-md-12">
									<hr>
									<h6><i class="fa fa-info-circle"></i> Dados da Embalagem escolhida</h6>

									<ul class="list-group list-group-sm">
										<li class="list-group-item"><strong>ID Embalagem:</strong> {{ embalagemEscolhida.id }}</li>
										<li class="list-group-item"><strong>Descrição:</strong> {{ embalagemEscolhida.descricao }}</li>
										<li class="list-group-item"><strong>Peso:</strong> {{ embalagemEscolhida.pesoembalagem }}</li>
										<li class="list-group-item"><strong>Comprimento:</strong> {{ embalagemEscolhida.comprimentoembalagem }}</li>
										<li class="list-group-item"><strong>Largura:</strong> {{ embalagemEscolhida.larguraembalagem }}</li>
										<li class="list-group-item"><strong>Altura:</strong> {{ embalagemEscolhida.alturaembalagem }}</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-secondary btn-sm" @click.prevent="$modal.hide('mdl-info-embalagem-ecommerce')" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
			</div>
        </modal> -->
		<modal name="mdl-gerenciar-entrega" height="auto" width="800">
            <div class="modal-header">
				<h6 class="modal-title" style="font-size: 14px;"><i class="fa fa-motorcycle" aria-hidden="true"></i> Gerenciar entrega do pedido</h6>
				<button type="button" class="close" @click.prevente="$modal.hide('mdl-gerenciar-entrega')">&times;</button>
			</div>
			<div class="modal-body">
				<div class="container">
					<div class="row">
						<div class="col-12 col-sm-12 col-md-3 col-lg-3">
							<label for="edidpedidopesqsttentrega">Nr. Pedido:</label>
							<input id="edidpedidopesqsttentrega" type="text" v-mask="'########'" class="form-control form-control-sm" v-model="pedidoentrega.id" disabled>
						</div>
						<div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
							<label for="eddtemissaoentrega">Dt. Emissão:</label>
							<input type="text" class="form-control form-control-sm text-right font-weight-bold" id="eddtemissaoentrega" v-bind:value="pedidoentrega.dtemissao"
								data-bv-group=".group" disabled/>
						</div>
						<div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
							<label for="eddtfaturaentrega">Dt. Fatura:</label>
							<input type="text" class="form-control form-control-sm text-right font-weight-bold" id="eddtfaturaentrega" v-bind:value="pedidoentrega.dtfatura"
								data-bv-group=".group" disabled/>
						</div>
						<div class="col-sm-12 col-md-3 col-lg-3">
							<label for="edtpentrega">Tipo Entrega:</label>
							<span v-if="pedidoentrega.tpentregaecommerce == 0" class="bdg-tipo-entrega-pedido">RETIRAR NA LOJA</span>
							<span v-else class="bdg-tipo-entrega-pedido">ENTREGA EXTERNA</span>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col-sm-12 col-md-3 col-lg-3">
							<label for="edclienteentrega">Cliente:</label>
							<div class="input-group" style="z-index: 1;">
								<input type="text" class="form-control form-control-sm" id="edclienteentrega" v-model="pedidoentrega.idcliente">
							</div>
						</div>
						<div class="col-sm-12 col-md-9 col-lg-9 col-xl-9">
							<label for="ednomeclienteentrega">Nome do cliente:</label>
							<div class="input-group" style="z-index: 1;">
								<input type="text" class="form-control form-control-sm" id="ednomeclienteentrega" v-model="pedidoentrega.nomecliente"
									data-bv-group=".group" maxlength="50" disabled style="font-weight: bold;"/>
								<div class="input-group-append">
									<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdinformacoescliente(pedidoentrega.idcliente, pedidoentrega.nomecliente, pedidoentrega.vlcreditoclli)" title="Detalhes do cliente"><i class="fa fa-info-circle" style="padding-top: 3px;"></i></a>
								</div>								
							</div>	
						</div>
					</div>
					<div class="row mt-2">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 d-flex flex-column">
							<label for="edstatusatualstt">Situação:</label>
							<span v-if="pedidoentrega.stentregaexterna == 0" class="bdg-stpedido" style="background-color: #6c757d;">Aguardando liberação</span>
							<span v-else-if="pedidoentrega.stentregaexterna == 1" class="bdg-stpedido" style="background-color: green;">Liberado e aguardando retirada.</span>
							<!-- <span class="bdg-stpedido">Aguardando despache</span> -->
						</div>	
					</div>
				</div>

			</div>
			<div class="modal-footer">
				<button v-if="pedidoentrega.tpentregaecommerce == 0 && pedidoentrega.stentregaexterna == 0" type="button" class="btn btn-primary btn-sm" style="width: 140px;" @click.prevent="mtdconfirmaralteracaoentrega()"><i class="fa fa-check"></i> Liberar retirada</button>
				<button v-else type="button" class="btn btn-primary btn-sm mr-auto" style="width: 300px;" @click.prevent="mtdconfirmaenvioemailnotificarentrega()"><i class="fa fa-envelope" aria-hidden="true"></i> Enviar e-mail para notificar cliente</button>
				<button type="button" class="btn btn-secondary btn-sm" @click.prevent="$modal.hide('mdl-gerenciar-entrega')" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
			</div>
        </modal>
		<div class="modal fade" id="mdqtditemconf">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                                          
                    
                    <div class="modal-body">
                        <div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <label for="edqtditemproditem">Quantidade:</label>

									<div class="input-group" style="z-index: 1;">
										<div class="input-group-append">
											<a href="#" class="btn btn-info btn-sm btn-grupo-pesq-left" role="button" @click.prevent="mtdquantidadeconf(2)"><i class="fa fa-minus"></i></a>
										</div>
										<money type="text" class="form-control form-control-sm" id="edqtditemproditem" v-model="vqtditenconf" data-bv-group=".group" maxlength="20" style="text-align:right;" ></money>
										<div class="input-group-append">
											<a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdquantidadeconf(1)"><i class="fa fa-plus"></i></a>
										</div>
									</div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdpreparaqtdconf()" style="width: 100px;"><i class="fa fa-check"></i> Ok</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
                    </div>                          
                </div>
            </div>
        </div> 


		<modal name="mdl-add-formapagto" height="auto" width="800" @before-close="mtdlimpaformaspagto()">
            <div class="modal-header">
				<h6 class="modal-title" style="font-size: 14px;"><i class="fa fa-motorcycle" aria-hidden="true"></i> add forma pgto</h6>
				<button type="button" class="close" @click.prevent="$modal.hide('mdl-add-formapagto')">&times;</button>
			</div>
			<div class="modal-body">
				<div class="container">
					<div class="row">
						<div class="col-12 col-sm-12 col-md-2 col-lg-2">
							<label for="ednrpedido2">Nr. Pedido:</label>
							<input id="ednrpedido2" type="text" v-mask="'########'" class="form-control form-control-sm" v-model="pedidoaddformaspagto.id" disabled>
						</div>
						<div class="col-12 col-sm-12 col-md-3 col-lg-3">
							<label for="edidlancfluxo2">ID Lanç. Fluxo:</label>
							<input id="edidlancfluxo2" type="text" class="form-control form-control-sm" v-model="vidlancfluxo2">
						</div>
						<div  class="col-sm-12 col-md-4 col-lg-4">
							<span class="lblselect2">Forma de pagamento:</span>
							<select id="cbformapagamento2" data-placeholder="Selecione uma forma" v-model="vidformapagamento2" data-allow-clear="true" style="width:100%;">
							</select>
						</div>
						<div class="col-sm-12 col-md-3 col-lg-3">
							<label for="edvlformapgto">Valor forma:</label>
							<money type="text" class="form-control form-control-sm" id="edvlformapgto"  v-model="vvalorformapagto2" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align:right; font-weight: bold; background: honeydew; color: green;"></money>
						</div>	
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary btn-sm mr-auto" style="width: 300px;" @click.prevent="mtdconfirmaaddformaspgto()"><i class="fa fa-envelope" aria-hidden="true"></i> Gravar</button>
				<button type="button" class="btn btn-secondary btn-sm" @click.prevent="$modal.hide('mdl-add-formapagto')" style="width: 100px;"><i class="fa fa-close"></i> Cancelar</button>
			</div>
        </modal>
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
	import vPagination from 'vue-plain-pagination'
	import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
	import ConsultarClientes from '../components/cmpconsultarclientes.vue'
	import EtiquetasVolumesPedido from '../components/cmpetiquetasvolumespedido.vue'
	import util from '../utilitarios/util.js'
	import GraficoPie from '../components/cmpgraficopie.vue'	
    import { useSound } from '@vueuse/sound'
    import conferenciaSfx from '@/assets/conferencia.mp3'
	import DetalhesPedido from '../components/cmpdetalhespedido.vue'	
	import DetalhesProdutos from '../components/cmpdetalhesprodutos.vue'	
	import InformacoesCliente from '../components/cmpinformacoescliente.vue'		
	import AlertaCliente from '../components/cmpconteudoalertacliente.vue'	
	import VisualizadorEstoque from '../components/cmpconsultaestoquepro2'	
	import { faDiceSix } from '@fortawesome/free-solid-svg-icons'


	var _ = require('lodash');

    export default {
        name: 'cadpedidos',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' 			: BreadCrumb,
			'consultaprodutos'  	: ConsultarProdutos,
			'consultaclientes'  	: ConsultarClientes,
			'etiquesvolumespedido'	: EtiquetasVolumesPedido,
			'graficopie'			: GraficoPie,
			'detalhespedido'  		: DetalhesPedido,
			'detalhesprodutos'  	: DetalhesProdutos,
			'informacoescliente'	: InformacoesCliente,
			'alertacliente'			: AlertaCliente,
			'visualizadorestoque'   : VisualizadorEstoque
        },
        data: function() {
            return {
				pedidoaddformaspagto : {id: 0},
				vidformapagamento2	: null,
				vidlancfluxo2		: null,
				vvalorformapagto2	: 0,
				
				//variável para detalhes do pedido
				vidpedidodet : '',
				//variável para detalhes do produto
				vidprodutos : '',
				/////////////////////
				//exibicaocard		: this.$store.state.usuario.exibicaocard == 1 ? true : false,//tipo de visualização da listagem dos pedidos card ou table
				utodasfiliais 		: this.$store.state.usuario.todasfiliais,
				vshowprtabela		: true,
				tipopropesquisa     : '0, 2',
				lstpedidos   		: [],
				pidfilial	 		: null,
				pidpedido    		: '',
				pidcliente	 		: null,
				pidplano			: null,
				pidvendedor  		: null,
				pidrota				: null,
				ptipo				: 4,
				pidentificador		: '',
				presponsavel		: '',				
				pfiltroperiodo      : 1,
				pfiltropor			: 0,
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),				
				psituacao	 		: 0,
				pentregaexterna		: 2,
				psituacaoentrega    : 2,
                pqtdregistros		: 10,
                pqtd_paginas 		: 1,
                pagina_atual 		: 1,
				pqtd_total_registros: 0,
				ptotalaberto		: 0,
				vordemitens         : 0,
				vdestacacupom       : 0,
				vocaoitemguia       : 2,
				ptotalfaturado		: 0,
				ptotalcusto			: 0,
				ptotalimposto			: 0,
				ptotalmkp			: 0,


				// Variavel de detalhar por filial
				detalharfilial 		: 0,

				//Luiz Trindade - Variável de margem de lucro geral
				pmargemlucrogeral	: 0,

				ptotalcancelado		: 0,
				ptotaldesconto		: 0,
				ptotaldescontoperc  : 0,
				ptotalacrescperc    : 0,
				ptotalacrescimo     : 0,

				ptotalcreditos		: 0,
				pqa					: 0,
				pqf					: 0,
				pqc					: 0,
				pqca				: 0,
				pvisualizartotalizadores : 0,
				pvisualizargraficos		 : 0,
				pvisualizarcustos		 : 0,
				pcredito				 : 0,
				pidpedidooff			 : '',
				pidlancamentopdvoff		 : '',
				porigem					 : 10,
				pidmarca     			 : null,
                pidforma     			 : null,	
				pidgrupo				 : null,
				pidstos					 : null,	
				vermelho				 : false,	
				pmaisfiltros			 : false,
				phrini					 : '00:00',
				phrfim					 : '23:59',


			    //id do produto para visualização
				idprodutoestoque    : 0,
                descproestoque      : '',

                //variáveis do crud
				opcrud              :  0,
                vid                 : '',
				vidfilial           : null,
				vidcliente			: '',
				vnomecliente		: '',
				vvlcreditoclidet    : 0,
				vidvendedor			: null,
				vtipo				: 0,
				vdtemissao			: util.DataAtual(),
				valertarcliente		: false,
				vconteudoalerta		: '',
				vidinfcpl           : null,
				vinfcpl             : '',

				vidplano			: null,
				vtipoplano			: 0,
				vdescplano			: '',
				vidtabela			: null,//carrega a tabela vinculada ao plano de pagamento
				vpercentrada		: 0,
				vpermitedesconto	: 0,

				vtotalprodutos		: 0,
				vtotalservicos		: 0,
				videntificador		: '',
				vobjeto				: '',
				vmarcacao			: '',
				vnrserie			: '',
				vmarca				: '',
				vmodelo				: '',
				vresponsavel		: '',
				vfone				: '',
				vdtretorno			: '',
				vdefeitoapresentado	: '',
				vacessorios			: '',
				voutrasinformacoes	: '',
				vobservacoes		: '',
				//vtotalimpostos		: 0,				
				vtotalgeral			: 0,
				vqtditens			: 0,
				vquantitativo		: 0,
				vstpedido			: 0,
				vdtfatura			: '',
				vreservar			: false,
				ventregaexterna		: false,
				vorigem				: 0,
				vpathimagens        : '',
				lstitens			: [],
				lstservicos			: [],
				lstplanos			: [],
				lstchecklist		: [],
				vtotfrete           : 0,
				ativaedicaofrete    : false,
				vtottaxaservico     : 0,
				ativaedicaotxservico: false,	
				vtokenconsultaplaca : '', 			

                //rotina imagens
                arqimgselecionado    : null,
                lstImagens           : [],

				vmostraestoque       : false,

                //pega o path do diretorio padrão das imagens
                pathimgview          : this.$store.state.configpaths.pathimagens,				

				//Filial para geração da NF
				alterafilialnf			: false,//carrega do perfil do usuário
				habbtnf					: false,
				vidfilialnf				: null,
				vnomefilianf			: '',
				vmodelonf				: 55,
				vpedidonf				: [],

				//Variável de edição dos itens do pedido
				vvltotal_old_edicao		: 0,//somente para a alteração
				//vtotalimpostos_old_edicao: 0,
				alteraentra           	: false,
				vedicaodescpro			: true,
				vitem					: 0,
				vitemalteracao			: 0,
				vtitdesc              	: '%',
				vopitem					: 0,							
				vidprodutoedicao    	: '',
				vcoddigedicao			: '',
				vdescricaoprodutoedicao : '',
				vmarcaprodutoedicao     : '',
				vundprodutoedicao		: '',
				vqtditemedicao			: 1,
				vvltabelaitemedicao		: 0,
				vvlunitarioedicao		: 0,
				vprvendaminimo			: 0,
				vdescacresedicao		: 0,
				vtipodescacresedicao	: 0,
				vvalordescacresedicao	: 0,
				vmanipulavaledicao		: 0,
				vvltotaledicao			: 0,
				vvltotalimpostoitemedicao: 0,
				videstoqueedicao		: null,
				vfracionadoedicao		: 0,
				vinfadprod				: '',
				vidtecnicosolicitaedicao: null,	
				vdadosclasseitem		: [],
				vldescmostrar 			: 0,		

				//variáveis de edição dos serviços
				opserv                		: 0,
				vprecoservicoedicao			: [],
				vtitdescserv          		: 'Descto.(%)',				
				vidservicoedicao			: null,
				vidtecnicoedicao			: null,
				vqtdservicoedicao			: 1,
				vvlservicoedicao			: 0,
				vtipodescontoservicoedicao	: 0,
				vvalordescontoservicoedicao	: 0,
				vvltotalservicoedicao		: 0,
				vidstos						: null,
				vdescstos					: '',


                //variável para habilitação dos campos
				ativadesativa       		: true,
				ativadesativavendedor		: true,

				pedidomenu					: [], //para geração do menu do pedido no modal

				//variáveis aplicação do desconto no total dos itens
				vtotalsemdesconto	: 0,
				vtotalcomdesconto   : 0,
				vtipodesctotal		: 0,	
				vfatordescontototal	: 0,
				vresdesconto		: 0,	

				//variaveis do faturamento
				lstformasfaturar	: [],
				lsttitulosfaturar	: [],
				pedidofaturar		: [],
				vdtfatura			: util.DataAtual(),
				vidformapagamento	: null,
				vvlforma			: 0,
				vtipoforma			: 0,
				vespecieforma		: 0,
				vabatecredito		: 0,
				vnrvendaforma		: '',				
				vtotaltitulos		: 0,
				vtotalformas		: 0,
				vdiferenca			: 0,
				//mostrar o cashback disponivel quando houver
				vltotalcashback		: 0,
				vlcashbackdisponivelvenda: 0,

				//variáveis da alteração do título
				tindiceparcela			: 0,
				tacodtit 				: '',
				tadtventit				: '',
				tavltit					: 0,
				taidtipocobranca		: null,
				tatipocobranca			: 0,// 0 - Normal 1 - Cheque
				tadescricaocob			: '',
				tanumerocheque			: '',
				taidbanco				: null,
				tadescbanco				: '',
				taagencia				: '',
				taconta					: '',
				tapraca					: '',
				taemitente				: '',
				tacnpjcpf				: '',						
				taidsituacaocheque		: null,
				tadescsituacaocheque: '',

				tajustarparcelas		: false,//recalcula as parcelas restantes
				tajustarcentavos 		: false,//ajusta os centavos para a ultima parcela
				tajustardatas			: false,//determina se as demais datas serão ajustadas para o mesmo dia

				
				//variáveis para o cancelamento
				pedidocancelar			: [],
				cmotivocancelamento 	: '',
				cdtcancelamento			: util.DataAtual(),

				//variaveis de perfil
				pmanipularvaloritem 	: false,
				pdefinirestoque			: false,
				palterardatafatura		: false,
				palterarvendedor		: false,

				//variaveis da edicao da quantidade de quanto o cliente vai levar
				litemlevar				: [],
				lqtdlevar				: 0,
				lfracionado				: 0,

				//variáveis do gerenciamento da entrega externa
				pedidoentrega			: [],
				eitementregar			: [],
				eqtdentregue			: 1,
				eopimpentrega			: 0,

				//variáveis para visualização das imagens do pedido
				images              	: [],

				//perfil fo fluxo
				vidperfilfluxoforma   	: null,
				vdescperfilfluxoforma 	: '',  				
				
                //alteração perfil fluxo
                aindiceperfilfluxo      : 0,
                aidperfilfluxo          : 0,
                adescperfilfluxo        : '',
				clonar					: false,

				//variáveis da conferência do pedido
                cfidpedido 				: 0,
				lstitensconf			: [],
				lstcodigosconf    		: [],

                ativadesativacod        : true,
                vicodpro                : null,
                videscpro               : '',
                vqtdfalta               : 0,

				vfatorconf              : 1,
                vachouPro               : false,
                vmsgPro                 : '',
                vfaltaitens             : true,
                vfinalizado             : false, 

                //variaveis oculos
				vativainfooculos        : false,
				vesfericoesquerdoperto  : 0,
				vcilindricoesquerdoperto: 0,
				veixoesquerdoperto      : 0,
				vadicaoesquerdoperto    : 0,

				vesfericodireitoperto   : 0,
				vcilindricodireitoperto : 0,
				veixodireitoperto       : 0,
				vadicaodireitoperto     : 0,

				vesfericoesquerdolonge  : 0,
				vcilindricoesquerdolonge: 0,
				veixoesquerdolonge      : 0,
				vadicaoesquerdolonge    : 0,

				vesfericodireitolonge   : 0,
				vcilindricodireitolonge : 0,
				veixodireitolonge       : 0,
				vadicaodireitolonge     : 0,

				vdptotal                : 0,

                 	
				//para alteração da quantidade
				vindiceitemconf 	    : 0,
                vqtditenconf    		: 0,
				
				//variáveis do recibo do pedido
				pedidorecibo			: [],
				prformapagamento		: '',
				prtrasportadora			: '',
				prnnf					: '',
				prindicacao				: '',
				pratividade				: '',
				probservacoes			: '',

				detpedido               : [],

				//variáveis do corte
				crotinacortes		    : false,//variável para permissão do usuário
				cdtini       		    : util.DataAtual(true),
				cdtfim       		    : util.DataAtual(true),
				ctipo				    : 0,
				cdiferenca			    : 2,
				lstitenscorte		    : [],
				cqtditenscorte		    : 0,
				ctotalcortes		    : 0,
				vleghistorico           : [],
				//variáis do item a ser cortado
				itemcortar			    : [],
				pedidocortar		    : [],
				qtditemcortar		    : 1,
				//variáveis da listagem dos itens cortados
				lcdtini       		    : util.DataAtual(true),
				lcdtfim       		    : util.DataAtual(true),
				lcidvendedor		    : null,
				lcidcliente		    	: null,
				lcidrota		    	: null,
				lcidproduto		    	: null,
				lcidsubgrupo		    : null,
				lcidgrupo		    	: null,
				lcidmarca		    	: null,
				lcidcidade              : null,
				lstrecuperacortes       : [],
				vindiceitemalt 			: 0,
                vqtdalteritem  			: 0,
				lstitenspedidosrecuperacorte : [],
				//variáveis de informações do cliente
				idclienteinf			: 0,
				nomeclienteinf			: '',
				vlcreditoinf 			: 0,
				imagemclienteinf        : '',

				//variáveis do crédito avulso
				vidfilialca				: null,
				vidclienteca			: null,
				vvalorcreditoavulso		: 0,
				vobservacoesca			: '',
				

				//variáveis da devolução
				pedidodevolucao			: [],
				dtemissaodevolucao		: util.DataAtual(true),
				totaldevolucao			: 0,
				observacoesdevolucao	: '',
				aestoquedevolucao       : null,
				indicedevolucao         : 0, 
				vgerarcreditodevolucao  : false, 


				//variaveis da impressao de guia - guga
				vqtdpedidosselecionados : 0,
				vpedidosselecionados    : [],

				//variáveis para edição do crédito avulso
				ecreditoavulso			: [],
				eobsalteracaocredito	: '',
				evledicaocreditoavulso  : 0,
				defsubs					: 0,
				vlegcredavulso          : 0,
				vvlcredcedido           : 0,
				vvlcredadquirido        : 0,
			    vlcreditotot            : 0,
				vlegcredanterior        : 0,
				qtddef                  : 0,
				vstyle                  : 'text-align:right; font-weight: bold; background: honeydew; color: green;',

				//variáveis do agrupamento de pedidos
				lstitensagrupados		: [],
				lstservicosagrupados    : [], 
				lstpedidosexcluiragrupar: '',
				vexcluiragrupados		: false,
				

				//variavel para alerta de cliente
				vidclientealerta		: 0,

				//variavel de impressão detalhada
				mostrarDetalheImpressao	: false,
				detalheitem				: 0,

				//variavel emissao de rotulo
				vqtdimpressãorotulo : 1,
                vtprotulo           : 'P',
                vformatorotulo      : 'ET',
                vimprimeremetente   : 'S',
                vlayoutimp          : 'PADRAO',

				//variaveis modal PPL
				lstInfosPPL			: {},
				embalagemEscolhida  : {},
				chavenfe			: '',
				nrnotafiscal		: '',


				sortField: 'id',
    			sortOrder: 'asc', // ou 'desc'
				todosmarcados	: false,

				detcredito : 		{
					idpedido 			: 0,
					vlcredito			: 0,
					vlcreditoutilizado  : 0,
					vlcreditodisponivel	: 0,
					lsthistorico		: [],
					lsthistoricoreccredito	: [],
					detalhecashback			: {
						lista		: [],
						disponiveis : 0,
						vencidos	: 0
					}
				},
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },				
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
				columnsconf: [
					{
						label: "Código",
						name: "coddig",
						sort: true,
						slot_name: "id_f",
						row_classes: "def-col-cod-conf",
					},          						
					{
						label: "Descrição",
						name: "descricao",
						initial_sort : true,
						initial_sort_order: 'asc',
						sort: true,
						row_text_alignment: "text-left",
						column_text_alignment: "text-left"
                    },
					{
						label: "Marca",
						name: "descmarca",
						initial_sort : true,
						initial_sort_order: 'asc',
						sort: true,
						row_text_alignment: "text-left",
						column_text_alignment: "text-left",
						row_classes: "def-col-marca"
                    },
					{
						label: "Unidade",
						name: "und",
						initial_sort : false,
						initial_sort_order: 'asc',
						sort: true,
						row_text_alignment: "text-center",
						column_text_alignment: "text-center",
                        row_classes: "def-col-und"
                    },
                    {
                        label: "Qtd.",
                        name: "qtditem",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "qtd_p",
                        column_classes: "def-col-qtd"
                    },           
                    {
                        label: "Qtd. Conf.",
                        name: "qtdconf",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "qtd_c",
                        column_classes: "def-col-qtdconf"
                    },
                    {
                        label: "Qtd. Falta",
                        name: "qtdfalta",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "qtd_f",
                        column_classes: "def-col-qtdfalta"
                    },
                    {
                        label: "Status",
                        name: "situacao",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "status_s",
                        column_classes: "def-col-status"
                    },                              
                ],				
                itensbc : {
                    item1 : {
                        titulo : 'PEDIDOS',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes_ped",
						sort: false						
                    },
                    {
                        label: "",
                        name: "stpedido",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_detalhes",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    },
                    {
                        label: "Nr.Pedido",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
						row_text_alignment: "text-center",
						column_text_alignment: "text-left",
						row_classes: "def-col-nrpedido",
					},
                    {
                        label: "Tipo",
                        name: "tipo",
                        sort: true,
                        slot_name: "slot_tipo",
                        row_classes: "def-col-tipo",
					},					
                    {
                        label: "Situação",
                        name: "stpedido",
                        sort: true,
                        slot_name: "slot_stpedido",
                        row_classes: "def-col-stpedido",
					},														
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
						sort: true,
						slot_name: "slot_dtemissao",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    },														
                    {
                        label: "Dt.Fatura",
                        name: "dtfatura",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
						sort: true,
						slot_name: "slot_dtfatura",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    },					
                    {
                        label: "Cliente",
                        name: "nomecliente",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
						slot_name: "slot_cliente",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
						row_classes: "def-col-cliente"
                    },
                    {
                        label: "Filial",
                        name: "fantasia",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
						slot_name: "slot_filial",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Vendedor",
                        name: "nomevendedor",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
						slot_name: "slot_vendedor",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},
                    {
                        label: "Plano",
                        name: "descplano",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
						slot_name: "slot_plano",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Identificador",
                        name: "identificador",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
						slot_name: "slot_identificador",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Nr.Série",
                        name: "nrserie",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
						slot_name: "slot_serie",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Retorno",
                        name: "dtretorno",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
						slot_name: "slot_retorno",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },					
                    {
                        label: "Valor",
                        name: "totalgeral",
                        sort: true,
                        slot_name: "slot_totalgeral",
						column_classes: "def-col-totalgeral",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
					{
                        label: "Descto",
                        name: "totaldesconto",
                        sort: true,
                        slot_name: "slot_desconto",
						column_classes: "def-col-totalgeral",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},										
                    {
                        label: "Inf.Off",
                        name: "idpedidooff",
                        sort: true,
                        slot_name: "slot_dadosoff",
						column_classes: "def-col-dadosoff",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},										
                    {
                        label					: "Total Custo",
                        name					: "totalcusto",
                        sort					: true,
                        slot_name				: "slot_totalcusto",
						column_classes			: "def-col-totalcusto",
                        row_text_alignment		: "text-right",
						column_text_alignment	: "text-left",
						visibility				: true						
					},										
                    {
                        label					: "Formas",
                        name					: "formas",
                        sort					: false,
                        slot_name				: "slot_formaspedido",
						column_classes			: "def-col-formas-pedido",
                        row_text_alignment		: "text-left",
						column_text_alignment	: "text-left"						
					}
				],
                columnsi: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        column_classes: "def-col-opcoes",
						sort: false,
						slot_name: "opcoesi"
					},
					{
                        label: "",
                        name: "stpedido",
                        sort: false,
                        initial_sort : false,
                        slot_name: "slot_detalhesprodutos",
                        row_classes: "def-col-detalhes",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center"                        
                    },
                    {
                        label: "Ítem",
						name: "item",
						slot_name: "slot_item",
						sort: true,
						initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado                        
						initial_sort_order: 'asc',
						column_classes: "def-col-item",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
                    },					
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "id_fi",
						column_classes: "def-col-coddig",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
                    },
                    {
                        label: "Descrição",
                        name: "descproduto",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},	
					{
                        label: "Marca",
                        name: "descmarca",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},				
                    {
                        label: "Und.",
                        name: "unditem",
                        sort: true,
                        slot_name: "slot_unditem",
						column_classes: "def-col-unditem",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Vl. Unitário",
                        name: "vlunitario",
                        sort: true,
                        slot_name: "slot_vlunitarioitem",
						column_classes: "def-col-qtdvlunitarioitem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Desc/Acres",
                        name: "valordescacres",
                        sort: true,
                        slot_name: "slot_valordescacres",
						column_classes: "def-col-valordescacres",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Qtd.",
                        name: "qtditem",
                        sort: true,
                        slot_name: "slot_qtditem",
						column_classes: "def-col-qtditem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Levar",
                        name: "qtdlevar",
                        sort: true,
                        slot_name: "slot_qtdlevar",
						column_classes: "def-col-qtdlevar",
                        row_text_alignment: "text-right",
						column_text_alignment: "text-left",						
						visibility:	false
					},					
                    {
                        label: "Total",
                        name: "vltotal",
                        sort: true,
                        slot_name: "slot_vltotalitem",
						column_classes: "def-col-vltotalitem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Estoque",
                        name: "descestoque",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},
                    {
                        label: "Solicitante",
                        name: "nometecnicosolicita",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},	
					{
						visibility : false,
                        label: 'Estoque',
                    
						sort: false,
						slot_name: "estoqueslst",
						row_classes: "def-col-estoques-cmp",
					},
				],
                columnss: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "idservico",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descservico",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Técnico",
                        name: "nometecnico",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Vl. Unitário",
                        name: "vlservico",
                        sort: true,
                        slot_name: "slot_vlunitarioservico",
						column_classes: "def-col-qtdvlunitarioitem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Descto.",
                        name: "valordesconto",
                        sort: true,
                        slot_name: "slot_valordescacres",
						column_classes: "def-col-valordescacres",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Qtd.",
                        name: "qtdservico",
                        sort: true,
                        slot_name: "slot_qtditemserv",
						column_classes: "def-col-qtditem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
                    {
                        label: "Total",
                        name: "vltotal",
                        sort: true,
                        slot_name: "slot_vltotalservico",
						column_classes: "def-col-vltotalitem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},
				],
				columnsientrega: [
                    {
                        label: "Ítem",
						name: "item",
						slot_name: "slot_item",
						sort: true,
						initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado                        
						initial_sort_order: 'asc',
						column_classes: "def-col-item",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
                    },					
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "id_fi",
						column_classes: "def-col-coddig",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
                    },
                    {
                        label: "Descrição",
                        name: "descproduto",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					},				
                    {
                        label: "Und.",
                        name: "unditem",
                        sort: true,
                        slot_name: "slot_unditem",
						column_classes: "def-col-unditem",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Qtd.",
                        name: "qtditem",
                        sort: true,
                        slot_name: "slot_qtditem",
						column_classes: "def-col-qtditem",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",						
					},					
                    {
                        label: "Levou",
                        name: "qtdentregar",
                        sort: true,
                        slot_name: "slot_qtdlevou",
						column_classes: "def-col-qtdlevou",
                        row_text_alignment: "text-right",
						column_text_alignment: "text-left"
					},										
                    {
                        label: "À entregar",
                        name: "qtdentregar",
                        sort: true,
                        slot_name: "slot_qtdlevar",
						column_classes: "def-col-qtdlevar",
                        row_text_alignment: "text-right",
						column_text_alignment: "text-left"
					},										
                    {
                        label: "Entregue",
                        name: "qtdentregue",
                        sort: true,
                        slot_name: "slot_qtdentregue",
						column_classes: "def-col-qtdentregue",
                        row_text_alignment: "text-right",
						column_text_alignment: "text-left"
					},					
                    {
                        label: "Estoque",
                        name: "descestoque",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
					}					
				],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
				}
            }
        },
        methods:{
			qtdmarcados(array){
				let qtdmarcados = 0;
				for(let i = 0; i < array.length; i++){
					if(parseInt(array[i].marcado) === 1){
						qtdmarcados++;
					}
				}
			},
			mtdverificaordematual(campo) {
				if (this.sortField === campo) {
					return this.sortOrder;
				}
				return 'asc'; // padrão
			},
			mtdsortlista(campo) {
				// alterna se for o mesmo campo
				if (this.sortField === campo) {
					this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
				} else {
					this.sortField = campo;
					this.sortOrder = 'asc';
				}

				this.lstpedidos = _.orderBy(this.lstpedidos, [campo], [this.sortOrder]);
			},
			marcadesmarcatodos(){
				let qtdmarcados = 0;
				this.todosmarcados = true;
				for(let i = 0; i < this.lstpedidos.length; i++){
					if(parseInt(this.lstpedidos[i].marcado) === 1){
						qtdmarcados++;
					}
				}
				if(qtdmarcados === this.lstpedidos.length){
					//desmarcar todos
					this.todosmarcados = false;
					for(let i = 0; i < this.lstpedidos.length; i++){
						this.lstpedidos[i].marcado = 0;
					}
				}else{
					//marcar todos
					this.todosmarcados = true;
					for(let i = 0; i < this.lstpedidos.length; i++){
						this.lstpedidos[i].marcado = 1;	
					}	
				}

				this.mtdprocessaselecionados();
			},
			marcadesmarcaitem(item, index){
				let vself = this;
				if(parseInt(item.marcado) === 1){
					vself.lstpedidos[index].marcado = 0;
				}else{
					vself.lstpedidos[index].marcado = 1;	
				}
				vself.mtdprocessaselecionados();
			},
			mtdformatafone(fone){
				return util.formatarfone(fone);
			},
			mtdInfosEmbalagem() {
				let vself = this;
				// let loader = vself.$loading.show();
				let parametros = [
					{ parametro: 'op', valor: 'listagemdadosembalagem' },
					{ parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
					{ parametro: 'idembalagem', valor: vself.lstInfosPPL.idembalagem },
				];

				let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/ecommerce/auxiliares.php');

				retorno.then(function (response) {
					if (response.data.inf === 0 || response.data.erro) {
						vself.$toastr.e(response.data.erro, 'Erro!');
						return;
					}
					vself.embalagemEscolhida = response.data;
					// loader.hide();
				}).catch(function (error) {
					vself.$toastr.e('Erro na comunicação com o servidor.', 'Erro!');
					// loader.hide();
				});
			},
			carregaInfosEcommerce() {
				let vself = this;
				let loader = vself.$loading.show();

				let parametros = [
					{ parametro: 'op', valor: 'listagemdadosecommerce' },
					{ parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
					{ parametro: 'idpedido', valor: vself.pedidoentrega.id },
				];

				let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/ecommerce/auxiliares.php');

				retorno.then(function (response) {
					if (response.data.inf === 0 || response.data.erro) {
						vself.$toastr.e(response.data.erro, 'Erro!');
						loader.hide();
						return;
					}
					vself.lstInfosPPL = response.data;
					vself.mtdInfosEmbalagem();
					loader.hide();
				}).catch(function (error) {
					vself.$toastr.e('Erro na comunicação com o servidor.', 'Erro!');
					loader.hide();
				});
			},

			async mtdGerarRotuloImpresso() {
				let vself = this;

				let loader = vself.$loading.show();
				let parametros = [
					{ parametro: 'op', 				valor: 'emiterotulo' },
					{ parametro: 'idclientesac', 	valor: vself.$store.state.filialpadrao.idcliente },
					{ parametro: 'idfilial', 		valor: vself.pedidoentrega.idfilial },
					{ parametro: 'idpedido', 		valor: vself.pedidoentrega.id },
					{ parametro: 'idcliente', 		valor: vself.pedidoentrega.idcliente },
					{ parametro: 'qtdimp', 			valor: vself.vqtdimpressãorotulo },
					{ parametro: 'tprotulo', 		valor: vself.vtprotulo },
					{ parametro: 'formatorotulo', 	valor: vself.vformatorotulo },
					{ parametro: 'impremetente', 	valor: vself.vimprimeremetente },
					{ parametro: 'layoutimp', 		valor: vself.vlayoutimp },
				];

				try {
					const response = await util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadpedidosvenda.php');

					if (response.data.success) {
						await vself.mtdDownloadRotulo(response.data.idrecibo);
					} else {
						vself.$toastr.e(response.data.msg || 'Erro ao gerar rótulo.', 'Erro!');
					}
				} catch (error) {
					vself.$toastr.e('Erro na comunicação: ' + (error.message || 'Tente novamente.'), 'Erro!');
				} finally {
					loader.hide();
				}
			},
			async mtdDownloadRotulo(idrecibo) {
				let vself = this;

				const formData = new FormData();
				formData.append('op', 'baixarrotulo');
				formData.append('idrecibo', idrecibo);
				formData.append('idclientesac', vself.$store.state.filialpadrao.idcliente);
				formData.append('idfilial', vself.pedidoentrega.idfilial);
				formData.append('idpedido', vself.pedidoentrega.id);
				formData.append('idcliente', vself.pedidoentrega.idcliente);

				let adrsrv = vself.$store.state.usuario.adrsrv;
				if (!/^https?:\/\//i.test(adrsrv)) {
					adrsrv = 'https://' + adrsrv;
				}
				let url = adrsrv + '/controller/rtcadpedidosvenda.php';
				// let url = vself.$store.state.usuario.adrsrv + '/controller/rtcadpedidosvenda.php';

				try {
					const response = await fetch(url, {
						method: 'POST',
						body: formData,
					});

					if (!response.ok) {
						throw new Error('Erro na requisição: ' + response.status);
					}

					const data = await response.json();

					if (data && data.dados) {
						const base64 = data.dados;
						const blob = vself.base64ToBlob(base64, 'application/pdf');
						const blobUrl = URL.createObjectURL(blob);
						window.open(blobUrl, '_blank');
					} else {
						vself.$toastr.e('Rótulo não encontrado.', 'Erro!');
					}
				} catch (err) {
					console.error(' Erro ao baixar o rótulo:', err);
					vself.$toastr.e('Erro ao baixar o PDF do rótulo.', 'Erro!');
				}
			},
			// async mtdDownloadRotulo(idrecibo) {
			// 	let vself = this;

			// 	let adrsrv = vself.$store.state.usuario.adrsrv;
			// 	if (!/^https?:\/\//i.test(adrsrv)) {
			// 		adrsrv = 'https://' + adrsrv;
			// 	}

			// 	const params = new URLSearchParams({
			// 		op: 'baixarrotulo',
			// 		idrecibo: idrecibo,
			// 		idclientesac: vself.$store.state.filialpadrao.idcliente,
			// 		idfilial: vself.pedidoentrega.idfilial,
			// 		idpedido: vself.pedidoentrega.id,
			// 		idcliente: vself.pedidoentrega.idcliente,
			// 	});

			// 	const url = `${adrsrv}/controller/rtcadpedidosvenda.php?${params.toString()}`;

			// 	try {
			// 		window.open(url, '_blank');
			// 	} catch (err) {
			// 		console.error('Erro ao abrir o rótulo:', err);
			// 		vself.$toastr.e('Erro ao abrir o PDF do rótulo.', 'Erro!');
			// 	}
			// },

			base64ToBlob(base64, mime) {
				const byteChars = atob(base64);
				const byteNumbers = new Array(byteChars.length);
				for (let i = 0; i < byteChars.length; i++) {
					byteNumbers[i] = byteChars.charCodeAt(i);
				}
				const byteArray = new Uint8Array(byteNumbers);
				return new Blob([byteArray], { type: mime });
			},
			mtdGerarPrePostagem() {
				let vself = this;

				if(parseInt(vself.pedidoentrega.idnotafiscal) <= 0){
					
					vself.$toastr.e('Necessário gerar e enviar a nota fiscal antes da Pré-Postagem.', 'Erro!');
					return;
				}

				let loader = vself.$loading.show();
				let parametros = [
					{ parametro: 'op', valor: 'prepostagem' },
					{ parametro: 'idclientesac', valor: vself.$store.state.filialpadrao.idcliente },
					{ parametro: 'idfilial', valor: vself.pedidoentrega.idfilial },
					{ parametro: 'idpedido', valor: vself.pedidoentrega.id },
					{ parametro: 'idcliente', valor: vself.pedidoentrega.idcliente },
				];
				let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv + '/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					loader.hide();
					if(response.data && response.data.inf == 1){
						vself.$toastr.s(response.data.message || 'Pré-Postagem processada com sucesso!', 'Informação!');
						vself.$modal.hide('mdl-info-pedido-ecommerce');
						vself.carregaInfosEcommerce();
					} else {
						vself.$toastr.e(response.data.message || 'Erro ao processar Pré-Postagem.', 'Erro!');
						vself.$modal.hide('mdl-info-pedido-ecommerce');
					}
				}).catch(function (error) {
					loader.hide();
					vself.$toastr.e(error.message || 'Erro na comunicação com o servidor.', 'Erro!');
					vself.$modal.hide('mdl-info-pedido-ecommerce');
				});
			},
			mtdConsultaDadosTokenPlaca(){
				let vself = this;
				if (vself.vidfilial != null) {
					//let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',       valor : ' and f.codfil='+vself.vidfilial},
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0},
					];
					let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
					retorno.then(function (response) {
						vself.vtokenconsultaplaca = response.data[0].tokenplacas;
						
						//pega o estoque padrão da filial selecionada
						//19/08/2025 11:10 Nilson Oliveira
						//Adicionei aqui pra que toda vez que selecionar a filial carregar o estoque padrão dela
						vself.videstoqueedicao			= response.data[0].idestoque;
						var defestoque  				= new Option(response.data[0].descestoque, vself.videstoqueedicao, true, true);
						$('#cbestoqueedicao').append(defestoque).trigger('change');

						//loader.hide();

					}).catch(function (response) {
						//loader.hide();
					});
				} else {//quando limpa seleção
					vself.vtokenconsultaplaca = '';	
					vself.videstoqueedicao			= null;
					$('#cbestoqueedicao').val(null).trigger('change');
				}
			},
			contultaplaca(){
				let vself = this;

				if(vself.vtokenconsultaplaca.trim() === ''){
					vself.$toastr.w('Informe a chave de api no cadastro de filiais!', 'Atenção!');
					return;
				}
				if(vself.videntificador.trim() === ''){
					vself.$toastr.w('O número da placa!', 'Atenção!');
					return;
				}

				fetch(`https://wdapi2.com.br/consulta/${this.videntificador.toUpperCase()}/${this.vtokenconsultaplaca}`)
				.then(response => response.json())
				.then(data => {
					vself.vobjeto		= data.extra?.tipo_veiculo || 'Automovel';
					vself.vnrserie	    = !data.chassi ? '' : data.chassi;
					vself.vmarca		= !data.marca  ? '' : data.marca;
					vself.vmodelo		= !data.modelo ? '' : data.modelo;
				})
				.catch(error => {
					console.error('Erro na consulta:', error);
				});
			},
			mtddimpressaosint(){
				let vself 			= this;
				$.confirm({
					title: 'Confirmação!',
					content: 'Deseja sintetizar a impressão?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'cancelar',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						Sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-success',
							action: function () {
								vself.mtdimprimesint()
							},
						},
						cancelar: {
							text: '<u>C</u>ancelar',
							keys: ['n', 'N'],
							action: function () {
							

							}
						}
					}
				});
			},
			mtdimprimesint(){
				let lstpedidosimp = '';

				if(this.pidcliente === null && parseInt(this.psituacao) !== 1){
					this.$toastr.w('Para gerar a impressão sintetizada o pedido deve estar faturado e o cliente informado!', 'Atenção!');
					return;
				}

				if(!this.exibicaocard){
					for (var i = 0; i < this.$refs.reflstpedidos.selected_items.length; i++) {
						lstpedidosimp = lstpedidosimp+', '+this.$refs.reflstpedidos.selected_items[i].id; 
					}
				}else{
					for (var i = 0; i < this.lstpedidos.length; i++) {
						if(parseInt(this.lstpedidos[i].marcado) === 1){
							lstpedidosimp = lstpedidosimp+', '+this.lstpedidos[i].id; 
						}
					}					
				}
				

				window.open(this.$store.state.configpaths.pathcontrole+'rtcadpedidosvenda.php?idclientesac='+this.$store.state.filialpadrao.idcliente+'&op=imprimirsintetizada'+
								'&idu='+
								this.$store.state.usuario.id+
								'&idcliente='+
								this.pidcliente+
								'&pedidos='+
								lstpedidosimp.substring(2), '_blank');
			},
			mtdlimpafiltros(){//adicionar novos filtros aqui no futuro
				if(parseInt(this.utodasfiliais) === 0){
					var deffilial  	= new Option(this.$store.state.filialpadrao.fantasia, this.$store.state.filialpadrao.codfil, true, true);
					$('#cbfilialpesq').append(deffilial).trigger('change');	
				}
				this.pidvendedor     = null;
				this.pidrota         = null;
				this.pidcliente      = null;
				this.pidplano        = null;
				$('#cbvendedorpesq').val(null).trigger('change');
				$('#cbrotapesq').val(null).trigger('change');
				$('#cbplanopesq').val(null).trigger('change');
				$('#cbclientepesq').val(null).trigger('change');
			},
			mtddetalhesprodutos(idproduto){
				this.vidprodutos = 0;
                this.vidprodutos = idproduto;
                $('#mddetalhesproduto').modal('show');  
			},
			mtdsetarqtditemconf(item){
				this.vindiceitemconf = util.getArrayIndexForKey(this.lstitensconf, 'idproduto', item.idproduto);
				this.vqtditenconf    = parseFloat(item.qtdconf);
				$('#mdqtditemconf').modal('show');

			},
			mtdisalowedqtdconf(){
				if(util.opcaousuario('020Z.010Z.260Z', this.$store.state.perfilusuario)){///MANIPULAR QUANTIDADE NA CONFERÊNCIA 
					return true
				}else{
					return false
				}
			},
			mtdpreparaqtdconf(){
				var quantidadefalta     = 0
				var quantidadeconferida = 0 
				var atingido            = false; 

				if((parseFloat(this.vqtditenconf)) > (parseFloat(this.lstitensconf[this.vindiceitemconf].qtditem)) ){
					this.$toastr.w('A quantidade não pode ultrapassar o total disponivel para conferência', 'Atenção!');
					return;
				}

				
				quantidadeconferida = parseFloat(this.vqtditenconf);
				quantidadefalta     = parseFloat(this.vqtditenconf) - parseFloat(this.lstitensconf[this.vindiceitemconf].qtditem);
				

				if(quantidadeconferida === parseFloat(this.lstitensconf[this.vindiceitemconf].qtditem)){
					atingido = true;
				}


				this.lstitensconf[this.vindiceitemconf].qtdfalta = quantidadefalta
				this.lstitensconf[this.vindiceitemconf].qtdconf  = quantidadeconferida
				this.lstitensconf[this.vindiceitemconf].situacao = atingido ? 1 : 0;
				

                this.vindiceitemconf = 0;
                this.vqtditenconf    = 0;
                $('#mdqtditemconf').modal('hide');

			},
			mtdInfosPrePostagem(){
				this.$modal.show('mdl-info-pedido-ecommerce');
			},
			mtdpreparaalterarstatusentrega(){
				this.$modal.show('mdl-gerenciar-entrega');
			},
			mtdconfirmaralteracaoentrega(){
				let vself = this;
				$.confirm({
						title: 'Confirmação!',
						content: 'Deseja confirmar a alteração no pedido?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						escapeKey: 'nao',
						type: 'dark',
						typeAnimated: true,
						buttons: {
							sim: {
								text: '<u>S</u>im',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: function () {
									vself.mtdalteracaoentrega();
								},
							},
							nao: {
								text: '<u>N</u>ão',
								keys: ['n', 'N'],
								action: function () {
								}
							}
						}
					});
			},
			mtdalteracaoentrega(){
				let vself           = this;
				let loader          = vself.$loading.show();
				let stentregaexterna = 0;
				let idtransportadora = 0;
				let codrastreioentrega = '';

				if(vself.pedidoentrega.tpentregaecommerce == 0) {
					stentregaexterna = 1
				}

				let registro = {
					idpedido 				: vself.pedidoentrega.id,
					idcliente 				: vself.pedidoentrega.idcliente,
					stentregaexterna		: stentregaexterna,
					idtransportadora		: idtransportadora,
					codtrasnteiraentrega	: codrastreioentrega,
				}

				let parametros      = [
					{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'alterarsituacaoentrega'},
					{parametro: 'registro',     valor : JSON.stringify(registro)},
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data.inf)){
						vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.pedidoentrega.stentregaexterna = response.data.pedido.stentregaexterna;
					}else{
						vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
					}
			
				}).catch(function (response) {
					loader.hide()
				}); 
			},
			mtdconfirmaenvioemailnotificarentrega(){
				let vself = this;
				$.confirm({
						title: 'Confirmação!',
						content: 'Deseja enviar o e-mail de notificação de entrega?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						escapeKey: 'nao',
						type: 'dark',
						typeAnimated: true,
						buttons: {
							sim: {
								text: '<u>S</u>im',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: function () {
									vself.mtdenviaremailnotificarentrega();
								},
							},
							nao: {
								text: '<u>N</u>ão',
								keys: ['n', 'N'],
								action: function () {
								}
							}
						}
					});
			},
			mtdenviaremailnotificarentrega(){
				let vself           = this;
				let loader          = vself.$loading.show();
				let parametros      = [
					{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'enviaremailentregapedido'},
					{parametro: 'idpedido',     valor : vself.pedidoentrega.id},
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)){
						vself.$toastr.s('E-mail enviado com sucesso!', 'Informação!');
					}else{
						vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
					}
			
				}).catch(function (response) {
					loader.hide()
				}); 
			},
			mtdverificatiposis(tp){
				if(parseInt(tp) === parseInt(this.$store.state.usuario.tpsistema)){
					return true;
				}else{
					return false;
				}
            },
			mtdprocessitensrec(lstprodutos, lstprodutoscorte){
				
				this.vidplano 			= this.$store.state.filialpadrao.idplano;					
				this.vdescplano	    	= this.$store.state.filialpadrao.descplano;
				this.vtipoplano	    	= this.$store.state.filialpadrao.tipoplano;
				this.vidtabela			= this.$store.state.filialpadrao.idtabela;									
				this.vpercentrada		= this.$store.state.filialpadrao.percentrada;
				this.vpermitedesconto	= this.$store.state.filialpadrao.permitedesconto;

				for (let index = 0; index < lstprodutoscorte.length; index++) {

					let indicemaster = util.getArrayIndexForKey(lstprodutos, 'id', lstprodutoscorte[index].idproduto)

					let prtabela     = util.mtdcarregaprecotabela(lstprodutos[indicemaster].tabelas, this.vidtabela)

					let ret 		 = util.itemcomimposto(this.mtdclasseitem(lstprodutos[indicemaster].classes), parseFloat(prtabela), lstprodutoscorte[index].qtdrecupera, 0, 0);
				

					if(util.findValInArray(this.lstitens, 'idproduto', lstprodutoscorte[index].idproduto)){ ///se ja existir na listagem
						
						
						let ind = util.getArrayIndexForKey(this.lstitens, 'idproduto', lstprodutoscorte[index].idproduto);

						
						let retalt = util.itemcomimposto(this.mtdclasseitem(lstprodutos[indicemaster].classes), prtabela, lstprodutoscorte[index].qtdrecupera, 0, 0);
						
						this.lstitens[ind].qtditem        = this.lstitens[ind].qtditem + lstprodutoscorte[index].qtdrecupera;
						this.lstitens[ind].vltotal        = parseFloat(this.lstitens[ind].vltotal) + parseFloat(retalt.vltotalitem);
						this.lstitens[ind].vltotalimposto = parseFloat(this.lstitens[ind].vltotalimposto) + parseFloat(retalt.totalimpostoitem);
						this.lstitens[ind].qtdentregar    = lstprodutoscorte[index].qtdrecupera;

						this.vqtditens			= this.lstitens.length;
						this.vquantitativo		= this.vquantitativo + parseFloat(lstprodutoscorte[index].qtdrecupera);							
													
					}else{
						let itl = this.lstitens.length === 0 ? 0 : this.lstitens[this.lstitens.length - 1].item;
						let itemtmp = {
							idproduto		    : lstprodutos[indicemaster].id,
							descproduto		    : lstprodutos[indicemaster].descricao, //trazer do payload
							descmarca		    : lstprodutos[indicemaster].descmarca, //trazer do payload
							coddig			    : lstprodutos[indicemaster].id,
							item			    : itl + 1,//this.lstitens.length + 1,
							qtditem			    : lstprodutoscorte[index].qtdrecupera, //trazer do payload,
							unditem			    : lstprodutos[indicemaster].und, //trazer do payload,
							vlunitario		    : prtabela, //trazer do payload,
							descacres		    : 0,
							tipodescacres	    : 0, 
							valordescacres	    : 0,
							manipulaval		    : 0,
							vltotal			    : parseFloat(ret.vltotalitem),      //trazer do payload, 
							vltotalimposto      : parseFloat(ret.totalimpostoitem), //trazer do payload,
							idestoque		    : this.$store.state.filialpadrao.idestoque,
							descestoque		    : this.$store.state.filialpadrao.descestoque, //não sei como, mas vou dar um jeito de trazer do payload tambem,
							infadprod		    : '',
							qtdentregar		    :  lstprodutoscorte[index].qtdrecupera, //trazer do payload, 
							idtecnicosolicita   :  0,
							nometecnicosolicita : ''						
						};	
						this.lstitens.push(itemtmp);

						this.vqtditens			= this.lstitens.length;
						this.vquantitativo		= this.vquantitativo + parseFloat( lstprodutoscorte[index].qtdrecupera);							
					}
				}
				//this.mtdrecalcularprecos();//recalcula tudo
				this.mtdrecalculartudo(false);

			},
			mtdgerarpedidoviareccorte(){
				let vself     = this;
				let idcliente = this.lcidcliente;
				$('#mdgerenciarecuperacorte').modal('hide');
				vself.mtdnovo()

				//
				vself.vidcliente = idcliente;

				vself.mtdlocalizarcliente(idcliente);


				let lstprodutosped = '';
				for (var i = 0; i < vself.lstitenspedidosrecuperacorte.length; i++) {
					lstprodutosped = lstprodutosped+', '+vself.lstitenspedidosrecuperacorte[i].idproduto; 
				}

				//let loader      = vself.$loading.show();
				let parametros  = [
					{parametro: 'op',               valor : 'listagem'},
					{parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'filtro',           valor : ' and p.tipo in (0, 2) and p.id in ('+lstprodutosped.substring(2)+')'},
					{parametro: 'limit',            valor : 99999},
					{parametro: 'offset',           valor : 0},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
				retorno.then(function (response) {
					//loader.hide();						
					
					vself.mtdprocessitensrec(response.data, vself.lstitenspedidosrecuperacorte)


				}).catch(function (response) {
					//loader.hide();
				});
			},
			mtdprocessaitenscortes(){
				let vself = this;

				vself.lstitenspedidosrecuperacorte = [] //reseta

				if(this.lcidcliente !== null){
					/////////////////////////////////////////
					if(util.opcaousuario('020Z.010Z.250Z', vself.$store.state.perfilusuario)){
						$.confirm({
							title: 'Confirmação!',
							content: 'Deseja Gerar um pedido de venda para os itens recuperados',
							icon: 'fa fa-question-circle',
							escapeKey: true,
							backgroundDismiss: false,
							escapeKey: 'nao',
							type: 'orange',
							typeAnimated: true,
							buttons: {
								sim: {
									text: '<u>S</u>im',
									keys: ['s', 'S'],
									btnClass: 'btn-blue',
									action: function () {
										for (let index = 0; index < vself.lstrecuperacortes.length; index++) {
											if(parseFloat(vself.lstrecuperacortes[index].qtdrecupera) > 0){
												vself.lstitenspedidosrecuperacorte.push(vself.lstrecuperacortes[index])
											}	
										}
										vself.mtdgerarpedidoviareccorte()
									},
								},
								nao: {
									text: '<u>N</u>ão',
									keys: ['n', 'N'],
									action: function () {
										vself.mtdlistaritenscortes();
									}
								}
							}
						});	
					}else{
						vself.mtdlistaritenscortes();
					}
				}else{
					vself.mtdlistaritenscortes();
				}
			},
			mtdbuscahistorico(corte){
				this.vleghistorico = corte;
				$('#mdhistoricocorte').modal('show');
			},
			mtdpreparaqtd(){
                this.lstrecuperacortes[this.vindiceitemalt].qtdrecupera    = parseFloat(this.vqtdalteritem); 
                this.vindiceitemalt = 0;
                this.vqtdalteritem  = 0;
                $('#mdqtditem').modal('hide');
            },
			mtdinserirqtd(item){
              
				this.vqtdalteritem  = 0;
				this.vindiceitemalt = util.getArrayIndexForKey(this.lstrecuperacortes, 'id', item.id);                
				this.vqtdalteritem  = parseFloat(this.lstrecuperacortes[this.vindiceitemalt].qtdrecupera)  
				$('#mdqtditem').modal('show');
                
            },
			mtdalterarqtd(item, aumentar, qtd){
				let indiceitem 		= util.getArrayIndexForKey(this.lstrecuperacortes, 'id', item.id);                
				if (aumentar) {
					this.lstrecuperacortes[indiceitem].qtdrecupera   += parseFloat(qtd); 
				}else{
					if (parseFloat(this.lstrecuperacortes[indiceitem].qtdrecupera) > 1){
						this.lstrecuperacortes[indiceitem].qtdrecupera   -= parseFloat(qtd);
					}else{
						return;
					}
				}    
            },
			mtdprocessarecuperacorte(){
				let vself           = this;
				let loader          = vself.$loading.show();
				let parametros      = [
					{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'recuperaitenscortados'},
					{parametro: 'itens',        valor : JSON.stringify(vself.lstrecuperacortes)},
					{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
					{parametro: 'idusuario',    valor : vself.$store.state.usuario.id}
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)){
						vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.mtdprocessaitenscortes();
					}else{
						vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
					}
			
				}).catch(function (response) {
					loader.hide()
				}); 
			},
			mtdrecuperaitenscortados(){
				let vself       = this;

				let qtdrecupera = 0;


				for (let index = 0; index < vself.lstrecuperacortes.length; index++) {
					qtdrecupera  += vself.lstrecuperacortes[index].qtdrecupera;
				}
				if(qtdrecupera > 0){
					$.confirm({
						title: 'Confirmação!',
						content: 'Deseja recuperar os cortes informados?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						escapeKey: 'nao',
						type: 'orange',
						typeAnimated: true,
						buttons: {
							sim: {
								text: '<u>S</u>im',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: function () {
									vself.mtdprocessarecuperacorte();
								},
							},
							nao: {
								text: '<u>N</u>ão',
								keys: ['n', 'N'],
								action: function () {
								}
							}
						}
					});		
				}else{
					vself.$toastr.w('Informe a quantidade de recuperação para executar esta ação!', 'Atenção!');
				}
			},
			mtdlistaritenscortes(){
				let vself           = this;


				let filtro		 = 'and i.dthrcorte between "' + util.InverterData(vself.lcdtini) + ' : 00:00:00" and "' + util.InverterData(vself.lcdtfim) + ' : 23:59:59"';

				if (vself.lcidvendedor !== null){
					filtro		 = filtro + ' and i.idvendedor='+vself.lcidvendedor;
				}
				if (vself.lcidproduto !== null){
					filtro		 = filtro + ' and i.idproduto='+vself.lcidproduto;
				}
				if (vself.lcidrota !== null){
					filtro		 = filtro + ' and r.id='+vself.lcidrota;
				}
				if (vself.lcidmarca !== null){
					filtro		 = filtro + ' and p.idmarca='+vself.lcidmarca;
				}
				if (vself.lcidcidade !== null){
					filtro		 = filtro + ' and c.idmunicipio='+vself.lcidcidade;
				}
				if (vself.lcidgrupo !== null){
					filtro		 = filtro + ' and p.idgrupo='+vself.lcidgrupo;
				}
				if (vself.lcidsubgrupo !== null){
					filtro		 = filtro + ' and p.idsubgrupo='+vself.lcidsubgrupo;
				}
				if (vself.lcidcliente !== null){
					filtro		 = filtro + ' and i.idcliente='+vself.lcidcliente;
				}

				let loader          = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'gerenciaritenscortados'},
					{parametro: 'filtro',       valor : filtro},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
					vself.lstrecuperacortes =  response.data.itens;
			
                }).catch(function (response) {
                    loader.hide()
                   
                });
			},
			mtdalterarestoquedevolucao(index){
				if(!util.opcaousuario('020Z.010Z.230Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{
					this.aestoquedevolucao = null;
					$('#cbestoquedevolucao').val(null).trigger('change');
					this.indicedevolucao   = index;
					$('#mdalteraestoquedevolucao').modal('show');
				}
			},
			mtdconfirmaestoquedevolucao(){
				let ped = JSON.parse(JSON.stringify(this.pedidodevolucao));

				ped.itens[this.indicedevolucao].idestoque   = this.aestoquedevolucao;
				ped.itens[this.indicedevolucao].descestoque = $('#cbestoquedevolucao').select2('data')[0]['text'];

				this.pedidodevolucao = JSON.parse(JSON.stringify(ped));
			},
			confirmarImpressao(detimp) {
				let vself = this;
				if(detimp === 0 && vself.pidfilial === null){
					$.confirm({
                    title: 'Confirmação!',
                    content: 'Detalhar filial na impressão?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.detalharfilial = 1;
                                vself.mtdimpressao();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                vself.detalharfilial = 0;
                                vself.mtdimpressao();
                            }
                        }
                    }
                });
				}else{
					vself.mtdimpressao(0); 
					vself.mostrarDetalheImpressao = false; 
					$('.dropdown-toggle').dropdown('hide'); 
					vself.detalheitem = 0;
				} 
			},
			alternadetalheimpressao() {
				this.mostrarDetalheImpressao = !this.mostrarDetalheImpressao;
			},
			mtdinformafator(){
				if(util.opcaousuario('020Z.010Z.033Z', this.$store.state.perfilusuario)){
					return true
				}else{
					return false
				}
			},
			mtdatualizapedidolista(pedido, idpedido){
				let legpedidos     = JSON.parse(JSON.stringify(this.lstpedidos));
				this.lstpedidos    = [];
				
				let ind = util.getArrayIndexForKey(legpedidos, 'id', idpedido);
				legpedidos[ind]    = pedido;
				
				this.lstpedidos    = JSON.parse(JSON.stringify(legpedidos));
			},
			mtdverificaperfilalt(){
				if(parseInt(this.opcrud)===2){
					if(util.opcaousuario('020Z.010Z.027Z', this.$store.state.perfilusuario)){
						return false
					}else{
						return true
					}
				}else{
					return false
				}
			},
			mtdmudamostraestoque(){
				if(this.vmostraestoque){
					this.vmostraestoque = false
				}else{
					this.vmostraestoque = true
				}
			},
			mtdprocessaestoquepro(produtos){
				let leglstitens = JSON.parse(JSON.stringify(this.lstitens));
				this.lstitens   = [];
				for (let index = 0; index < produtos.length; index++) {
					let ind = util.getArrayIndexForKey(leglstitens, 'item', produtos[index].item);
					leglstitens[ind].estoques = produtos[index].estoques
				}
				this.lstitens = JSON.parse(JSON.stringify(leglstitens));

			},
			mtdconsultarestoqueitens(){
				let vself = this;
				if(this.lstitens.length > 0){
					let itens = [];
					for (let index = 0; index < this.lstitens.length; index++) {
						//////////////// 

						let itemtmp = {
							item      : this.lstitens[index].item,
							idproduto : this.lstitens[index].coddig,
							idestoque : this.lstitens[index].idestoque
						} 

                        itens.push(itemtmp);

						////////////////
					}

					let loader      = vself.$loading.show();
				
					let parametros  = [
						{parametro: 'op',           valor : 'estoquesprodutos'},
						{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'itens',        valor : JSON.stringify(itens)},
					
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
					retorno.then(function (response) {
						loader.hide();   
					    vself.mtdprocessaestoquepro(response.data)
					}).catch(function (response) {
						loader.hide();
					});
				}
			},
			mtdfecharconsulta(){
				let payload = {
					abrirtela    : false			
				};
				this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);								
			},
			mtdvisualizarestoque(item){
				this.idprodutoestoque = item.idproduto;
				this.descproestoque   = item.descproduto;
				// $('#mdestoqueproduto2').modal('show');

				let payload = {
					abrirtela    : true,
					idproduto    : this.idprodutoestoque,
					descproduto  : this.descproestoque			
				};
				this.$store.commit('CONSULTA_ESTOQUE_CHANGE',payload);
			},
			mtdativafocusfrete(){
				this.ativaedicaofrete = true; 
				setTimeout(function() {
					$('#totalfrete').focus()
				}, 300);
				
			},
			mtdativafocustxservico(){
				this.ativaedicaotxservico = true; 
				setTimeout(function() {
					$('#totaltaxaservico').focus()
				}, 300);
				
			},
			mtdativafrete(){
				this.ativaedicaofrete = false
				this.vtotalgeral	= parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtotfrete) + parseFloat(this.vtottaxaservico);
		    },
			mtdativatxservico(){
				this.ativaedicaotxservico = false
				this.vtotalgeral	= parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtotfrete) + parseFloat(this.vtottaxaservico);
		    },
			mtdopmaisfiltros(){
				this.pmaisfiltros 	= this.pmaisfiltros ? false : true;
				this.phrini			= '00:00';
				this.phrfim			= '23:59';				
			},	
			calculatotalind(){
				let valdescacres 			= 0;
				let totaledicaosemimposto 	= 0;
				this.vldescmostrar			= 0;

				switch (parseInt(this.vtipodescacresedicao)) {
					case 0://Percentual
						valdescacres 		= this.vqtditemedicao * this.vvlunitarioedicao * this.vvalordescacresedicao / 100;
						this.vldescmostrar 	= valdescacres;
						break;
					case 1://Valor
						valdescacres 		= this.vvalordescacresedicao;
						this.vldescmostrar 	= (valdescacres / (this.vqtditemedicao * this.vvlunitarioedicao) * 100).toFixed(2);
						break;
				}
				
				let ret = util.itemcomimposto(this.vdadosclasseitem, parseFloat(this.vvlunitarioedicao), parseFloat(this.vqtditemedicao), parseFloat(this.vdescacresedicao), parseFloat(valdescacres));								

				this.vvltotalimpostoitemedicao = parseFloat(ret.totalimpostoitem);
				this.vvltotaledicao 		   = parseFloat(ret.vltotalitem);
				this.mtdtpdescacres(this.vtipodescacresedicao);
			},
			processaprodutos(items){
				for (let index = 0; index < items.length; index++) {

					let ret = util.itemcomimposto(this.mtdclasseitem(items[index].prod.classes), parseFloat(items[index].prod.prtabela), parseFloat(items[index].qtd), 0, 0);
					   
						if(util.findValInArray(this.lstitens, 'idproduto', items[index].id)){ ///se ja existir na listagem
							
							if (!util.opcaousuario('020Z.010Z.075Z', this.$store.state.perfilusuario)){
								this.$toastr.i('Item já incluso no pedido. Favor utilizar alteração para manipular a quantidade.', 'Informação!');
								return;
							}

							let ind = util.getArrayIndexForKey(this.lstitens, 'idproduto', items[index].id);

							let retalt = util.itemcomimposto(this.mtdclasseitem(items[index].prod.classes), parseFloat(items[index].prod.prtabela), parseFloat(items[index].qtd), 0, 0);
							
							this.lstitens[ind].qtditem        = this.lstitens[ind].qtditem + items[index].qtd;
							this.lstitens[ind].vltotal        = parseFloat(this.lstitens[ind].vltotal) + parseFloat(retalt.vltotalitem);
							this.lstitens[ind].vltotalimposto = parseFloat(this.lstitens[ind].vltotalimposto) + parseFloat(retalt.totalimpostoitem);
							this.lstitens[ind].qtdentregar    = this.lstitens[ind].qtditem;

							this.vqtditens			= this.lstitens.length;
							this.vquantitativo		= this.vquantitativo + parseFloat(items[index].qtd);							
														
						}else{
							let itl = this.lstitens.length === 0 ? 0 : this.lstitens[this.lstitens.length - 1].item;
							let itemtmp = {
								idproduto		    : items[index].id,
								descproduto		    : items[index].prod.descricao, //trazer do payload
								descmarca		    : items[index].prod.descmarca, //trazer do payload
								coddig			    : items[index].id,
								item			    : itl + 1,//this.lstitens.length + 1,
								qtditem			    : items[index].qtd, //trazer do payload,
								unditem			    : items[index].prod.und, //trazer do payload,
								vlunitario		    : parseFloat(items[index].prod.prtabela), //trazer do payload,
								descacres		    : 0,
								tipodescacres	    : 0, 
								valordescacres	    : 0,
								manipulaval		    : 0,
								vltotal			    : parseFloat(ret.vltotalitem),      //trazer do payload, 
								vltotalimposto      : parseFloat(ret.totalimpostoitem), //trazer do payload,
								idestoque		    : this.$store.state.filialpadrao.idestoque,
								descestoque		    : this.$store.state.filialpadrao.descestoque, //não sei como, mas vou dar um jeito de trazer do payload tambem,
								infadprod		    : '',
								qtdentregar		    : items[index].qtd, //trazer do payload, 
								idtecnicosolicita   :  0,
								nometecnicosolicita : ''						
							};	
							this.lstitens.push(itemtmp);

							this.vqtditens			= this.lstitens.length;
							this.vquantitativo		= this.vquantitativo + parseFloat(items[index].qtd);							
						}
				}
				//this.mtdrecalcularprecos();
				this.mtdrecalculartudo(false);
			},
			mtdclcula() {
				if (this.vlegcredanterior !== this.evledicaocreditoavulso) {
					if (parseInt(this.defsubs) === 1) {
						this.vvlcredcedido += this.evledicaocreditoavulso;
					}else {
						this.vvlcredcedido -= this.evledicaocreditoavulso;
					}
					this.vlegcredanterior = this.evledicaocreditoavulso;
				}
				this.vlcreditotot = this.vvlcredcedido + this.vvlcredadquirido;
			},
			mtdadicionarinfcpl(){              
				let vself       = this;
				if (vself.vidinfcpl !== null){    
					let loader      = vself.$loading.show();
					let filtro      = ' and id='+vself.vidinfcpl;
					let parametros  = [
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',       valor : filtro},
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadinformacoescomplementares.php');
					retorno.then(function (response) {
						loader.hide();   
						if((vself.vobservacoes === '' )||(vself.vobservacoes === undefined)){
							vself.vobservacoes = response.data[0].conteudo; 
						}else{
							vself.vobservacoes = vself.vobservacoes +'\n'+ response.data[0].conteudo;
						}                     
						$('#cbinfcpl').val(null).trigger('change');
					}).catch(function (response) {
							loader.hide();
					});
				}             
			},
			mtdprocessaselecionados(){
				let vself = this;


				if(vself.exibicaocard){
					let qtdmarcado = 0;
					let pedidosmarcados = [];
					for (let index = 0; index < vself.lstpedidos.length; index++) {
						 if(vself.lstpedidos[index].marcado === 1){
							qtdmarcado++
							pedidosmarcados.push(vself.lstpedidos[index])
						 }
					}
					vself.vpedidosselecionados    = pedidosmarcados
					vself.vqtdpedidosselecionados = qtdmarcado;
				}else{
					vself.vqtdpedidosselecionados = vself.$refs.reflstpedidos.selected_items.length;

					setTimeout(() => {
						vself.vpedidosselecionados = vself.$refs.reflstpedidos.selected_items
					}, 300);
				}
				
				
			},
			mtddimprimeguia(){
				let vself 			= this;
				$.confirm({
					title: 'Confirmação!',
					content: 'Deseja imprimir a guia?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'cancelar',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						normal: {
							text: '<u>N</u>ormal',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								vself.mtdimprimisep(1)//normal
							},
						},
						sint: {
							text: '<u>S</u>intetizada',
							keys: ['s', 'S'],
							btnClass: 'btn-success',
							action: function () {
								vself.mtdimprimisep(2)//sintetizada
							},
						},
						cancelar: {
							text: '<u>C</u>ancelar',
							keys: ['n', 'N'],
							action: function () {
							

							}
						}
					}
				});
			},
			mtdimprimisep(tipo){
				let lstpedidosimp = '';

				if(this.exibicaocard){
					for (var i = 0; i < this.lstpedidos.length; i++) {
						if(parseInt(this.lstpedidos[i].marcado) === 1){
							lstpedidosimp = lstpedidosimp+', '+this.lstpedidos[i].id; 
						}
					}	
				}else{
					for (var i = 0; i < this.$refs.reflstpedidos.selected_items.length; i++) {
						lstpedidosimp = lstpedidosimp+', '+this.$refs.reflstpedidos.selected_items[i].id; 
					}
				}



				if(tipo == 1){  //1 - normal 2 - sintetizada
					window.open(this.$store.state.configpaths.pathcontrole+'rtcadpedidosvenda.php?idclientesac='+
								this.$store.state.filialpadrao.idcliente+'&op=imprimirguiaseparacaorota'+
								'&idu='+
								 this.$store.state.usuario.id+
								'&pedidos='+lstpedidosimp.substring(2), '_blank');
				}
				if(tipo == 2){
					window.open(this.$store.state.configpaths.pathcontrole+'rtcadpedidosvenda.php?idclientesac='+
								this.$store.state.filialpadrao.idcliente+'&op=imprimirguiaseparacaosintetizada'+
								'&idu='+
								 this.$store.state.usuario.id+
								'&pedidos='+lstpedidosimp.substring(2), '_blank');
				}
			},
			mtdchecklist(){
				var vself       = this;
				let loader      = this.$loading.show();
				let parametros  = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'listagem'},
					{parametro: 'filtro',       valor : ''},
					{parametro: 'limit',        valor : '99999999999'},
					{parametro: 'offset',       valor : '0'},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadchecklist.php');
				retorno.then(function (response) {
					vself.lstchecklist = response.data;
					loader.hide();
				}).catch(function (response) {
					vself.lstchecklist = [];
					loader.hide();
				});
			},
			mtdquantidade(op){
				if (parseInt(op) === 1){
					this.vqtditemedicao++;
				}else{
					if (parseFloat(this.vqtditemedicao) > 1){
						this.vqtditemedicao--;
					}
				}
				this.mtdverificadescontoquantidade();
			},
			mtdquantidadeconf(op){
				if (parseInt(op) === 1){
					this.vqtditenconf++;
				}else{
					if (parseFloat(this.vqtditenconf) > 1){
						this.vqtditenconf--;
					}
				}
			},
			mtdverificadescontoquantidade(){
				if(parseFloat(this.vqtdminimodescedicao) > 0){
					// let indiceitem   = util.getArrayIndexForKey(this.lstitens, 'item', this.vitemalteracao)
					// var qtditem_old  = this.mtdpegaqtditemvenda(this.lstitens[indiceitem].idproduto)
					// var qtdreal      = qtditem_old + this.vqtditemedicao - this.lstitens[indiceitem].qtditem
					
					if(this.vqtditemedicao >= this.vqtdminimodescedicao){
						this.vtipodescacresedicao = 1;
						this.vvalordescacresedicao = this.vvldescontoqtdmin * parseFloat(this.vqtditemedicao);
				    }else{
						this.vvalordescacresedicao = 0;
					}
				}
			},
			mtdpegadadosdesctabela(op, tabelas, idtabela){
				for (var i = 0; i < tabelas.length; i++) {
					if (parseInt(tabelas[i]['idtabela']) === parseInt(idtabela) ){
						if(op===1){
							return parseInt(tabelas[i]['qtdminima']) === 0 ? 0 : parseInt(tabelas[i]['qtdminima']);
						}else{
							return parseInt(tabelas[i]['qtdminima']) === 0 ? 0 : parseFloat(tabelas[i]['desconto']);
						}
					}    
				}
			},						
            mtdselecionarimagem(event){
                let vself               = this;
                vself.arqimgselecionado = event.target.files[0];
                let loader              = vself.$loading.show();
                let localsalvar         = vself.$store.state.configpaths.pathimgpedidos + vself.$store.state.filialpadrao.idcliente +'/'+ vself.vpathimagens;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqimgselecionado.name},
                    {parametro: 'nomediferente',    valor  : 1},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Imagem enviada com sucesso!', 'Informação!');
                        vself.lstImagens = [];
                        vself.lstImagens = response.data.arquivos;
                        vself.arqimgselecionado = null;
                        $('#ipselecionarimg').val('');

                    }else{
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdexcluirimgpedido(patharquivo){
                let vself        = this;
                let loader       = vself.$loading.show();
                let localarquivo = vself.$store.state.configpaths.pathimgpedidos + vself.$store.state.filialpadrao.idcliente +'/'+ vself.vpathimagens;

                let parametros      = [
                    {parametro: 'op',               valor  : "excluirarquivo"},
                    {parametro: 'patharquivo',      valor  : patharquivo},
                    {parametro: 'localarquivo',     valor  : localarquivo}
                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Imagem excluída com sucesso!', 'Informação!');
                        vself.lstImagens = [];
                        vself.lstImagens = response.data.arquivos;
                    }else{                        
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });                  
            },			
			mtdmostradetcred(pedido){
				this.detcredito.idpedido 			    = pedido.id;
				this.detcredito.vlcredito			    = pedido.vlcredito;
				this.detcredito.vlcreditoutilizado  	= pedido.vlcreditoutilizado;
				this.detcredito.vlcreditodisponivel 	= this.detcredito.vlcredito - this.detcredito.vlcreditoutilizado;
				this.detcredito.lsthistorico			= pedido.historicocredito;
				this.detcredito.lsthistoricoreccredito  = pedido.historicoreccredito;
				
				if (pedido.detcashback){
					this.detcredito.detalhecashback 	= pedido.detcashback
				}else{	
					this.detcredito.detalhecashback.disponiveis = 0;
					this.detcredito.detalhecashback.vencidos 	= 0;
					this.detcredito.detalhecashback.lista		= [];
				}

				$('#mddetalhescredito').modal('show');
			},
			mtdatzvariaveisperfil(){
				this.pmanipularvaloritem = util.opcaousuario('020Z.010Z.070Z', this.$store.state.perfilusuario) === false ? true : false;
				this.pdefinirestoque 	 = util.opcaousuario('020Z.010Z.080Z', this.$store.state.perfilusuario) === false ? true : false;
				this.palterardatafatura  = util.opcaousuario('020Z.010Z.100Z', this.$store.state.perfilusuario) === false ? true : false;
				this.palterarvendedor	 = util.opcaousuario('020Z.010Z.120Z', this.$store.state.perfilusuario);
			},
			mtdimprimirpedido(idpedido, tp){				
				$('#mdmenupedido').modal('hide');
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirpedido.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+idpedido+'&tpimp='+tp+'&idu='+
							this.$store.state.usuario.id, '_blank');				
			},
			mtdimprimirguiaseparacao(idpedido, tp) {	
				let vself = this;
				let filtro = '';

				switch (parseInt(vself.vordemitens)) {
					case 0: // Item
						filtro = ' order by i.item ASC';
						break;
					case 1: // Codigo
						filtro = ' order by CAST(i.coddig AS UNSIGNED) ASC';
						break;
					case 2: // Descricao
						filtro = ' order by i.descproduto ASC';
						break;
					case 3: // Localizacao
						filtro = ' order by lg.descricao ASC';
						break;
					case 4: // Referencia
						filtro = ' order by p.referencia ASC';
						break;
					case 5: // Estoque
						filtro = ' order by i.qtditem ASC';
						break;
				}
				$('#mdmenupedido').modal('hide');
				window.open(vself.$store.state.configpaths.pathcontrole + 'rtimprimirguiaseparacao.php?idclientesac=' +
					vself.$store.state.filialpadrao.idcliente +
					'&filtro=' + filtro +
					'&idpedido=' + idpedido +
					'&destaca=' + vself.vdestacacupom +
					'&opcaitem=' + vself.vocaoitemguia +
					'&tpimp=' + tp +
					'&idu=' + vself.$store.state.usuario.id, '_blank');	
			},
			mtdimprimirdanfe(pedido){
				$('#mdmenupedido').modal('hide');
				if (parseInt(this.$store.state.filialpadrao.plnc) < 2){
					this.$swal.fire({
										position: 'bottom-end',
										//icon: 'success',
										title: 'Atenção!',
										html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
										showConfirmButton: false,
										showCloseButton: true,
										backdrop: false,
										timer: 2000                                                
									}); 
					return;                                                               
				}							
				if (parseInt(pedido.situacaonota) === 2){
					window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirdocnfe.php?idclientesac='+
								this.$store.state.filialpadrao.idcliente+
								'&idnf='+pedido.idnotafiscal+'&docimp=danfe', '_blank');
				}else{
					this.$toastr.i('Nota não liberada para impressão!', 'Atenção!');
				}			
			},
			mtdmostrarmenu(pedido){				
				this.pedidomenu = pedido;
				$('#mdmenupedido').modal('show');
			},
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},
			mtdformatavalordecimal(valor, digitos){
				return util.formatavalordecimais(valor, digitos);
			},
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},
            mtdconsultarcliente(){
				if (parseInt(this.opcrud) < 3){
					this.vidcliente 	= '';
					this.vnomecliente 	= '';
					this.vconteudoalerta= '';
					this.lstplanos		= [];
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_CLIENTE_CHANGE',payload);
					let payloadx = {
						idcliente    : null			
					};
					this.$store.commit('CLIENTE_RETORNO_CHANGE',payloadx);                
				}
			},	
            mtdlocalizarcliente(idcliente){
				if (idcliente !== '' && idcliente !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : 'and c.ativo=0 and c.id='+idcliente},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let cliente = response.data[0];							
							vself.vidcliente  			    = cliente.id;
							vself.vnomecliente 				= cliente.nome;
							vself.valertarcliente			= parseInt(cliente.alertarcliente) === 0 ? false : true;
							vself.vvlcreditoclidet			= cliente.vlcredito;							
							vself.vidplano 					= null;
							vself.vtipoplano				= 0;
							vself.vdescplano				= '';
							vself.vidtabela					= null;												
							vself.vpercentrada				= 0;
							vself.vpermitedesconto			= 0;

							if (parseInt(vself.$store.state.filialpadrao.defvendedorcliente) === 1){
								vself.vidvendedor				= cliente.idvendedor;
								let defvendedor  		= new Option(cliente.nomevendedor, vself.vidvendedor, true, true);
								$('#cbvendedor').append(defvendedor).trigger('change');			
								vself.$toastr.i('Vendedor carregado automaticamente do cadastro do cliente!', 'Informação!');			
							}

							vself.mtdlocalizarplanos();
							vself.$nextTick(function () {
								$('#cbplano').focus();
							});
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.vidcliente 	= '';
							vself.vnomecliente 	= '';
							vself.valertarcliente = false;
							vself.vidplano 		= null;
							vself.vtipoplano	= 0;
							vself.vpercentrada	= 0;
							vself.vpermitedesconto = 0;
							vself.vdescplano	= '';
							vself.vidtabela		= null;								
							vself.lstplanos		= [];
							$('#edcliente').focus();
						}
					}).catch(function (response) {
						vself.lstplanos = [];
						loader.hide();
					});
				}else{
					this.vidcliente 	= '';
					this.vnomecliente 	= '';
					this.valertarcliente= false;			
					this.vidplano 		= null;
					this.vtipoplano		= 0;
					this.vdescplano		= '';
					this.vidtabela		= null;
					this.vpercentrada   = 0;					
					this.vpermitedesconto = 0;
					this.lstplanos		= [];
				}
            },
			mtdclasseitem(classes){
				let vself = this;
				if (classes.length > 0){
					let indc = util.getArrayIndexForKey(classes, 'idfilial', vself.vidfilial);
					if (indc > -1){
						return classes[indc];
					}else{
						return [];
					}
				}else{
					return [];
				}
			},					
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ' and p.tipo in (0, 2)'},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];							
							vself.vidprodutoedicao			= produto.id; //
							vself.vdescricaoprodutoedicao 	= produto.descricao; //
							vself.vundprodutoedicao			= produto.und; //
							vself.vfracionadoedicao			= produto.fracionado;//
							vself.vvltabelaitemedicao		= util.mtdcarregaprecotabela(produto.tabelas, vself.vidtabela);
							vself.vvltabelaitemedicao 		= parseFloat(vself.vvltabelaitemedicao).toFixed(2);//acrescentei essa linha pra arredondar o valor
							vself.vvlunitarioedicao			= vself.vvltabelaitemedicao;
							vself.vmarcaprodutoedicao       = produto.descmarca;

							vself.vqtdminimodescedicao      = vself.mtdpegadadosdesctabela(1, produto.tabelas, vself.vidtabela)
							vself.vvldescontoqtdmin         = vself.mtdpegadadosdesctabela(2, produto.tabelas, vself.vidtabela)							

							vself.vprvendaminimo			= produto.prvendaminimo;
							vself.vdadosclasseitem			= vself.mtdclasseitem(produto.classes);

							let it = util.getArrayIndexForKey(produto.tabelas, 'idtabela', vself.vidtabela);

							//carrega o desconto promocional
							vself.vldescpromocionalitemedicao= produto.tabelas[it].vldescpromocional

							if (parseFloat(produto.tabelas[it].vldescpromocional) > 0){
								vself.alteraentra           = true;
								vself.vdescacresedicao		= 0;
								vself.vtipodescacresedicao  = 0;
								vself.vvalordescacresedicao = parseFloat(produto.tabelas[it].vldescpromocional);						
							}
							vself.$nextTick(function () {
								$('#edqtditemedicao').focus();
							});
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.mtdlimparedicaoitem();
							$('#edidprodutoedicao').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					this.mtdlimparedicaoitem();
				}
            },			
            mtdconsultarproduto(){
				if (parseInt(this.vopitem) === 1){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},
			mtdselect2_servico_def(){
				let vself = this;
				$("#cbservico").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbservicos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidservicoedicao = $("#cbservico").val();
					if (vself.vidservicoedicao !== null){
						let loader      = vself.$loading.show();
						let filtro      = ' and id='+vself.vidservicoedicao;
						let parametros  = [
							{parametro: 'op',           valor : 'listagem'},
							{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
							{parametro: 'filtro',       valor : filtro},
							{parametro: 'limit',        valor : 1},
							{parametro: 'offset',       valor : 0},
						];
						let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadservicos.php');
						retorno.then(function (response) {
							loader.hide();
							let servico = [];
							servico     = response.data[0];
							vself.vprecoservicoedicao = [];
							vself.vprecoservicoedicao = util.mtdcarregaprecoservicofilial(servico.precos, vself.vidfilial);
							if(typeof vself.vprecoservicoedicao.vlservico !== 'undefined'){
								vself.vvlservicoedicao = vself.vprecoservicoedicao.vlservico;
							}else{
								vself.$toastr.w('Este serviço não contem preço na filial da edição!', 'Atenção')
								vself.vvlservicoedicao = 0;
							}
						}).catch(function (response) {
							loader.hide();
						});	
					}				
				});
			},
            mtdselect2_def(){
				let vself = this;
				$('#mdedicaoitem').on('show.bs.modal', function (e) {
				});	
				$('#totalfrete').on('focusout', function(){
					vself.mtdativafrete()
				});	
				$('#totaltaxaservico').on('focusout', function(){
					vself.mtdativatxservico()
				});			
				$('#mdedicaoitem').on('shown.bs.modal', function (e) {
					if (parseInt(vself.vopitem) === 1){
						$('#edidprodutoedicao').focus();
					}else{
						$('#edqtditemedicao').focus();
					}
				});
				$('#mdaplicardesconto').on('shown.bs.modal', function (e) {
					$('#cbtipodesctotal').focus();
				});

				$('#mdrecibopedido').on('shown.bs.modal', function (e) {
					$('#edprformapagamento').focus();
				});
				$('#mdanalisecortes').on('show.bs.modal', function (e) {
					vself.ctipo 		= 0;
					vself.cdiferenca	= 2;
					vself.cdtini       	= util.DataAtual(true);
					vself.cdtfim       	= util.DataAtual(true);					
					vself.cqtditenscorte= 0;
					vself.ctotalcortes	= 0;
					vself.lstitenscorte = [];
				});
				$('#mdanalisecortes').on('shown.bs.modal', function (e) {
					vself.ctipo 		= 0;
					vself.lstitenscorte = [];
					$('#edcdtini').focus();
				});
				$("#cbmarcapesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbmarcas',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidmarca = $("#cbmarcapesq").val();
                    vself.mtdlimpar_listagem();
                });
                $("#cbgrupopesq").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbgrupos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.pidgrupo = $("#cbgrupopesq").val();
                    vself.mtdlimpar_listagem();
                });
				$('#mdcorteitem').on('shown.bs.modal', function (e) {
					$('#edqtditemcortar').focus();
				});				
							
				$('#mditenscortados').on('shown.bs.modal', function (e) {
					$('#edlcdtini').focus();
				});				

				$('#mdmenupedido').on('show.bs.modal', function (e) {
					vself.eopimpentrega = 0;
					$('#dvdefnf').collapse('hide');
					$('#dvdefimpressao').collapse('hide');
					$('#dvdefguiaseparacao').collapse('hide');
					$('#dvdefentrega').collapse('hide');
				});	
				
				$('#dvdefimpressao').on('shown.bs.collapse', function () {
					$('#dvdefnf').collapse('hide');
					$('#dvdefentrega').collapse('hide');
					$('#dvdefguiaseparacao').collapse('hide');
				});
				$('#dvdefguiaseparacao').on('shown.bs.collapse', function () {
					$('#dvdefimpressao').collapse('hide');
					$('#dvdefnf').collapse('hide');
					$('#dvdefentrega').collapse('hide');
				});				

				$('#dvdefnf').on('shown.bs.collapse', function () {
					$('#dvdefimpressao').collapse('hide');
					$('#dvdefentrega').collapse('hide');
					$('#dvdefguiaseparacao').collapse('hide');
				});				

				$('#dvdefentrega').on('shown.bs.collapse', function () {
					$('#dvdefimpressao').collapse('hide');
					$('#dvdefnf').collapse('hide');
					$('#dvdefguiaseparacao').collapse('hide');
				});	


				$('#mdcreditoavulso').on('shown.bs.modal', function (e) {
					vself.vidfilialca			= null;
					vself.vidclienteca			= null;
					vself.vvalorcreditoavulso	= 0;
					vself.vobservacoesca		= '';
					
					var deffilial  				= new Option(vself.$store.state.filialpadrao.fantasia, vself.$store.state.filialpadrao.codfil, true, true);
					$('#cbfilialca').append(deffilial).trigger('change');

					$("#cbclienteca").val(null).trigger('change');					

					$("#cbfilialca").select2("open");
				});

				$('#mddevolucao').on('shown.bs.modal', function (e) {
					$('#eddtdevolucao').focus();
				});

						
                $('#mdconsultarproduto').on('hide.bs.modal', function (e) {
                    vself.mtdfecharconsulta();
                });	

				$('#mddefinefilialnf').on('shown.bs.modal', function (e) {
					vself.habbtnf 				= false;
					var deffilial  				= new Option(vself.vnomefilianf, vself.vidfilialnf, true, true);
					$('#cbfilialnf').append(deffilial).trigger('change');					
					//$('#cbfilialnf').select2('open');
				});								


				$('#mdedicaocreditoavulso').on('shown.bs.modal', function (e) {
					$('#txteobsalteracaocredito').focus();
				});

				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';			

				$("#cbvendedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidvendedor = $("#cbvendedor").val();
				}); 
				$("#cbestoqueedicao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoqueedicao = $("#cbestoqueedicao").val();
				});
				$("#cbtecnico").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtecnicos',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidtecnicoedicao = $("#cbtecnico").val();
				});				

				$("#cbtecnicosolicitaedicao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtecnicos',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidtecnicosolicitaedicao = $("#cbtecnicosolicitaedicao").val();
				});				

				$("#cbstos").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbstos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidstos = $("#cbstos").val();
					vself.vidstos ? vself.vdescstos = $("#cbstos").select2('data')[0] : vself.vdescstos = "";
					
				}); 				

				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
					vself.mtdlocalizarplanos();
					vself.mtdselect2_servico_def();
					vself.mtdConsultaDadosTokenPlaca();
				});


				$("#cbfilialnf").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilialnf = $("#cbfilialnf").val();
				});				
				$("#cbinfcpl").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbinformacoescomplementares',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
									results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidinfcpl = $("#cbinfcpl").val();
				});
				//selects da consulta
				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});
				$("#cbclientepesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidcliente = $("#cbclientepesq").val();
				});
				$("#cbvendedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidvendedor = $("#cbvendedorpesq").val();
				});
				$("#cbplanopesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbplanospagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidplano = $("#cbplanopesq").val();
				});
				$("#cbrotapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbrotas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidrota = $("#cbrotapesq").val();
				});
				
				$("#cbformapesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbformaspagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidforma     = $("#cbformapesq").val();
				});	
				
				$("#cbstospesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbstos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidstos = $("#cbstospesq").val();
					vself.mtdlimpar_listagem();
				}); 				
				//campos para faturamento
				$('#mdalterartitulo').on('shown.bs.modal', function (e) {
					$('#eddtventit').focus();
				});				
				$("#cbformapagamento").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbformaspagamento',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidformapagamento     = $("#cbformapagamento").val();
                    if (vself.vidformapagamento != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and f.id='+vself.vidformapagamento},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformaspagamento.php');
                        retorno.then(function (response) {
                            vself.vtipoforma = parseFloat(response.data[0].tipo); 
							vself.vespecieforma = parseFloat(response.data[0].especie);
							vself.vabatecredito = parseInt(response.data[0].abatecredito); 
							vself.vnrvendaforma = '';					
							vself.vidperfilfluxoforma   = 0;                
							vself.vdescperfilfluxoforma = ''; 																			
                            loader.hide();

							if (parseInt(vself.vabatecredito) === 1){//localiza o crédito quando houver
								let loader      = vself.$loading.show();
								let filtro      = ' and p.stpedido=1 and p.tipo=3 and p.idcliente='+vself.pedidofaturar.idcliente;
								let parametros  = [
									{parametro: 'op',           	valor : 'listagem'},
									{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
									{parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
									{parametro: 'filtro',       	valor : filtro},
									{parametro: 'limit',        	valor : 1},
									{parametro: 'offset',       	valor : 0},
								];
								let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
								retorno.then(function (response) {
									loader.hide();
									if (response.data.pedidos.length > 0){
										let vllimitecreditoabater = util.arredondaValores( parseFloat(vself.pedidofaturar.fatorcreditoutilizar) * parseFloat(vself.pedidofaturar.totalgeral) / 100, 2, 'round');				
										let vlcreditodisp = parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado);
										if (parseInt(parseFloat(vlcreditodisp) * 100) > parseInt(parseFloat(vllimitecreditoabater) * 100)){
											vself.vvlforma = vllimitecreditoabater;
										}else{
											vself.vvlforma = vlcreditodisp;
										}
										//vself.vvlforma = util.arredondaValores(parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado) * parseFloat(response.data.pedidos[0].fatorcreditoutilizar) / 100, 2, 'round');
										vself.vnrvendaforma = response.data.pedidos[0].id;
									}
								}).catch(function (response) {
									console.log(response);
									vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
									$('#cbformapagamento').focus();
									loader.hide();
								});
							}
                        }).catch(function (response) {
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.vtipoforma = 0;
						vself.vespecieforma = 0;
						vself.vabatecredito = 0;
						vself.vnrvendaforma = '';
                        vself.vidperfilfluxoforma   = 0;                
                        vself.vdescperfilfluxoforma = ''; 												
                    }										
				});

				$("#cbtipocobranca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbtiposcobranca',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidtipocobranca = $("#cbtipocobranca").val();
                    if (vself.taidtipocobranca != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.taidtipocobranca},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtiposcobranca.php');
                        retorno.then(function (response) {
                            vself.tatipocobranca = parseFloat(response.data[0].tipo); 
                            loader.hide();
                        }).catch(function (response) {
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.tatipocobranca = 0;
                    }					
				});

				$("#cbbanco").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbbancos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidbanco = $("#cbbanco").val();
				});

				$("#cbsituacaocheque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsituacoescheques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.taidsituacaocheque = $("#cbsituacaocheque").val();
				});

				//cancelamento
				$('#mdcancelarpedido').on('shown.bs.modal', function (e) {
					$('#txtmotivocancelamento').focus();
				});
				
				$('#mdalteracaoqtdlevar').on('shown.bs.modal', function (e) {
					$('#edqtdlevar').focus();
				});	
				
				$('#mddefinirqtdentregue').on('shown.bs.modal', function (e) {
					$('#edqtdlevarentrega').focus();
				});	
				
                $("#cbperfilfluxofinal").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbperfisfluxocaixa',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.aidperfilfluxo = $("#cbperfilfluxofinal").val();
                });

				$("#mdlalterarperfilfluxofinal").on('show.bs.modal', function(){
					$('#cbperfilfluxofinal').select2('open');
				});	
				
				//itens cortados
				$("#cblcvendedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidvendedor = $("#cblcvendedor").val();
				});	
					//itens cortados
				$("#cblidcidade").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmunicipios',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidcidade = $("#cblidcidade").val();
				});	
				$("#cblccliente").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidcliente = $("#cblccliente").val();
				});	
				$("#cblcproduto").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbprodutos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidproduto = $("#cblcproduto").val();
				});	
				$("#cblcsubgrupo").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsubgrupos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidsubgrupo = $("#cblcsubgrupo").val();
				});	
				$("#cblcgrupo").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbgrupos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidgrupo = $("#cblcgrupo").val();
				});	
				$("#cblcrota").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbrotas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidrota = $("#cblcrota").val();
				});	
				$("#cblcmarca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmarcas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.lcidmarca = $("#cblcmarca").val();
				});	
				
				//crédito avulso
				$("#cbfilialca").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilialca = $("#cbfilialca").val();
				});

				$("#cbclienteca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbclientes',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 2,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidclienteca = $("#cbclienteca").val();
				});
				$("#cbestoquedevolucao").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.aestoquedevolucao = $("#cbestoquedevolucao").val();
				});

			},
			mtdlocalizarplanos(){
				let vself = this;
				if (vself.vidfilial !== null && vself.vidcliente !== ''){	
					vself.vidplano  	= null;
					vself.vtipoplano	= 0;
					vself.vidtabela		= null;												
					vself.vpercentrada 	= 0;				
					vself.vpermitedesconto = 0;

					let parametros  = [
						{parametro: 'op',           valor : 'planospedido'},
						{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'idfilial',     valor : vself.vidfilial},
						{parametro: 'idcliente',    valor : vself.vidcliente}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
					retorno.then(function (response) {
						vself.lstplanos  = response.data;
					}).catch(function (response) {
						vself.lstplanos  = [];
					});				
				}else{
					vself.vidplano   	= null;
					vself.vtipoplano 	= 0;
					vself.vidtabela		= null;												
					vself.vpercentrada 	= 0;
					vself.vpermitedesconto = 0;
					vself.lstplanos  	= [];					
				}
			},
			mtdidtabelaplano(idplano){
				this.vidtabela = util.getValInArray(this.lstplanos, 'id', idplano, 'idtabela');
			},	
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (this.pidpedido !== ''){
                    rfiltro = ' and p.id='+this.pidpedido;
				}
                if (parseInt(this.psituacao) < 3){
                    rfiltro = rfiltro + ' and p.stpedido='+this.psituacao;
				}	
				if (this.pidfilial !== null){
					rfiltro = rfiltro + ' and p.idfilial='+this.pidfilial;
				}
				if (this.pidcliente !== null){
					rfiltro = rfiltro + ' and p.idcliente='+this.pidcliente;
				}
				if (this.pidvendedor !== null){
					rfiltro = rfiltro + ' and p.idvendedor='+this.pidvendedor;
				}
				if (this.pidrota !== null){
					rfiltro = rfiltro + ' and c.idrota='+this.pidrota;
				}				
				if (this.pidplano !== null){
					rfiltro = rfiltro + ' and p.idplano='+this.pidplano;
				}
				if (this.pidforma !== null){
					rfiltro = rfiltro + ' and fpp.idforma='+this.pidforma;
				}
				if (this.pmaisfiltros){
					if (this.pidmarca !== null){
						rfiltro = rfiltro + ' and pro.idmarca='+this.pidmarca;
					}
					if (this.pidgrupo !== null){
						rfiltro = rfiltro + ' and pro.idgrupo='+this.pidgrupo;
					}
					if (this.pidstos !== null){
						rfiltro = rfiltro + ' and p.idstos='+this.pidstos;
					}					
				}
				
				if (parseInt(this.pfiltroperiodo) === 1){
					if (parseInt(this.pfiltropor) === 0){
						rfiltro = rfiltro + ' and p.dtemissao between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
					}else if (parseInt(this.pfiltropor) === 1){
						if (this.pmaisfiltros){
							rfiltro = rfiltro + ' and p.dtfatura between "' + util.InverterData(this.pdtini) + ' '+this.phrini+':00" and "' + util.InverterData(this.pdtfim) + ' '+this.phrfim+':59"';
						}else{
							rfiltro = rfiltro + ' and p.dtfatura between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
						}
					}else{
						rfiltro = rfiltro + ' and p.dtretorno is not null and p.dtretorno between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
					}
				}				

				if (parseInt(this.ptipo) < 4){
					rfiltro = rfiltro + ' and p.tipo='+this.ptipo;
				}else if(parseInt(this.ptipo) === 5){
					rfiltro = rfiltro + ' and p.tipo <> 3';
				}
				if (this.pidentificador !== ''){
					rfiltro = rfiltro + ' and upper(p.identificador) like upper("'+this.pidentificador+'%")';
				}
				if (this.presponsavel !== ''){
					rfiltro = rfiltro + ' and upper(p.responsavel) like upper ("'+this.presponsavel+'%")';
				}
                if (parseInt(this.pentregaexterna) < 2){
                    rfiltro = rfiltro + ' and p.entregaexterna='+this.pentregaexterna;
				}
                if (parseInt(this.pentregaexterna) < 2){
                    rfiltro = rfiltro + ' and p.entregaexterna='+this.pentregaexterna;

					if (parseInt(this.psituacaoentrega) < 2){
						rfiltro = rfiltro + ' and p.entregaexternafinalizada='+this.psituacaoentrega;
					}
				}
				if (this.pidpedidooff !== ''){
					rfiltro = rfiltro + ' and p.idpedidooff='+this.pidpedidooff;
				}				
				if (this.pidlancamentopdvoff !== ''){
					rfiltro = rfiltro + ' and p.idlancamentopdvoff='+this.pidlancamentopdvoff;
				}								
				if (parseInt(this.pcredito) > 0){
					rfiltro = rfiltro + ' and p.vlcredito > 0';
				}
				if (parseInt(this.porigem) < 10){
					rfiltro = rfiltro + ' and p.origem='+this.porigem;
				}
                return rfiltro;
            },
            mtdexecutapesquisa(){
				let vself           = this;
				vself.$refs.reflstpedidos.selected_items = [];
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}				
				let filtro          = vself.mtdfiltropesquisa();
				this.pagina_atual   = 1;
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor  : 'qtdregistros'},
					{parametro: 'filtro',       valor  : filtro}					
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
					let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
					vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
					vself.mtdcarregapedidos(1);
				}).catch(function (response) {
					alert('Erro ao consultar registros');
				});				
            },
            mtdcarregapedidos(ipagina){
				var vself       = this;
				let loader      = this.$loading.show();
				vself.$refs.reflstpedidos.selected_items = [];
				let filtro      = vself.mtdfiltropesquisa();

				let joinaux 	= "";
				if (this.pmaisfiltros){
					if (this.pidmarca !== null || this.pidgrupo !== null){
						joinaux 	= "0";
					}else if(this.pidmarca !== null && this.pidgrupo !== null){
						joinaux 	= "0";
					}
				}

				// Se não for selecionado filtro de crédito, mantém a rotina enviando 1 como infcredito.
				// Caso, seja escolhido um filtro de crédito, envia esse valor para filtrar a listagem.
				let infcredito = this.pcredito == 0 ? 1 : this.pcredito;

				let parametros  = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           valor : 'listagem'},
					{parametro: 'filtro',       valor : filtro},
					{parametro: 'infcredito',   valor : infcredito},
					{parametro: 'joinaux',   	valor : joinaux},										
					{parametro: 'limit',        valor : vself.pqtdregistros},
					{parametro: 'idforma',      valor : vself.pidforma},
					{parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					vself.lstpedidos = response.data.pedidos;
					//totalizadores
					vself.ptotalaberto		= response.data.totalaberto;
					vself.ptotalfaturado	= response.data.totalfaturado;
					vself.ptotalcusto		= response.data.totalcusto;
					vself.ptotalimposto		= response.data.totalvlimposto;
					
					let totalgeral = vself.ptotalaberto + vself.ptotalfaturado;


					let dif = (parseFloat(totalgeral) - parseFloat(vself.ptotalcusto) - parseFloat(vself.ptotalimposto));
					vself.pmargemlucrogeral = dif / totalgeral * 100;
					vself.ptotalmkp = (totalgeral / vself.ptotalcusto - 1) * 100;


					vself.ptotalcancelado	= response.data.totalcancelado;
					
					vself.ptotaldesconto	= response.data.totaldesconto;
					vself.ptotaldescontoperc= parseFloat(response.data.totaldesconto) > 0 ? util.arredondaValores(parseFloat(response.data.totaldesconto) / (response.data.totalaberto + response.data.totalfaturado + response.data.totaldesconto) * 100, 2, 'round') : 0;
					vself.ptotalacrescimo	= response.data.totalacrescimo;
					vself.ptotalacrescperc  = parseFloat(response.data.totalacrescimo) > 0 ? util.arredondaValores(parseFloat(response.data.totalacrescimo) / (response.data.totalaberto + response.data.totalfaturado + response.data.totalacrescimo) * 100, 2, 'round') : 0;

					vself.ptotalcreditos    = response.data.totalcreditos;
					vself.pqa				= response.data.qa;
					vself.pqf				= response.data.qf;
					vself.pqc				= response.data.qc;
					vself.pqca				= response.data.qca;
					loader.hide();											
				}).catch(function (response) {
					vself.lstpedidos = [];
					loader.hide();
				});
            },
            resetarDados(callback) {
                util.toTop();
                this.vid                = '';
				this.vidfilial          = this.$store.state.filialpadrao.codfil;
				this.vidcliente			= '';
				this.vnomecliente		= '';
				this.valertarcliente	= false;
				this.vidvendedor		= this.$store.state.usuario.idvendedor;
				this.vtipo				= 0;
				this.vdtemissao			= util.DataAtual();
				this.vidplano			= null;
				this.vtipoplano			= 0;
				this.vidtabela			= null;	
				this.vidstos			= null;									
				this.vpercentrada		= 0;
				this.vordemitens        = 0;
				this.vpermitedesconto   = 0;
				this.vtotalprodutos		= 0;
				this.vtotalservicos		= 0;
				this.vidinfcpl          = null;
				this.vinfcpl            = '';
				this.videntificador		= '';
				this.vobjeto			= '';
				this.vmarcacao			= '';
				this.vnrserie			= '';
				this.vmarca				= '';
				this.vmodelo			= '';
				this.vresponsavel		= '';
				this.vfone				= '';
				this.vdtretorno			= '',
				this.vdefeitoapresentado= '';
				this.vacessorios		= '';
				this.voutrasinformacoes	= '';
				this.vobservacoes		= '';
				this.vtotfrete          = 0;
				this.vtottaxaservico    = 0;
				this.sringaleatoria     = '';
				//this.vtotalimpostos		= 0;
				this.vtotalgeral		= 0;
				this.vqtditens			= 0;
				this.vquantitativo		= 0;
				this.vstpedido			= 0;
				this.vdtfatura			= '';
				this.vreservar			= false;
				this.ventregaexterna	= false;
				this.vorigem			= 0;
				this.vpathimagens       = '';
				this.lstitens			= [];
				this.lstservicos		= [];
				this.lstplanos			= [];
				this.lstImagens			= [];
				this.lstchecklist		= [];
				this.vmostraestoque     = false;


				//oculos 
				this.vativainfooculos          = false;
				this.vesfericoesquerdoperto    = 0;
				this.vcilindricoesquerdoperto  = 0;
				this.veixoesquerdoperto        = 0;
				this.vadicaoesquerdoperto      = 0;

				this.vesfericodireitoperto     = 0;
				this.vcilindricodireitoperto   = 0;
				this.veixodireitoperto         = 0;
				this.vadicaodireitoperto       = 0; 
 
				this.vesfericoesquerdolonge    = 0;
				this.vcilindricoesquerdolonge  = 0;
				this.veixoesquerdolonge        = 0;
				this.vadicaoesquerdolonge      = 0;

				this.vesfericodireitolonge     = 0
				this.vcilindricodireitolonge   = 0;
				this.veixodireitolonge         = 0;
				this.vadicaodireitolonge       = 0;

				this.vdptotal                  = 0;
				
				this.vitem				= 0;//contador dos itens
				
				$('#cbinfcpl').val(null).trigger('change');
				$("#cbservico").val(null).trigger('change');
				$("#cbtecnico").val(null).trigger('change');
				$("#cbstos").val(null).trigger('change');
				// $("#cbmarcapesq").val(null).trigger('change');
				// $("#cbgrupopesq").val(null).trigger('change');

				if (parseInt(this.opcrud) === 1){
					var deffilial  			= new Option(this.$store.state.filialpadrao.fantasia, this.vidfilial, true, true);
					$('#cbfilial').append(deffilial).trigger('change');	
					this.vidcliente			= this.$store.state.filialpadrao.idclientepadrao;
					this.vnomecliente		= this.$store.state.filialpadrao.nomecliente;
					this.valertarcliente	= false;
					this.mtdlocalizarplanos();//
					this.mtdConsultaDadosTokenPlaca();
					this.vidplano 			= this.$store.state.filialpadrao.idplano;					
					this.vdescplano			= this.$store.state.filialpadrao.descplano;
					this.vtipoplano			= this.$store.state.filialpadrao.tipoplano;
					this.vidtabela			= this.$store.state.filialpadrao.idtabela;									
					this.vpercentrada		= this.$store.state.filialpadrao.percentrada;
					this.vpermitedesconto	= this.$store.state.filialpadrao.permitedesconto;

					//rotina para selecionar automaticamente o reserva para funcionar no pedido
                    this.ventregaexterna    = parseInt(this.$store.state.filialpadrao.entregaauto) === 1 ? true : false;
					this.vreservar          = parseInt(this.$store.state.filialpadrao.reservaauto) === 1 ? true : false;

					var defvendedor  		= new Option(this.$store.state.usuario.nomevendedor, this.vidvendedor, true, true);
					$('#cbvendedor').append(defvendedor).trigger('change');					
				}
				callback;
            },
            mtddefault(){
				let vself = this;
				$('#pnlista').hide();
				vself.resetarDados(vself.mtdchecklist());
				$('#pncadastro').fadeIn(700);
				setTimeout(function(){
                    if (parseInt(vself.opcrud) < 3) {
						$('#cbfilial').focus();					
                    } else {
						$('#btgravar').focus();						
                    }
				},200);
            },
            mtdpreparacrud(op) {
                let vself    	= this;
				vself.opcrud 	= op;
                $('.nav-tabs a[href="#dvprodutos"]').tab('show');
                vself.mtddefault();
				vself.sringaleatoria = util.GerarStringAleatoria()
            },
            mtdnovo(){
				if (!util.opcaousuario('020Z.010Z.010Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					this.itensbc.item2.titulo 	= 'INCLUSÃO DE PEDIDOS';
					this.itensbc.item1.ativo 	= true;
					this.itensbc.item2.ativo 	= true;
					this.ativadesativa 			= false;
					this.ativadesativavendedor 	= false;
					this.mtdpreparacrud(1);
					this.vpathimagens = util.GerarStringAleatoria();
				}
            },
            mtdcancelaredicao(){
				let vself = this;
				if ((parseInt(this.opcrud) >= 0 && parseInt(this.opcrud) <= 2) && this.lstitens.length > 0){
					$.confirm({
						title: 'Confirmação!',
						content: 'Confirma CANCELAMENTO do pedido em edição?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						escapeKey: 'nao',
						type: 'orange',
						typeAnimated: true,
						buttons: {
							sim: {
								text: '<u>S</u>im',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: function () {
									vself.mtdlimparedicao();
								},
							},
							nao: {
								text: '<u>N</u>ão',
								keys: ['n', 'N'],
								action: function () {

								}
							}
						}
					});					
				}else{
					this.mtdlimparedicao();
				}
            },
			mtdlimparedicao(){
				this.opcrud = 0;
				this.pedidoentrega		= [];
				this.eitementregar		= [];
				this.eqtdentregue		= 1;
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;

				//limpa as variáveis de agrupamento de pedidos
				this.lstitensagrupados		 = [];
				this.lstpedidosexcluiragrupar= '';
				this.vexcluiragrupados		 = false;

                $('#pncadastro').hide();
				$('#pnentregaexterna').hide();
				$('#pnconferencia').hide();				
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
			},
            mtdlimpar_listagem() {
				// $( '#dvlistagempedidos .table-responsive' ).css('height', 'auto');
				let vself = this;
                vself.lstpedidos 	= [];
                vself.pagina_atual 	= 1;
                vself.filtro 		= '';
                vself.pqtd_total_registros 	= 0;
				vself.pqtd_paginas 			= 0;

				///variaveis listagem
				vself.vqtdpedidosselecionados			 = 0;
				vself.$refs.reflstpedidos.selected_items = [];
				vself.$refs.reflstpedidos.unSelectAllItems();

				//totalizadores
				vself.ptotalaberto		= 0;
				vself.ptotalfaturado	= 0;
				vself.ptotalcusto		= 0;
				vself.ptotalimposto		= 0;
				vself.ptotalmkp			= 0;

				//Luiz Trindade - Limpar margem de lucro geral
				vself.pmargemlucrogeral	= 0;

				vself.ptotalcancelado	= 0;
				vself.ptotaldesconto	= 0;
				vself.ptotaldescontoperc= 0;
				vself.ptotalcreditos    = 0;
				vself.pqa				= 0;
				vself.pqf				= 0;
				vself.pqc				= 0;
				vself.pqca				= 0;							
            },
            mtdgravar(){
				let vself 			= this;
				let temprecozerado = false;
				for (let item of vself.lstitens) {
					if (parseFloat(item.vlunitario) <= 0){
						temprecozerado = true;
						break;
					}
				}
				if (temprecozerado){
					vself.$toastr.w('Existe(m) algum(ns) ítem(ns) com preço menou ou igual a zero. Verifique e tente novamente!', 'Atenção!');
					return;
				}
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								vself.mtdregistro();
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                //let loader      = vself.$loading.show();
                let filtro      = ' and p.id='+id;
                let parametros  = [
                    {parametro: 'op',               valor : 'listagem'},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',           valor : filtro},
                    {parametro: 'limit',            valor : 1},
                    {parametro: 'offset',           valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
					//loader.hide();
					if (!vself.clonar){	
						if (parseInt(response.data.pedidos[0].origem) === 4){
							vself.$toastr.i('Operação não permitida para pedidos de origem externa!', 'Informação!');
							vself.mtdcancelaredicao();
							return;
						}

						if (parseInt(response.data.pedidos[0].stpedido) !== 0){
							vself.$toastr.i('Para ALTERAR ou EXCLUIR o pedido, a situação do mesmo deve estar em aberto!', 'Informação!');
							vself.mtdcancelaredicao();
							return;
						}

						if (parseInt(response.data.pedidos[0].liberarpdv) === 1){
							vself.$toastr.i('Para ALTERAR ou EXCLUIR o pedido, o mesmo deve estar bloqueado para o PDV!', 'Informação!');
							vself.mtdcancelaredicao();
							return;
						}
						vself.mtdigualarcampos(response.data.pedidos[0]);

					}else{
						vself.mtdigualarcampos(response.data.pedidos[0]);
						vself.clonar = false;
						vself.vid    = '';
					}				
                    
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
					}					
                }).catch(function (response) {
                    //loader.hide();
                });
            },
            mtdalterar(item){
				$('#mdmenupedido').modal('hide');
				if (parseInt(item.tipo) !== 3){
					if (!util.opcaousuario('020Z.010Z.020Z', this.$store.state.perfilusuario)){
						this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					}else {						
						this.itensbc.item2.titulo 	= 'ALTERAÇÃO DE PEDIDOS';
						this.itensbc.item1.ativo 	= true;
						this.itensbc.item2.ativo 	= true;
						this.ativadesativa 			= false;
						if (this.palterarvendedor === true){
							this.ativadesativavendedor = false;
						}else{
							this.ativadesativavendedor = true;
						}
						this.mtdpreparacrud(2);
						this.mtdlocalizaregistro(item.id);
					}
				}else{
					if (!util.opcaousuario('020Z.010Z.025Z', this.$store.state.perfilusuario)){
						this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					}else {
						this.defsubs                = 0;
						this.vermelho               = true;	
						this.evledicaocreditoavulso	= 0;				
						this.ecreditoavulso 		= item;
						this.eobsalteracaocredito 	= '';
						this.vlegcredavulso         = item.vlcreditocedido
						this.vvlcredadquirido       = item.vlcreditoadquirido;
						this.vlcreditotot           =  this.vvlcredadquirido + this.vlegcredavulso 			
						$('#mdedicaocreditoavulso').modal('show');
					}
				}
            },
            mtdclonar(item){
				let vself = this;
				console.log("inidep");
				$('#mdmenupedido').modal('hide');
				if (parseInt(item.tipo) === 3){
					this.$toastr.i('Impossível clonar um crédito avulso!', 'Informação!');
					return;
				}
				if (parseFloat(item.totalgeral) <= 0){
					this.$toastr.w('Impossível clonar um pedido de crédito!', 'Atenção!');
					return;
				}				
				if (!util.opcaousuario('020Z.010Z.063Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {		
					//limpa as variáveis de agrupamento de pedidos
					this.lstitensagrupados		 = [];
					this.lstpedidosexcluiragrupar= '';
					this.vexcluiragrupados		 = false;					

					this.itensbc.item2.titulo 	= 'INCLUSÃO DE PEDIDOS';
					this.itensbc.item1.ativo 	= true;
					this.itensbc.item2.ativo 	= true;
					this.ativadesativa 			= false;
					if (this.palterarvendedor === true){
						this.ativadesativavendedor = false;
					}else{
						this.ativadesativavendedor = true;
					}
					this.clonar = true;
					this.mtdpreparacrud(1);
					this.mtdlocalizaregistro(item.id);
				}
            },			
            mtdexcluir(item){
				$('#mdmenupedido').modal('hide');
				if (!util.opcaousuario('020Z.010Z.030Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					this.itensbc.item2.titulo = 'EXCLUSÃO DE PEDIDOS';
					this.itensbc.item1.ativo = true;
					this.itensbc.item2.ativo = true;
					this.ativadesativa = true;
					this.ativadesativavendedor = true;
					this.mtdpreparacrud(3);
					this.mtdlocalizaregistro(item.id);
				}
            },
            mtdigualarcampos(registro){
                this.vid                = registro.id;
				//this.vidfilial          = registro.idfilial;
				this.vidcliente			= registro.idcliente;
				this.vnomecliente		= registro.nomecliente;
				this.valertarcliente	= parseInt(registro.alertarcliente) === 0 ? false : true;
				this.vconteudoalerta	= registro.conteudoalerta;				
				//this.vidvendedor		= registro.idvendedor;
				this.vtipo				= registro.tipo;
				this.vdtemissao			= registro.dtemissao;
				this.vtotalprodutos		= registro.totalprodutos;
				this.vtotalservicos		= registro.totalservicos;
				this.videntificador		= registro.identificador;
				this.vordemitens        = registro.ordemitens;
				this.vobjeto			= registro.objeto;
				this.vinfcpl       		= registro.infcpl;
				this.vmarcacao			= registro.marcacao;
				this.vnrserie			= registro.nrserie;
				this.vmarca				= registro.marca;
				this.vmodelo			= registro.modelo;
				this.vresponsavel		= registro.responsavel;
				this.vfone				= registro.fone;
				this.vdtretorno			= registro.dtretorno === null ? '' : registro.dtretorno;
				this.vdefeitoapresentado= registro.defeitoapresentado;
				this.vacessorios		= registro.acessorios;
				this.voutrasinformacoes	= registro.outrasinformacoes;
				this.vobservacoes		= registro.observacoes;
				this.vtotalgeral		= registro.totalgeral;
				this.vtotfrete          = registro.totfrete;
				this.vtottaxaservico    = registro.tottaxaservico;

				this.vqtditens			= registro.itens.length;
				this.vquantitativo		= registro.quantitativo;

				this.vstpedido			= registro.stpedido;
				this.vdtfatura			= registro.dtfatura;
				this.vreservar			= parseInt(registro.reservar) === 0 ? false : true;
				this.ventregaexterna	= parseInt(registro.entregaexterna) === 0 ? false : true;
				this.vorigem			= registro.origem;
				this.vpathimagens       = registro.pathimagens !== '' ? registro.pathimagens : util.GerarStringAleatoria();				
				this.lstservicos		= registro.servicos;
				this.lstImagens         = registro.imagens;			

				this.vitem				= registro.itens.length === 0 ? 0 : registro.itens[registro.itens.length - 1].item;

                var deffilial  = new Option(registro.fantasia, registro.idfilial, true, true);
				$('#cbfilial').append(deffilial).trigger('change');
				
                var defvendedor  = new Option(registro.nomevendedor, registro.idvendedor, true, true);
				$('#cbvendedor').append(defvendedor).trigger('change');

				if (registro.idstos == 0){
					this.vidstos = null;
					$("#cbstos").val(null).trigger('change');
				}else{
					this.vidstos = registro.idstos;
					var defstos  = new Option(registro.descstos, registro.idstos, true, true);
					$('#cbstos').append(defstos).trigger('change');
				}

				this.vidplano			= registro.idplano;
				this.vtipoplano			= registro.tipoplano;
				this.vdescplano			= registro.descplano;
				this.vidtabela			= registro.idtabela;
				this.vpercentrada		= registro.percentrada;
				this.vpermitedesconto	= registro.permitedesconto;
				this.vquantitativo		= registro.quantitativo;


				///oculos
				this.vativainfooculos          = parseInt(registro.ativainfooculos) === 1 ? true : false;
				this.vesfericoesquerdoperto    = registro.esfericoesquerdoperto
				this.vcilindricoesquerdoperto  = registro.cilindricoesquerdoperto
				this.veixoesquerdoperto        = registro.eixoesquerdoperto
				this.vadicaoesquerdoperto      = registro.adicaoesquerdoperto

				this.vesfericodireitoperto     = registro.esfericodireitoperto
				this.vcilindricodireitoperto   = registro.cilindricodireitoperto
				this.veixodireitoperto         = registro.eixodireitoperto
				this.vadicaodireitoperto       = registro.adicaodireitoperto 
 
				this.vesfericoesquerdolonge    = registro.esfericoesquerdolonge
				this.vcilindricoesquerdolonge  = registro.cilindricoesquerdolonge
				this.veixoesquerdolonge        = registro.eixoesquerdolonge
				this.vadicaoesquerdolonge      = registro.adicaoesquerdolonge

				this.vesfericodireitolonge     = registro.esfericodireitolonge
				this.vcilindricodireitolonge   = registro.cilindricodireitolonge
				this.veixodireitolonge         = registro.eixodireitolonge
				this.vadicaodireitolonge       = registro.adicaodireitolonge

				this.vdptotal                  = registro.dptotal


				if (registro.checklist.length > 0){
					for (let i = 0; i < registro.checklist.length; i++) {
						if (util.findValInArray(this.lstchecklist, 'id', registro.checklist[i].idchecklist)){
							let ii = util.getArrayIndexForKey(this.lstchecklist, 'id', registro.checklist[i].idchecklist);
							this.lstchecklist[ii].habilita = 1;
						}												
					}
				}

				setTimeout(() => {
					this.lstitens    = registro.itens;
					let leglstitens  = JSON.parse(JSON.stringify(this.lstitens));
					this.lstitens    = JSON.parse(JSON.stringify(leglstitens));
				}, 500);

            },
            mtdregistro(){
				let vself  = this;
                let loader = vself.$loading.show();
				let lstcltmp = [];
				for (let i = 0; i < vself.lstchecklist.length; i++) {
					if (parseInt(vself.lstchecklist[i].habilita) === 1){
						lstcltmp.push(vself.lstchecklist[i]);
					}					
				}
                let registrocrud = {
                    'id'                	 : this.vid,
					'idfilial'          	 : this.vidfilial,
					'idcliente'				 : this.vidcliente,
					'idvendedor'			 : this.vidvendedor,
					'tipo'					 : this.vtipo,
					'dtemissao'				 : this.mtdformatadatagravar(this.vdtemissao),
					'idplano'				 : this.vidplano,
					'totalprodutos'			 : this.vtotalprodutos,
					'totalservicos'			 : this.vtotalservicos,
					'identificador'			 : this.videntificador,
					'objeto'				 : this.vobjeto,
					'infcpl' 				 : this.vinfcpl,
					'marcacao'				 : this.vmarcacao,
					'nrserie'				 : this.vnrserie,
					'ordemitens'        	 : this.vordemitens,
					'marca'					 : this.vmarca,
					'modelo'				 : this.vmodelo,
					'responsavel'			 : this.vresponsavel,
					'fone'					 : (this.vfone !== '' && this.vfone !== null) ? this.vfone.replace(/[^0-9]/g,'') : '',
					'dtretorno'				 : this.vdtretorno !== '' ? this.mtdformatadatagravar(this.vdtretorno) : '',
					'defeitoapresentado'	 : this.vdefeitoapresentado,
					'acessorios'			 : this.vacessorios,
					'outrasinformacoes'		 : this.voutrasinformacoes,
					'idstos'				 : this.vidstos === null ? 0 : this.vidstos,
					'descstos'               : this.vdescstos.text ? this.vdescstos.text : "",
					'observacoes'			 : this.vobservacoes,
					'totfrete'		    	 : this.vtotfrete,
					'tottaxaservico'		 : this.vtottaxaservico,
					'totalgeral'			 : this.vtotalgeral,
					'stpedido'				 : this.vstpedido,
					'dtfatura'				 : this.vdtfatura,
					'reservar'				 : this.vreservar === false ? 0 : 1,
					'entregaexterna'		 : this.ventregaexterna === false ? 0 : 1,
					'origem'				 : this.vorigem,
					'pathimagens'       	 : this.vpathimagens, 
					'itens'					 : this.lstitens,
					'servicos'				 : this.lstservicos,
					'checklist'			     : lstcltmp,

					'ativainfooculos'        : this.vativainfooculos ? 1 : 0,
					'esfericoesquerdoperto'	 : this.vesfericoesquerdoperto,
					'cilindricoesquerdoperto': this.vcilindricoesquerdoperto,
					'eixoesquerdoperto'		 : this.veixoesquerdoperto,
					'adicaoesquerdoperto'	 : this.vadicaoesquerdoperto,

					'esfericodireitoperto'	 : this.vesfericodireitoperto,
					'cilindricodireitoperto' : this.vcilindricodireitoperto,
					'eixodireitoperto'		 : this.veixodireitoperto,
					'adicaodireitoperto'	 : this.vadicaodireitoperto,

					'esfericoesquerdolonge'	 : this.vesfericoesquerdolonge,
					'cilindricoesquerdolonge': this.vcilindricoesquerdolonge,
					'eixoesquerdolonge'		 : this.veixoesquerdolonge,
					'adicaoesquerdolonge'	 : this.vadicaoesquerdolonge,

					'esfericodireitolonge'	 : this.vesfericodireitolonge,
					'cilindricodireitolonge' : this.vcilindricodireitolonge,
					'eixodireitolonge'		 : this.veixodireitolonge,
					'adicaodireitolonge'	 : this.vadicaodireitolonge,
					'dptotal'                : this.vdptotal      
                };
                let parametros      = [
                    {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'rotinacrud'},
                    {parametro: 'opcrud',           valor : vself.opcrud},
                    {parametro: 'registro',         valor : JSON.stringify(registrocrud)},
					{parametro: 'stragrupados',     valor : vself.vexcluiragrupados ? vself.lstpedidosexcluiragrupar : ''},
                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
					{parametro: 'straleatoria',     valor : vself.sringaleatoria},
                    {parametro: 'codop',            valor : parseInt(this.opcrud) === 1 ? '020Z.010Z.010Z' : parseInt(this.opcrud) === 2 ? '020Z.010Z.010Z' : '020Z.010Z.030Z'},
					{parametro: 'faturarsemsaldo',	valor : util.opcaousuario('020Z.010Z.090Z', vself.$store.state.perfilusuario) === false ? 0 : 1}
                ];				
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
                        vself.pidpedido     	= parseInt(vself.opcrud) === 1 ? response.data.inf : vself.vid;
					    if(parseInt(vself.opcrud) === 1){
							vself.mtdlimpafiltros();
						}
                        vself.pqtd_paginas  	= 1;
						vself.pcredito			= 0;
						vself.porigem			= 10;											
						vself.opcrud			= 0;
						vself.lstitens			= [];
                        vself.mtdcancelaredicao();
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
			},
			mtdhabilitaedicaodescpro(){
				this.vedicaodescpro = false;
				setTimeout(function(){
            		$('#eddescricaoprodutoedicao').focus();
        		}, 300); 				
			},
			mtddesabilitaedicaodescpro(){
				this.vedicaodescpro = true;
			},			
			mtdlimparedicaoitem(){			
				this.vedicaodescpro				= true;
				this.vidprodutoedicao    		= '';
				this.vcoddigedicao				= '';
				this.vdescricaoprodutoedicao 	= '';
				this.vundprodutoedicao			= '';
				this.vqtditemedicao				= 1;
				this.vvlunitarioedicao			= 0;

				this.vqtdminimodescedicao       = 0,
				this.vvldescontoqtdmin          = 0,

				this.vprvendaminimo				= 0;
				this.vldescpromocionalitemedicao= 0;
				this.vdescacresedicao			= 0;
				this.vtipodescacresedicao		= 0;
				this.vvalordescacresedicao		= 0;
				this.vmanipulavaledicao			= 0;
				this.vvltotalimpostoitemedicao  = 0;
				this.vvltotaledicao				= 0;
				this.vfracionadoedicao			= 0;
				this.vinfadprod					= '';
				this.vdadosclasseitem			= [];
				this.vldescmostrar				= 0;

				this.vidtecnicosolicitaedicao	= null;
				$("#cbtecnicosolicitaedicao").val('').trigger('change');

				//pega o estoque padrão da filial selecionada
				//19/08/2025 11:06 - Nilson Oliveira
				//comentei pra pegar o estoque padrão da filial que foi selecionada no pedido
				//dessa forma quando o usuário selecionar a filial já vai disparar automático e ficar como padrão para todo o pedido
				
				// this.videstoqueedicao			= this.$store.state.filialpadrao.idestoque;
                // var defestoque  				= new Option(this.$store.state.filialpadrao.descestoque, this.videstoqueedicao, true, true);
				// $('#cbestoqueedicao').append(defestoque).trigger('change');
				   
			},
			mtdadcionaritem(){
				if (this.vidfilial === null){
					this.$toastr.w('Filial deve ser informada!', 'Atenção!');
					$('#cbfilial').focus();
					return;
				}
				if (this.vidcliente === ''){
					this.$toastr.w('Cliente deve ser informado!', 'Atenção!');
					$('#edcliente').focus();
					return;
				}
				if (this.vidplano === null){
					this.$toastr.w('Plano de pagamento deve ser informado!', 'Atenção!');
					$('#cbplano').focus();
					return;
				}				
				this.vopitem					= 1;
				this.mtdlimparedicaoitem();
				$('#mdedicaoitem').modal('show');
			},
			mtdalteraritem(item){
				if (!util.opcaousuario('020Z.010Z.130Z', this.$store.state.perfilusuario) && parseInt(this.opcrud) === 2){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					return;
				}
				var vself       = this;
				if (vself.vidfilial === null){
					vself.$toastr.w('Filial deve ser informada!', 'Atenção!');
					$('#cbfilial').focus();
					return;
				}
				if (vself.vidcliente === ''){
					vself.$toastr.w('Cliente deve ser informado!', 'Atenção!');
					$('#edcliente').focus();
					return;
				}
				if (vself.vidplano === null){
					vself.$toastr.w('Plano de pagamento deve ser informado!', 'Atenção!');
					$('#cbplano').focus();
					return;
				}								
				let loader      = vself.$loading.show();
				let parametros  = [
					{parametro: 'op',               valor : 'listagem'},
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'filtro',           valor : ''},
					{parametro: 'coddig',           valor : item.coddig},
					{parametro: 'limit',            valor : 1},
					{parametro: 'offset',           valor : 0},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
				retorno.then(function (response) {
					loader.hide();						
					if (response.data.length > 0){
						let produto = response.data[0];	

						vself.vvltotal_old_edicao		= item.vltotal;//variável para estornar o valor anterior
						//vself.vtotalimpostos_old_edicao = item.vltotalimposto;

						vself.vdadosclasseitem			= vself.mtdclasseitem(produto.classes);

						vself.alteraentra  				= true;																			
						vself.vopitem					= 2;
						vself.vitemalteracao			= item.item;
						vself.vedicaodescpro			= true;
						vself.vidprodutoedicao    		= item.idproduto;
						vself.vcoddigedicao				= item.coddig;
						vself.vdescricaoprodutoedicao 	= item.descproduto;
						vself.vundprodutoedicao			= item.unditem;
						vself.vmarcaprodutoedicao	    = item.descmarca;
						vself.vprvendaminimo			= item.prvendaminimo;
						vself.vqtditemedicao			= parseFloat(item.qtditem);
						vself.vvltabelaitemedicao		= parseFloat(util.mtdcarregaprecotabela(produto.tabelas, vself.vidtabela));						
						vself.vvlunitarioedicao			= parseFloat(item.vlunitario);
						vself.vprvendaminimo			= parseFloat(item.prvendaminimo);						

						//carrega o desconto promocional
						let it = util.getArrayIndexForKey(produto.tabelas, 'idtabela', vself.vidtabela);
						if (it >= 0){
							vself.vldescpromocionalitemedicao = produto.tabelas[it].vldescpromocional;
						}else{
							vself.$toastr.i('Produto sem tabela de preço para o plano selecionado!', 'Informação!');
							return;
						}

						vself.vdescacresedicao			= item.descacres;
						vself.vtipodescacresedicao		= item.tipodescacres;
						vself.vvalordescacresedicao		= parseFloat(item.valordescacres);
						vself.vmanipulavaledicao		= item.manipulaval;
						vself.vvltotaledicao			= parseFloat(item.vltotal);
						vself.vvltotalimpostoitemedicao = parseFloat(item.vltotalimposto);
						vself.vfracionadoedicao			= produto.fracionado;
						vself.vinfadprod				= item.infadprod;

						vself.vqtdminimodescedicao      = vself.mtdpegadadosdesctabela(1, produto.tabelas, vself.vidtabela)
						vself.vvldescontoqtdmin         = vself.mtdpegadadosdesctabela(2, produto.tabelas, vself.vidtabela)						

						if (parseInt(item.idtecnicosolicita) > 0){
							vself.vidtecnicosolicitaedicao  = item.idtecnicosolicita;
							var deftec  				    = new Option(item.nometecnicosolicita, item.idtecnicosolicita, true, true);
							$('#cbtecnicosolicitaedicao').append(deftec).trigger('change');						
						}else{
							vself.vidtecnicosolicitaedicao  = null;
							$("#cbtecnicosolicitaedicao").val('').trigger('change');
						}

						vself.videstoqueedicao			= item.idestoque;
						var defestoque  				= new Option(item.descestoque, item.idestoque, true, true);
						$('#cbestoqueedicao').append(defestoque).trigger('change');

						$('#mdedicaoitem').modal('show');				
					}else{
						vself.$toastr.e('Erro ao tentar alterar o ítem. Tente novamente mais tarde!', 'Erro!');
					}
				}).catch(function (response) {
					vself.$toastr.e('Erro ao tentar alterar o ítem. Tente novamente mais tarde!', 'Erro!');
					loader.hide();						
				});
			},
			mtdgravaritem(){
				let vself = this;
				console.log('inidep');

				if (this.vcoddigedicao === ''){
					this.$toastr.w('Código do produto deve ser informado!', 'Atenção!');
					$('#edidprodutoedicao').focus();
					return;
				}
				if (parseFloat(this.vqtditemedicao) <= 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditemedicao').focus();
					return;
				}
				if (parseFloat(this.vvlunitarioedicao) <= 0){
					this.$toastr.w('Valor do produto deve ser informado!', 'Atenção!');
					$('#edvlunitarioedicao').focus();
					return;
				}
                if (parseInt(this.vfracionadoedicao) === 0){
                    if (!Number.isInteger(this.vqtditemedicao)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemedicao').focus();
                        return;
                    }
				}
				if (this.videstoqueedicao === null){
					this.$toastr.w('Estoque deve ser informado!', 'Atenção!');
					$('#cbestoqueedicao').focus();
					return;
				}
				// VERIFICA SE O VALOR DE DESCONTO BATE COM O VALOR DE DESCONTO DA TABELA, SE SIM, PERMITE GRAVAR,
				// SE NÃO, ENTRA NA LÓGICA DO DESCONTO -- Akira e Rodrigo
				if (parseFloat(this.vvalordescacresedicao) / parseFloat(this.vqtditemedicao) <= parseFloat(this.vvldescontoqtdmin) 
				&& parseInt(this.vtipodescacresedicao) === 1 && parseFloat(this.vqtditemedicao) >= parseFloat(this.vqtdminimodescedicao)){

				} else {
					let fatd = 0;
					if (parseInt(this.vdescacresedicao) === 0){					
						if (parseInt(this.vtipodescacresedicao) === 0){
							fatd = this.vvalordescacresedicao;
						}else{
							fatd = parseFloat(this.vvalordescacresedicao) / (parseFloat(this.vqtditemedicao) * parseFloat(this.vvlunitarioedicao)) * 100;
						}
	
						if (parseInt(this.vtipodescacresedicao) === 0){
							if (parseFloat(this.vldescpromocionalitemedicao) > 0){
								if (parseFloat(fatd) > parseFloat(this.vldescpromocionalitemedicao)){
									this.$toastr.i('Desconto promocional maior que o permitido para o item!', 'Informação!');
									$('#edfatordesconto').focus();
									return;
								}	
							}else{
								if (parseInt(this.vpermitedesconto) === 0 && parseFloat(fatd) > 0){
									this.$toastr.i('O plano de pagamento selecionado não permite desconto!', 'Informação!');
									$('#edvaldescacresedicao').focus();					
									return;
								}
	
								let descto_comparar = parseInt(this.vtipoplano) === 0 ? this.$store.state.usuario.descontoprodutos : this.$store.state.usuario.descontoprodutosprazo;
	
								if (parseFloat(fatd) > parseFloat(descto_comparar)){
									this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
									$('#cbtipodesctotal').focus();					
									return;
								}							
							}
						}else{
							if (parseInt(this.vpermitedesconto) === 0 && parseFloat(fatd) > 0){
								this.$toastr.i('O plano de pagamento selecionado não permite desconto!', 'Informação!');
								$('#edvaldescacresedicao').focus();					
								return;
							}
	
							let descto_comparar = parseInt(this.vtipoplano) === 0 ? this.$store.state.usuario.descontoprodutos : this.$store.state.usuario.descontoprodutosprazo;
	
							if (parseFloat(fatd) > parseFloat(descto_comparar)){
								this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
								$('#cbtipodesctotal').focus();					
								return;
							}	
						}
					
						if (parseFloat(this.vprvendaminimo) > 0){
							let vldesconto = 0;
							if (parseInt(this.vtipodescacresedicao) === 0){
								vldesconto = parseFloat(this.vvalordescacresedicao) * parseFloat(this.vvlunitarioedicao) / 100;														
							}else{
								vldesconto = parseFloat(this.vqtditemedicao) > 0 ? parseFloat(this.vvalordescacresedicao) / parseFloat(this.vqtditemedicao) : 0;	
							}
							vldesconto		= util.arredondaValores(vldesconto, 2, 'round');					
							if ((parseFloat(this.vvlunitarioedicao) - parseFloat(vldesconto)) < parseFloat(this.vprvendaminimo)){
								this.$toastr.w('Impossível vender o item com o valor abaixo do mínimo!', 'Atenção!');
								$('#edvlunitarioedicao').focus();
								return;
							}
						}					
						
					}
					$('#btnsalvaritem').prop('disabled', true);
				}

				if (parseInt(this.vopitem) === 1){
					if (util.findValInArray(this.lstitens, 'idproduto', this.vidprodutoedicao)){
						if (!util.opcaousuario('020Z.010Z.075Z', this.$store.state.perfilusuario)){
							this.$toastr.i('Item já incluso no pedido. Favor utilizar alteração para manipular a quantidade.', 'Informação!');
							$('#btnsalvaritem').prop('disabled', false)
							return;
						}else{
							$.confirm({
								title: 'Confirmação!',
								content: 'O ítem já está incluso no pedido. Deseja continuar e adicioná-lo novamente?',
								icon: 'fa fa-question-circle',
								escapeKey: true,
								backgroundDismiss: false,
								escapeKey: 'nao',
								type: 'dark',
								typeAnimated: true,
								buttons: {
									sim: {
										text: '<u>S</u>im',
										keys: ['s', 'S'],
										btnClass: 'btn-blue',
										action: function () {
											$('.btn-blue').prop('disabled', true);
											//vself.vitem++;
											vself.vitem = vself.lstitens.length === 0 ? 0 : vself.lstitens[vself.lstitens.length - 1].item;
											vself.vitem++;
											let itemtmp = {
												idproduto			: vself.vidprodutoedicao,
												descproduto			: vself.vdescricaoprodutoedicao,
												descmarca			: vself.vmarcaprodutoedicao,
												coddig				: vself.vcoddigedicao,
												item				: vself.vitem,
												qtditem				: parseFloat(vself.vqtditemedicao),
												unditem				: vself.vundprodutoedicao,
												vlunitario			: parseFloat(vself.vvlunitarioedicao),
												prvendaminimo		: parseFloat(vself.vprvendaminimo),
												descacres			: vself.vdescacresedicao,
												tipodescacres		: vself.vtipodescacresedicao,
												valordescacres		: parseFloat(vself.vvalordescacresedicao),
												manipulaval			: vself.vmanipulavaledicao,
												vltotal				: parseFloat(vself.vvltotaledicao),
												vltotalimposto  	: parseFloat(vself.vvltotalimpostoitemedicao),
												idestoque			: vself.videstoqueedicao,
												descestoque			: $('#cbestoqueedicao').select2('data')[0]['text'],
												infadprod			: vself.vinfadprod,
												qtdentregar			: parseFloat(vself.vqtditemedicao),
												idtecnicosolicita   : vself.vidtecnicosolicitaedicao === null ? 0 : vself.vidtecnicosolicitaedicao,
												nometecnicosolicita : vself.vidtecnicosolicitaedicao === null ? '' : $('#cbtecnicosolicitaedicao').select2('data')[0]['text']
											};
											//vself.vtotalimpostos 	  = parseFloat(vself.vtotalimpostos) + parseFloat(vself.vvltotalimpostoitemedicao);
											vself.vtotalprodutos 	  = parseFloat(vself.vtotalprodutos) + parseFloat(vself.vvltotaledicao);

											vself.lstitens.push(itemtmp);

											vself.vtotalgeral	= parseFloat(vself.vtotalprodutos) + parseFloat(vself.vtotalservicos) + parseFloat(vself.vtotfrete) + parseFloat(vself.vtottaxaservico);
											
											vself.vquantitativo = parseFloat(vself.vquantitativo) + parseFloat(vself.vqtditemedicao);
											vself.vqtditens		= vself.lstitens.length;

											vself.mtdlimparedicaoitem();
											$('#edidprodutoedicao').focus();
											setTimeout(() => {
												$('#btnsalvaritem').prop('disabled', false);
											}, 500);
										},
									},
									nao: {
										text: '<u>N</u>ão',
										keys: ['n', 'N'],
										action: function () {
											$('#edqtditemedicao').focus();
											setTimeout(() => {
												$('#btnsalvaritem').prop('disabled', false);
											}, 500);										
											return;
										}
									}
								}
                        	});	
						}                        					
					}else{					
						//vself.vitem++;
						vself.vitem = vself.lstitens.length === 0 ? 0 : vself.lstitens[vself.lstitens.length - 1].item;
						vself.vitem++;						
						let itemtmp = {
							idproduto		: vself.vidprodutoedicao,
							descproduto		: vself.vdescricaoprodutoedicao,
							descmarca		: vself.vmarcaprodutoedicao,
							coddig			: vself.vcoddigedicao,
							item			: vself.vitem,
							qtditem			: parseFloat(vself.vqtditemedicao),
							unditem			: vself.vundprodutoedicao,
							vlunitario		: parseFloat(vself.vvlunitarioedicao),
							prvendaminimo	: parseFloat(vself.vprvendaminimo),
							descacres		: vself.vdescacresedicao,
							tipodescacres	: vself.vtipodescacresedicao,
							valordescacres	: parseFloat(vself.vvalordescacresedicao),
							manipulaval		: vself.vmanipulavaledicao,
							vltotal			: parseFloat(vself.vvltotaledicao),
							vltotalimposto  : parseFloat(vself.vvltotalimpostoitemedicao),
							idestoque		: vself.videstoqueedicao,
							descestoque		: $('#cbestoqueedicao').select2('data')[0]['text'],
							infadprod		: vself.vinfadprod,
							qtdentregar		: parseFloat(vself.vqtditemedicao),
							idtecnicosolicita   : vself.vidtecnicosolicitaedicao === null ? 0 : vself.vidtecnicosolicitaedicao,
							nometecnicosolicita : vself.vidtecnicosolicitaedicao === null ? '' : $('#cbtecnicosolicitaedicao').select2('data')[0]['text']							
						};
						//vself.vtotalimpostos = parseFloat(vself.vtotalimpostos) + parseFloat(vself.vvltotalimpostoitemedicao);
						vself.vtotalprodutos = parseFloat(vself.vtotalprodutos) + parseFloat(vself.vvltotaledicao);

						vself.lstitens.push(itemtmp);
						vself.vtotalgeral	= parseFloat(vself.vtotalprodutos) + parseFloat(vself.vtotalservicos) + parseFloat(vself.vtotfrete) + parseFloat(vself.vtottaxaservico);

						vself.vquantitativo = parseFloat(vself.vquantitativo) + parseFloat(vself.vqtditemedicao);
						vself.vqtditens		= vself.lstitens.length;						

						vself.mtdlimparedicaoitem();
						$('#edidprodutoedicao').focus();
						setTimeout(() => {
							$('#btnsalvaritem').prop('disabled', false);
						}, 500);												
					}	
				}else{
					this.vtotalprodutos = parseFloat(this.vtotalprodutos) - parseFloat(this.vvltotal_old_edicao);
					//this.vtotalimpostos = parseFloat(this.vtotalimpostos) - parseFloat(this.vtotalimpostos_old_edicao);
				
					let lsttmp = JSON.parse(JSON.stringify(this.lstitens));

					let indiceitem 						= util.getArrayIndexForKey(lsttmp, 'item', this.vitemalteracao)
					this.lstitens						= [];

					this.vquantitativo = parseFloat(this.vquantitativo) - parseFloat(lsttmp[indiceitem].qtditem);					

					lsttmp[indiceitem].descproduto		= this.vdescricaoprodutoedicao;
					lsttmp[indiceitem].descmarca		= this.vmarcaprodutoedicao;
					lsttmp[indiceitem].qtditem			= parseFloat(this.vqtditemedicao);
					lsttmp[indiceitem].unditem			= this.vundprodutoedicao;
					lsttmp[indiceitem].vlunitario		= parseFloat(this.vvlunitarioedicao);
					lsttmp[indiceitem].prvendaminimo	= parseFloat(this.vprvendaminimo),
					lsttmp[indiceitem].descacres		= this.vdescacresedicao;
					lsttmp[indiceitem].tipodescacres	= this.vtipodescacresedicao;
					lsttmp[indiceitem].valordescacres	= parseFloat(this.vvalordescacresedicao);
					lsttmp[indiceitem].manipulaval		= this.vmanipulavaledicao;
					lsttmp[indiceitem].vltotal			= parseFloat(this.vvltotaledicao);
					lsttmp[indiceitem].vltotalimposto	= parseFloat(this.vvltotalimpostoitemedicao);	
					lsttmp[indiceitem].idestoque		= this.videstoqueedicao;
					lsttmp[indiceitem].descestoque		= $('#cbestoqueedicao').select2('data')[0]['text'];					
					lsttmp[indiceitem].infadprod		= this.vinfadprod;
					lsttmp[indiceitem].qtdentregar		= parseFloat(this.vqtditemedicao);
					lsttmp[indiceitem].idtecnicosolicita   = this.vidtecnicosolicitaedicao === null ? 0 : this.vidtecnicosolicitaedicao,
					lsttmp[indiceitem].nometecnicosolicita = this.vidtecnicosolicitaedicao === null ? '' : $('#cbtecnicosolicitaedicao').select2('data')[0]['text']												

					//this.vtotalimpostos  = parseFloat(this.vtotalimpostos) + parseFloat(this.vvltotalimpostoitemedicao);
					this.vtotalprodutos  = parseFloat(this.vtotalprodutos) + parseFloat(this.vvltotaledicao);					

					this.lstitens = JSON.parse(JSON.stringify(lsttmp));
					this.vtotalgeral					= parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtotfrete) + parseFloat(this.vtottaxaservico);

					this.vquantitativo = parseFloat(this.vquantitativo) + parseFloat(this.vqtditemedicao);
					this.vqtditens	   = this.lstitens.length;											

										
					$('#mdedicaoitem').modal('hide');
					setTimeout(() => {
						$('#btnsalvaritem').prop('disabled', false);
					}, 500);					
				}				
			},
			mtdexcluiritem(item){
				if (!util.opcaousuario('020Z.010Z.130Z', this.$store.state.perfilusuario) && parseInt(this.opcrud) === 2){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					return;
				}				
				let indiceitem 		= util.getArrayIndexForKey(this.lstitens, 'item', item);

				//this.vtotalimpostos = parseFloat(this.vtotalimpostos) - parseFloat(this.lstitens[indiceitem].vltotalimposto);

				this.vquantitativo  = parseFloat(this.vquantitativo)  - parseFloat(this.lstitens[indiceitem].qtditem);

				this.vtotalprodutos = parseFloat(this.vtotalprodutos) - parseFloat(this.lstitens[indiceitem].vltotal);

				this.vtotalgeral	=  parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtotfrete) + parseFloat(this.vtottaxaservico);

				this.lstitens.splice(indiceitem, 1);
				
				this.vqtditens	   = this.lstitens.length;					
			},
			mtdtpdescacres(val){				
				// if (parseInt(val) === 0){
				// 	if (parseInt(this.vdescacresedicao) === 0){
				// 		this.vtitdesc = 'Descto.(%):';
				// 	}else{
				// 		this.vtitdesc = 'Acresc.(%):';
				// 	}
				// }else{
				// 	if (parseInt(this.vdescacresedicao) === 0){
				// 		this.vtitdesc = 'Descto.(R$):';
				// 	}else{
				// 		this.vtitdesc = 'Acresc.(R$):';
				// 	}
				// }
				
				if (parseInt(val) === 0){
					if (parseInt(this.vdescacresedicao) === 0){
						this.vtitdesc = 'Descto.: R$ '+this.mtdformatavalordecimal(parseFloat(this.vldescmostrar), 2);
					}else{
						this.vtitdesc = 'Acresc.(%):';
					}
				}else{
					if (parseInt(this.vdescacresedicao) === 0){
						this.vtitdesc = 'Descto.: '+this.mtdformatavalordecimal(parseFloat(this.vldescmostrar), 2)+'%';
					}else{
						this.vtitdesc = 'Acresc.(R$):';
					}
				}					
			},
			mtdadicionarservico(){
				if (this.vidservicoedicao === null){
					this.$toastr.w('Serviço deve ser informado!', 'Atenção!');
					$('#cbservico').focus();
					return;
				}
				if (this.vidtecnicoedicao === null){
					this.$toastr.w('Técnico deve ser informado!', 'Atenção!');
					$('#cbtecnico').focus();
					return;
				}
				// if (!Number.isInteger(parseFloat(this.vqtdservicoedicao))){
				// 	this.$toastr.w('Quantidade não permitida!', 'Atenção!');
				// 	$('#edqtdservedicao').focus();
				// 	return;
				// }else{
				// 	if (this.vqtdservicoedicao == 0){
				// 		this.$toastr.w('Informe uma quantidade válida!', 'Atenção!');
				// 		$('#edqtdservedicao').focus();
				// 		return;
				// 	}
				// }
				if (this.vqtdservicoedicao == 0){
					this.$toastr.w('Informe uma quantidade válida!', 'Atenção!');
					$('#edqtdservedicao').focus();
					return;
				}
				if (this.vvlservicoedicao <= 0){
					this.$toastr.w('Informe o valor unitário do serviço!!', 'Atenção!');
					$('#edvlservicoedicao').focus();
					return false;
				}


				let fatd = 0;
				if (parseInt(this.vtipodescontoservicoedicao) === 0){
					fatd = this.vvalordescontoservicoedicao;
				}else{
					fatd = parseFloat(this.vvalordescontoservicoedicao) / (parseFloat(this.vqtdservicoedicao) * parseFloat(this.vvlservicoedicao)) * 100;
				}
				if (parseFloat(fatd) > parseFloat(this.$store.state.usuario.descontoservicos)){
					this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoservicos+'%!', 'Informação!');
					$('#edvalordescontoservicoedicao').focus();					
					return;
				}	

				if (util.findValInArray(this.lstservicos, 'idservico', this.vidservicoedicao)){	
					this.$toastr.w('Serviço já lançado na venda!', 'Atenção!');
					$('#cbservico').focus();
					return;					
				}
				let servico = {
					idservico		: this.vidservicoedicao,
					descservico		: $('#cbservico').select2('data')[0]['text'],
					qtdservico		: this.vqtdservicoedicao,
					vlservico		: parseFloat(this.vvlservicoedicao),
					tipodesconto	: this.vtipodescontoservicoedicao,
					valordesconto	: parseFloat(this.vvalordescontoservicoedicao),
					vltotal			: parseFloat(this.vvltotalservicoedicao),
					idtecnico		: this.vidtecnicoedicao,
					nometecnico		: $('#cbtecnico').select2('data')[0]['text']
				};
				this.lstservicos.push(servico);

				this.vtotalservicos = parseFloat(this.vtotalservicos) + parseFloat(this.vvltotalservicoedicao);//total dos serviços

				this.vtotalgeral	= parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtotfrete) + parseFloat(this.vtottaxaservico);

				this.vidservicoedicao				= null;
				this.vqtdservicoedicao				= 1;
				this.vvlservicoedicao				= 0;
				this.vtipodescontoservicoedicao		= 0;
				this.vvalordescontoservicoedicao	= 0;
				this.vvltotalservicoedicao			= 0;
				this.vidtecnicoedicao				= null;

				$("#cbservico").val('').trigger('change');
				$("#cbtecnico").val('').trigger('change');				

				$('#cbservico').focus();

			},
			mtdexcluirservico(servico){
				if (!util.opcaousuario('020Z.010Z.140Z', this.$store.state.perfilusuario) && parseInt(this.opcrud) === 2){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					return;
				}								
				let indiceservico 	= util.getArrayIndexForKey(this.lstservicos, 'idservico', servico.idservico);

				this.vtotalservicos = parseFloat(this.vtotalservicos) - parseFloat(this.lstservicos[indiceservico].vltotal);//total dos serviços

				this.vtotalgeral	= parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos) + parseFloat(this.vtotfrete) + parseFloat(this.vtottaxaservico);

				this.lstservicos.splice(indiceservico, 1);
			},
			mtdselecionarplano(){
				let vself = this;
				if (this.vidfilial === null){
					vself.$toastr.w('Filial deve ser informada!', 'Informação!');
					$('#cbfilial').focus();
					return;
				}				
				if (this.vidcliente === ''){
					vself.$toastr.w('Cliente deve ser informado!', 'Informação!');
					$('#edcliente').focus();
					return;
				}
				$('#mdselecionarplano').modal('show');
			},
			mtddefineplano(plano) {
				this.vidplano 			= plano.id;
				this.vtipoplano 		= plano.tipo;
				this.vdescplano 		= plano.descricao;
				this.vidtabela 			= plano.idtabela;
				this.vpercentrada 		= parseFloat(plano.percentrada);
				this.vpermitedesconto 	= plano.permitedesconto;

				if (this.lstitens.length > 0) {
					if (!util.opcaousuario('020Z.010Z.031Z', this.$store.state.perfilusuario) && parseInt(this.opcrud) !== 3) {
						this.mtdrecalcularprecos();
						$('#mdselecionarplano').modal('hide');
						return
					} 
					$.confirm({
						title: 'Confirmação!',
						content: 'DESEJA RECALCULAR OS PREÇOS AO ALTERAR O PLANO?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						escapeKey: 'nao',
						type: 'dark',
						typeAnimated: true,
						buttons: {
							sim: { // recalcular
								text: '<u>S</u>im',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: () => {
									$('.btn-blue').prop('disabled', true);
									this.mtdrecalcularprecos();
									$('#mdselecionarplano').modal('hide');
								},
							},
							nao: { // não recalcular
								text: '<u>N</u>ão',
								keys: ['n', 'N'],
								action: () => {
									$('#btgravar').focus();
									$('#mdselecionarplano').modal('hide');
								}
							}
						}
					});
			    }else{
					$('#mdselecionarplano').modal('hide');
				}
			},
			mtdgerartitulos(lstbase, valor){
				this.lsttitulosfaturar = [];

				let vlparcela = valor / lstbase.length;

				for (var i = 0; i < lstbase.length; i++) {
					let titulo = {
						codtit 				: this.pedidofaturar.id + '/' + this.mtdformatarzeros(i + 1, 2) + '-'+lstbase.length,
						dtventit			: util.somaDias(this.mtdformatadatagravar(this.vdtfatura), parseInt(lstbase[i]['prazo'])),
						vltit				: vlparcela,
						idtipocobranca		: lstbase[i]['idtipocob'],
						tipocobranca		: lstbase[i]['tipocobranca'],// 0 - Normal 1 - Cheque
						descricaocob		: lstbase[i]['descricaocob'],
						numerocheque		: '',
						idbanco				: null,
						descbanco			: '',
						agencia				: '',
						conta				: '',
						praca				: '',
						emitente			: '',
						cnpjcpf				: '',						
						idsituacaocheque	: null,
						descsituacaocheque	: ''
					}
					this.lsttitulosfaturar.push(titulo);
				}
				this.vtotaltitulos = valor;
			},
			mtdfaturarpedido(idpedido){
				$('#mdmenupedido').modal('hide');
				if (!util.opcaousuario('020Z.010Z.050Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{				
					var vself       = this;
					let loader      = this.$loading.show();
					let parametros  = [
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'infcredito',   valor : '1'},
						{parametro: 'filtro',       valor : ' and p.id='+idpedido},
						{parametro: 'detplano',     valor : 1},					
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						vself.pedidofaturar 	= response.data.pedidos[0];

						if (util.opcaousuario('020Z.010Z.036Z', vself.$store.state.perfilusuario)){
							if (parseInt(response.data.pedidos[0].conferido) === 0){
								vself.$toastr.i('Seu perfil só permite FATURAR o pedido, se o mesmo estiver com a conferência finalizada!', 'Atenção!');
								vself.mtdcancelaredicao();
								return;
							}								
						}
						if (parseInt(response.data.pedidos[0].liberarpdv) === 1){
							vself.$toastr.i('Para FATURAR o pedido, o mesmo deve estar bloqueado para o PDV!', 'Informação!');
							vself.mtdcancelaredicao();
							return;
						}	

						$("#cbformapagamento").val(null).trigger('change');
						vself.vdtfatura			= util.DataAtual();					

						vself.vvlforma			= 0;
						vself.lstformasfaturar 	= [];
						vself.lsttitulosfaturar = [];
						if (parseInt(vself.pedidofaturar.stpedido) !== 0){
							vself.$toastr.i('Para faturar o pedido, a situação do mesmo deve estar em aberto!', 'Informação!');
							vself.pedidofaturar = [];
							return;
						}
						//inclui a forma de pagamento cadastrada no plano
						let forma = {
							idforma 		: vself.pedidofaturar.idforma,
							descforma		: vself.pedidofaturar.descforma,
							vlforma			: vself.pedidofaturar.totalgeral,
							tipo			: vself.pedidofaturar.tipoforma,
							idperfilfluxo   : 0,
							descperfilfluxo : ''
						};
						vself.lstformasfaturar.push(forma);
						/////////////////////////////////////////////////

						//se o plano for a prazo, gera as parcelas
						if (parseInt(vself.pedidofaturar.detplano.tipo) === 1){
							vself.mtdgerartitulos(vself.pedidofaturar.detplano.parcelas, vself.pedidofaturar.totalgeral);				
						}
						
						vself.mtdvisualizarcashback();

						vself.mtdsomarformas();
						$('#mdfaturarpedido').modal('show');										
					}).catch(function (response) {
						loader.hide();
					});
				}		
			},
			mtdvisualizarcashback(){
				let vself = this;
				vself.vltotalcashback 			= 0;
				vself.vlcashbackdisponivelvenda = 0;				
				let loader      = vself.$loading.show();
				let filtro      = ' and p.stpedido=1 and p.tipo=3 and p.idcliente='+vself.pedidofaturar.idcliente;
				let parametros  = [
					{parametro: 'op',           	valor : 'listagem'},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'filtro',       	valor : filtro},
					{parametro: 'limit',        	valor : 1},
					{parametro: 'offset',       	valor : 0},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					loader.hide();
					if (response.data.pedidos.length > 0){
						vself.vltotalcashback 			= parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado)
						vself.vlcashbackdisponivelvenda = util.arredondaValores( parseFloat(vself.pedidofaturar.fatorcreditoutilizar) * parseFloat(vself.pedidofaturar.totalgeral) / 100, 2, 'round');
						if (vself.vlcashbackdisponivelvenda > vself.vltotalcashback){
							vself.vlcashbackdisponivelvenda = vself.vltotalcashback;
						}
					}
				}).catch(function (response) {
					console.log(response);
					vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
					$('#cbformapagamento').focus();
					loader.hide();
				});	
			}, 
			mtdsomarformas(){
				let sf = 0;
				for (let forma of this.lstformasfaturar) {
					sf = sf + forma.vlforma;
				}
				this.vtotalformas = sf;
				if (this.vtotalformas < this.pedidofaturar.totalgeral){
					this.vvlforma 	= this.pedidofaturar.totalgeral - this.vtotalformas;
					this.vdiferenca = 0;
				}else{
					this.vdiferenca = this.vtotalformas - this.pedidofaturar.totalgeral;
				}
			},
			mtdtemespecie(){
				let existe = false;
				for (let forma of this.lstformasfaturar) {
					if (parseInt(forma.especie) === 1) {
						existe = true;
						break;
					}
				}
				return existe;
			},			
			mtdincluirforma(){
				let vself = this;
				if (this.vidformapagamento === null){
					this.$toastr.w('Forma de pagamento deve ser informada!', 'Informação!');
					$('#cbformapagamento').focus();
					return;					
				}
				if (parseFloat(this.vvlforma) <= 0){
					this.$toastr.w('Valor da forma de pagamento inválido!', 'Informação!');
					$('#edvlforma').focus();
					return;					
				}
				if (parseInt(this.pedidofaturar.tipoplano) === 0 && parseInt(this.vtipoforma) === 1){
					this.$toastr.w('Forma de pagamento A PRAZO não é permitida para um plano de pagamento A VISTA!', 'Informação!');
					$('#cbformapagamento').focus();
					return;					
				}	

				if (parseInt(this.vabatecredito) === 1 && this.vnrvendaforma === ''){
					vself.$toastr.w('Informe o número da venda para o resgate!', 'Informação!');
					$('#ednrvendaforma').focus();
					return;					
				}

				if (parseInt(this.vabatecredito) === 1){
					let vllimitecreditoabater = util.arredondaValores( parseFloat(this.pedidofaturar.fatorcreditoutilizar) * parseFloat(this.pedidofaturar.totalgeral) / 100, 2, 'round');				
					if (parseInt(parseFloat(this.vvlforma) * 100) > parseInt(parseFloat(vllimitecreditoabater) * 100)){
						vself.$toastr.w('O valor permitido para uso do crédito/cashback não pode ultrapassar '+util.formatavalordecimais(vllimitecreditoabater, 2)+' ('+this.pedidofaturar.fatorcreditoutilizar+'%). Verifique e tente novamente!', 'Informação!');
						return;						
					}
				}

				if (vself.mtdtemespecie() && parseInt(vself.vespecieforma) === 1){
					vself.$toastr.w('Já existe uma forma em espécie lançada na venda!', 'Informação!');
					return;
				}				
				if (vself.vnrvendaforma === ''){//caso não seja resgate			
					let forma = {
						idforma 	: this.vidformapagamento,
						descforma	: $('#cbformapagamento').select2('data')[0]['text'],
						vlforma		: this.vvlforma,
						tipo		: this.vtipoforma,
						especie		: vself.vespecieforma,
						nrvenda		: vself.vnrvendaforma,						
						idperfilfluxo    : this.vidperfilfluxoforma,
						descperfilfluxo  : this.vdescperfilfluxoforma											
					};
					if (!util.findValInArray(this.lstformasfaturar, 'idforma', this.vidformapagamento)){
						this.lstformasfaturar.push(forma);
						
						if (parseInt(forma.tipo) === 1 && this.pedidofaturar.detplano.parcelas.length > 0){
							this.lsttitulosfaturar = [];
							this.mtdgerartitulos(this.pedidofaturar.detplano.parcelas, forma.vlforma);
						}

						$("#cbformapagamento").val(null).trigger('change');
						this.vvlforma			= 0;
					}else{
						this.$toastr.w('Forma de pagamento já lançada!', 'Informação!');
					}
					this.mtdsomarformas();
					$('#cbformapagamento').focus();
				}else{//resgate
					let loader      = vself.$loading.show();
					let filtro      = ' and p.stpedido=1 and p.id='+vself.vnrvendaforma;
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgpedidos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : filtro},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						if (response.data.pedidos.length > 0){
							if (parseInt(response.data.pedidos[0].creditoindividual) === 1){//caso o crédito for individual
								if (parseInt(response.data.pedidos[0].idcliente) !== parseInt(vself.pedidofaturar.idcliente)){//verifica se o cliente é o titular do crédito. caso não for não libera
									vself.$toastr.i('O crédito em questão só pode ser utilizado pelo cliente titular!', 'Informação!');
									return;
								}
							}

							let vlcreditodisp = parseFloat(response.data.pedidos[0].vlcredito) - parseFloat(response.data.pedidos[0].vlcreditoutilizado);
							if (vself.vvlforma > vlcreditodisp){
								vself.$toastr.i('Valor do crédito desta venda não é suficiente ou não está disponível para resgate!', 'Informação!');
								$('#cbformapagamento').select2('open');
								return;
							}else{
								let forma = {
									idforma 	: vself.vidformapagamento,
									descforma	: $('#cbformapagamento').select2('data')[0]['text'],
									vlforma		: vself.vvlforma,
									tipo		: vself.vtipoforma,
									especie		: vself.vespecieforma,
									nrvenda		: vself.vnrvendaforma,
									idperfilfluxo    : vself.vidperfilfluxoforma,
									descperfilfluxo  : vself.vdescperfilfluxoforma															
								};				
								if (!util.findValInArray(vself.lstformasfaturar, 'idforma', vself.vidformapagamento)){
									vself.lstformasfaturar.push(forma);
									
									if (parseInt(forma.tipo) === 1 && vself.lancamentousu.plano.prazosplanos.length > 0){
										vself.lsttitulosfaturar = [];
										vself.mtdgerartitulos(vself.lancamentousu.plano.prazosplanos, forma.vlforma);
									}

									$("#cbformapagamento").val(null).trigger('change');
									vself.vvlforma			= 0;
								}else{
									vself.$toastr.w('Forma de pagamento já lançada!', 'Informação!');
								}
								vself.mtdsomarformas();
								$('#cbformapagamento').focus();
							}
						}else{
							vself.$toastr.w('Venda não encontrada/cancelada no sistema. Verifique corretamente se a venda permite que o crédito seja resgatado e tente novamente!', 'Informação!');
							$('#ednrvendaforma').focus();
						}
					}).catch(function (response) {
						vself.$toastr.e('Erro ao tentar carregar dados da venda!', 'Erro!');						
						$('#cbformapagamento').focus();
						loader.hide();
					});					
				}
			},	
			mtddeletarforma(index){
				if (parseInt(this.lstformasfaturar[index].tipo) === 1){
					this.lsttitulosfaturar = [];
				}
				this.lstformasfaturar.splice(index, 1); 
				this.mtdsomarformas();
			},
			mtdalterartitulo(titulo, i){
				if (!util.opcaousuario('020Z.010Z.110Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					return;
				}

				this.tindiceparcela			= i;
				this.tajustarparcelas		= false;
				this.tajustarcentavos		= false;
				this.tajustardatas			= false;

				this.tacodtit 				= titulo.codtit;
				this.tadtventit				= titulo.dtventit;
				this.tavltit				= titulo.vltit;
				this.taidtipocobranca		= titulo.idtipocobranca;
				this.tatipocobranca			= titulo.tipocobranca;
				this.tadescricaocob			= titulo.descricaocob;
				this.tanumerocheque			= titulo.numerocheque;
				this.taidbanco				= titulo.idbanco;
				this.tadescbanco			= titulo.descbanco;
				this.taagencia				= titulo.agencia;
				this.taconta				= titulo.conta;
				this.tapraca				= titulo.praca;
				this.taemitente				= titulo.emitente;
				this.tacnpjcpf				= titulo.cnpjcpf;						
				this.taidsituacaocheque		= titulo.idsituacaocheque;
				this.tadescsituacaocheque	= titulo.descsituacaocheque;				


				var deftipocobranca  = new Option(this.tadescricaocob, this.taidtipocobranca, true, true);
				$('#cbtipocobranca').append(deftipocobranca).trigger('change');

				if (this.taidbanco !== null){
					var defbanco  = new Option(this.tadescbanco, this.taidbanco, true, true);
					$('#cbbanco').append(defbanco).trigger('change');
				}else{
					$("#cbbanco").val(null).trigger('change');
				}
				
				if (this.taidsituacaocheque !== null){
					var defsituacaoch  = new Option(this.tadescsituacaocheque, this.taidsituacaocheque, true, true);
					$('#cbsituacaocheque').append(defsituacaoch).trigger('change');
				}else{
					$("#cbsituacaocheque").val(null).trigger('change');
				}

				$('#mdalterartitulo').modal('show');
			},
			mtconfirmaralteracaotitulo(){
				if (this.tadtventit === ''){
					this.$toastr.w('Data de vencimento deve ser informada!', 'Atenção!');
					$('#eddtventit').focus();
					return;
				}
				if (parseFloat(this.tavltit) <= 0){
					this.$toastr.w('Valor do título inválido!', 'Atenção!');
					$('#edvltit').focus();
					return;
				}
				if (this.taidtipocobranca === null){
					this.$toastr.w('Tipo de cobrança deve ser informada!', 'Atenção!');
					$('#cbtipocobranca').focus();
					return;
				}				
				if (parseInt(this.tatipocobranca) === 1){
					if (this.tanumerocheque === ''){
						this.$toastr.w('Número do cheque deve ser informado!', 'Atenção!');
						$('#ednumerocheque').focus();
						return;
					}
					if (this.taidbanco === null){
						this.$toastr.w('Banco deve ser informado!', 'Atenção!');
						$('#cbbanco').focus();
						return;
					}
					if (this.taagencia === ''){
						this.$toastr.w('Agência deve ser informada!', 'Atenção!');
						$('#edagencia').focus();
						return;
					}
					if (this.taconta === ''){
						this.$toastr.w('Conta deve ser informada!', 'Atenção!');
						$('#edconta').focus();
						return;
					}
					if (this.tapraca === ''){
						this.$toastr.w('Praça deve ser informada!', 'Atenção!');
						$('#edpraca').focus();
						return;
					}
					if (this.taemitente === ''){
						this.$toastr.w('Emitente deve ser informado!', 'Atenção!');
						$('#edemitente').focus();
						return;
					}
					if (this.tacnpjcpf === ''){
						this.$toastr.w('CNPJ/CPF deve ser informado!', 'Atenção!');
						$('#edcnpjcpf').focus();
						return;
					}
					if (this.taidsituacaocheque === null){
						this.$toastr.w('Situação do cheque deve ser informada!', 'Atenção!');
						$('#cbsituacaocheque').focus();
						return;
					}					
				}
				let indice = util.getArrayIndexForKey(this.lsttitulosfaturar, 'codtit', this.tacodtit);
				this.vtotaltitulos = this.vtotaltitulos - this.lsttitulosfaturar[indice].vltit;


				this.lsttitulosfaturar[indice].dtventit 			= this.tadtventit;
				this.lsttitulosfaturar[indice].dtventit				= this.tadtventit;
				this.lsttitulosfaturar[indice].vltit				= this.tavltit;
				this.lsttitulosfaturar[indice].idtipocobranca		= this.taidtipocobranca;
				this.lsttitulosfaturar[indice].tipocobranca			= this.tatipocobranca;
				this.lsttitulosfaturar[indice].descricaocob			= $('#cbtipocobranca').select2('data')[0]['text'];

				this.lsttitulosfaturar[indice].numerocheque			= parseInt(this.tatipocobranca) === 1 ? this.tanumerocheque 	: '';
				this.lsttitulosfaturar[indice].idbanco				= parseInt(this.tatipocobranca) === 1 ? this.taidbanco 			: null;
				this.lsttitulosfaturar[indice].descbanco			= parseInt(this.tatipocobranca) === 1 ? $('#cbbanco').select2('data')[0]['text'] : '';
				this.lsttitulosfaturar[indice].agencia				= parseInt(this.tatipocobranca) === 1 ? this.taagencia 			: '';
				this.lsttitulosfaturar[indice].conta				= parseInt(this.tatipocobranca) === 1 ? this.taconta 			: '';
				this.lsttitulosfaturar[indice].praca				= parseInt(this.tatipocobranca) === 1 ? this.tapraca 			: '';
				this.lsttitulosfaturar[indice].emitente				= parseInt(this.tatipocobranca) === 1 ? this.taemitente 		: '';
				this.lsttitulosfaturar[indice].cnpjcpf				= parseInt(this.tatipocobranca) === 1 ? this.tacnpjcpf 			: '';						
				this.lsttitulosfaturar[indice].idsituacaocheque		= parseInt(this.tatipocobranca) === 1 ? this.taidsituacaocheque : null;
				this.lsttitulosfaturar[indice].descsituacaocheque	= parseInt(this.tatipocobranca) === 1 ? $('#cbsituacaocheque').select2('data')[0]['text'] : '';				


				this.vtotaltitulos = this.vtotaltitulos + this.tavltit;

				//divide os valores das parcelas igualmente
				if (this.tajustarparcelas && this.lsttitulosfaturar.length > 0){
					let vlformacalc = 0;
					for (let i = 0; i < this.lstformasfaturar.length; i++) {
						if (parseInt(this.lstformasfaturar[i].tipo) === 1){
							vlformacalc = this.lstformasfaturar[i].vlforma;
							break;
						}
					}
					let vlrestante = vlformacalc - this.tavltit;
					let vlparcela  = vlrestante / (this.lsttitulosfaturar.length - 1);					

					if (this.lsttitulosfaturar.length > 1){
						this.vtotaltitulos = 0;
						for (let i = 0; i < this.lsttitulosfaturar.length; i++) {
							if (i > 0){
								this.lsttitulosfaturar[i].vltit = vlparcela;
							}
							this.vtotaltitulos = this.vtotaltitulos + this.lsttitulosfaturar[i].vltit;
						}
					}					
				}

				//joga os centavos na ultima parcela
				if (this.tajustarcentavos && this.lsttitulosfaturar.length > 0){
					let vlformacalc = 0;
					for (let i = 0; i < this.lstformasfaturar.length; i++) {
						if (parseInt(this.lstformasfaturar[i].tipo) === 1){
							vlformacalc = this.lstformasfaturar[i].vlforma;
							break;
						}
					}
					let vlrestante = vlformacalc - this.tavltit;

					let vlparcela  = vlrestante / (this.lsttitulosfaturar.length - 1);

					let pint	   = Math.floor(vlparcela);
					let fracao	   = util.fracaonumero(vlparcela) * (this.lsttitulosfaturar.length - 1);					
					if (this.lsttitulosfaturar.length > 1){
						this.vtotaltitulos = 0;
						for (let i = 0; i < this.lsttitulosfaturar.length; i++) {
							if (i > 0){
								if (i === this.lsttitulosfaturar.length - 1){
									this.lsttitulosfaturar[i].vltit = pint + fracao;
								}else{
									this.lsttitulosfaturar[i].vltit = pint;
								}
							}
							this.vtotaltitulos = this.vtotaltitulos + this.lsttitulosfaturar[i].vltit;
						}
					}
				}
				
				//ajusta o mesmo dia para as demais datas
				if (this.tajustardatas && this.lsttitulosfaturar.length > 0){
					let dia = this.tadtventit.substring(0, 2);					
					let diaold = dia;
					for (let i = 0; i < this.lsttitulosfaturar.length; i++) {
						if (i > 0){
							let mes 	= this.lsttitulosfaturar[i].dtventit.substring(3, 5);
							let bissexto= util.anobissexto(parseInt(this.lsttitulosfaturar[i].dtventit.substring(6, 10)));
							
							if (!bissexto && parseInt(dia) >= 29 && parseInt(mes) === 2){//fevereiro e bissexto
								dia = 28;
							}

							if (bissexto && parseInt(dia) >= 29 && parseInt(mes) === 2){//nao for bissexto fevereiro
								dia = 29;
							}

							if (parseInt(mes) === 4 && parseInt(dia) === 31){//mes de abril
								dia = 30;
							}

							if (parseInt(mes) === 6 && parseInt(dia) === 31){//mes de abril
								dia = 30;
							}			
							
							if (parseInt(mes) === 9 && parseInt(dia) === 31){//mes de setembro
								dia = 30;
							}			
							
							if (parseInt(mes) === 11 && parseInt(dia) === 31){//mes de novembro
								dia = 30;
							}							

							let novadata= dia + this.lsttitulosfaturar[i].dtventit.substring(2, 10);
							this.lsttitulosfaturar[i].dtventit = novadata;

							dia = diaold;
						}
					}					
				}				

				$('#mdalterartitulo').modal('hide');
			},
			mtdpendenciasparcela(){
				let ret = false;
				for (let titulo of this.lsttitulosfaturar) {
					if (parseInt(titulo.tipocobranca) === 1){
						if (titulo.numerocheque === ''){
							ret = true;
							break;
						}
						if (titulo.idbanco === null){
							ret = true;
							break;
						}
						if (titulo.agencia === ''){
							ret = true;
							break;
						}
						if (titulo.conta === ''){
							ret = true;
							break;
						}
						if (titulo.praca === ''){
							ret = true;
							break;
						}
						if (titulo.emitente === ''){
							ret = true;
							break;
						}
						if (titulo.cnpjcpf === ''){
							ret = true;
							break;
						}
						if (titulo.idsituacaocheque === null){
							ret = true;
							break;
						}																		
					}
				}
				return ret;
			},
			mtdverificasomaparcelas(){
				let vlaprazo = 0;
				for (let forma of this.lstformasfaturar) {
					if (parseInt(forma.tipo) === 1){
						vlaprazo = forma.vlforma;
						break;
					}
				}
				if (parseFloat(this.vtotaltitulos.toFixed(2)) !== parseFloat(vlaprazo.toFixed(2))){
					return false;
				}else{
					return true;
				}
			},
			mtdconfirmarfatura(){
				let vself = this;
				if (this.lstformasfaturar.length === 0){
					this.$toastr.w('Informe as formas de pagamento!', 'Atenção!');
					return;
				}				
				if (parseFloat(this.vtotalformas) !== parseFloat(this.pedidofaturar.totalgeral)){
					this.$toastr.w('A soma das formas de pagamento não confere com o valor à ser faturado. Verifique e tente novamente!', 'Atenção!');
					return;
				}				
				if (parseInt(this.pedidofaturar.detplano.tipo) === 1){
					let vlaprazo  = 0;
					let vlentrada = 0;
					for (let forma of this.lstformasfaturar) {
						if (parseInt(forma.tipo) === 1){
							vlaprazo  = vlaprazo  + parseFloat(forma.vlforma);
						}else{
							vlentrada = vlentrada + parseFloat(forma.vlforma);
						}
					}

					if (parseFloat(this.pedidofaturar.percentrada) > 0){
						let vlentradaplano = parseFloat(this.pedidofaturar.totalgeral) * parseFloat(this.pedidofaturar.percentrada) / 100;
						if (parseFloat(vlentrada).toFixed(2) < parseFloat(vlentradaplano).toFixed(2)){	
							this.$toastr.w('Valor da entrada é inferior ao permitdo pelo plano! Valor mínimo deve ser: R$ '+this.mtdformatavalordecimal(vlentradaplano, 2)+'.', 'Atenção!');
							return;
						}						
					}

					if (parseInt(this.pedidofaturar.liberarfat) === 0){
						if (parseInt(this.pedidofaturar.atraso) > parseInt(this.pedidofaturar.qtddiasbloqvenda)){
							this.$toastr.w('Cliente com débitos em atraso. Favor entrar em contato com o setor responsável!', 'Informação!');
							return;
						}						
						if (parseFloat(vlaprazo.toFixed(2)) > parseFloat(this.pedidofaturar.vlcreditodisponivel.toFixed(2))){	
							this.$toastr.w('Limite de crédito disponível está inferior ao valor da venda a prazo. Favor Entrar em contato com o setor financeiro!', 'Atenção!');
							return;
						}						
					}

					if (this.lsttitulosfaturar.length === 0){
						this.$toastr.w('Para um plano à prazo, as parcelas devem ser informadas!', 'Atenção!');
						return;
					}					
					if (this.mtdpendenciasparcela()){//se estiver faltando algum campo do cheque ser preenchido
						this.$toastr.w('Algum(ns) título(s) definido(s) como cheque não apresenta(m) todas as informações preenchidas. Verifique e tente novamente!', 'Atenção!');
						return;					
					}
					if (!this.mtdverificasomaparcelas()){//verifica se a soma dos títulos é diferente da forma a prazo
						this.$toastr.w('A soma dos títulos não confere com o valor da forma à prazo. Verifique os valores das parcelas!', 'Atenção!');
						return;					
					}				
				}
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma FATURAMENTO do pedido?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								setTimeout(function(){
									vself.mtdefetivafaturamento();
								}, 300); 								
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});					
			},
			mtdefetivafaturamento(){
				let vself  	= this;
				let loader 	= vself.$loading.show();
				let hora   	= util.DataAtual(true, true);
				hora 		= hora.substring(11, 19);
				let parametros      = [
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           		valor : 'faturamento'},
					{parametro: 'idpedido',     		valor : vself.pedidofaturar.id},
					{parametro: 'idfilial',     		valor : vself.$store.state.filialpadrao.codfil},
					{parametro: 'idusuario',    		valor : vself.$store.state.usuario.id},
					{parametro: 'dtfatura',     		valor : vself.mtdformatadatagravar(vself.vdtfatura)+' '+hora},
					{parametro: 'formas',     			valor : JSON.stringify(vself.lstformasfaturar)},
					{parametro: 'titulos',     			valor : JSON.stringify(vself.lsttitulosfaturar)},
					{parametro: 'codop',        		valor : '020Z.010Z.050Z'},
					{parametro: 'faturarsemsaldo',      valor : util.opcaousuario('020Z.010Z.090Z', this.$store.state.perfilusuario) === false ? 0 : 1}
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)){
						$('#mdfaturarpedido').modal('hide');
						vself.$toastr.s('Faturamento realizado com sucesso!', 'Informação!');
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
						vself.pidpedido     	= vself.pedidofaturar.id;
						vself.pqtd_paginas  	= 1;
						vself.mtdcancelaredicao();
						vself.mtdcarregapedidos(1);
					}else{
						let tpret = response.data.substring(0,1);
						switch (tpret) {
							case 'I':
								vself.$toastr.w(response.data.substring(4), 'Atenção!');
								break;
							case 'E': default:
								vself.$toastr.e(response.data.substring(4), 'Erro!');
								break;
						}
					}
				}).catch(function (response) {
					loader.hide();
					vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
				});
			},			
			mtdrotinapdv(idpedido){
				$('#mdmenupedido').modal('hide');
				if (parseFloat(this.pedidomenu.totalgeral) <= 0){
					this.$toastr.w('Opção indisponível para um pedido de crédito!', 'Atenção!');
					return;
				}				
				if (!util.opcaousuario('020Z.010Z.040Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{
					let vself  = this;
					let loader = vself.$loading.show();
					let joinaux 	= "";
					if (vself.pmaisfiltros){
						if (vself.pidmarca !== null || vself.pidgrupo !== null){
							joinaux 	= "0";
						}else if(vself.pidmarca !== null && vself.pidgrupo !== null){
							joinaux 	= "0";
						}
					}
					let parametros      = [
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           valor : 'rotinapdv'},
						{parametro: 'idpedido',     valor : idpedido},
						{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
						{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
						{parametro: 'codop',        valor : '020Z.010Z.040Z'},
						{parametro: 'infcredito',   valor : 1},	
						{parametro: 'joinaux',   	valor : joinaux},										
						{parametro: 'idforma',      valor : vself.pidforma},
						{parametro: 'opconf',       valor : util.opcaousuario('020Z.010Z.036Z', this.$store.state.perfilusuario) ? 1 : 0},

					];
					let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						if ($.isNumeric(response.data.ret)){
							vself.$toastr.s('Solicitação realizada com sucesso!', 'Informação!');
							// vself.pfiltropor		= 0;
							// vself.psituacao     	= 3;
							// vself.pentregaexterna 	= 2;
							// vself.pidpedido     	= idpedido;
							// vself.pqtd_paginas  	= 1;
							// vself.mtdcancelaredicao();
							// vself.mtdcarregapedidos(1);
							vself.mtdatualizapedidolista(response.data.pedido[0], idpedido)
						}else{
							let tpret = response.data.ret.substring(0,1);
							switch (tpret) {
								case 'I':
									vself.$toastr.w(response.data.ret.substring(4), 'Atenção!');
									break;
								case 'E': default:
									vself.$toastr.e(response.data.ret.substring(4), 'Erro!');
									break;
							}
						}
					}).catch(function (response) {
						loader.hide();
						vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
					});
				}				
			},
			mtdcancelarpedido(idpedido){
				$('#mdmenupedido').modal('hide');				
				if (!util.opcaousuario('020Z.010Z.060Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{				
					var vself       = this;
					let loader      = this.$loading.show();
					let parametros  = [
						{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'filtro',       valor : ' and p.id='+idpedido},
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0}
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						vself.pedidocancelar 	  = response.data.pedidos[0];

						if (parseInt(vself.pedidocancelar.stpedido) !== 1){
							vself.$toastr.i('Para CANCELAR o pedido, a situação do mesmo deve estar como FATURADO!', 'Informação!');
							vself.pedidocancelar  = [];
							return;
						}

						if (parseInt(vself.pedidocancelar.idpedidooff) > 0){
							$.confirm({
								title: 'Confirmação!',
								content: 'Este pedido é de origem de um PDV Offline. '+
											'O cancelamento deve ser feito no PDV que originou a venda. '+
											'Caso contrário podem acontecer diferenças no caixa. Deseja mesmo continuar?',
								icon: 'fa fa-question-circle',
								escapeKey: true,
								backgroundDismiss: false,
								escapeKey: 'nao',
								type: 'dark',
								typeAnimated: true,
								buttons: {
									sim: {
										text: '<u>S</u>im',
										keys: ['s', 'S'],
										btnClass: 'btn-blue',
										action: function () {							
											vself.cmotivocancelamento = '';
											vself.cdtcancelamento	  = util.DataAtual();
											$('#mdcancelarpedido').modal('show');												
										},
									},
									nao: {
										text: '<u>N</u>ão',
										keys: ['n', 'N'],
										action: function () {
										}
									}
								}
							});			
						}else{
							vself.cmotivocancelamento = '';
							vself.cdtcancelamento	  = util.DataAtual();
							$('#mdcancelarpedido').modal('show');																				
						}										
					}).catch(function (response) {
						loader.hide();
					});
				}				
			},
			mtdconfirmarcancelamento(){
				let vself = this;
				if (this.cmotivocancelamento === ''){
					this.$toastr.w('Informe o motivo do cancelamento!', 'Atenção!');
					$('#txtmotivocancelamento').focus();
					return;
				}				
				if (this.cdtcancelamento === ''){
					this.$toastr.w('Informe a data do cancelamento!', 'Atenção!');
					$('#eddtcancelamento').focus();
					return;
				}
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma CANCELAMENTO?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								setTimeout(function(){
									vself.mtdefetivacancelamento();
								}, 300); 								
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});								
			},
			mtdefetivacancelamento(){
				let vself  = this;
				let loader = vself.$loading.show();
				let hora   = util.DataAtual(true, true);
				hora = hora.substring(11, 19);
				let parametros      = [
					{parametro: 'idclientesac',         valor : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'op',           		valor : 'cancelamento'},
					{parametro: 'idpedido',     		valor : vself.pedidocancelar.id},
					{parametro: 'idfilial',     		valor : vself.$store.state.filialpadrao.codfil},
					{parametro: 'idusuario',    		valor : vself.$store.state.usuario.id},
					{parametro: 'dtcancelamento',     	valor : vself.mtdformatadatagravar(vself.cdtcancelamento)+' '+hora},
					{parametro: 'motivocancelamento',   valor : vself.cmotivocancelamento},
					{parametro: 'codop',        		valor : '020Z.010Z.060Z'}
				];
				let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					loader.hide();
					if ($.isNumeric(response.data)){
						$('#mdcancelarpedido').modal('hide');
						vself.$toastr.s('Cancelamento realizado com sucesso!', 'Informação!');
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
						vself.pidpedido     	= vself.pedidocancelar.id;
						vself.pqtd_paginas  	= 1;
						vself.mtdcancelaredicao();
						vself.mtdcarregapedidos(1);
					}else{
						let tpret = response.data.substring(0,1);
						switch (tpret) {
							case 'I':
								vself.$toastr.w(response.data.substring(4), 'Atenção!');
								break;
							case 'E': default:
								vself.$toastr.e(response.data.substring(4), 'Erro!');
								break;
						}
					}
				}).catch(function (response) {
					loader.hide();
					vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
				});
			},
			mtdrecalcularprecos(){
				let vself 		= this;
				let lstitenstmp = [];
				
				vself.vqtditens		= vself.lstitens.length;
				vself.vquantitativo = 0;
				for (let item of vself.lstitens) {
					vself.vquantitativo = vself.vquantitativo + item.qtditem;
					let itemtmp = {
						idproduto		: item.idproduto,
						item			: item.item
					};
					lstitenstmp.push(itemtmp);
				}
				let loader      = vself.$loading.show();
				let parametros  = [
					{parametro: 'op',           valor : 'precosplano'},
					{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'idfilial',     valor : vself.vidfilial},
					{parametro: 'idtabela',     valor : vself.vidtabela},
					{parametro: 'itens',    	valor : JSON.stringify(lstitenstmp)}
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
				retorno.then(function (response) {
					$('#mdselecionarplano').modal('hide');					
					vself.vtotalgeral	=  vself.vtotalgeral - vself.vtotalprodutos;
					vself.vtotalprodutos = 0;

					let lstitenscopia = [];
					lstitenscopia     = JSON.parse(JSON.stringify(vself.lstitens));					
					let lstitensret   = response.data;
					for (let item of lstitensret) {						
						let indi = util.getArrayIndexForKey(lstitenscopia, 'item', item.item);					
						
						let valdescacres = 0;

						if (parseInt(lstitenscopia[indi].manipulaval) === 0){							
							lstitenscopia[indi].vlunitario 		= parseFloat(item.vlunitario);
							lstitenscopia[indi].descacres		= 0;

							if (parseFloat(item.vldescpromocional) > 0){								
								lstitenscopia[indi].tipodescacres	= 0;
								lstitenscopia[indi].valordescacres	= parseFloat(item.vldescpromocional);
								lstitenscopia[indi].manipulaval		= 0;

								valdescacres 		= parseFloat(lstitenscopia[indi].qtditem) * item.vlunitario * lstitenscopia[indi].valordescacres / 100;
															
							}else{
								lstitenscopia[indi].tipodescacres	= 0;
								lstitenscopia[indi].valordescacres	= 0;
								lstitenscopia[indi].manipulaval		= 0;							
							}

							let ret = util.itemcomimposto(item.dadosclasseitem, parseFloat(item.vlunitario), parseFloat(lstitenscopia[indi].qtditem), 0, parseFloat(valdescacres));								

							lstitenscopia[indi].vltotalimposto  = ret.totalimpostoitem;
							lstitenscopia[indi].vltotal	   		= ret.vltotalitem;	

						}
						vself.vtotalprodutos = parseFloat(vself.vtotalprodutos) + parseFloat(lstitenscopia[indi].vltotal);
					}
					vself.lstitens	    = [];
					vself.lstitens	    = lstitenscopia;

					vself.vtotalgeral	=  parseFloat(vself.vtotalgeral) + parseFloat(vself.vtotalprodutos);					

					loader.hide();
				}).catch(function (response) {
					$('#mdselecionarplano').modal('hide');
					vself.$toastr.e('Erro ao tentar carregar os preços do plano de pagamento. Descrição do erro: '+response.message, 'Erro!');
					loader.hide();
				});
			},
			mtdaplicardesconto(){
				if (this.lstitens.length === 0){
					this.$toastr.i('Não há itens para lançamento do desconto!', 'Informação!');
				}else{
					if (parseInt(this.vpermitedesconto) === 0){
						this.$toastr.i('O plano de pagamento selecionado não permite desconto!', 'Informação!');
						return;
					}
					for (let i = 0; i < this.lstitens.length; i++) {
						if (parseFloat(this.lstitens[i].vltotalimposto) > 0){
							this.$toastr.i('Alguns itens possuem imposto atrelado. Desconto deve ser aplicado individualmente!', 'Informação!');
							return;
						}
					}
					this.vtipodesctotal		 = 0;
					this.vfatordescontototal = 0;
					this.vtotalsemdesconto   = 0;
					this.vresdesconto		 = 0;
					for (let item of this.lstitens) {
						this.vtotalsemdesconto = parseFloat(this.vtotalsemdesconto) + (item.vlunitario * item.qtditem);
					}
					this.vtotalcomdesconto	   = parseFloat(this.vtotalsemdesconto);
					$('#mdaplicardesconto').modal('show');
				}
			},
			// mtdconfirmaaplicacaodesconto(){				
			// 	let fatoraplicar 		= 0;

			
			// 	if (parseInt(this.vtipodesctotal)){
			// 		fatoraplicar = parseFloat(this.vresdesconto);					
			// 	}else{
			// 		fatoraplicar = parseFloat(this.vfatordescontototal);
			// 	}
				
			// 	let descto_comparar = parseInt(this.vtipoplano) === 0 ? this.$store.state.usuario.descontoprodutos : this.$store.state.usuario.descontoprodutosprazo;

			// 	if (parseFloat(fatoraplicar) > parseFloat(descto_comparar)){
			// 		this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
			// 		$('#cbtipodesctotal').focus();					
			// 		return;
			// 	}

			// 	if (parseFloat(fatoraplicar) < 0){
			// 		this.$toastr.w('Desconto inválido!', 'Informação!');
			// 		$('#edfatordescontototal').focus();
			// 		return;
			// 	}

			// 	if (fatoraplicar > 0){
			// 		for (let item of this.lstitens) {
			// 			if (((parseFloat(item.vlunitario) * parseFloat(item.qtditem)) * parseFloat(fatoraplicar) / 100) < 0.01){
			// 				this.$toastr.i('Desconto não pode ser divido pela quantidade total de itens do pedido. '+
			// 								'A divisão do desconto fica abaixo de 0,01 centavo. Tente o desconto individual', 'Informação!');
			// 				return;
			// 			}
			// 		}
			// 	}
			// 	$('#btnconfirmadesconto').prop('disabled', true);
			// 	this.vtotalgeral		= parseFloat(this.vtotalgeral) - parseFloat(this.vtotalprodutos);				
			// 	this.vtotalprodutos		= 0;
			// 	let descacumulado 		= 0;
			// 	let mandarmsg           = false; 
			// 	let vldesconto			= 0;

			// 	for (var i = 0; i < this.lstitens.length; i++) {
			// 		let dardesc = true;
			// 		console.log("inidep");
			// 		//verfica o preco de venda mínimo
			// 		if (parseFloat(this.lstitens[i].prvendaminimo) > 0){
			// 			let vldescpm = 0;
			// 			vldescpm = parseFloat(this.lstitens[i].vlunitario) - (parseFloat(this.lstitens[i].vlunitario) *  parseFloat(fatoraplicar) / 100);

			// 			if (parseFloat(this.lstitens[i].prvendaminimo) > parseFloat(vldescpm)){
			// 				//this.$toastr.i('O item: '+this.lstitens[i].item+' ultrapassou o preço mínimo. Desconto deve ser aplicado individualmente!', 'Informação!');
			// 				//$('#btnconfirmadesconto').prop('disabled', false);
			// 				//return;		
			// 				dardesc   = false;
			// 				mandarmsg = true;

			// 			}								
			// 		}else{
			// 			vldesconto 	= (parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem)) * parseFloat(fatoraplicar) / 100;
			// 		}


			// 		//let vldesconto 			= (parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem)) * parseFloat(fatoraplicar) / 100;
					
			// 		if (vldesconto < 0.01){
			// 			descacumulado = parseFloat(vldesconto);
			// 		}else{
			// 			descacumulado = 0;
			// 		}

			// 		vldesconto 			= util.arredondaValores(vldesconto, 2, 'round');
			// 		if(dardesc){
			// 			if (vldesconto >= 0.01){
			// 				this.lstitens[i].descacres		= 0;
			// 				this.lstitens[i].tipodescacres	= 1;
			// 				this.lstitens[i].valordescacres	= parseFloat(vldesconto) + parseFloat(descacumulado);
			// 				descacumulado = 0;
			// 				this.lstitens[i].vltotal		= util.arredondaValores((parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem)) - parseFloat(vldesconto), 2, 'round');
			// 			}else{
			// 				this.lstitens[i].valordescacres	= 0;
			// 				this.lstitens[i].vltotal		= util.arredondaValores(parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem), 2, 'round');
			// 			}
			// 			this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(this.lstitens[i].vltotal);
			// 		}
			// 	}

			// 	this.vtotalprodutos 	= util.arredondaValores(parseFloat(this.vtotalprodutos), 2, 'round');

			// 	this.vtotalgeral		= parseFloat(this.vtotalgeral) + parseFloat(this.vtotalprodutos);	
				
			// 	let vlajuste = 0;
			// 	let ajustar  = 0;
			// 	if (parseFloat(this.vtotalcomdesconto) > parseFloat(this.vtotalprodutos)){
			// 		vlajuste = parseFloat(this.vtotalcomdesconto) - parseFloat(this.vtotalprodutos);
			// 		ajustar  = 1;//ajuste para menos
			// 	}else{
			// 		vlajuste = parseFloat(this.vtotalprodutos) - parseFloat(this.vtotalcomdesconto);
			// 		ajustar  = 0;//ajuste para mais
			// 	}
			// 	if (vlajuste > 0 && vlajuste < 0.01){
			// 		vlajuste = 0.01;
			// 	}
			// 	if (vlajuste > 0){
			// 		for (var x = 0; x < this.lstitens.length; x++) {
			// 			if (parseFloat(this.lstitens[x].vltotal) > vlajuste){
			// 				if (ajustar === 0){//ajuste para mais
			// 					this.lstitens[x].valordescacres	= util.arredondaValoresV2(parseFloat(this.lstitens[x].valordescacres) + parseFloat(vlajuste), 2, 'round');
			// 				}else{//ajuste
			// 					this.lstitens[x].valordescacres	= util.arredondaValoresV2(parseFloat(this.lstitens[x].valordescacres) - parseFloat(vlajuste), 2, 'round');
			// 				}							
			// 				if (this.lstitens[x].valordescacres < 0){
			// 					this.lstitens[x].valordescacres = 0;
			// 				}
			// 				this.lstitens[x].vltotal		= (parseFloat(this.lstitens[x].vlunitario) * parseFloat(this.lstitens[x].qtditem)) - parseFloat(this.lstitens[x].valordescacres);							
			// 				break;
			// 			}
			// 		}
			// 		if (parseInt(ajustar) === 0){
			// 			this.vtotalprodutos = parseFloat(this.vtotalprodutos) - parseFloat(vlajuste);
			// 			this.vtotalgeral	= parseFloat(this.vtotalgeral)    - parseFloat(vlajuste);
			// 		}else{
			// 			this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(vlajuste);
			// 			this.vtotalgeral	= parseFloat(this.vtotalgeral)    + parseFloat(vlajuste);						
			// 		}					
			// 	}	
			// 	this.mtdrecalculartudo(mandarmsg)		
			// 	$('#mdaplicardesconto').modal('hide');
			// 	setTimeout(() => {
			// 		$('#btnconfirmadesconto').prop('disabled', false);
			// 	}, 500);
			// },
			mtdconfirmaaplicacaodesconto(){				
				let fatoraplicar 		= 0;
			
				/// Cara.. essa rotina é muito dificil mas eu vou comentar aqui para me ajudarno futuro e para vcs DEVs - GUGa

				/*Este metodo serve para aplicar um desconto geral na listagem*/

				if (parseInt(this.vtipodesctotal)){ //
					fatoraplicar = parseFloat(this.vresdesconto);					
				}else{
					fatoraplicar = parseFloat(this.vfatordescontototal);
				}
				
				let descto_comparar = parseInt(this.vtipoplano) === 0 ? this.$store.state.usuario.descontoprodutos : this.$store.state.usuario.descontoprodutosprazo;

				if (parseFloat(fatoraplicar) > parseFloat(descto_comparar)){
					this.$toastr.i('Desconto à ser aplicado é maior do que o permitido para o usuário. Percentual permitido '+this.$store.state.usuario.descontoprodutos+'%!', 'Informação!');
					$('#cbtipodesctotal').focus();					
					return;
				}

				if (parseFloat(fatoraplicar) < 0){
					this.$toastr.w('Desconto inválido!', 'Informação!');
					$('#edfatordescontototal').focus();
					return;
				}

				if (fatoraplicar > 0){
					for (let item of this.lstitens) {
						if (((parseFloat(item.vlunitario) * parseFloat(item.qtditem)) * parseFloat(fatoraplicar) / 100) < 0.01){
							this.$toastr.i('Desconto não pode ser divido pela quantidade total de itens do pedido. '+
											'A divisão do desconto fica abaixo de 0,01 centavo. Tente o desconto individual', 'Informação!');
							return;
						}
					}
				}
				$('#btnconfirmadesconto').prop('disabled', true);
				this.vtotalgeral		= parseFloat(this.vtotalgeral) - parseFloat(this.vtotalprodutos);				
				this.vtotalprodutos		= 0;
				let descacumulado 		= 0;
				let mandarmsg           = false; 
				
				for (var i = 0; i < this.lstitens.length; i++) {
					let dardesc = true;
					//verfica o preco de venda mínimo
					if (parseFloat(this.lstitens[i].prvendaminimo) > 0){
						let vldescpm = 0;
						vldescpm = parseFloat(this.lstitens[i].vlunitario) - (parseFloat(this.lstitens[i].vlunitario) *  parseFloat(fatoraplicar) / 100);

						if (parseFloat(this.lstitens[i].prvendaminimo) > parseFloat(vldescpm)){					
							dardesc   =  false;
							mandarmsg = true;
						}								
					}

					let vldesconto 			= (this.lstitens[i].vlunitario * this.lstitens[i].qtditem) * fatoraplicar / 100;
					
					if (vldesconto < 0.01){
						descacumulado = parseFloat(vldesconto);
					}else{
						descacumulado = 0;
					}

					vldesconto 			= util.arredondaValores(vldesconto, 2, 'round');
					if(dardesc){
						if (vldesconto >= 0.01){
							this.lstitens[i].descacres		= 0;
							this.lstitens[i].tipodescacres	= 1;
							this.lstitens[i].valordescacres	= parseFloat(vldesconto) + parseFloat(descacumulado);
							descacumulado = 0;
							this.lstitens[i].vltotal		= util.arredondaValores((parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem)) - parseFloat(vldesconto), 2, 'round');
						}else{
							this.lstitens[i].valordescacres	= 0;
							this.lstitens[i].vltotal		= util.arredondaValores(parseFloat(this.lstitens[i].vlunitario) * parseFloat(this.lstitens[i].qtditem), 2, 'round');
						}
						//Totaliza os produtos 
						this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(this.lstitens[i].vltotal);	
					}
					
				}

				this.vtotalprodutos 	= util.arredondaValores(parseFloat(this.vtotalprodutos), 2, 'round');
				this.vtotalgeral		= parseFloat(this.vtotalgeral) + parseFloat(this.vtotalprodutos);	
				/////////////////////////////////////////////////////////////////////////////////////////


				//ajuste de valor para resolver dizimas e etc
				let vlajuste = 0;
				let ajustar  = 0;
				if (parseFloat(this.vtotalcomdesconto) > parseFloat(this.vtotalprodutos)){
					vlajuste = parseFloat(this.vtotalcomdesconto) - parseFloat(this.vtotalprodutos);
					ajustar  = 1;//ajuste para menos
				}else{
					vlajuste = parseFloat(this.vtotalprodutos) - parseFloat(this.vtotalcomdesconto);
					ajustar  = 0;//ajuste para mais
				}
				if (vlajuste > 0 && vlajuste < 0.01){
					vlajuste = 0.01;
				}
				if (vlajuste > 0){
					for (var x = 0; x < this.lstitens.length; x++) {
						if (parseFloat(this.lstitens[x].vltotal) > vlajuste){


							let valorDescontoAjuste = 0;
							//ve o tipo de desconto no item 
							if(parseInt(this.lstitens[x].tipodescacres) === 1){// em valor
								valorDescontoAjuste = parseFloat(this.lstitens[x].valordescacres);
							}else{// em percentual
								valorDescontoAjuste = parseFloat(this.lstitens[x].valordescacres) * parseFloat(this.lstitens[x].qtditem) * parseFloat(this.lstitens[x].vlunitario) / 100   
							    
								this.lstitens[x].tipodescacres = 1; //muda o tipo pra valor, para facilitar a nossa vida. 
							}


							if (ajustar === 0){//ajuste para mais
								this.lstitens[x].valordescacres	= util.arredondaValoresV2(parseFloat(valorDescontoAjuste) + parseFloat(vlajuste), 2, 'round');
							}else{//ajuste
								this.lstitens[x].valordescacres	= util.arredondaValoresV2(parseFloat(valorDescontoAjuste) - parseFloat(vlajuste), 2, 'round');
							}							
							if (this.lstitens[x].valordescacres < 0){
								this.lstitens[x].valordescacres = 0;
							}
							this.lstitens[x].vltotal		= (parseFloat(this.lstitens[x].vlunitario) * parseFloat(this.lstitens[x].qtditem)) - parseFloat(this.lstitens[x].valordescacres);							
							break;
						}
					}
					if (parseInt(ajustar) === 0){
						this.vtotalprodutos = parseFloat(this.vtotalprodutos) - parseFloat(vlajuste);
						this.vtotalgeral	= parseFloat(this.vtotalgeral)    - parseFloat(vlajuste);
					}else{
						this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(vlajuste);
						this.vtotalgeral	= parseFloat(this.vtotalgeral)    + parseFloat(vlajuste);						
					}					
				}	
				this.mtdrecalculartudo(mandarmsg);		
				$('#mdaplicardesconto').modal('hide');
				setTimeout(() => {
					$('#btnconfirmadesconto').prop('disabled', false);
				}, 500);
			},
			mtdrecalculartudo(mandarmsg){
				this.vtotalprodutos = 0;
				for(let i = 0; i < this.lstitens.length; i++){
					this.vtotalprodutos = parseFloat(this.vtotalprodutos) + parseFloat(this.lstitens[i].vltotal);
				}
				this.vtotalgeral =  parseFloat(this.vtotalprodutos) + parseFloat(this.vtotalservicos);
				if(mandarmsg){
					 this.$toastr.i('Desconto aplicado, mas um ou mais itens atingiram o preço minimo, seu desconto pode ser dado individualmente!', 'Atenção!');
				}
			},
			mtddefinirfilialemissaonf(pedido, modelo){
				$('#mdmenupedido').modal('hide');
				if (parseInt(this.$store.state.filialpadrao.plnc) < 2){
					this.$swal.fire({
										position: 'bottom-end',
										//icon: 'success',
										title: 'Atenção!',
										html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
										showConfirmButton: false,
										showCloseButton: true,
										backdrop: false,
										timer: 2000                                                
									}); 
					return;                                                               
				}			
				if (parseInt(pedido.tipo) === 3){
					this.$toastr.i('Emissão de NF somente para pedidos!', 'Informação!');
					return;
				}
				if (parseFloat(pedido.totalgeral) <= 0){
					this.$toastr.w('Emissão de NF somente para pedidos!', 'Atenção!');
					return;
				}

				this.vpedidonf   = pedido;
				this.vidfilialnf = pedido.idfilial;
				this.vnomefilianf= pedido.fantasia;	
				this.vmodelonf	 = modelo;			
				$('#mddefinefilialnf').modal('show');
			},
			mtdgerarenviarnf(apenasregistro){				
				let vself 	 = this;		

				if (vself.vidfilialnf === null){
					vself.$toastr.w('Informe a filial para emissão da NF!', 'Atenção!');
					$('#cbfilialnf').select2('open');
					return;
				}
				
				this.habbtnf = true;
				$('#mddefinefilialnf').modal('hide');

				vself.vpedidonf.idfilialnf = vself.vidfilialnf;//define a filial para emissão da nf
				vself.vpedidonf.origemnf   = 0;
				if (!util.opcaousuario('020Z.010Z.065Z', vself.$store.state.perfilusuario)){
					vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{
					let loader = vself.$loading.show();
					let parametros      = [
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'op',           valor : apenasregistro ? 'gerarnf' : 'gerarenviarnf'},
						{parametro: 'pedido',     	valor : JSON.stringify(vself.vpedidonf)},
						{parametro: 'modelo',     	valor : vself.vmodelonf},
						{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
						{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
						{parametro: 'codop',        valor : '020Z.010Z.065Z'}
					];
					let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						if ($.isNumeric(response.data)){
							vself.vpedidonf.idnotafiscal = response.data;
							vself.vpedidonf.situacaonota = 2;
							vself.$toastr.s('Nota gerada com sucesso!', 'Informação!');
							if (!apenasregistro){
								vself.mtdimprimirdanfe(vself.vpedidonf);
							}
							vself.pfiltropor		= 0;
							vself.psituacao     	= 3;
							vself.pentregaexterna 	= 2;
							vself.pidpedido     	= vself.vpedidonf.id;
							vself.pqtd_paginas  	= 1;
							vself.mtdcancelaredicao();
							vself.mtdcarregapedidos(1);								
						}else{
							let tpret = response.data.substring(0,1);
							switch (tpret) {
								case 'I':
									vself.$toastr.w(response.data.substring(4), 'Atenção!');
									break;
								case 'E': default:
									vself.$toastr.e(response.data.substring(4), 'Erro!');
									break;
							}
						}
					}).catch(function (response) {
						loader.hide();
						vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
					});
				}				
			},			
			mtdalterarqtdlevar(item){
				let vself 			= this;

				if (parseInt(vself.opcrud) < 3){
					vself.litemlevar 	= item;

					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : vself.litemlevar.coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto 		= response.data[0];	
							vself.lfracionado	= produto.fracionado;

							vself.lqtdlevar  	= parseFloat(item.qtditem) - parseFloat(item.qtdentregar);
							$('#mdalteracaoqtdlevar').modal('show');
						}else{
							vself.$toastr.e('Erro durante sua solicitação. Tente novamente mais tarde!', 'Erro!');
						}
					}).catch(function (response) {
						vself.$toastr.e('Erro durante sua solicitação. Tente novamente mais tarde!', 'Erro!');
						loader.hide();						
					});
				}	
			},
			mtdconfirmaraltercaoqtdlevar(){
				if (parseFloat(this.lqtdlevar) < 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtdlevar').focus();
					return;
				}
                if (parseInt(this.lfracionado) === 0){
                    if (!Number.isInteger(this.lqtdlevar)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtdlevar').focus();
                        return;
                    }
				}				
				if (parseFloat(this.lqtdlevar) > parseFloat(this.litemlevar.qtditem)){
					this.$toastr.w('Quantidade não pode ser superior a quantidade do item!', 'Atenção!');
					$('#edqtdlevar').focus();
					return;
				}								
				let indiceitem 						= util.getArrayIndexForKey(this.lstitens, 'item', this.litemlevar.item)
				let lsttmp 							= this.lstitens;
				this.lstitens						= [];

				lsttmp[indiceitem].qtdentregar      = parseFloat(this.litemlevar.qtditem) - parseFloat(this.lqtdlevar);

				this.lstitens 						= lsttmp;	
				
				$('#mdalteracaoqtdlevar').modal('hide');
			},
			mtdentregaexterna(pedido){
				var vself       = this;
				if (!util.opcaousuario('020Z.010Z.165Z', vself.$store.state.perfilusuario)){
					vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {                
					let loader      = vself.$loading.show();
					let filtro      = ' and p.id='+pedido.id;
					let parametros  = [
						{parametro: 'op',           valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',       valor : filtro},
						{parametro: 'limit',        valor : 1},
						{parametro: 'offset',       valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
					retorno.then(function (response) {
						loader.hide();
						
						if (parseInt(response.data.pedidos[0].stpedido) !== 1){
							vself.$toastr.w('Opção disponível somente para pedidos faturados!', 'Informação!');
							return;
						}
						if (parseInt(response.data.pedidos[0].entregaexterna) !== 1){
							vself.$toastr.w('Opção disponível apenas para pedidos marcados como entrega externa!', 'Informação!');
							return;
						}
						if (parseInt(response.data.pedidos[0].entregaexternafinalizada) !== 0){
							vself.$toastr.w('Entrega externa do pedido já finalizada!', 'Informação!');
							return;
						}							
						vself.pedidoentrega			= response.data.pedidos[0];
						vself.itensbc.item2.titulo 	= 'GERENCIAR ENTREGA EXTERNA';
						vself.itensbc.item1.ativo 	= true;
						vself.itensbc.item2.ativo 	= true;
						vself.ativadesativa 			= false;
						vself.ativadesativavendedor 	= false;
						vself.carregaInfosEcommerce();
						$('#pnlista').hide();
						$('#pnentregaexterna').fadeIn(700);

					}).catch(function (response) {
						loader.hide();
					});
				}				
			},
			mtddefinirqtdentregue(item){
				let vself 			= this;

				vself.eitementregar	= item;

				let loader      = vself.$loading.show();
				let parametros  = [
					{parametro: 'op',               valor : 'listagem'},
					{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
					{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
					{parametro: 'filtro',           valor : ''},
					{parametro: 'coddig',           valor : vself.eitementregar.coddig},
					{parametro: 'limit',            valor : 1},
					{parametro: 'offset',           valor : 0},
				];
				let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
				retorno.then(function (response) {
					loader.hide();						
					if (response.data.length > 0){
						let produto 		= response.data[0];	
						vself.efracionado	= produto.fracionado;

						vself.eqtdentregue	= parseFloat(item.qtdentregar);
						$('#mddefinirqtdentregue').modal('show');
					}else{
						vself.$toastr.e('Erro durante sua solicitação. Tente novamente mais tarde!', 'Erro!');
					}
				}).catch(function (response) {
					vself.$toastr.e('Erro durante sua solicitação. Tente novamente mais tarde!', 'Erro!');
					loader.hide();						
				});
			},
			mtdconfirmaraltercaoqtdentregue(){
				if (parseFloat(this.eqtdentregue) < 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtdlevarentrega').focus();
					return;
				}
                if (parseInt(this.efracionado) === 0){
                    if (!Number.isInteger(this.eqtdentregue)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtdlevarentrega').focus();
                        return;
                    }
				}				
				if (parseFloat(this.eqtdentregue) > parseFloat(this.eitementregar.qtdentregar)){
					this.$toastr.w('Quantidade não pode ser superior a quantidade a ser entregue!', 'Atenção!');
					$('#edqtdlevarentrega').focus();
					return;
				}								
				let indiceitem 						= util.getArrayIndexForKey(this.pedidoentrega.itens, 'item', this.eitementregar.item)
				let lsttmp 							= this.pedidoentrega.itens;
				this.lstitens						= [];

				lsttmp[indiceitem].qtdentregue      = parseFloat(this.eqtdentregue);

				this.pedidoentrega.itens 			= lsttmp;	
				
				$('#mddefinirqtdentregue').modal('hide');
			},
			mtdentregartodositens(){
				for (let i = 0; i < this.pedidoentrega.itens.length; i++) {
					this.pedidoentrega.itens[i].qtdentregue = this.pedidoentrega.itens[i].qtdentregar;					
				}
			},
			mtditenspendentesentrega(){
				let $ret  = false;
				for (let i = 0; i < this.pedidoentrega.itens.length; i++) {
					if (parseFloat(this.pedidoentrega.itens[i].qtdentregue) < parseFloat(this.pedidoentrega.itens[i].qtdentregar)){
						$ret = true;
						return $ret;						
					}
				}
			},
			mtdsalvarentrega(){
				let vself = this;
				$.confirm({
					title: 'Confirmação!',
					content: 'Salvar alterações na entrega externa?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								let loader = vself.$loading.show();
								let itensentrega = [];
								for (let i = 0; i < vself.pedidoentrega.itens.length; i++) {
									let itemtmp = {
										item		: vself.pedidoentrega.itens[i].item,
										idproduto	: vself.pedidoentrega.itens[i].idproduto,
										qtdentregue	: vself.pedidoentrega.itens[i].qtdentregue
									};																		
									itensentrega.push(itemtmp);
								}								
								let parametros      = [
									{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
									{parametro: 'op',           		valor : 'salvarentrega'},
									{parametro: 'idpedido',     		valor : vself.pedidoentrega.id},
									{parametro: 'itens',				valor : JSON.stringify(itensentrega)},
									{parametro: 'idfilial',     		valor : vself.$store.state.filialpadrao.codfil},
									{parametro: 'idusuario',    		valor : vself.$store.state.usuario.id},
									{parametro: 'codop',        		valor : '020Z.010Z.165Z'}
								];
								let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
								retorno.then(function (response) {
									loader.hide();
									if ($.isNumeric(response.data)){
										vself.$toastr.s('Alterações salvas com sucesso!', 'Informação!');
										vself.pfiltropor		= 0;
										vself.psituacao     	= 3;
										vself.pentregaexterna 	= 2;
										vself.pidpedido     	= vself.pedidoentrega.id;
										vself.pqtd_paginas  	= 1;
										vself.mtdcancelaredicao();
										vself.mtdcarregapedidos(1);
									}else{
										let tpret = response.data.substring(0,1);
										switch (tpret) {
											case 'I':
												vself.$toastr.w(response.data.substring(4), 'Atenção!');
												break;
											case 'E': default:
												vself.$toastr.e(response.data.substring(4), 'Erro!');
												break;
										}
									}
								}).catch(function (response) {
									loader.hide();
									vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
								});
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});								
			},
			mtdfinalizarentregaexterna(){
				let vself = this;
				if (vself.mtditenspendentesentrega()){
					vself.$toastr.w('Impossível finalizar entrega com itens pendentes!', 'Informação!');
					return;
				}
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma finalização da entrega externa?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								let loader = vself.$loading.show();
								let parametros      = [
									{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
									{parametro: 'op',           		valor : 'finalizarentrega'},
									{parametro: 'idpedido',     		valor : vself.pedidoentrega.id},
									{parametro: 'idfilial',     		valor : vself.$store.state.filialpadrao.codfil},
									{parametro: 'idusuario',    		valor : vself.$store.state.usuario.id},
									{parametro: 'codop',        		valor : '020Z.010Z.165Z'}
								];
								let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
								retorno.then(function (response) {
									loader.hide();
									if ($.isNumeric(response.data)){
										vself.$toastr.s('Entrega finalizada com sucesso!', 'Informação!');
										vself.pfiltropor		= 0;
										vself.psituacao     	= 3;
										vself.pentregaexterna 	= 2;
										vself.pidpedido     	= vself.pedidoentrega.id;
										vself.pqtd_paginas  	= 1;
										vself.mtdcancelaredicao();
										vself.mtdcarregapedidos(1);
									}else{
										let tpret = response.data.substring(0,1);
										switch (tpret) {
											case 'I':
												vself.$toastr.w(response.data.substring(4), 'Atenção!');
												break;
											case 'E': default:
												vself.$toastr.e(response.data.substring(4), 'Erro!');
												break;
										}
									}
								}).catch(function (response) {
									loader.hide();
									vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
								});
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
								$('#btgravar').focus();
							}
						}
					}
				});								
			},
			mtdimprimirentrega(idpedido, tp, eopitensimpressao){
				if (!util.opcaousuario('020Z.010Z.165Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else { 								
					window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirentregaexternapedido.php?idclientesac='+
								this.$store.state.filialpadrao.idcliente+
								'&idpedido='+idpedido+'&tpimp='+tp+
								'&opitens='+eopitensimpressao+'&idu='+
								this.$store.state.usuario.id, '_blank');				
				}
			},
            mtdgerarimagens(imagens){
                this.images = [];
                for (let i = 0; i < imagens.length; i++) {
                    this.images.push(this.$store.state.configpaths.pathimagens + imagens[i].patharquivo);                    
                }
                this.$viewerApi({                   
                    images: this.images,
                });
            },
            mtdvisualizarimagens(pedido){
				if (parseInt(pedido.tipo) === 3){
					this.$toastr.i('Imagem não disponível!', 'Informação!');
					return;
				}				
				if (parseFloat(pedido.totalgeral) <= 0){
					this.$toastr.w('Imagem não disponível!', 'Atenção!');
					return;
				}				
                if (pedido.imagens.length > 0){
					this.mtdgerarimagens(pedido.imagens);                                                 
                }else{
                    this.$toastr.i('Não há imagens disponíveis para visualização!', 'Informação!');
                }				
            },
            mtdaplicaselecaochecklist: function(valoratribuir){
                for (var i = 0; i < this.lstchecklist.length; i++) {
                    this.lstchecklist[i].habilita = valoratribuir;
                }
            },
            mtdmarcartodaschecklist(){
                if (util.findValInArray(this.lstchecklist, 'habilita', 0)){
                    this.mtdaplicaselecaochecklist(1);
                }else{
                    this.mtdaplicaselecaochecklist(0);
                }
            },
            mtdhabilitachecklist(index){
                if (this.opcrud < 3) {
                    if (parseInt(this.lstchecklist[index].habilita) === 0) {
                        this.lstchecklist[index].habilita = 1;
                    } else {
                        this.lstchecklist[index].habilita = 0;
                    }
                }
            },
            mtdalterarperfilfluxo(forma, indice){
				if(parseInt(this.$store.state.usuario.operaperfilfluxo)===0){
					this.$toastr.i('Seu usuário não esta habilitado a operar perfil de fluxo!', 'Informação!');
					return;
				}
                this.aindiceperfilfluxo  = indice;
                this.aidperfilfluxo      = forma.idperfilfluxo;
                this.adescperfilfluxo    = forma.descperfilfluxo;
                if (parseInt(this.aidperfilfluxo) !== 0){
                    var deffluxo  = new Option(this.adescperfilfluxo, this.aidperfilfluxo, true, true);
                    $('#cbperfilfluxofinal').append(deffluxo).trigger('change');
                }else{
                    $('#cbperfilfluxofinal').val(null).trigger('change');
                }

                $('#mdlalterarperfilfluxofinal').modal('show');
            },
            mtdconfirmarperfilfluxo(){
                this.lstformasfaturar[this.aindiceperfilfluxo].idperfilfluxo   = this.aidperfilfluxo === null ? 0 : this.aidperfilfluxo;
                this.lstformasfaturar[this.aindiceperfilfluxo].descperfilfluxo = this.aidperfilfluxo === null ? '' : $('#cbperfilfluxofinal').select2('data')[0]['text'];
                $('#mdlalterarperfilfluxofinal').modal('hide');
            },
            mtdconferencia(item){
				if (parseInt(item.tipo) === 3){
					this.$toastr.i('Conferência não permitida à um crédito avulso!', 'Informação!');
					return;
				}
				if (parseFloat(item.totalgeral) <= 0){
					this.$toastr.w('Conferência não permitida para um pedido de crédito!', 'Atenção!');
					return;
				}
                if (!util.opcaousuario('020Z.010Z.032Z', this.$store.state.perfilusuario)){
                   this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'CONFERÊNCIA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.vicodpro 		= null;
                    this.videscpro 		= '';
                    this.vqtdfalta 		= '0';
					this.vfatorconf     = 1;
                    this.vfinalizado 	= false;
                    this.vachouPro 		= false;
                    this.vmsgPro 		= '';
                    $('#pnlista').hide();
                    $('#pncadastro').hide();
                    $('#pnconferencia').fadeIn(700);                    
                    this.mtdlocalizaritensconf(item);
                }
            },
			mtdlocalizaritensconf(item){
                var vself           = this;
                let loader          = this.$loading.show();

                vself.cfidpedido 	= item.id;			

                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'listagemconf'},
                    {parametro: 'idpedido', 	valor  : item.id}
                ];
                let retorno              = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    vself.lstitensconf		= response.data.itens;
                    vself.lstcodigosconf    = response.data.codigos;

                    if(vself.lstitensconf.length > 0){
                        vself.ativadesativa    = true;
                        vself.ativadesativacod = false;
                        loader.hide()

                        vself.$nextTick(function () {
                            $("#edvicodpro").focus();
                        })
                    }else{
                        vself.$toastr.w('Nenhum registro encontrado!', 'Warning!');
                    }
                }).catch(function (response) {
                    vself.lstitensconf     = [];
                    vself.lstcodigos       = [];
                    loader.hide();
                    vself.ativadesativa    = false;
                    vself.ativadesativacod = true;
                })                				
			},
            mtdativacodpro(){
                setTimeout(() => {
                    this.ativadesativacod = false;                    
                    this.$nextTick(function () {
                        $("#edvicodpro").focus()
                    });                    
                }, 300);                
            },
            submitProd(){
				let	prod   = this.vicodpro;
				for (var i = 0; i < parseInt(this.vfatorconf); i++) {
					this.vicodpro = prod
					this.mtdprocessaconf();
                }
            },
			mtdprocessaconf(){
				this.ativadesativacod   = true;
				let cdpro_busca         = null;
				cdpro_busca             = this.vicodpro;
				if (cdpro_busca === null || cdpro_busca === undefined || cdpro_busca === '') {
					this.limpaCamposPro(this.mtdativacodpro);
					return;
				}else {
					this.igualaDadosProduto(cdpro_busca)
					
				}	
			},
            limpaCamposPro(callback) {
                this.ativadesativacod = false;
                this.videscpro        = '';
                this.vqtdfalta        = 0;
				this.vfatorconf       = 1;
      
                callback();
            },
            igualaDadosProduto(codPro){

                //this.limpaCamposPro()
                this.videscpro        = '';
                this.vqtdfalta        = 0;

                if (codPro != null) {
                    let indxCod        = util.getArrayIndexForKey(this.lstcodigosconf, 'codigo', codPro)
                    let codPesq        = codPro

                    if(indxCod > -1){
                        codPesq        = this.lstcodigosconf[indxCod].idproduto
                    }
                    
                    if (util.findValInArray(this.lstitensconf, 'idproduto', codPesq)) {

                        this.vmsgPro   = ''

                        let indxPro    = util.getArrayIndexForKey(this.lstitensconf, 'idproduto', codPesq)
                        this.videscpro = this.lstitensconf[indxPro].descricao
                        this.vqtdfalta = this.lstitensconf[indxPro].qtdfalta

                        if(this.lstitensconf[indxPro].qtdconf === this.lstitensconf[indxPro].qtditem) {
                            if(((this.lstitensconf[indxPro].qtdconf === this.lstitensconf[indxPro].qtditem) && 
                                (this.lstitensconf[indxPro].qtdfalta < 0)) || 
                                ((this.lstitensconf[indxPro].qtdconf === this.lstitensconf[indxPro].qtditem) && 
                                (this.lstitensconf[indxPro].qtdfalta <= this.lstitensconf[indxPro].qtditem))) {

                                //Zerar o qtdfalta   
                                this.lstitensconf[indxPro].qtdfalta = 0
                            }

                            this.lstitensconf[indxPro].situacao   = 1
                            this.mtItemConcluidoConf(codPesq)                            
                        }else{
                            this.lstitensconf[indxPro].qtdconf    = ++this.lstitensconf[indxPro].qtdconf;
                            this.lstitensconf[indxPro].qtdfalta   = --this.vqtdfalta;

                            if(((this.lstitensconf[indxPro].qtdconf === this.lstitensconf[indxPro].qtditem) && 
                                (this.lstitensconf[indxPro].qtdfalta < 0)) || 
                                ((this.lstitensconf[indxPro].qtdconf === this.lstitensconf[indxPro].qtditem) && 
                                (this.lstitensconf[indxPro].qtdfalta <= this.lstitensconf[indxPro].qtditem))) {

                                //Zerar o qtdfalta   
                                this.lstitensconf[indxPro].qtdfalta = 0
                                this.lstitensconf[indxPro].situacao = 1

                                this.mtItemConcluidoConf(codPesq)
                            }else{
                                this.play({ id: 'faltando' })
                                this.vachouPro = true
                                this.vmsgPro = 'PRODUTO ( ' + this.vicodpro + ' ) CONFERIDO | FALTA ' + this.vqtdfalta                
                            }

                            this.vicodpro = '';
                            setTimeout(() => {
                                this.limpaCamposPro(this.mtdativacodpro);
                            }, 500);                                      
                        }        
                    }else{
                        this.$toastr.w('Produto não encontrado na lista!', 'Warning!');
                        this.play({ id: 'alerta' });
                        this.vachouPro = false;
                        this.vmsgPro   = 'PRODUTO ( ' + this.vicodpro + ' ) NÃO ENCONTRADO NA LISTA';
                        this.vicodpro  = null;
                        setTimeout(() => {
                            this.limpaCamposPro(this.mtdativacodpro);
                        }, 500);                                  
                    }          
                }
            },
            mtItemConcluidoConf(CodProd){
                this.$toastr.w('Quantidade do produto ' + CodProd + ' atingida!', 'Warning!');
                this.play({ id: 'concluido' });
                this.vachouPro = false;
                this.vicodpro  = null;
                this.videscpro = '';
				this.vfatorconf=  0;
                this.vqtdfalta = '0';
                this.limpaCamposPro(this.mtdativacodpro);
            },
            mtdcancelarconf(){
                let vself = this
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Tem certeza que deseja cancelar a conferência?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {        
                                vself.ativadesativa 		= false;
                                vself.ativadesativacod 		= true;
                                vself.lstitensconf	 		= [];
                                vself.lstcodigosconf 		= [];
                                vself.itensbc.item1.ativo 	= false;
                                vself.itensbc.item2.ativo 	= false;
                                vself.vfinalizado         	= false;
                                vself.vachouPro           	= false;
                                vself.vmsgPro             	= '';

                                $('#pnconferencia').hide();
                                $('#pncadastro').hide();
                                $('#pnlista').fadeIn(700);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#edvicodpro').focus()
                            }
                        }
                    }
                });        
            },	
			mtdgravarconf(){
                let vself          = this;
                let falta_conferir = true;

                for (var i = 0; i < vself.lstitensconf.length; i++) {									
                    if(vself.lstitensconf[i]['qtdfalta'] > 0){
                        falta_conferir = false
                        break
                    }				
                }

                if(!falta_conferir){
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Tem certeza que deseja gravar com pedência de itens conferidos?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {        
                            //Grava com pendencia
                            vself.mtatribuiConfItens();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            	$('#edvicodpro').focus()
                            }
                        }
                        }
                    });
                }else{
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Confirma finalização da conferência?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'dark',
                        typeAnimated: true,
                        buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {        
								//Finaliza conferência
								vself.mtatribuiConfItens();
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                            	$('#edvicodpro').focus();
                            }
                        }
                        }
                    });
                }				
			},
            mtatribuiConfItens(){
                let vself        = this
                let loader       = vself.$loading.show()
                let registroconf = {
                    'idpedido'  	: vself.cfidpedido,
                    'itensconf'     : vself.lstitensconf
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'gravarconferencia'},
                    {parametro: 'registro',     valor : JSON.stringify(registroconf)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '010Z.010Z.028Z'},//verificar                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!')
                        vself.lstitensconf     = []
                        vself.lstcodigosconf   = []
                        //vself.limpaCamposPro()
                        vself.ativadesativa    = false
                        vself.ativadesativacod = true
                        vself.vfinalizado      = false
                        vself.vachouPro        = false
                        vself.vmsgPro          = ''
						//carrega a listagem - montar os campos
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
                        vself.pidpedido     	= vself.cfidpedido;
                        vself.pqtd_paginas  	= 1;
						vself.pcredito			= 0;					
						vself.porigem			= 10;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.substring(0,1)
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!')
                                break
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!')
                                break
                        }
                    }
                }).catch(function (response) {
                    loader.hide()
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!')
                });
            },
			mtdrotinarecibopedido(pedido){
				let vself = this;
				if (parseInt(pedido.tipo) === 3){
					this.$toastr.i('Recibo somente para pedidos faturados!', 'Informação!');
					return;
				}
				if (parseFloat(pedido.totalgeral) <= 0){
					this.$toastr.w('Recibo somente para pedidos faturados!', 'Atenção!');
					return;
				}								
				if (!util.opcaousuario('020Z.010Z.170Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {				
					vself.pedidorecibo			= JSON.parse(JSON.stringify(pedido));
					vself.prformapagamento		= pedido.prformapagamento === '' ? pedido.descplano : pedido.prformapagamento;
					vself.prtrasportadora		= pedido.prtrasportadora;
					vself.prnnf					= parseInt(pedido.prnnf) === 0 ? (parseInt(pedido.idnotafiscal) > 0 ? pedido.idnotafiscal : '') : pedido.prnnf;
					vself.prindicacao			= pedido.prindicacao;
					vself.pratividade			= pedido.pratividade;
					vself.probservacoes			= pedido.probservacoes;				
					$('#mdrecibopedido').modal('show');
				}
			},
			mtdconfirmarecibopedido(){
				let vself = this;
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma emissão do recibo do pedido?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
					sim: {
						text: '<u>S</u>im',
						keys: ['s', 'S'],
						btnClass: 'btn-blue',
						action: function () {        
							vself.mtdsalvarecibopedido();
						},
					},
					nao: {
						text: '<u>N</u>ão',
						keys: ['n', 'N'],
						action: function () {
							//$('#edvicodpro').focus()
						}
					}
					}
				});				
			},
			mtdsalvarecibopedido(){
                let vself        = this
                let loader       = vself.$loading.show()
                let registro = {
                    'idpedido'  		: vself.pedidorecibo.id,
                    'prformapagamento'	: vself.prformapagamento,
					'prtrasportadora'	: vself.prtrasportadora,
					'prnnf'				: vself.prnnf === '' ? 0 : vself.prnnf,
					'prindicacao'		: vself.prindicacao,
					'pratividade'		: vself.pratividade,
					'probservacoes'		: vself.probservacoes
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'gravarecibopedido'},
                    {parametro: 'registro',     valor : JSON.stringify(registro)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.010Z.170Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
						vself.mtdimprimerecibopedido(vself.pedidorecibo.id);
						vself.pedidorecibo			= [];
						vself.prformapagamento		= '';
						vself.prtrasportadora		= '';
						vself.prnnf					= '';
						vself.prindicacao			= '';
						vself.pratividade			= '';
						vself.probservacoes			= '';
                    }else{
                        let tpret = response.data.substring(0,1)
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!')
                                break
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!')
                                break
                        }
                    }
                }).catch(function (response) {
                    loader.hide()
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!')
                });
			},
			mtdimprimerecibopedido(idpedido){
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimerecibopedido.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+idpedido+'&idu='+this.$store.state.usuario.id, '_blank');					
			},
			mtdetiquetasvolumes(){
				if (parseInt(this.pedidomenu.tipo) === 3){
					this.$toastr.i('Emissão de etiquetas somente para pedidos!', 'Informação!');
					return;
				}
				if (parseFloat(this.pedidomenu.totalgeral) <= 0){
					this.$toastr.w('Emissão de etiquetas somente para pedidos!', 'Atenção!');
					return;
				}								
				$("#mdetiquetasvolumepedido").modal('show');
			},
			mtddetalhespedido(idpedido){
				this.vidpedidodet = 0;
                this.vidpedidodet = idpedido;
                $('#mddetalhespedido').modal('show');
			},
            mtdimpressao(gerarexcel){
                let vself   = this;
                let filtro  = vself.mtdfiltropesquisa();
				let idforma = vself.pidforma !== null ? vself.pidforma : 0;
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadpedidosvenda.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
							'&op=imprimirlistapedidos'+
                            '&filtro='+filtro+
                            '&situacao='+vself.psituacao+
                            '&dtini='+vself.pdtini+
                            '&dtfim='+vself.pdtfim+
							'&idforma='+idforma+
							'&detitem='+vself.detalheitem+
                            '&usuario='+vself.$store.state.usuario.nome+
							'&gerarexcel='+gerarexcel, '_blank');	                
            },
			mtdanalisecortes(){
				if (!util.opcaousuario('020Z.010Z.034Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {				
					$('#mdanalisecortes').modal('show');
				}
			},
			mtdlistarcortes(idproduto){
                let vself        = this;				
				let filtro		 = 'and p.stpedido=0 and p.dtemissao between "' + util.InverterData(vself.cdtini) + '" and "' + util.InverterData(vself.cdtfim) + '"';
				if (parseInt(vself.ctipo) < 3){
					filtro = filtro + ' and p.tipo='+vself.ctipo;
				}
                let loader       = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listarcortes'},
					{parametro: 'filtro',       valor : filtro},
					{parametro: 'diferenca',	valor : vself.cdiferenca},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
					vself.lstitenscorte = response.data.itens;
					vself.cqtditenscorte= response.data.itenscortar;
					vself.ctotalcortes	= response.data.totalcorte;
					if (idproduto > 0){
						for (let i = 0; i < vself.lstitenscorte.length; i++) {
							if (parseInt(vself.lstitenscorte[i].idproduto) === parseInt(idproduto)){
								vself.lstitenscorte[i].expandir = 1;
								return;
							}
						}
					}
                }).catch(function (response) {
                    loader.hide()
                    vself.$toastr.e('Erro ao processar os registos. Descrição do erro: '+response.message, 'Erro!')
                });				
			},
			mtdexpandirpedidos(indice){
				if (parseInt(this.lstitenscorte[indice].expandir) === 1){
					this.lstitenscorte[indice].expandir = 0;
				}else{
					this.lstitenscorte[indice].expandir = 1;
				}
			},
			mtdimprimirlistagemcortes(){
                let vself   = this;
				let filtro		 = 'and p.stpedido=0 and p.dtemissao between "' + util.InverterData(vself.cdtini) + '" and "' + util.InverterData(vself.cdtfim) + '"';
				if (parseInt(vself.ctipo) < 3){
					filtro = filtro + ' and p.tipo='+vself.ctipo;
				}
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadpedidosvenda.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
							'&op=imprimirlistagemcortes'+
                            '&filtro='+filtro+
                            '&diferenca='+vself.cdiferenca+
                            '&dtini='+vself.cdtini+
                            '&dtfim='+vself.cdtfim+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');				
			},
			mtdrotinacorteitem(iitem, ipedido){
				this.itemcortar 	= JSON.parse(JSON.stringify(this.lstitenscorte[iitem]));
				this.pedidocortar   = JSON.parse(JSON.stringify(this.lstitenscorte[iitem].pedidos[ipedido]));
				this.qtditemcortar  = this.lstitenscorte[iitem].pedidos[ipedido].qtditem;
				$('#mdcorteitem').modal('show');
			},
			mtdconfirmarcorteitem(){
				let vself = this;
				if (parseFloat(vself.qtditemcortar) <= 0){
					vself.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditemcortar').focus();
					return;
				}
                if (parseInt(vself.itemcortar.fracionado) === 0){
                    if (!Number.isInteger(vself.qtditemcortar)){
						vself.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemcortar').focus();
                        return;
                    }
				}				
				if (parseFloat(vself.qtditemcortar) > parseFloat(vself.pedidocortar.qtditem)){
					vself.$toastr.w('Quantidade de corte não pode ser maior que a quantidade do item!', 'Atenção!');
					$('#edqtditemcortar').focus();
					return;
				}				
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma corte do item?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
					sim: {
						text: '<u>S</u>im',
						keys: ['s', 'S'],
						btnClass: 'btn-blue',
						action: function () {        
							vself.mtdgravarcortaritem();
						},
					},
					nao: {
						text: '<u>N</u>ão',
						keys: ['n', 'N'],
						action: function () {
							$('#edqtditemcortar').focus();
						}
					}
					}
				});								
			},
			mtdgravarcortaritem(){
				let vself = this;
                let loader       = vself.$loading.show()
                let parametros   = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'cortaritem'},
					{parametro: 'qtdcorte',     valor : vself.qtditemcortar},
					{parametro: 'idpedido',     valor : vself.pedidocortar.idpedido},
					{parametro: 'idproduto',    valor : vself.itemcortar.idproduto},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : '020Z.010Z.034Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Corte realizado com sucesso!', 'Informação!')
						vself.mtdlistarcortes(vself.itemcortar.idproduto);
						$('#mdcorteitem').modal('hide');
                    }else{
                        let tpret = response.data.substring(0,1)
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!')
                                break
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!')
                                break
                        }
                    }
                }).catch(function (response) {
                    loader.hide()
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!')
                });				
			},
			mtditenscortados(){		
				if(!util.opcaousuario('020Z.010Z.240Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
					return;
				}
				this.lcdtini 		   = util.DataAtual(true);
				this.lcdtfim 		   = util.DataAtual(true);
				this.lcidvendedor 	   = null;
				this.lcidproduto 	   = null;
				this.lcidmarca 		   = null;
				this.lcidrota 		   = null;
				this.lcidgrupo 		   = null;
				this.lcidsubgrupo 	   = null;
				this.lcidcidade        = null;
				this.lstrecuperacortes = [];
				this.lcidcliente 	   = null;
				$("#cblidcidade").val(null).trigger('change');				
				$("#cblcvendedor").val(null).trigger('change');										
				$("#cblcsubgrupo").val(null).trigger('change');										
				$("#cblcgrupo").val(null).trigger('change');										
				$("#cblcmarca").val(null).trigger('change');										
				$("#cblcrota").val(null).trigger('change');									
				$("#cblcproduto").val(null).trigger('change');										
				$("#cblccliente").val(null).trigger('change');										
				// $('#mditenscortados').modal('show');
				$('#mdgerenciarecuperacorte').modal('show');
			},
			mtdimprimiritenscortados(){
                let vself   = this;
				let filtro		 = 'and i.dthrcorte between "' + util.InverterData(vself.lcdtini) + ' : 00:00:00" and "' + util.InverterData(vself.lcdtfim) + ' : 23:59:59"';

				if (vself.lcidvendedor !== null){
					filtro		 = filtro + ' and i.idvendedor='+vself.lcidvendedor;
				}
				if (vself.lcidproduto !== null){
					filtro		 = filtro + ' and i.idproduto='+vself.lcidproduto;
				}
				if (vself.lcidmarca !== null){
					filtro		 = filtro + ' and p.idmarca='+vself.lcidmarca;
				}
				if (vself.lcidrota !== null){
					filtro		 = filtro + ' and r.id='+vself.lcidrota;
				}
				if (vself.lcidcidade !== null){
					filtro		 = filtro + ' and c.idmunicipio='+vself.lcidcidade;
				}
				if (vself.lcidgrupo !== null){
					filtro		 = filtro + ' and p.idgrupo='+vself.lcidgrupo;
				}
				if (vself.lcidsubgrupo !== null){
					filtro		 = filtro + ' and p.idsubgrupo='+vself.lcidsubgrupo;
				}
				if (vself.lcidcliente !== null){
					filtro		 = filtro + ' and i.idcliente='+vself.lcidcliente;
				}
				window.open(vself.$store.state.configpaths.pathcontrole+'rtcadpedidosvenda.php?idclientesac='+
							vself.$store.state.filialpadrao.idcliente+
							'&op=imprimiritenscortados'+
                            '&filtro='+filtro+
                            '&dtini='+vself.lcdtini+
                            '&dtfim='+vself.lcdtfim+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');				
				$('#mditenscortados').modal('hide');							
			},
			mtdliberarpedido(idpedido){
				$('#mdmenupedido').modal('hide');
				let vself = this;
				if (!util.opcaousuario('020Z.010Z.045Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{					
					$.confirm({
						title: 'Confirmação!',
						content: 'Confirma LIBERAÇÃO do pedido para o FATURAMENTO?',
						icon: 'fa fa-question-circle',
						escapeKey: true,
						backgroundDismiss: false,
						escapeKey: 'nao',
						type: 'dark',
						typeAnimated: true,
						buttons: {
							sim: {
								text: '<u>S</u>im',
								keys: ['s', 'S'],
								btnClass: 'btn-blue',
								action: function () {
									$('.btn-blue').prop('disabled', true);

									let loader = vself.$loading.show();
									let joinaux 	= "";
									if (vself.pmaisfiltros){
										if (vself.pidmarca !== null || vself.pidgrupo !== null){
											joinaux 	= "0";
										}else if(vself.pidmarca !== null && vself.pidgrupo !== null){
											joinaux 	= "0";
										}
									}
									let parametros      = [
										{parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
										{parametro: 'op',           valor : 'liberarfaturamento'},
										{parametro: 'idpedido',     valor : idpedido},
										{parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
										{parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
										{parametro: 'infcredito',   valor : 1},	
										{parametro: 'joinaux',   	valor : joinaux},										
										{parametro: 'limit',        valor : vself.pqtdregistros},
										{parametro: 'idforma',      valor : vself.pidforma},
										{parametro: 'codop',        valor : '020Z.010Z.045Z'}
									];
									let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
									retorno.then(function (response) {
										loader.hide();
										if ($.isNumeric(response.data.ret)){
											vself.$toastr.s('Solicitação realizada com sucesso!', 'Informação!');
											// vself.pfiltropor		= 0;
											// vself.psituacao     	= 3;
											// vself.pentregaexterna 	= 2;
											// vself.pidpedido     	= idpedido;
											// vself.pqtd_paginas  	= 1;
											// vself.mtdcancelaredicao();
											// vself.mtdcarregapedidos(1);
											vself.mtdatualizapedidolista(response.data.pedido[0], idpedido);
										}else{
											let tpret = response.data.ret.substring(0,1);
											switch (tpret) {
												case 'I':
													vself.$toastr.w(response.data.ret.substring(4), 'Atenção!');
													break;
												case 'E': default:
													vself.$toastr.e(response.data.ret.substring(4), 'Erro!');
													break;
											}
										}
									}).catch(function (response) {
										loader.hide();
										vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
									});
								},
							},
							nao: {
								text: '<u>N</u>ão',
								keys: ['n', 'N'],
								action: function () {
									$('#btgravar').focus();
								}
							}
						}
					});		
				}		
			},
			mtdinformacoescliente(idcliente, nomecliente, vlcredito, imagemcliente){
                this.idclienteinf 	= 0;
                this.nomeclienteinf = '';
                this.vlcreditoinf 	= 0; 				
				if (idcliente !== '' && idcliente !== null){
					this.idclienteinf 		= idcliente;
					this.nomeclienteinf 	= nomecliente;
					this.imagemclienteinf 	= imagemcliente;
					this.vlcreditoinf 		= vlcredito;
					$('#mdinformacoescliente').modal('show');
				}else{
					this.$toastr.w('Cliente deve ser informado!', 'Atenção!');
				}
			},
			mtdcreditoavulso(){
				if (!util.opcaousuario('020Z.010Z.180Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {				
					$('#mdcreditoavulso').modal('show');
				}
			},
			mtdconfirmarcreditoavulso(){
				let vself = this;
				if (vself.vidfilialca === null){
					vself.$toastr.w('Informe a filial!', 'Atenção!');
					$("#cbfilialca").select2("open");
					return;
				}
				if (vself.vidclienteca === null){
					vself.$toastr.w('Informe o cliente!', 'Atenção!');
					$("#cbclienteca").select2("open");
					return;
				}				
				if (vself.vvalorcreditoavulso <= 0){
					vself.$toastr.w('Valor do crédito deve ser informado!', 'Atenção!');
					$('#edvlcreditoavulso').focus();
					return;
				}				
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma inclusão do crédito avulso?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								vself.mtdgravarcreditoavulso();
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});				
			},
			mtdgravarcreditoavulso(){
				let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'creditoavulso'},
                    {parametro: 'idfilial',     	valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    	valor : vself.$store.state.usuario.id},
					{parametro: 'idfilialca',     	valor : vself.vidfilialca},
					{parametro: 'idclienteca',    	valor : vself.vidclienteca},
					{parametro: 'dtemissaoca',    	valor : vself.mtdformatadatagravar(util.DataAtual())},
					{parametro: 'observacoesca',  	valor : vself.vobservacoesca},
					{parametro: 'vlcreditoavulso',	valor : vself.vvalorcreditoavulso},
                    {parametro: 'codop',        	valor : '020Z.010Z.010Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
					$('#mdcreditoavulso').modal('hide');
                    if ($.isNumeric(response.data.inf)){						
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.ptipo				= 4;
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
                        vself.pidpedido     	= response.data.inf;
                        vself.pqtd_paginas  	= 1;
						vself.pcredito			= 0;					
						vself.porigem			= 10;
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
								vself.ptipo				= 4;
								vself.pfiltropor		= 0;
								vself.psituacao     	= 3;
								vself.pentregaexterna 	= 2;
								vself.pidpedido     	= response.data.pedido.id;
								vself.pqtd_paginas  	= 1;
								vself.pcredito			= 0;					
								vself.porigem			= 10;
								vself.mtdcarregapedidos(1);								
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
			},
			mtddevolucao(pedido){
				if (!util.opcaousuario('020Z.010Z.190Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {
					if (parseFloat(pedido.vlcredito) > 0){
						this.$toastr.w('Devolução de crédito não permitida!', 'Atenção!');
						return;
					}	
					if (parseInt(pedido.stpedido) !== 1){
						this.$toastr.w('Devolução permitida apenas para pedidos faturados!', 'Atenção!');
						return;
					}								
					this.pedidodevolucao		= [];
					this.dtemissaodevolucao		= util.DataAtual(true);
					this.totaldevolucao			= 0;
					this.observacoesdevolucao   = '';
					let ped = JSON.parse(JSON.stringify(pedido));
					for (let i = 0; i < ped.length; i++) {
						ped[i].qtddevolucao = 0;					
					}
					this.pedidodevolucao = JSON.parse(JSON.stringify(ped));
					$('#mddevolucao').modal('show');
				}
			},
			mtddevolvertodos(){
				let ped = JSON.parse(JSON.stringify(this.pedidodevolucao));
				for (let i = 0; i < ped.itens.length; i++) {
					ped.itens[i].qtddevolucao = ped.itens[i].qtditem;
				}
				this.pedidodevolucao = JSON.parse(JSON.stringify(ped));
				this.mtdcalculatotaldevolucao();
			},
			mtdcalculatotaldevolucao(){
				this.totaldevolucao			= 0;
				for (let i = 0; i < this.pedidodevolucao.itens.length; i++) {
					this.totaldevolucao = this.totaldevolucao + (
						parseFloat(this.pedidodevolucao.itens[i].qtddevolucao) * (parseFloat(this.pedidodevolucao.itens[i].vltotal) / parseFloat(this.pedidodevolucao.itens[i].qtditem))
					);					
				}
			},
			mtdprocessadevolucao(){
				let vself = this;
				let existedev = false;	
				for (let i = 0; i < vself.pedidodevolucao.itens.length; i++) {
					if (vself.pedidodevolucao.itens[i].qtddevolucao > 0){
						existedev = true;
					}
					if (vself.pedidodevolucao.itens[i].qtddevolucao < 0){
						vself.$toastr.w('Item '+vself.pedidodevolucao.itens[i].item+' está com a quantidade de devolução negativa!', 'Atenção!');
						return;
					}

					if (vself.pedidodevolucao.itens[i].qtddevolucao > vself.pedidodevolucao.itens[i].qtditem){
						vself.$toastr.w('Item '+vself.pedidodevolucao.itens[i].item+' está com a quantidade de devolução maior que a quantidade vendida. Verifique e tente novamente!', 'Atenção!');
						return;
					}

					if (parseInt(vself.pedidodevolucao.itens[i].fracionado) === 0){
						if (!Number.isInteger(vself.pedidodevolucao.itens[i].qtddevolucao)){
							vself.$toastr.w('Quantidade do item: '+vself.pedidodevolucao.itens[i].item+' não pode ser FRACIONADA!', 'Atenção!');
							return;
						}
					}					
				}
				if (!existedev){
					vself.$toastr.w('Não foram encontrados itens para devolução!', 'Atenção!');
					return;
				}										
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma devolução dos itens do pedido?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								vself.mtdgravardevolucao();
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});
			},
			mtdconfirmardevolucao(){
				let vself = this;
				$.confirm({
					title: 'Confirmação!',
					content: 'Deseja gerar crédito para esta devolução?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: {
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								vself.vgerarcreditodevolucao = true;
								vself.mtdprocessadevolucao();
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
								vself.vgerarcreditodevolucao = false;
								vself.mtdprocessadevolucao();
							}
						}
					}
				});
			
			},
			mtdgravardevolucao(){
				let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', 		 valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           		 valor : 'devolucao'},
                    {parametro: 'idfilial',     		 valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    		 valor : vself.$store.state.usuario.id},
					{parametro: 'pedido',  				 valor : JSON.stringify(vself.pedidodevolucao)},
					{parametro: 'dtdevolucao',    		 valor : vself.mtdformatadatagravar(vself.dtemissaodevolucao)},
					{parametro: 'observacoes',  		 valor : vself.observacoesdevolucao},					
					{parametro: 'totaldevolucao',		 valor : vself.totaldevolucao},
					{parametro: 'gerarcreditodevolucao', valor : vself.vgerarcreditodevolucao ? 1 : 0},
                    {parametro: 'codop',          	     valor : '020Z.010Z.190Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();					
                    if ($.isNumeric(response.data.inf)){						
						$('#mddevolucao').modal('hide');
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.ptipo					 = 4;
						vself.pfiltropor			 = 0;
						vself.psituacao     		 = 3;
						vself.pentregaexterna 		 = 2;
                        vself.pidpedido     		 = response.data.inf;
                        vself.pqtd_paginas  	     = 1;
						vself.pcredito				 = 0;					
						vself.porigem				 = 10;
						vself.vgerarcreditodevolucao = false;
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
			},
			mtdconfirmaredicaocreditoavulso(){
				let vself = this;
				if (parseFloat(vself.evledicaocreditoavulso) <= 0){
					vself.$toastr.w('Valor do crédito inválido!', 'Atenção!');
					$('#ededicaovlcreditoavulso').focus();
					return;
				}	
				if ((parseFloat(vself.vlegcredavulso) < parseFloat(vself.evledicaocreditoavulso))&&(parseInt(vself.defsubs)===0)){
					vself.$toastr.w('Valor do crédito inválido!', 'Atenção!');
					$('#ededicaovlcreditoavulso').focus();
					return;
				}				
				$.confirm({
					title: 'Confirmação!',
					content: 'Confirma alteração do crédito?',
					icon: 'fa fa-question-circle',
					escapeKey: true,
					backgroundDismiss: false,
					escapeKey: 'nao',
					type: 'dark',
					typeAnimated: true,
					buttons: { 
						sim: {
							text: '<u>S</u>im',
							keys: ['s', 'S'],
							btnClass: 'btn-blue',
							action: function () {
								$('.btn-blue').prop('disabled', true);
								vself.mtdsalvaralteracaocredito();
							},
						},
						nao: {
							text: '<u>N</u>ão',
							keys: ['n', 'N'],
							action: function () {
							}
						}
					}
				});
			},
			mtdsalvaralteracaocredito(){
				let vself  = this;
                let loader = vself.$loading.show();
			
                let parametros      = [
                    {parametro: 'idclientesac', 	valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           	valor : 'alterarcredito'},
                    {parametro: 'idfilial',     	valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    	valor : vself.$store.state.usuario.id},
					{parametro: 'idpedido',    		valor : vself.ecreditoavulso.id},
					{parametro: 'dtalteracao',    	valor : vself.mtdformatadatagravar(util.DataAtual())},
					{parametro: 'obsalteracao',  	valor : vself.eobsalteracaocredito},
					{parametro: 'vledicaocreditoavulso', valor : vself.evledicaocreditoavulso},
					{parametro: 'somarsubs',        valor : vself.defsubs},
                    {parametro: 'codop',        	valor : '020Z.010Z.025Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
					$('#mdedicaocreditoavulso').modal('hide');
                    if ($.isNumeric(response.data.inf)){						
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
						vself.ptipo				= 4;
						vself.pfiltropor		= 0;
						vself.psituacao     	= 3;
						vself.pentregaexterna 	= 2;
                        vself.pidpedido     	= vself.ecreditoavulso.id;
                        vself.pqtd_paginas  	= 1;
						vself.pcredito			= 0;					
						vself.porigem			= 10;
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.inf.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.inf.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.inf.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
			},
			resetacalc(event){
				this.evledicaocreditoavulso = 0
				 
			},
			mtdagruparpedidos(){
				
				if (!util.opcaousuario('020Z.010Z.220Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else{		
					let vself 			   = this;		
					// let loader      	   = vself.$loading.show();
					let pricli			   = 0;
					let itensnovopedido    = [];
					let servicosnovopedido = [];
					let temservico         = false;
					let nritem 			   = 0;
					let lstpedidosexcluir  = '';
					let totgeral 		   = 0;
					let totprodutos 	   = 0;
					let totservicos 	   = 0;
					if(this.exibicaocard){

						if(vself.qtdmarcados(vself.lstpedidos) > 0){
							let selecionados = vself.lstpedidos.filter(p => parseInt(p.marcado) == 1);

							pricli	    = selecionados[0].idcliente;

							for (let i = 0; i < selecionados.length; i++) {
								if (parseInt(selecionados[i].idcliente) !== parseInt(pricli)){
									// loader.hide();
									vself.$toastr.w('Impossível agrupar pedidos de clientes diferentes!', 'Atenção!');
									return;
								}else{
									///itens	
									lstpedidosexcluir = lstpedidosexcluir + selecionados[i].id +', ';

									totgeral          = totgeral     + parseFloat(selecionados[i].totalgeral);
									totprodutos       = totprodutos  + parseFloat(selecionados[i].totalprodutos);
									totservicos       = totservicos + parseFloat(selecionados[i].totalservicos);

									for (let x = 0; x < selecionados[i].itens.length; x++) {								
										nritem = nritem + 1;
										let item = selecionados[i].itens[x];
										item.item = nritem;
										itensnovopedido.push(item);
									
									}

									if(parseInt(selecionados[i].tipo) > 0){
										temservico = true; //muda para ordem de serviço caso entre os pedidos exista um serviço
									}
									///servicos
									if(selecionados[i].servicos.length > 0){
										for (let x = 0; x < selecionados[i].servicos.length; x++) {								
											let servico  = selecionados[i].servicos[x];
											servicosnovopedido.push(servico);
										}
									}
								}
							}
						}
					}else{
						if (vself.$refs.reflstpedidos.selected_items.length > 0){
							pricli	    = vself.$refs.reflstpedidos.selected_items[0].idcliente;
							
							for (let i = 0; i < vself.$refs.reflstpedidos.selected_items.length; i++) {
								if (parseInt(vself.$refs.reflstpedidos.selected_items[i].idcliente) !== parseInt(pricli)){
									// loader.hide();
									vself.$toastr.w('Impossível agrupar pedidos de clientes diferentes!', 'Atenção!');
									return;
								}else{
									///itens	
									lstpedidosexcluir = lstpedidosexcluir + vself.$refs.reflstpedidos.selected_items[i].id +', ';
	
									totgeral          = totgeral     + parseFloat(vself.$refs.reflstpedidos.selected_items[i].totalgeral);
									totprodutos       = totprodutos  + parseFloat(vself.$refs.reflstpedidos.selected_items[i].totalprodutos);
									totservicos       = totservicos + parseFloat(vself.$refs.reflstpedidos.selected_items[i].totalservicos);
	
									for (let x = 0; x < vself.$refs.reflstpedidos.selected_items[i].itens.length; x++) {								
										nritem = nritem + 1;
										let item = vself.$refs.reflstpedidos.selected_items[i].itens[x];
										item.item = nritem;
										itensnovopedido.push(item);
									
									}
	
									if(parseInt(vself.$refs.reflstpedidos.selected_items[i].tipo) > 0){
										temservico = true; //muda para ordem de serviço caso entre os pedidos exista um serviço
									}
									///servicos
									if(vself.$refs.reflstpedidos.selected_items[i].servicos.length > 0){
										for (let x = 0; x < vself.$refs.reflstpedidos.selected_items[i].servicos.length; x++) {								
											let servico  = vself.$refs.reflstpedidos.selected_items[i].servicos[x];
											servicosnovopedido.push(servico);
										}
									}
								}
							}
						}
					}
					lstpedidosexcluir = lstpedidosexcluir.slice(0, -2);	
					vself.lstitensagrupados 	   = JSON.parse(JSON.stringify(itensnovopedido));
					vself.lstservicosagrupados 	   = JSON.parse(JSON.stringify(servicosnovopedido));
					vself.lstpedidosexcluiragrupar = lstpedidosexcluir;
					vself.mtdnovo();

					setTimeout(() => {
						vself.vidcliente		= pricli;
						vself.lstitens			= JSON.parse(JSON.stringify(vself.lstitensagrupados));	
						
						vself.lstservicos	    = JSON.parse(JSON.stringify(vself.lstservicosagrupados));	

						vself.vtotalgeral    = totgeral;
					    vself.vtotalprodutos = totprodutos;
						vself.vtotalservicos = totservicos;

						vself.vitem	 			= nritem;
						if(temservico){
							vself.vtipo = 2;
						}
						vself.vexcluiragrupados = true;
						vself.vobservacoes 		= 'GERADO VIA AGRUPAMENTO DOS PEDIDOS: '+vself.lstpedidosexcluiragrupar+', PELO USUÁRIO: '+vself.$store.state.usuario.nome;				
						vself.mtdlocalizarcliente(vself.vidcliente);
						// loader.hide();
						setTimeout(() => {
							vself.mtdselecionarplano();
						}, 300);										
					}, 1000);
				}
			},
			mtdvisualizaralerta(){
				this.vidclientealerta = 0;//mudo antes o valor pro componente entender que houve alteração do valor pra poder reagir
				this.vidclientealerta = this.vidcliente;
				$('#mdconteudoalertacliente').modal('show');				
			},
			mtdaddformapagto(item){
				this.pedidoaddformaspagto = item;
				this.$modal.show('mdl-add-formapagto');
				let vself = this;
				setTimeout(() => {
					$("#cbformapagamento2").select2({
						id: function (e) {return e.id},
						ajax: {
							url: vself.$store.state.configpaths.pathselect2,
							dataType: 'json',
							delay: 250,
							data: function (params) {
								return {
									q: params.term,
									idclientesac : vself.$store.state.filialpadrao.idcliente,
									tb: 'tbformaspagamento',
									c1: 'id',
									c2: 'descricao'
								};
							},
							processResults: function (data) {
								return {
									results: data
								};
							},
							cache: true
						},
						minimumInputLength: 0,
						theme: 'bootstrap',
						language: "pt-BR",
						templateResult: util.formatResult,
						templateSelection: util.formatSelection
					}).change(function () {
						vself.vidformapagamento2     = $("#cbformapagamento2").val();
					});
				}, 1000);
			},
			mtdlimpaformaspagto(){
				this.pedidoaddformaspagto = {id: 0};
				this.vidformapagamento2   = null;
				this.vvalorformapagto2	 = 0;
				this.vidlancfluxo2		 = null;
			},
			mtdconfirmaaddformaspgto(){
				let vself = this;
                let loader       = vself.$loading.show()
                let parametros   = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'addformapagto'},
					{parametro: 'dadosforma', valor: JSON.stringify(vself.pedidoaddformaspagto)},
					{parametro: 'idformapagamento', valor: vself.vidformapagamento2},
					{parametro: 'valorformapagto', valor: vself.vvalorformapagto2},
					{parametro: 'idlancfluxo', valor: vself.vidlancfluxo2}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidosvenda.php');
                retorno.then(function (response) {
                    loader.hide();
					if(isNaN(response.data)){
						vself.$toastr.e(response.data.substring(4), 'Erro!');
					} else {
						vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
					}
					vself.mtdlimpaformaspagto();
                    vself.$modal.hide('mdl-add-formapagto');
                }).catch(function (response) {
                    loader.hide()
					vself.mtdlimpaformaspagto();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!')
                });	
			}
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
				vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
					$('[data-toggle="popover"]').popover();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('020Z.010Z', vself.$store.state.perfilusuario)) {
						vself.pathimgview         = vself.$store.state.configpaths.pathimagens;
						vself.crotinacortes		  = util.opcaousuario('020Z.010Z.034Z', vself.$store.state.perfilusuario);
						$('#pnlista').fadeIn(700);
						$('#edidpedidopesq').focus();
						vself.mtdatzvariaveisperfil();
						vself.mtdselect2_def();
						vself.mtdexecutapesquisa();

						vself.sortOrder = 'desc';
						vself.sortKey   = 'id';
						vself.mtdverificaordematual('id');
						
						vself.pvisualizartotalizadores 	= util.opcaousuario('020Z.010Z.150Z', vself.$store.state.perfilusuario);
						vself.pvisualizarcustos 		= util.opcaousuario('020Z.010Z.155Z', vself.$store.state.perfilusuario);
						vself.pvisualizargraficos 		= util.opcaousuario('020Z.010Z.160Z', vself.$store.state.perfilusuario);
						vself.alterafilialnf			= util.opcaousuario('020Z.010Z.068Z', vself.$store.state.perfilusuario);
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });

				if((parseInt(vself.psituacao) === 0 || (parseInt(vself.psituacao) === 1 && vself.pidcliente !== null) )){
					vself.$refs.reflstpedidos.checkbox_rows = true
				}else{
					vself.$refs.reflstpedidos.checkbox_rows = false
				}
            }
        },
        computed:{
            validou(){
				return this.vidfilial === null || this.vidvendedor === null || this.vidcliente === '' || this.vidplano === null ||
				(this.lstitens.length === 0 && this.lstservicos.length === 0) || this.vdtemissao === null || ((parseInt(this.vtipo) == 2) && (parseInt(this.$store.state.usuario.tpsistema) !== 5 ) && (this.videntificador === '' || this.vmarcacao === '' || this.vmarca === '' || this.vmodelo === '') ) ;
            },
            idclienteretorno(){
                return this.$store.state.clienteretornoconsulta.idcliente;
			},
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
		    listaprodutosretorno(){
                return this.$store.state.listaprodutosretornoconsulta.lstprod;
            },				
			manipulaval(){
				if (!this.alteraentra) {
					this.vtipodescacresedicao 	= 0;
					this.vvalordescacresedicao 	= 0;
					this.vtipodescacresedicao 	= 0;
					this.vdescacresedicao 	= 0;
				}
				switch (parseInt(this.vmanipulavaledicao)) {
					case 0:
						if (!this.alteraentra) {
							this.vvlunitarioedicao = this.vvltabelaitemedicao;
						}
						return true;
						break;
					case 1:
						return false;
						break;
				}
				this.alteraentra = false;
			},
			calculatotalitem() {
				let valdescacres 			= 0;
				let totaledicaosemimposto 	= 0;
				this.vldescmostrar			= 0;

				switch (parseInt(this.vtipodescacresedicao)) {
					case 0://Percentual
						valdescacres 		= this.vqtditemedicao * this.vvlunitarioedicao * this.vvalordescacresedicao / 100;
						this.vldescmostrar 	= valdescacres;
						break;
					case 1://Valor
						valdescacres 		= this.vvalordescacresedicao;
						this.vldescmostrar 	= (valdescacres / (this.vqtditemedicao * this.vvlunitarioedicao) * 100).toFixed(2);
						break;
				}
				
				let ret = util.itemcomimposto(this.vdadosclasseitem, parseFloat(this.vvlunitarioedicao), parseFloat(this.vqtditemedicao), this.vdescacresedicao, parseFloat(valdescacres));								

				this.vvltotalimpostoitemedicao = parseFloat(ret.totalimpostoitem);
				this.vvltotaledicao 		   = parseFloat(ret.vltotalitem);
				
				this.mtdtpdescacres(this.vtipodescacresedicao);
			},
			calculatotalserv() {
				try{
					var valdescacres = 0;
					switch (parseInt(this.vtipodescontoservicoedicao)) {
						case 0://Percentual
							valdescacres = this.vqtdservicoedicao * this.vvlservicoedicao * this.vvalordescontoservicoedicao / 100;
							break;
						case 1://Valor
							valdescacres = this.vvalordescontoservicoedicao;
							break;
					}
					this.vvltotalservicoedicao = (this.vqtdservicoedicao * this.vvlservicoedicao) - valdescacres;
				}catch(e){
					this.vvltotalservicoedicao = 0;
					this.$toastr.e('Erro ao carregar valor do serviço. Verifique o cadastro e tente novamente!', 'Erro!');
				}


				
			},
			calculadescontototalitens(){
				if (parseInt(this.vtipodesctotal) === 0){
					this.vtotalcomdesconto = this.vtotalsemdesconto - (this.vtotalsemdesconto * this.vfatordescontototal / 100);
					this.vresdesconto	   = this.vfatordescontototal * this.vtotalsemdesconto / 100;						
				}else{
					this.vtotalcomdesconto = this.vtotalsemdesconto - this.vfatordescontototal;			
					this.vresdesconto	   = this.vfatordescontototal / this.vtotalsemdesconto * 100;			
				}
			},
			selecionaperiodo: function () {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
			},
            temItens(){
                return this.lstitensconf.length === 0
            },
			exibicaocard(){
				return parseInt(this.$store.state.usuario.exibicaocard) === 1 ? true : false;
			}	 

        },
        watch:{
			vmostraestoque(val){
				this.columnsi[14].visibility = val;
				if(val){
					this.mtdconsultarestoqueitens()
					
				}
			},
			vermelho(){
				if(!this.vermelho){
					this.vstyle = 'text-align:right; font-weight: bold; background: honeydew; color: green;'
				}else{
					this.vstyle = 'text-align:right; font-weight: bold; background: honeydew; color: rgb(128, 23, 0);'
				}
			},
			defsubs(){
				if(parseInt(this.defsubs)===1){	
					this.vermelho = false
				}else{
					this.vermelho = true
				}
			},
			psituacao(){
				if((parseInt(this.psituacao) === 0 || (parseInt(this.psituacao) === 1 && this.pidcliente !== null) )){
					this.$refs.reflstpedidos.checkbox_rows = true
				}else{
					this.$refs.reflstpedidos.selected_items = [];
					this.$refs.reflstpedidos.checkbox_rows = false
				}
			},
			pidcliente(){
				if((parseInt(this.psituacao) === 0 || (parseInt(this.psituacao) === 1 && this.pidcliente !== null) )){
					this.$refs.reflstpedidos.checkbox_rows = true

				}else{
					this.$refs.reflstpedidos.selected_items = [];
					this.$refs.reflstpedidos.checkbox_rows = false
				}
			},
            pagina_atual(val){
                this.mtdcarregapedidos(val);
			},
            idclienteretorno(val){
                if (val !== null || val !== ''){
					this.vidcliente = val;
					this.mtdlocalizarcliente(this.vidcliente);					
                }
			},			
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddigedicao = val;
					this.mtdlocalizarproduto(this.vcoddigedicao);					
                }
			},
			listaprodutosretorno(val){
				this.processaprodutos(val);
			},			
			vdescacresedicao(){
				this.mtdtpdescacres(this.vtipodescacresedicao);
			},
			vtipodescacresedicao(val) {
				this.mtdtpdescacres(val);
        	},
			vtipodescontoservicoedicao(val){
				if (val == 0){
					this.vtitdescserv = 'Descto.(%):';
				}else{
					this.vtitdescserv = 'Descto.(R$):';
				}			
			},
			vtipo(val, antigo){
				if(parseInt(val)===0){
					if(this.lstservicos.length > 0){
						this.$toastr.w('Você esta tentando mudar uma OS ou orçamento para pedido, mas ainda há serviços na listagem!', 'Atenção')
						this.vtipo = antigo;
					}
				}
			},
			vtipodesctotal(){
				this.vfatordescontototal 	= 0;
				this.vresdesconto			= 0;
				this.vtotalcomdesconto 		= this.vtotalsemdesconto;
			},
			ventregaexterna(val){
				this.columnsi[10].visibility = val;
				for (let i = 0; i < this.lstitens.length; i++) {
					this.lstitens[i].qtdentregar = this.lstitens[i].qtditem;					
				}
			},
			pvisualizarcustos(val){
				this.columns[17].visibility = val;//índice da coluna do custo
			},
			pentregaexterna(){
				this.psituacaoentrega    = 2;
			},
			vachouPro(){
                this.vfaltaitens = true

                for (var i = 0; i < this.lstitensconf.length; i++) {									
                    if(this.lstitensconf[i]['qtdfalta'] > 0){
                        this.vfaltaitens = false
                        break
                    }
                }
                if(this.vfaltaitens){
                    this.vfinalizado = true
                    this.ativadesativacod = true
                    this.videscpro = ''
                    this.$nextTick(function () {
                        $("#btngravar").focus()
                    })              
                }
			} 
        },
        setup() {
            // //Obs, o audio possui 3 sons diferentes, o sprite abaixo, pega cada posição
            const { play } = useSound(conferenciaSfx, {
                sprite: {
                    concluido: [0, 350],    
                    faltando: [374, 540],
                    alerta: [998, 350]
                },
            })

            return {
                play,
            }
        }
    }
</script>
<style>
	.bdg-tipo-entrega-pedido{
		background-color: #3e4d59;
		height: 25px;
		border-radius: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
		font-weight: 600;
		margin-block: auto !important;
	}
    #mdcorteitem{
        z-index: 20011!important;
    }
	.nav-link-ped{
		height: 45px!important;
	}
	.def-col-opcoes_ped{
		width: 70px !important;
	}
	.def-col-nrpedido{
		width: 150px;
	}
    .def-col-item{
        min-width: 55px !important;
	}	
    .def-col-coddig{
        min-width: 50px !important;
	}
	.def-col-cod-conf{
        min-width: 50px !important;
		user-select: none;
		-webkit-user-select: none;
	}
	.def-col-unditem{
		min-width: 80px !important;
	}
	.def-col-formas-pedido{
		width: 130px;
	}	
	.def-col-cliente{
		width: 250px;
	}
	.dropdown-toggle::after { 
		display: none !important; 
	}
	.btn_selecionar_plano{
		font-weight: bold!important;
		margin-top: 22px!important;
		transition: 0.2s!important;
	}
	.btn_selecionar_plano:hover{
		filter: brightness(80%)!important;
	}
	#edtotalitenssemdesconto{
		background: #727cf5;
		font-weight: bold;
		text-align: right;
		font-size: 20px;
		color: white;
		border-color: #727cf5;
	}
	#edtotalitenscomdesconto{
		background: #0acf97;
		font-weight: bold;
		text-align: right;
		font-size: 20px;
		color: white;
		border-color: #0acf97;
	}
	#icone-entregar{
		color: #0acf97;
		position: relative;
		font-size: 18px;
		transform: scale(-1, 1);
		top: 2px;
		left: 5px;		
		transition: 0.4s; 
	}
	#lblentregar{
		cursor: pointer;
	}
	#lblentregar:hover #icone-entregar{
		left: 50px;
		transition: 0.4s; 
	}
	.icone-entregafinalizada{
		position: relative;
		color: #f82b54!important;
		left: -8px;
		top: -2px;
		font-size: 10px;		
	}
	.btn-editaitementrega{
		width: 30px!important;
		font-size: 10px!important;
		padding: 2px !important;
	}
	.bdg-credito-disponivel{
		cursor: pointer;
		background-color: #28a745!important;
		margin-left : 3px;		
	}
	.bdg-credito-utilizado{
		cursor: pointer;
		background-color: #6c757d!important;
		margin-left : 3px;
	}
	.bdg-credito-saldo{
		cursor: pointer;
		background-color: #17a2b8!important;
		margin-left : 3px;
	}
	.bdg-stpedido{
		background-color: #3e4d59;
		height: 25px;
		border-radius: 10px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #fff;
		font-weight: 600;
	}
	.item-lst-cred{
		padding: 5px!important;
	}	
    #btmarcartodaschecklist{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodaschecklist:hover{
        color: #666666;
        transition: .35s;
    }	
	.def-col-marca{
		min-width: 80px !important
    }
	.def-col-und{
		min-width: 80px !important
    }
    .def-col-qtd{
        min-width: 90px !important
    }
    .def-col-qtdconf{
        min-width: 90px !important
    }
    .def-col-qtdfalta{
        min-width: 90px !important
    }
    .bdg-alerta {
        border-radius: 8px !important;
        font-size: 14px !important;
        background-color: #c91212 !important;
        width: 100px;
    }
    .bdg-success {
        border-radius: 8px !important;
        font-size: 14px !important;
        background-color: #d7a519 !important;
        width: 100px;
    }
    .bdg-finalizado {
        border-radius: 8px !important;
        font-size: 14px !important;
        background-color: #28a745 !important;      
        width: 100px;
    }
    .slot_detalhes{
        width: 50px;
    }	
    .slot_detalhesprodutos{
        width: 50px;
    }	
    .icon-detalhes{
        cursor: pointer;
        font-size: 22px;
        color: #d7a519;
    }
	.btncortaritem{
		width: 25px;
		height: 25px;
		padding: 0px!important;
		font-size: 12px;
	}	
	.bdg-credito{
		position: relative;
		top: -4px;		
	}
	.icone-pendencias{
		position: relative;
		top: -1px;
		color: #c91212;
		font-weight: 600;
		font-size: 18px;
		margin-left: 5px;
	}
	.icone-origem{
		color: #2f3c48;
		font-size: 20px;
		margin-left: 5px;
		margin-right: 3px;
	}
	.icone-libera-pdv{
		font-size: 18px;
		cursor: pointer;
	}
	.icone-imprimir-pedido{
		color: #3e4d59;
		cursor: pointer;
		margin-left: 5px;
		font-size: 18px;
	}	
	.lbldescformapedido{
		font-weight: bold;
		font-size: 10px;
	}
	.def-col-estoques-cmp{
        width: 120px;
    }
	.card-white{        
        background: white!important;
		color: black !important;              
    }
</style>